<template>
  <div style="width:100%">
  <div class="header-main ">
  <div class="hm-left ">
    <div>
      <div class="bread-crumb"></div>
      <div class="header-main__title-wrap"><h1 class="header-main__title">Заказы </h1>
      <div class="header-main__review"></div>
      </div>
      </div>
    </div>

    <div class="hm-right">

      <div v-if="$store.state.user.id === 162">
        
      <div class="btn-wrapper btn-wrapper_group new megamenu">
        
        <transition name="fade-menu">

        <div class="allitem" v-if="isVisibleMegamenu">
        <router-link to="/tasksto" class="btn_ms m0 btn grens">
          <div class="">Задачи СТО</div>
        </router-link>
        
        <router-link to="/sto" class="btn_ms m0 btn grens">
          <div class="">Посты СТО</div>
        </router-link>     
        
        <router-link to="/chats" class="btn_ms m0 btn currentorange">
          <div class="">Чаты</div>
        </router-link>          
        <router-link to="/bonus" class="btn_ms btn currentorange">
            <div class="">Бонусы</div>
          </router-link>          
        <router-link to="/info_bonus" class="btn_ms btn currentorange">
            <div class="">Инфо Бонусы</div>
          </router-link>
       <router-link to="/" class="btn_ms btn currentorange">
          <div class="">Товары</div>
        </router-link>   
        
        <router-link to="/alltask" class="btn_ms m0 btn btntask">
          <div class="">Задачи</div>
        </router-link>

        </div>

      </transition>


        <button class="btn_md custmenu" @click="openMegamenu">
          <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24          px" viewBox="0 0 24 24" fill="none">
            <path d="M4 18H10" stroke="#fff" stroke-width="2" stroke-linecap="round"/>
            <path d="M4 12L16 12" stroke="#fff" stroke-width="2" stroke-linecap="round"/>
            <path d="M4 6L20 6" stroke="#fff" stroke-width="2" stroke-linecap="round"/>
          </svg>
          Меню
        </button>

              <div class="btn_md m0 btn" :class="{ disabled: hasSavedOrders }"
    :disabled="hasSavedOrders">
          <div class="btn-content btn-content_icon btn-content_new" @click="newOrder">Новый заказ</div>

        </div>  
        <div class="btn_md m0 btn btn-lite-wrap">
          <div class="btn-content btn-content_icon btn-content_new" @click="openLiteOrderModal" title="Быстрый заказ Lite">Lite</div>
        </div>


        
       

      </div>
        



      </div>

      <div v-else>

      <div class="btn-wrapper btn-wrapper_group new">

        <router-link to="/timesellers" style="margin-right: 15px !important;" class="btn_ms m0 btn" v-if="$store.state.user.id === 307">
          <div >Время работы продавцов</div>
        </router-link> 

        <router-link to="/tasksto" class="btn_ms m0 btn" style="margin-right: 15px !important;" v-if="$store.state.user.id === 14 || $store.state.user.id === 126">
          <div class="">Задачи</div>
        </router-link> 

        <router-link to="/bonus" class="btn_ms btn "  v-if="$store.state.user.id !== 126">
            <div class="">Бонусы</div>
          </router-link>
        <router-link to="/alltask" class="btn_ms m0 btn btntask" v-if="$store.state.user.id !== 126">
          <div class="">Задачи</div>
        </router-link>
        <router-link to="/sto" class="btn_ms m0 btn" style="margin-right: 15px !important;" v-if="$store.state.user.id === 14 || $store.state.user.id === 126">
          <div class="">Посты</div>
        </router-link>
       <router-link to="/" class="btn_ms btn">
          <div class="">Товары</div>
        </router-link>   
      <div class="btn_md m0 btn" :class="{ disabled: hasSavedOrders }"
    :disabled="hasSavedOrders">
          <div class="btn-content btn-content_icon btn-content_new" @click="newOrder">Новый заказ</div>
        
        </div>  
        <div class="btn_md m0 btn btn-lite-wrap">
          <div class="btn-content btn-content_icon btn-content_new" @click="openLiteOrderModal" title="Быстрый заказ Lite">Lite</div>
        </div>

      </div>
      </div>


    </div>

  </div>
  
    <div class="m-filter filter__wrap">
      
      <div class="endFilter" style="display: flex; align-items: center; gap: 8px;">
        <span @click="toggleFilter" style="display: flex; align-items: center; cursor: pointer;">
          {{ displayFilter ? 'Скрыть фильтр' : 'Развернуть фильтр ' }}  <svg xmlns="http://www.w3.org/2000/svg" :class="{'rotated': displayFilter }" width="24" height="24" fill="#005EEB"><path d="M12.72 15.78a.75.75 0 0 1-.53.22h-.38a.77.77 0 0 1-.53-.22l-5.13-5.14a.5.5 0 0 1 0-.71l.71-.71a.49.49 0 0 1 .7 0L12 13.67l4.44-4.45a.5.5 0 0 1 .71 0l.7.71a.5.5 0 0 1 0 .71l-5.13 5.14z"/></svg>
        </span>
        <span @click="openFilterSettings" title="Настройки фильтров" style="cursor:pointer; font-size:16px;">⚙️</span>
      </div>

     <div class="contentFilter" v-if="displayFilter">

    <!-- Форма фильтров -->
    <form @submit.prevent="applyFilters" class="default-form-filter">
    <div class="filter-content cleared filter__row filter-flex-container">
      <div class="filter-group" v-if="isFilterVisible('number')" :style="{ order: getFilterOrder('number') }">
        <label for="filter_number">Номер заказа:</label>
        <input v-model="filters.number" @input="onFilterNumberInput" type="text" id="filter_number" placeholder="Несколько через пробел; % — подстановка (76314%, %76314, %76314%)">
      </div>

      <div class="filter-group" v-if="isFilterVisible('customer')" :style="{ order: getFilterOrder('customer') }">
        <label for="filter_customer">Покупатель:</label>
        <input v-model="filters.customer" type="text" id="filter_customer" placeholder="ФИО или телефон или email">
      </div>

      <div class="filter-group" v-if="isFilterVisible('city')" :style="{ order: getFilterOrder('city') }">
        <label for="filter_city">Город:</label>
        <input v-model="filters.city" type="text" id="filter_city" placeholder="Введите город">
      </div>

      <div class="filter-group" v-if="isFilterVisible('inn')" :style="{ order: getFilterOrder('inn') }">
        <label for="filter_inn">ИНН:</label>
        <input v-model="filters.inn" type="text" id="filter_inn" placeholder="Введите ИНН">
      </div>

      <div class="filter-group" v-if="isFilterVisible('createdAt')" :style="{ order: getFilterOrder('createdAt') }">
        <label for="filter_createdAt">Дата оформления заказа:</label>
        <div class="input_flex">
        <date-picker 
          v-model="filters.createdAt_gte"
          :format="formatDate"
          :language="language"
          placeholder="От"
          id="filter_createdAt_gte"
          :shortcuts="datepickerShortcuts"
        >
          <template v-slot:footer="{ emit }">
            <div class="datepicker-footer">
              <button class="btn-datepicker-reset" @click="emit(null)">
                <svg viewBox="0 0 24 24" width="16" height="16"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" fill="currentColor"/></svg>
                Сбросить
              </button>
            </div>
          </template>
        </date-picker>
        <span> - </span>
        <date-picker 
          v-model="filters.createdAt_lte"
          :format="formatDate"
          :language="language"
          placeholder="До"
          id="filter_createdAt_lte"
          :shortcuts="datepickerShortcuts"
        >
          <template v-slot:footer="{ emit }">
            <div class="datepicker-footer">
              <button class="btn-datepicker-reset" @click="emit(null)">
                <svg viewBox="0 0 24 24" width="16" height="16"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" fill="currentColor"/></svg>
                Сбросить
              </button>
            </div>
          </template>
        </date-picker>
        </div>
      </div>

     

      <div class="filter-group" v-if="isFilterVisible('managers')" :style="{ order: getFilterOrder('managers') }">
        <label for="filter_managers">Менеджеры(тест):</label>
        <div class="filter-treeselect-row">
          <TreeSelect
            v-model="filters.managers"
            :options="formattedManagersList"
            :multiple="true"
            value-consists-of="ALL"
            :clearable="true"
            placeholder="Выберите менеджеров"
            id="filter_sites"
            :normalizer="normalizeSiteData"
            :appendToBody="true"
          />
          <div class="treeselect-actions">
            <button type="button" class="btn-select-all" @click="filters.managers = getAllIdsFromOptions(formattedManagersList)">Выбрать все</button>
            <button type="button" class="btn-clear-treeselect" @click="filters.managers = []">Сбросить</button>
          </div>
        </div>
      </div>

        <div class="filter-group" v-if="isFilterVisible('managersOld') && isFieldVisible('managersOld')" :style="{ order: getFilterOrder('managersOld') }">
        <label for="filter_managers">Менеджеры (old):</label>
        <div class="filter-treeselect-row">
          <TreeSelect
            v-model="filters.managersOld"
            :options="formattedManagersListOld"
            :multiple="true"
            value-consists-of="ALL"
            :clearable="true"
            placeholder="Выберите менеджеров"
            id="filter_sites"
            :normalizer="normalizeSiteData"
            :appendToBody="true"
          />
          <div class="treeselect-actions">
            <button type="button" class="btn-select-all" @click="filters.managersOld = getAllIdsFromOptions(formattedManagersListOld)">Выбрать все</button>
            <button type="button" class="btn-clear-treeselect" @click="filters.managersOld = []">Сбросить</button>
          </div>
        </div>
      </div>

      <div class="filter-group" v-if="isFilterVisible('prodavec')" :style="{ order: getFilterOrder('prodavec') }">
        <label for="filter_managers">Продавцы:</label>
        <div class="filter-treeselect-row">
          <TreeSelect
            v-model="filters.prodavec"
            :options="formattedProdavecList"
            :multiple="true"
            value-consists-of="ALL"
            :clearable="true"
            placeholder="Выберите продавцов"
            id="filter_sites"
            :normalizer="normalizeSiteData"
            :appendToBody="true"
          />
          <div class="treeselect-actions">
            <button type="button" class="btn-select-all" @click="filters.prodavec = getAllIdsFromOptions(formattedProdavecList)">Выбрать все</button>
            <button type="button" class="btn-clear-treeselect" @click="filters.prodavec = []">Сбросить</button>
          </div>
        </div>
      </div>

      <div class="filter-group" v-if="isFilterVisible('couriers')" :style="{ order: getFilterOrder('couriers') }">
        <label for="filter_couriers">Курьеры:</label>
        <div class="filter-treeselect-row">
          <TreeSelect
            v-model="filters.couriers"
            :options="formattedCouriersList"
            :multiple="true"
            value-consists-of="ALL"
            :clearable="true"
            placeholder="Выберите курьеров"
            id="filter_couriers"
            :normalizer="normalizeSiteData"
            :appendToBody="true"
          />
          <div class="treeselect-actions">
            <button type="button" class="btn-select-all" @click="filters.couriers = getAllIdsFromOptions(formattedCouriersList)">Выбрать все</button>
            <button type="button" class="btn-clear-treeselect" @click="filters.couriers = []">Сбросить</button>
          </div>
        </div>
      </div>

      <div class="filter-group" v-if="isFilterVisible('deliveryDate')" :style="{ order: getFilterOrder('deliveryDate') }">
        <label for="filter_deliveryDate">Дата доставки:</label>
        <div class="input_flex">
        <date-picker 
          v-model="filters.deliveryDate_gte"
          :format="formatDate"
          :language="language"
          placeholder="От"
          id="filter_deliveryDate_gte"
          :shortcuts="datepickerShortcuts"
        >
          <template v-slot:footer="{ emit }">
            <div class="datepicker-footer">
              <button class="btn-datepicker-reset" @click="emit(null)">
                <svg viewBox="0 0 24 24" width="16" height="16"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" fill="currentColor"/></svg>
                Сбросить
              </button>
            </div>
          </template>
        </date-picker>
        <span> - </span>
        <date-picker 
          v-model="filters.deliveryDate_lte"
          :format="formatDate"
          :language="language"
          placeholder="До"
          id="filter_deliveryDate_lte"
          :shortcuts="datepickerShortcuts"
        >
          <template v-slot:footer="{ emit }">
            <div class="datepicker-footer">
              <button class="btn-datepicker-reset" @click="emit(null)">
                <svg viewBox="0 0 24 24" width="16" height="16"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" fill="currentColor"/></svg>
                Сбросить
              </button>
            </div>
          </template>
        </date-picker>
        </div>
      
      </div>

        <div class="filter-group" v-if="isFilterVisible('chipmentDate') && isFieldVisible('chipmentDate')" :style="{ order: getFilterOrder('chipmentDate') }">
        <label for="filter_deliveryDate">Дата отгрузки:</label>
        <div class="input_flex">
        <date-picker 
          v-model="filters.chipmentDate_gte"
          :format="formatDate"
          :language="language"
          placeholder="От"
          id="filter_chipmentDate_gte"
          :shortcuts="datepickerShortcuts"
        >
          <template v-slot:footer="{ emit }">
            <div class="datepicker-footer">
              <button class="btn-datepicker-reset" @click="emit(null)">
                <svg viewBox="0 0 24 24" width="16" height="16"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" fill="currentColor"/></svg>
                Сбросить
              </button>
            </div>
          </template>
        </date-picker>
        <span> - </span>
        <date-picker 
          v-model="filters.chipmentDate_lte"
          :format="formatDate"
          :language="language"
          placeholder="До"
          id="filter_chipmentDate_lte"
          :shortcuts="datepickerShortcuts"
        >
          <template v-slot:footer="{ emit }">
            <div class="datepicker-footer">
              <button class="btn-datepicker-reset" @click="emit(null)">
                <svg viewBox="0 0 24 24" width="16" height="16"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" fill="currentColor"/></svg>
                Сбросить
              </button>
            </div>
          </template>
        </date-picker>
        </div>
      
      </div>

      <div class="filter-group" v-if="isFilterVisible('totalSumm')" :style="{ order: getFilterOrder('totalSumm') }">
        <label for="filter_totalSumm">Сумма заказа, руб.:</label>
        <div class="input_flex">
        <input v-model="filters.totalSumm_gte" type="number" id="filter_totalSumm_gte" placeholder="От">
        <span> - </span>
        <input v-model="filters.totalSumm_lte" type="number" id="filter_totalSumm_lte" placeholder="До">
        </div>
      </div>

      <div class="filter-group" v-if="isFilterVisible('shipmentStores') && isFieldVisible('shipmentStores')" :style="{ order: getFilterOrder('shipmentStores') }">
        <label for="filter_shipmentStores">Склады отгрузки:</label>
        <div class="filter-treeselect-row">
          <TreeSelect
            v-model="filters.shipmentStores"
            :options="formattedShipmentList"
            :multiple="true"
            value-consists-of="ALL"
            :clearable="true"
            placeholder="Выберите склады"
            id="filter_sites"
            :normalizer="normalizeSiteData"
            :appendToBody="true"
          />
          <div class="treeselect-actions">
            <button type="button" class="btn-select-all" @click="filters.shipmentStores = getAllIdsFromOptions(formattedShipmentList)">Выбрать все</button>
            <button type="button" class="btn-clear-treeselect" @click="filters.shipmentStores = []">Сбросить</button>
          </div>
        </div>
      </div>

      <div class="filter-group" v-if="isFilterVisible('shipped') && isFieldVisible('shipped')" :style="{ order: getFilterOrder('shipped') }">
        <label for="filter_shipped">Отгрузка:</label>
        <select v-model="filters.shipped" id="filter_shipped" class="filter-select">
          <option value="">Любой</option>
          <option value="true">Отгружен</option>
          <option value="false">Не отгружен</option>
        </select>
      </div>

      <div class="filter-group" v-if="isFilterVisible('product')" :style="{ order: getFilterOrder('product') }">
        <label for="filter_product">Товар/услуга в заказе:</label>
        <input v-model="filters.product" type="text" id="filter_product" placeholder="Название, артикул или штрих-код">
      </div>

      <div class="filter-group" v-if="isFilterVisible('deliveryTypes')" :style="{ order: getFilterOrder('deliveryTypes') }">
        <label for="filter_deliveryTypes">Типы доставки:</label>
        <div class="filter-treeselect-row">
          <TreeSelect
            v-model="filters.deliveryTypes"
            :options="formattedDeliveryList"
            :multiple="true"
            value-consists-of="ALL"
            :clearable="true"
            placeholder="Выберите типы доставки"
            id="filter_sites"
            :normalizer="normalizeSiteData"
            :appendToBody="true"
          />
          <div class="treeselect-actions">
            <button type="button" class="btn-select-all" @click="filters.deliveryTypes = getAllIdsFromOptions(formattedDeliveryList)">Выбрать все</button>
            <button type="button" class="btn-clear-treeselect" @click="filters.deliveryTypes = []">Сбросить</button>
          </div>
        </div>
      </div>

      <div class="filter-group" v-if="isFilterVisible('sites')" :style="{ order: getFilterOrder('sites') }">
        <label for="filter_sites">Магазины:</label>
        <div class="filter-treeselect-row">
          <TreeSelect
            v-model="filters.sites"
            :options="sitesFilterOptions"
            :multiple="true"
            value-consists-of="ALL"
            :clearable="!isRestrictedUser"
            :disabled="false"
            placeholder="Выберите магазины"
            id="filter_sites"
            :normalizer="normalizeSiteData"
            :appendToBody="true"
          />
          <div class="treeselect-actions">
            <button type="button" class="btn-select-all" @click="filters.sites = getAllIdsFromOptions(sitesFilterOptions)">Выбрать все</button>
            <button type="button" class="btn-clear-treeselect" @click="filters.sites = []">Сбросить</button>
          </div>
        </div>
      </div>

        <div class="filter-group" v-if="isFieldVisible('paymentTypes') && isFilterVisible('paymentTypes')" :style="{ order: getFilterOrder('paymentTypes') }">
        <label for="filter_deliveryTypes">Типы оплаты:</label>
        <div class="filter-treeselect-row">
          <TreeSelect
            v-model="filters.paymentTypes"
            :options="formattedPaymentList"
            :multiple="true"
            value-consists-of="ALL"
            :clearable="true"
            placeholder="Выберите типы оплаты"
            id="filter_sites"
            :normalizer="normalizeSiteData"
            :appendToBody="true"
          />
          <div class="treeselect-actions">
            <button type="button" class="btn-select-all" @click="filters.paymentTypes = getAllIdsFromOptions(formattedPaymentList)">Выбрать все</button>
            <button type="button" class="btn-clear-treeselect" @click="filters.paymentTypes = []">Сбросить</button>
          </div>
        </div>
      </div>

      <div class="filter-group" v-if="isFieldVisible('predoplata_beznalichnymi_spravochnik') && isFilterVisible('predoplata_beznalichnymi_spravochnik')" :style="{ order: getFilterOrder('predoplata_beznalichnymi_spravochnik') }">
        <label for="filter_predoplata_beznalichnymi_spravochnik">Предоплата безналичными (справочник):</label>
        <div class="filter-treeselect-row">
          <TreeSelect
            v-model="filters.predoplata_beznalichnymi_spravochnik"
            :options="formattedPredoplataBeznalichnymiList"
            :multiple="true"
            value-consists-of="ALL"
            :clearable="true"
            placeholder="Выберите значения"
            id="filter_predoplata_beznalichnymi_spravochnik"
            :normalizer="normalizeSiteData"
            :appendToBody="true"
          />
          <div class="treeselect-actions">
            <button type="button" class="btn-select-all" @click="filters.predoplata_beznalichnymi_spravochnik = getAllIdsFromOptions(formattedPredoplataBeznalichnymiList)">Выбрать все</button>
            <button type="button" class="btn-clear-treeselect" @click="filters.predoplata_beznalichnymi_spravochnik = []">Сбросить</button>
          </div>
        </div>
      </div>

      <div class="filter-group" v-if="isFieldVisible('ocenka_manageru') && isFilterVisible('ocenka_manageru')" :style="{ order: getFilterOrder('ocenka_manageru') }">
        <label for="filter_ocenka_manageru1Types">Оценка менеджеру:</label>
        <div class="filter-treeselect-row">
          <TreeSelect
            v-model="filters.ocenka_manageruTypes"
            :options="formattedocenka_manageruList"
            :multiple="true"
            value-consists-of="ALL"
            :clearable="true"
            placeholder="Выберите значения"
            id="filter_sites"
            :normalizer="normalizeSiteData"
            :appendToBody="true"
          />
          <div class="treeselect-actions">
            <button type="button" class="btn-select-all" @click="filters.ocenka_manageruTypes = getAllIdsFromOptions(formattedocenka_manageruList)">Выбрать все</button>
            <button type="button" class="btn-clear-treeselect" @click="filters.ocenka_manageruTypes = []">Сбросить</button>
          </div>
        </div>
      </div>

      <div class="filter-group" v-if="isFieldVisible('obzvon_klienta') && isFilterVisible('obzvon_klienta')" :style="{ order: getFilterOrder('obzvon_klienta') }">
        <label for="filter_obzvon_klienta">Обзвон клиентов</label>
        <div class="filter-treeselect-row">
          <TreeSelect
            v-model="filters.obzvon_klienta"
            :options="formattedobzvon_klienta"
            :multiple="true"
            value-consists-of="ALL"
            :clearable="true"
            placeholder="Выберите значения"
            id="filter_sites"
            :normalizer="normalizeSiteData"
            :appendToBody="true"
          />
          <div class="treeselect-actions">
            <button type="button" class="btn-select-all" @click="filters.obzvon_klienta = getAllIdsFromOptions(formattedobzvon_klienta)">Выбрать все</button>
            <button type="button" class="btn-clear-treeselect" @click="filters.obzvon_klienta = []">Сбросить</button>
          </div>
        </div>
      </div>

      <div class="filter-group" v-if="isFieldVisible('orderMethod') && isFilterVisible('orderMethod')" :style="{ order: getFilterOrder('orderMethod') }">
        <label for="filter_orderMethod">Способы оформления</label>
        <div class="filter-treeselect-row">
          <TreeSelect
            v-model="filters.orderMethodd"
            :options="formatteOrderMethods"
            :multiple="true"
            value-consists-of="ALL"
            :clearable="true"
            placeholder="Выберите значения"
            id="filter_sites"
            :normalizer="normalizeSiteData"
            :appendToBody="true"
          />
          <div class="treeselect-actions">
            <button type="button" class="btn-select-all" @click="filters.orderMethodd = getAllIdsFromOptions(formatteOrderMethods)">Выбрать все</button>
            <button type="button" class="btn-clear-treeselect" @click="filters.orderMethodd = []">Сбросить</button>
          </div>
        </div>
      </div>

      

       <div class="filter-group" v-if="isFieldVisible('proverkazakazamenedgero') && isFilterVisible('proverkazakazamenedgero')" :style="{ order: getFilterOrder('proverkazakazamenedgero') }">
        <label for="filter_proverkazakazamenedgeroTypes">Проверка заказа менеджер:</label>
        <div class="filter-treeselect-row">
          <TreeSelect
            v-model="filters.proverkazakazamenedgeroTypes"
            :options="formattedproverkazakazamenedgeroList"
            :multiple="true"
            value-consists-of="ALL"
            :clearable="true"
            placeholder="Выберите значения"
            id="filter_sites"
            :normalizer="normalizeSiteData"
            :appendToBody="true"
          />
          <div class="treeselect-actions">
            <button type="button" class="btn-select-all" @click="filters.proverkazakazamenedgeroTypes = getAllIdsFromOptions(formattedproverkazakazamenedgeroList)">Выбрать все</button>
            <button type="button" class="btn-clear-treeselect" @click="filters.proverkazakazamenedgeroTypes = []">Сбросить</button>
          </div>
        </div>
      </div>

      <div class="filter-group" v-if="isFieldVisible('contragentTypes') && isFilterVisible('contragentTypes')" :style="{ order: getFilterOrder('contragentTypes') }">
        <label for="filter_contragentTypes">Тип контрагента:</label>
        <div class="filter-treeselect-row">
          <TreeSelect
            v-model="filters.contragentTypes"
            :options="formattedContragentTypesList"
            :multiple="true"
            value-consists-of="ALL"
            :clearable="true"
            placeholder="Выберите типы контрагента"
            id="filter_contragentTypes"
            :normalizer="normalizeSiteData"
            :appendToBody="true"
          />
          <div class="treeselect-actions">
            <button type="button" class="btn-select-all" @click="filters.contragentTypes = getAllIdsFromOptions(formattedContragentTypesList)">Выбрать все</button>
            <button type="button" class="btn-clear-treeselect" @click="filters.contragentTypes = []">Сбросить</button>
          </div>
        </div>
      </div>

      <div class="filter-group" v-if="isFieldVisible('oplataTypes') && isFilterVisible('paymentStatus')" :style="{ order: getFilterOrder('paymentStatus') }">
        <label for="filter_oplataTypes">Статусы оплат:</label>
        <div class="filter-treeselect-row">
          <TreeSelect
            v-model="filters.paymentStatus"
            :options="formartpaymentStatusList"
            :multiple="true"
            value-consists-of="ALL"
            :clearable="true"
            placeholder="Выберите значения"
            id="filter_sites"
            :normalizer="normalizeSiteData"
            :appendToBody="true"
          />
          <div class="treeselect-actions">
            <button type="button" class="btn-select-all" @click="filters.paymentStatus = getAllIdsFromOptions(formartpaymentStatusList)">Выбрать все</button>
            <button type="button" class="btn-clear-treeselect" @click="filters.paymentStatus = []">Сбросить</button>
          </div>
        </div>
      </div>

      <div class="filter-group" v-if="isFilterVisible('paymentDate') && isFieldVisible('paymentDate')" :style="{ order: getFilterOrder('paymentDate') }">
        <label for="filter_paymentDate">Дата оплаты:</label>
        <div class="input_flex">
          <date-picker 
            v-model="filters.paymentDate_gte"
            :format="formatDate"
            :language="language"
            placeholder="От"
            id="filter_paymentDate_gte"
            :shortcuts="datepickerShortcuts"
          >
            <template v-slot:footer="{ emit }">
              <div class="datepicker-footer">
                <button class="btn-datepicker-reset" @click="emit(null)">
                  <svg viewBox="0 0 24 24" width="16" height="16"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" fill="currentColor"/></svg>
                  Сбросить
                </button>
              </div>
            </template>
          </date-picker>
          <span> - </span>
          <date-picker 
            v-model="filters.paymentDate_lte"
            :format="formatDate"
            :language="language"
            placeholder="До"
            id="filter_paymentDate_lte"
            :shortcuts="datepickerShortcuts"
          >
            <template v-slot:footer="{ emit }">
              <div class="datepicker-footer">
                <button class="btn-datepicker-reset" @click="emit(null)">
                  <svg viewBox="0 0 24 24" width="16" height="16"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" fill="currentColor"/></svg>
                  Сбросить
                </button>
              </div>
            </template>
          </date-picker>
        </div>
      </div>



      <div class="filter-group" v-if="isFieldVisible('statusTsAt') && isFilterVisible('statusTsAt')" :style="{ order: getFilterOrder('statusTsAt') }">
        <label for="filter_statusUpdatedAt">Отгружено ТС:</label>
        <div class="input_flex">
          <date-picker 
            v-model="filters.statusTsAt_gte"
            :format="formatDate"
            :language="language"
            placeholder="От"
            id="filter_statusTsAt_gte"
            :shortcuts="datepickerShortcuts"
          >
            <template v-slot:footer="{ emit }">
              <div class="datepicker-footer">
                <button class="btn-datepicker-reset" @click="emit(null)">
                  <svg viewBox="0 0 24 24" width="16" height="16"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" fill="currentColor"/></svg>
                  Сбросить
                </button>
              </div>
            </template>
          </date-picker>
          <span> - </span>
          <date-picker 
            v-model="filters.statusTsAt_lte"
            :format="formatDate"
            :language="language"
            placeholder="До"
            id="filter_statusTsAt_lte"
            :shortcuts="datepickerShortcuts"
          >
            <template v-slot:footer="{ emit }">
              <div class="datepicker-footer">
                <button class="btn-datepicker-reset" @click="emit(null)">
                  <svg viewBox="0 0 24 24" width="16" height="16"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" fill="currentColor"/></svg>
                  Сбросить
                </button>
              </div>
            </template>
          </date-picker>
        </div>
      </div>



      <div class="filter-group" :style="{ order: getFilterOrder('managerComment') }">
        <label for="filter_managerComment">Комментарий оператора:</label>
        <input v-model="filters.managerComment" type="text" id="filter_managerComment" placeholder="Введите комментарий">
      </div>

      <div class="filter-group" v-if="isFilterVisible('customerComment')" :style="{ order: getFilterOrder('customerComment') }">
        <label for="filter_customerComment">Комментарий клиента:</label>
        <input v-model="filters.customerComment" type="text" id="filter_customerComment" placeholder="Введите комментарий">
      </div>

      <div class="filter-group" v-if="isFieldVisible('statusUpdatedAt') && isFilterVisible('statusUpdatedAt')" :style="{ order: getFilterOrder('statusUpdatedAt') }">
        <label for="filter_statusUpdatedAt">Последнее изменение статуса:</label>
        <div class="input_flex">
        <date-picker 
          v-model="filters.statusUpdatedAt_gte"
          :format="formatDate"
          :language="language"
          placeholder="От"
          id="filter_statusUpdatedAt_gte"
          :shortcuts="datepickerShortcuts"
        >
          <template v-slot:footer="{ emit }">
            <div class="datepicker-footer">
              <button class="btn-datepicker-reset" @click="emit(null)">
                <svg viewBox="0 0 24 24" width="16" height="16"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" fill="currentColor"/></svg>
                Сбросить
              </button>
            </div>
          </template>
        </date-picker>
        <span> - </span>
        <date-picker 
          v-model="filters.statusUpdatedAt_lte"
          :format="formatDate"
          :language="language"
          placeholder="До"
          id="filter_statusUpdatedAt_lte"
          :shortcuts="datepickerShortcuts"
        >
          <template v-slot:footer="{ emit }">
            <div class="datepicker-footer">
              <button class="btn-datepicker-reset" @click="emit(null)">
                <svg viewBox="0 0 24 24" width="16" height="16"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" fill="currentColor"/></svg>
                Сбросить
              </button>
            </div>
          </template>
        </date-picker>
        </div>
        </div>

        <div class="filter-group" v-if="canExportOrders && isFilterVisible('datazakazaobrabotki')" :style="{ order: getFilterOrder('datazakazaobrabotki') }">
          <label for="filter_datazakazaobrabotki">Дата обработки заказа:</label>
          <div class="input_flex">
        <date-picker 
          v-model="filters.datazakazaobrabotki_gte"
          :format="formatDate"
          :language="language"
          placeholder="От"
          id="filter_datazakazaobrabotki_gte"
          :shortcuts="datepickerShortcuts"
        >
          <template v-slot:footer="{ emit }">
            <div class="datepicker-footer">
              <button class="btn-datepicker-reset" @click="emit(null)">
                <svg viewBox="0 0 24 24" width="16" height="16"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" fill="currentColor"/></svg>
                Сбросить
              </button>
            </div>
          </template>
        </date-picker>
        <span> - </span>
        <date-picker 
          v-model="filters.datazakazaobrabotki_lte"
          :format="formatDate"
          :language="language"
          placeholder="До"
          id="filter_datazakazaobrabotki_lte"
          :shortcuts="datepickerShortcuts"
        >
          <template v-slot:footer="{ emit }">
            <div class="datepicker-footer">
              <button class="btn-datepicker-reset" @click="emit(null)">
                <svg viewBox="0 0 24 24" width="16" height="16"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" fill="currentColor"/></svg>
                Сбросить
              </button>
            </div>
          </template>
        </date-picker>
          </div>
        </div>

        <div class="filter-group" v-if="isFieldVisible('kasssas') && isFilterVisible('kasssas')" :style="{ order: getFilterOrder('kasssas') }">
          <label for="filter_kasssas">Касса:</label>
          <div class="input_flex">
        <date-picker 
          v-model="filters.kasssas_gte"
          :format="formatDate"
          :language="language"
          placeholder="От"
          id="filter_kasssas_gte"
          :shortcuts="datepickerShortcuts"
        >
          <template v-slot:footer="{ emit }">
            <div class="datepicker-footer">
              <button class="btn-datepicker-reset" @click="emit(null)">
                <svg viewBox="0 0 24 24" width="16" height="16"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" fill="currentColor"/></svg>
                Сбросить
              </button>
            </div>
          </template>
        </date-picker>
        <span> - </span>
        <date-picker 
          v-model="filters.kasssas_lte"
          :format="formatDate"
          :language="language"
          placeholder="До"
          id="filter_kasssas_lte"
          :shortcuts="datepickerShortcuts"
        >
          <template v-slot:footer="{ emit }">
            <div class="datepicker-footer">
              <button class="btn-datepicker-reset" @click="emit(null)">
                <svg viewBox="0 0 24 24" width="16" height="16"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" fill="currentColor"/></svg>
                Сбросить
              </button>
            </div>
          </template>
        </date-picker>
          </div>
        </div>

         <div class="filter-group" v-if="isFilterVisible('sssylkaaaaasssyyylka')" :style="{ order: getFilterOrder('sssylkaaaaasssyyylka') }">
          <label class="control-label" for="filter_customFields_sssylkaaaaasssyyylka">Cсылка на подбор</label>
            <span></span>
            <input type="text" v-model="filters.sssylkaaaaasssyyylka" id="filter_customFields_sssylkaaaaasssyyylka">
          </div>

          <div class="filter-group" v-if="isFilterVisible('vgvgvgv')" :style="{ order: getFilterOrder('vgvgvgv') }">
          <label class="control-label" for="filter_customFields_vgvgvgv">Номер ВГ</label>
            <span></span>
            <input type="text" v-model="filters.vgvgvgv" id="filter_customFields_vgvgvgv">
          </div>

          <div class="filter-group" v-if="isFieldVisible('lkjdhgdhg768') && isFilterVisible('lkjdhgdhg768')" :style="{ order: getFilterOrder('lkjdhgdhg768') }">
          <label class="control-label" for="filter_customFields_lkjdhgdhg768">Номер реестра</label>
            <span></span>
            <input type="text" v-model="filters.lkjdhgdhg768" id="filter_customFields_lkjdhgdhg768">
          </div>

            <div class="filter-group" v-if="isFieldVisible('marssh') && isFilterVisible('marssh')" :style="{ order: getFilterOrder('marssh') }">
          <label class="control-label" for="filter_customFields_marssh" >Маршрутный лист курьер</label>
            <span></span>
            <input type="text" v-model="filters.marssh" id="filter_customFields_marssh">
          </div>

          <div class="filter-group" v-if="isFieldVisible('tegi_dialoga') && isFilterVisible('tegi_dialoga')" :style="{ order: getFilterOrder('tegi_dialoga') }">
          <label class="control-label" for="filter_customFields_tegi_dialoga">Теги диалога</label>
            <span></span>
            <input type="text" v-model="filters.tegi_dialoga" id="filter_customFields_tegi_dialoga">
          </div>

          <div class="filter-group" v-if="isFilterVisible('personal_offer_discount')" :style="{ order: getFilterOrder('personal_offer_discount') }">
            <label for="filter_personal_offer_discount">Товар дня:</label>
            <select v-model="filters.personal_offer_discount" id="filter_personal_offer_discount" class="filter-select">
              <option value="">Любой</option>
              <option value="20">Товар дня (−20%)</option>
            </select>
          </div>

        
      
      <div class="filter__cleared filter__cleared-row" style="order: 9998;">
      <button type="submit" class="apply text">Применить фильтры</button>
      <span v-if="filtersApplied" class="filter-cancel" @click="resetFilters"><span class="ur-hr-no">Сброс</span></span>
      <div class="temp-bk__wrap" v-if="isFieldVisible('fastFilters') || isFieldVisible('fastFiltersControl')">
        <div class="temp-bk" :class="{ collapsed: tempBkCollapsed }">
          <div class="temp-bk__row">
            <button type="button" class="temp-bk__btn-toggle" @click.stop="tempBkCollapsed = !tempBkCollapsed" :aria-label="tempBkCollapsed ? 'Развернуть' : 'Свернуть'"></button>
            <span class="temp-bk__inner-lt" @click="showFilterTemplateEdit = !showFilterTemplateEdit">Редактирование списка</span>
          </div>
          <div class="temp-bk__panel" v-show="showFilterTemplateEdit">
            <div class="temp-bk__list">
              <label v-for="tpl in validFilterTemplates" :key="'edit-' + tpl.id" class="temp-bk__list-item">
                <input type="checkbox" :value="tpl.id" v-model="filterTemplatesToDelete" :id="'template_ids_' + tpl.id">
                <span>{{ tpl.name || '' }}</span>
              </label>
            </div>
            <div class="temp-bk__actions">
              <button type="button" class="temp-bk__btn-delete" @click="deleteSelectedFilterTemplates">Удалить</button>
              <span class="temp-bk__btn-cancel" @click="showFilterTemplateEdit = false">Отмена</span>
              <button type="button" class="temp-bk__btn-save" v-if="hasActiveFilters" @click="saveCurrentFilterAsTemplate">Сохранить фильтр</button>
            </div>
          </div>
        </div>
      </div>
      </div>
      
      <div class="filter-group" style="margin-top: 15px; padding-top: 15px; border-top: 1px solid #e0e0e0; order: 9999;">
        <label style="display: flex; align-items: center; cursor: pointer;">
          <input 
            type="checkbox" 
            v-model="enableStatusStatisticsComputed" 
            :disabled="isLogistForcedStatistics"
            style="margin-right: 8px; cursor: pointer;"
          >
          <span>Подсчитывать количество заказов в статусах</span>
        </label>
      </div>
      </div>
    </form>


    
</div>

     <div class="checkbox-wrapper" :key="checkboxKey">
      <div class="custom_filter t" v-if="isFieldVisible('fastFilters') && validFilterTemplates.length === 0" >

      <input 
        type="checkbox" 
        id="orderdayCheckbox" 
        class="switch" 
        :checked="predefinedFilter === 'orderday'" 
        @change="applyPredefinedFilter('orderday')"
      >
      <label for="orderdayCheckbox">Сегодня + менеджер</label>


      <input 
      type="checkbox" 
      id="karvataCheckbox" 
      class="switch" 
      :checked="predefinedFilter === 'karvata'" 
      @change="applyPredefinedFilter('karvata')"
    >
    <label for="karvataCheckbox">Срез + менеджер</label>

    <input 
      type="checkbox" 
      id="minskCheckbox" 
      class="switch" 
      :checked="predefinedFilter === 'minsk'" 
      @change="applyPredefinedFilter('minsk')"
    >
    <label for="minskCheckbox">Конс + менеджер</label>

    <input 
      type="checkbox" 
      id="ourStoresCheckbox" 
      class="switch" 
      :checked="predefinedFilter === 'ourStores'" 
      @change="applyPredefinedFilter('ourStores')"
    >
    <label for="ourStoresCheckbox">Самовывоз + менеджер</label>


     <input 
      type="checkbox" 
      id="ourPrependCheckbox" 
      class="switch" 
      :checked="predefinedFilter === 'ourPrepend'" 
      @change="applyPredefinedFilter('ourPrepend')"
    >
    <label for="ourPrependCheckbox">Отложенные + менеджер</label>
      </div>


    <div class="custom_filter t" v-if="isFieldVisible('fastFiltersControl') && validFilterTemplates.length === 0" >
        <input 
          type="checkbox" 
          id="vgg" 
          class="switch" 
          :checked="predefinedFilter === 'vgg'" 
          @change="applyPredefinedFilter('vgg')"
        >
        <label for="vgg">Только Возим</label>

        <input 
          type="checkbox" 
          id="konverse" 
          class="switch" 
          :checked="predefinedFilter === 'konverse'" 
          @change="applyPredefinedFilter('konverse')"
        >
        <label for="konverse">Конверсия чатов</label>

        <input 
          type="checkbox" 
          id="oplataVozim" 
          class="switch" 
          :checked="predefinedFilter === 'oplataVozim'" 
          @change="applyPredefinedFilter('oplataVozim')"
        >
        <label for="oplataVozim">Оплаты возим</label>

        <input 
          type="checkbox" 
          id="lomVozim" 
          class="switch" 
          :checked="predefinedFilter === 'lomVozim'" 
          @change="applyPredefinedFilter('lomVozim')"
        >
        <label for="lomVozim">ЛОМ возимбай</label>



    </div>

    <div class="custom_filter t custom_filter_templates" v-if="(isFieldVisible('fastFilters') || isFieldVisible('fastFiltersControl')) && validFilterTemplates.length > 0">
      <span v-for="tpl in validFilterTemplates" :key="tpl.id" class="custom_filter_templates-item">
        <input
          type="checkbox"
          :id="'tplFilter_' + tpl.id"
          class="switch"
          :checked="activeFilterTemplateId === tpl.id"
          @change="toggleFilterTemplate(tpl)"
        >
        <label :for="'tplFilter_' + tpl.id">{{ tpl.name || '' }}</label>
      </span>
    </div>
    
     

 <div class="items-per-page-selector">
      <label for="itemsPerPage">Показывать по:</label>
      <select id="itemsPerPage" v-model="perPage" @change="updateItemsPerPage">
        <option value="20">20</option>
        <option value="50">50</option>
        <option value="100">100</option>
      </select>
    </div>
    </div>




    </div>
    

   <div class="container">
   <div class="m-box">
   <div class="modern-table-wrap">

   <!-- Статус-бар -->
    <div :class="{'status-bar': true, 'close': isClosed}" >
      <div class="closed status-bar_closed" @click="toggleStatusBar">
        <svg class="open-icon">
            <use xlink:href="/build/icons.ce3e0f0c.svg#burger-bold"></use>
        </svg>
        <span class="open-text">Статусы</span>
      </div>

      <div class="opened" v-if="statusBarOpened">
        <div class="roll-up gray fs11" @click="toggleStatusBar">← <span class="ur-hr-no">Свернуть</span></div>
        <div class="status-bar-list multiple-select">
          <ul>
            <li class="all" :class="{ active: isAllStatusesActive }" @click="selectAllStatuses">
              <a href="javascript:void(0);"><span>Все</span></a>
              <!-- Кнопка "Применить" рядом со "Все", если выбрано "все" -->
              <div
              v-if="lastSelectedStatus === 'all' && showApplyButton"
              id="apply-button"
              @click.stop=""
              style="display: inline-block; margin-left: 10px;"
            >
              <button type="button" class="btn apply" @click.stop="applyStatuses">Применить</button>
            </div>
            </li>
          </ul>

          <div v-for="(group, groupName) in sortedGroupedStatuses" :key="groupName">
    <ul :class="`custom-status-color-${group.color} status-bar-group`">
      <li 
  :class="[
    group.color,
    'status-bar-subheader',
    { selected: group.statuses.every(status => selectedStatuses.includes(status.id)) }
  ]"
  @click="toggleGroup(groupName)"
>
  <a href="javascript:void(0);">
    <span>{{ getStatusGrop(groupName) }}</span>&nbsp;
    <span class="orders-count">
      <span v-if="loadingStatusStatistics" class="status-count-loader"></span>
      <span v-else>{{ getGroupCount(groupName) }}</span>
    </span>
  </a>
</li>

     <li v-for="status in group.statuses"
      :key="status.id"
      :data-data="status.id"
      :class="[{ [status.color]: true }, { selected: selectedStatuses.includes(status.id) }]"
      @click="toggleStatus(status.id)">
    <a href="javascript:void(0);" class="no-italic">
      <span>{{ status.name }}</span>&nbsp;
      <span class="orders-count">
        <span v-if="loadingStatusStatistics" class="status-count-loader"></span>
        <span v-else>{{ getStatusCount(status.code, group.color) }}</span>
      </span>
    </a>
    <div v-if="lastSelectedStatus === status.id && showApplyButton" id="apply-button" @click.stop="">
      <button type="button" class="btn apply" @click.stop="applyStatuses">Применить</button>
    </div>
  </li>
    </ul>
  </div>

        </div>
      </div>
    </div>




 


   <div class="modern-table-container" style="position:relative">
    <!-- Таблица заказов -->
            <LoaderTable v-if="loading"/>

            <!-- Таблица заказов -->
            <table v-if="!loading" class="modern-table list js-order-list batch-tbl">
      <thead>
        <tr>
          <th>
          <div style="display:flex; align-items:center;">
          <input
            type="checkbox"
            :checked="isAllSelected"
            @change="toggleSelectAll"
            style="margin-left:5px"
          />
             <span @click="openTableSettings" title="Настройки таблицы" style="cursor:pointer; margin-left:8px; font-size:16px;">⚙️</span>
          </div>
        </th>
        <th v-for="col in visibleTableColumns" :key="col.key" 
            :class="{ 'sortable': isSortableColumn(col.key), 'sorted': sortField === col.key }"
            @click="isSortableColumn(col.key) ? toggleSort(col.key) : null"
            @dblclick="isSortableColumn(col.key) ? clearSort() : null"
            :style="(col.style || '') + (isSortableColumn(col.key) ? ' cursor: pointer; user-select: none; position: relative;' : '')"
            :title="isSortableColumn(col.key) ? 'Клик - сортировка, двойной клик - сброс' : ''">
          {{ col.label }}
          <span v-if="isSortableColumn(col.key) && sortField === col.key" class="sort-indicator">
            {{ sortDirection === 'asc' ? '↑' : '↓' }}
          </span>
          <span v-if="isSortableColumn(col.key) && sortField === col.key" 
                @click.stop.prevent="clearSort()" 
                class="clear-sort" 
                title="Сбросить сортировку"
                style="margin-left: 5px; cursor: pointer; color: #999; font-size: 12px;">✕</span>
        </th>
        </tr>
      </thead>
      
    
    <!-- Сама таблица заказов -->
    <tbody>
        <tr
          v-for="(order, index) in sortedOrders"
          :key="order.id"
          class="order-row-go-edit"
          @click="onOrderRowClick($event, order)"
        >
          <td style="text-align: center;" @click.stop>
            <input
              type="checkbox"
              :value="order.id"
              v-model="selectedOrders"
              @click="onOrderCheckboxClick($event, index)"
            />
          </td>
          <td v-for="col in visibleTableColumns" :key="col.key" :style="col.style || ''">
              <template v-if="col.key === 'createdAt'">{{ getCurDat(order.createdAt) }}</template>
              <template v-else-if="col.key === 'number'">
                  <span
                    v-if="isLogist"
                    class="clickable tr-link important-flag__link"
                    role="button"
                    tabindex="0"
                    @click.stop="handleOrderLinkClick($event, order)"
                    @keydown.enter.stop.prevent="handleOrderLinkClick($event, order)"
                    @keydown.space.stop.prevent="handleOrderLinkClick($event, order)"
                  >
                    {{ order.number}}
                  </span>
                  <router-link
                    v-else
                    class="clickable tr-link important-flag__link"
                    :to="{ name: 'OrderEdit', params: { orderId: order.id, site: order.site } }"
                    @click.native.stop="handleOrderLinkClick($event, order)"
                  >
                    {{ order.number}}
                  </router-link>
              </template>
              <template v-else-if="col.key === 'copyNumber'">
      <button @click.stop="copyOrderNumber(order)" class="copy-btn" style="position: relative;">
        <i class="fa fa-copy">
          <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 2048 2048">
            <path d="M416 0h979v1l31 4 22 6 21 9 16 9 16 12 10 9 13 13 12 16 11 19 9 21 5 18 3 17 1 12v133h129l22 2 15 3 17 5 18 8 18 10 17 13 13 12 10 11 10 14 9 15 7 15 6 17 5 22 2 21v1406l-2 19-4 20-6 18-7 16-13 21-13 16-16 16-19 14-20 11-20 8-15 4-17 3-12 1H711l-21-2-20-5-19-7-16-8-16-10-13-11-11-10-7-8-9-11-12-19-9-19-6-18-4-20-2-20v-129H420l-23-2-20-4-20-7-19-9-11-7-16-12-15-14-7-8-10-13-9-15-8-16-6-16-5-21-2-15-1-26V177l1-18 3-19 6-21 6-15 10-19 12-17 11-12 14-14 15-11 15-9 14-7 24-8 15-3 22-3zm10 94-16 1-13 3-16 8-9 6-8 7-10 13-7 14-4 13-1 6-1 1399 1 16 4 16 8 16 8 11 8 8 13 9 10 5 14 4 8 1 117 1h717l151-1 11-2 12-4 15-8 11-9 8-9 8-13 5-13 2-9 1-10V169l-3-16-5-13-7-12-11-12-8-7-14-8-15-5-5-1-21-1zm1139 298-1 1187-2 19-5 21-7 19-11 21-8 12-11 13-7 8-11 10-17 12-14 8-15 7-18 6-18 4-15 2-44 1H640l-1 1v132l2 11 4 12 7 13 7 9 10 10 12 8 11 5 17 4 13 1h936l42-1 16-4 16-8 10-7 11-11 7-11 6-13 3-11 1-7V465l-3-16-7-16-7-11-13-13-11-7-10-5-13-4-6-1z"></path>
          </svg>
        </i>
        <div v-if="copiedId === order.id" class="tooltips">
        <i class="fa fa-check"></i> Скопировано!
        <div class="tooltips-arrow"></div>
      </div>
      </button>
              </template>
              <template v-else-if="col.key === 'manager'">{{ getManager(null, order) }}</template>
              <template v-else-if="col.key === 'seller'">{{ getSeller(order.customFields.prodavec) }}</template>
              <template v-else-if="col.key === 'deliveryDate'">{{ getCurDatDostavka(order.delivery.date) }}</template>
              <template v-else-if="col.key === 'deliveryType'">{{getDeliveryName(order.delivery.code)}}</template>
              <template v-else-if="col.key === 'city'">{{ order.delivery && order.delivery.address && !Array.isArray(order.delivery.address) ? order.delivery.address.city : '' }}</template>
              <template v-else-if="col.key === 'status'">
            <div class="status-comment-wrap status-comment-wrap_orders">
              <div class="list-status-comment"  v-if="order.statusComment" >
                  <div class="message-indic small" @click.stop="togglePopupStatus(index)">
                      <div class="popup-comment-box down" v-if="activeIndex === index">
                          <div class="comment-info">
                              <div class="comment-text fs12 lh18 black">
                                  {{order.statusComment}}
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
               <div :class="`bill cleared mr10 ${getStatusGroupClass(order.status)}`" :style="{ backgroundColor: getStatusColor(order.status) }">
                <span class="img-st"></span>
                <span class="bill__title">{{ getStatusName(order.status) }}</span>
            </div>
                  </div>
              </template>
              <template v-else-if="col.key === 'customer'">
                <span>
                  {{
                    (order.lastName ? order.lastName + ' ' : '') +
                    (order.firstName || '') +
                    (order.patronymic ? ' ' + order.patronymic : '')
                  }}
                </span>
              </template>
              <template v-else-if="col.key === 'phone'">
            <div class="numbe">
              <div class="call-button" @click.stop="makeCall(order.phone)"></div>
              <p v-if="order.phone">
                <span>{{order.phone}}</span>
              </p>
            </div>
              </template>
              <template v-else-if="col.key === 'copyPhone'">
                <button @click.stop="copyNumberClient(order)" class="copy-btn" style="position: relative;">
                  <i class="fa fa-copy">
                    <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 2048 2048">
                      <path d="M416 0h979v1l31 4 22 6 21 9 16 9 16 12 10 9 13 13 12 16 11 19 9 21 5 18 3 17 1 12v133h129l22 2 15 3 17 5 18 8 18 10 17 13 13 12 10 11 10 14 9 15 7 15 6 17 5 22 2 21v1406l-2 19-4 20-6 18-7 16-13 21-13 16-16 16-19 14-20 11-20 8-15 4-17 3-12 1H711l-21-2-20-5-19-7-16-8-16-10-13-11-11-10-7-8-9-11-12-19-9-19-6-18-4-20-2-20v-129H420l-23-2-20-4-20-7-19-9-11-7-16-12-15-14-7-8-10-13-9-15-8-16-6-16-5-21-2-15-1-26V177l1-18 3-19 6-21 6-15 10-19 12-17 11-12 14-14 15-11 15-9 14-7 24-8 15-3 22-3zm10 94-16 1-13 3-16 8-9 6-8 7-10 13-7 14-4 13-1 6-1 1399 1 16 4 16 8 16 8 11 8 8 13 9 10 5 14 4 8 1 117 1h717l151-1 11-2 12-4 15-8 11-9 8-9 8-13 5-13 2-9 1-10V169l-3-16-5-13-7-12-11-12-8-7-14-8-15-5-5-1-21-1zm1139 298-1 1187-2 19-5 21-7 19-11 21-8 12-11 13-7 8-11 10-17 12-14 8-15 7-18 6-18 4-15 2-44 1H640l-1 1v132l2 11 4 12 7 13 7 9 10 10 12 8 11 5 17 4 13 1h936l42-1 16-4 16-8 10-7 11-11 7-11 6-13 3-11 1-7V465l-3-16-7-16-7-11-13-13-11-7-10-5-13-4-6-1z"></path>
                    </svg>
                  </i>
                  <div v-if="copiedId === order.phone" class="tooltips">
                  <i class="fa fa-check"></i> Скопировано!
                  <div class="tooltips-arrow"></div>
                </div>
                </button>
              </template>
              <template v-else-if="col.key === 'items'">
                <ul class="list-order-products">
                  <li v-for="(item, index) in order.items" :key="index">
                    {{ (item.offer && (item.offer.name || item.offer.displayName)) || item.productName || '—' }}&nbsp;—&nbsp;
                    <span class="order-price__value order-price__value_column">
                      <span class="discounted-price">{{ getOrderItemDisplayPrice(item) }}&nbsp;<span class="currency-symbol byn">руб.</span></span>
                      <span v-if="hasOrderItemDiscount(item)" class="original-price">{{ getOrderItemOriginalPrice(item) }}&nbsp;<span class="currency-symbol byn">руб.</span></span>
                    </span>
                    ,&nbsp;{{ item.quantity || 1 }}&nbsp;шт.
                  </li>
                </ul>
              </template>
              <template v-else-if="col.key === 'amount'"><span style="font-weight: bold;">{{ order.totalSumm}} руб.</span></template>
              <template v-else-if="col.key === 'orderDiscount'">{{ getOrderTotalDiscount(order).toFixed(2) }} руб.</template>
              <template v-else-if="col.key === 'bonus'">{{ order.customFields.dfhgodsf8g7 }}</template>
              <template v-else-if="col.key === 'shipped'">
                <span v-if="isOrderShipped(order)" class="icon-ok"></span>
              </template>
              <template v-else-if="col.key === 'amountToPay'">
                <span style="font-weight: bold;">{{ formatCurrency(getAmountToPay(order)) }}</span>
              </template>
              <template v-else-if="col.key === 'deliveryTime'">
                <span v-if="order.delivery && order.delivery.time">
                  {{ order.delivery.time.from || '' }}{{ order.delivery.time.from && order.delivery.time.to ? ' - ' : '' }}{{ order.delivery.time.to || '' }}
                </span>
              </template>
              <template v-else-if="col.key === 'deliveryAddress'">
                <span v-if="order.delivery && order.delivery.address && !Array.isArray(order.delivery.address)">
                  <span v-if="order.delivery.address.region">
                    {{ order.delivery.address.region }}{{ order.delivery.address.city || order.delivery.address.text || order.delivery.address.street ? ', ' : '' }}
                  </span>
                  <span v-if="order.delivery.address.city">{{ order.delivery.address.city }}{{ order.delivery.address.text || order.delivery.address.street ? ', ' : '' }}</span>
                  <span v-if="order.delivery.address.text">{{ order.delivery.address.text }}</span>
                  <span v-else>
                    <span v-if="order.delivery.address.street">{{ order.delivery.address.street }}</span>
                    <span v-if="order.delivery.address.building">, д. {{ order.delivery.address.building }}</span>
                    <span v-if="order.delivery.address.flat">, кв. {{ order.delivery.address.flat }}</span>
                  </span>
                </span>
              </template>
              <template v-else-if="col.key === 'paymentType'">
                <div v-if="order.payments">
                  <template v-if="Array.isArray(order.payments) && order.payments.length > 0">
                    <div v-for="(payment, index) in order.payments" :key="index" style="margin-bottom: 2px;">
                      <span>
                        {{ formatCurrency(payment.amount || 0) }} - {{ getPaymentTypeName(payment.type) }}
                      </span>
                    </div>
                  </template>
                  <template v-else-if="typeof order.payments === 'object' && Object.keys(order.payments).length > 0">
                    <div v-for="(payment, index) in Object.values(order.payments)" :key="index" style="margin-bottom: 2px;">
                      <span>
                        {{ formatCurrency(payment.amount || 0) }} - {{ getPaymentTypeName(payment.type) }}
                      </span>
                    </div>
                  </template>
                </div>
                <span v-else-if="order.paymentType">
                  {{ getPaymentTypeName(order.paymentType) }}
                </span>
              </template>
              <template v-else-if="col.key === 'paymentStatus'">
                <div v-if="isOrderPaid(order)" class="pay-status ml10 payed" title="Оплачен"></div>
                <div v-else-if="isOrderPartiallyPaid(order)" class="pay-status ml10 partial" title="Частичная оплата"></div>
                <div v-else class="pay-status ml10 wait" title="Ожидает"></div>
              </template>
              <template v-else-if="col.key === 'tradeInAmountNew'">
                <span v-if="order.customFields && order.customFields.dfgfdddfnew != null && String(order.customFields.dfgfdddfnew).trim() !== ''">
                  {{ formatCurrency(parseFloat(order.customFields.dfgfdddfnew) || 0) }}
                </span>
              </template>
              <template v-else-if="col.key === 'batteryCapacity'">
                {{ order.customFields && order.customFields.slksdkk2j3iu3nnew ? order.customFields.slksdkk2j3iu3nnew : '' }}
              </template>
              <template v-else-if="col.key === 'operatorComment'">
                {{ order.managerComment || '' }}
              </template>
              <template v-else-if="col.key === 'visitor_code'">
                {{ order.customFields && order.customFields.visitor_code ? order.customFields.visitor_code : '' }}
              </template>
              <template v-else-if="col.key === 'visitor_city'">
                {{ order.customFields && order.customFields.visitor_city ? order.customFields.visitor_city : '' }}
              </template>
              <template v-else-if="col.key === 'personal_offer_discount'">
                {{ order.customFields && order.customFields.personal_offer_discount != null && order.customFields.personal_offer_discount !== ''
                  ? (order.customFields.personal_offer_discount + '%')
                  : '' }}
              </template>
              <template v-else-if="col.key === 'courier'">
                <span v-if="order.delivery && order.delivery.data && order.delivery.data.courierId">
                  {{ getCourierName(order.delivery.data.courierId) }}
                </span>
                <span v-else-if="order.delivery && order.delivery.courierId">
                  {{ getCourierName(order.delivery.courierId) }}
                </span>
              </template>
              <template v-else-if="col.key === 'courierRouteSheet'">
                {{ order.customFields && order.customFields.marssh ? order.customFields.marssh : '' }}
              </template>
              <template v-else-if="col.key === 'vgNumber'">
                {{ order.customFields && order.customFields.vgvgvgv ? order.customFields.vgvgvgv : '' }}
              </template>
              <template v-else-if="col.key === 'deliveryStatus'">
                <span v-if="order.delivery && order.delivery.status">{{ getDeliveryStatusName(order.delivery.status) }}</span>
              </template>
              <template v-else-if="col.key === 'statusUpdatedAt'">{{ getCurDat(order.statusUpdatedAt) }}</template>
              <template v-else-if="col.key === 'dataSoglasovaniia'">
                {{ getCurDat(order.customFields && order.customFields.data_soglasovaniia1) }}
              </template>
              <template v-else-if="col.key === 'paymentSum'">
                <span v-if="order.prepaySum">{{ formatCurrency(parseFloat(order.prepaySum) || 0) }}</span>
                <span v-else-if="order.payments">
                  <span v-if="Array.isArray(order.payments)">
                    {{ formatCurrency(order.payments.reduce((sum, p) => sum + (parseFloat(p.amount) || 0), 0)) }}
                  </span>
                  <span v-else-if="typeof order.payments === 'object' && Object.keys(order.payments).length > 0">
                    {{ formatCurrency(Object.values(order.payments).reduce((sum, p) => sum + (parseFloat(p.amount) || 0), 0)) }}
                  </span>
                </span>
                <span v-else>{{ formatCurrency(0) }}</span>
              </template>
              <template v-else-if="col.key === 'cashbox'">
                {{ order.customFields && order.customFields.kasssas ? order.customFields.kasssas : '' }}
              </template>
              <template v-else-if="col.key === 'orderMethod'">
                <span v-if="order.orderMethod && typeof order.orderMethod === 'object'">
                  {{ order.orderMethod.label || order.orderMethod.value || '' }}
                </span>
                <span v-else-if="order.orderMethod">
                  {{ getOrderMethodName(order.orderMethod) }}
                </span>
              </template>
              <template v-else-if="col.key === 'orderCorrection'">
                {{ order.customFields && order.customFields.sf_num ? order.customFields.sf_num : '' }}
              </template>
              <template v-else-if="col.key === 'carBrand'">
                {{ order.customFields && order.customFields.marka_podbor ? order.customFields.marka_podbor : '' }}
              </template>
              <template v-else-if="col.key === 'carModel'">
                {{ order.customFields && order.customFields.model_podborts ? order.customFields.model_podborts : '' }}
              </template>
              <template v-else-if="col.key === 'lkjdhgdhg768'">
                {{ (order.customFields && order.customFields.lkjdhgdhg768) || order.lkjdhgdhg768 || '' }}
              </template>
              <template v-else-if="col.key === 'tegi_dialoga'">
                <span
                  v-if="order.customFields && order.customFields.tegi_dialoga"
                  :title="order.customFields.tegi_dialoga"
                  class="table-cell-truncate"
                >
                  {{ order.customFields.tegi_dialoga }}
                </span>
              </template>
              <template v-else-if="col.key === 'zvonok_text_bot'">
                <span
                  v-if="order.customFields && order.customFields.zvonok_text_bot"
                  :title="order.customFields.zvonok_text_bot"
                  class="table-cell-truncate"
                >
                  {{ order.customFields.zvonok_text_bot }}
                </span>
              </template>
          </td>
          <!--<td style="max-width: 80px !important;"><p v-if="order.customFields.sssylkaaaaasssyyylka"><a target="_blank" :href="order.customFields.sssylkaaaaasssyyylka">{{ order.customFields.sssylkaaaaasssyyylka }}</a></p></td>-->
        </tr>
      </tbody>
    </table>

<!-- Batch actions bar -->
<div class="batch-box" :style="{ display: selectedOrders.length > 0 ? 'block' : 'none' }">
    <div class="wrapper">
        <input
            type="checkbox"
            :checked="selectedOrders.length > 0"
            @change="handleBatchCheckboxChange"
            style="margin-right: 10px; cursor: pointer;"
        />
        <div class="elements-count">Выделен {{ selectedOrders.length }} {{ getElementWord(selectedOrders.length) }}</div>
        
        <span class="dropdown tiny-dropdown dropdown-up up" ref="batchMenuContainer">
            <button type="button" class="batch-actions white small btn up-icon" @click="toggleBatchMenu">Действия</button>
            <div class="ul-scroll-dropdown-wrapper batch-menu" ref="batchMenu" :style="{ display: showBatchMenu ? 'block' : 'none', height: 'auto', maxHeight: '500px', overflowY: 'auto' }">
                <ul class="left-list" style="display: block;">
                    <li class="with-list">
                        <a href="javascript:void(0);" @click="showSubmenu($event, 'customFields')">
                            Изменить пользовательское поле
                            <div class="batch_popup_warning" style="display: none;">
                                Для&nbsp;первых&nbsp;100&nbsp;заказов
                            </div>
                        </a>
                        <div class="drop save_batch no-pjax" 
                             v-if="activeSubmenu === 'customFields'"
                             :style="{ 
                                 left: submenuPosition.left + 'px',
                                 top: submenuPosition.top + 'px',
                                 bottom: submenuPosition.bottom
                             }">
                            <ul class="scroll-x options__custom-fields" style="display: block;">
                                <template v-for="(field, index) in customFieldsList">
                                    <li v-if="index === 0 || customFieldsList[index - 1].group !== field.group" 
                                        class="group custom" 
                                        :class="{ 'even': index % 2 === 0, 'odd': index % 2 !== 0 }"
                                        :key="'group-' + field.group">
                                        <div class="icon">{{ field.group }}</div>
                                    </li>
                                    <li class="button change-batch-custom-field" 
                                        :class="{ 'even': index % 2 === 0, 'odd': index % 2 !== 0 }"
                                        :data-field-code="field.code"
                                        :key="'field-' + field.code">
                                        <a href="javascript:void(0);" 
                                           class="as-form"
                                           @click="openCustomFieldModal(field)">
                                            {{ field.name }}
                                        </a>
                                    </li>
                                </template>
                            </ul>
                        </div>
                    </li>
                    
                    <li class="with-list">
                        <a href="javascript:void(0);" @click="showSubmenu($event, 'payment')">
                            Сменить статус оплаты
                            <div class="batch_popup_warning" data-count="100" style="display: none;">
                                Для&nbsp;первых&nbsp;100&nbsp;заказов
                            </div>
                        </a>
                        <div class="drop save_batch no-pjax" 
                             v-if="activeSubmenu === 'payment'"
                             :style="{ 
                                 left: submenuPosition.left + 'px',
                                 top: submenuPosition.top + 'px',
                                 bottom: submenuPosition.bottom
                             }">
                            <ul class="scroll-x border" style="display: block;">
                                <li v-for="status in paymentStatuses" :key="status.id">
                                    <a href="javascript:void(0);" @click="batchChangePaymentStatus(status.id)">{{ status.name }}</a>
                                </li>
                            </ul>
                        </div>
                    </li>
                    
                    <li class="button">
                        <a href="javascript:void(0);" @click="batchShip">
                            Отгрузить
                            <div class="batch_popup_warning" data-count="100" style="display: none;">Для&nbsp;первых&nbsp;100&nbsp;заказов</div>
                        </a>
                    </li>
                    
                    <li>
                        <a href="javascript:void(0);" @click="showSubmenu($event, 'courier')">
                            Сменить курьера
                            <div class="batch_popup_warning" data-count="100" style="display: none;">
                                Для&nbsp;первых&nbsp;100&nbsp;заказов
                            </div>
                        </a>
                        <div class="drop save_batch no-pjax" 
                             v-if="activeSubmenu === 'courier'"
                             :style="{ 
                                 left: submenuPosition.left + 'px',
                                 top: submenuPosition.top + 'px',
                                 bottom: submenuPosition.bottom
                             }">
                            <ul class="scroll-x border" style="display: block;">
                                <li v-for="courier in couriersList" :key="courier.value || courier.id">
                                    <a href="javascript:void(0);" @click="batchChangeCourier(courier.value)">{{ courier.label }}</a>
                                </li>
                            </ul>
                        </div>
                    </li>
                    
                    <li class="with-list">
                        <a href="javascript:void(0);" @click="showSubmenu($event, 'print')">
                            Распечатать документы
                            <div class="batch_popup_warning" data-count="50" style="display: none;">
                                Для&nbsp;первых&nbsp;50&nbsp;заказов
                            </div>
                        </a>
                        <div class="drop save_batch no-pjax" 
                             v-if="activeSubmenu === 'print'"
                             :style="{ 
                                 left: submenuPosition.left + 'px',
                                 top: submenuPosition.top + 'px',
                                 bottom: submenuPosition.bottom
                             }">
                            <ul class="scroll-x border" style="display: block;">
                                <li v-for="template in printTemplates" :key="template.id" :class="template.disabled ? 'disabled' : ''">
                                    <a v-if="!template.disabled" href="javascript:void(0);" @click="batchPrint(template.id)">{{ template.name }}</a>
                                    <div v-else>{{ template.name }}</div>
                                </li>
                            </ul>
                        </div>
                    </li>
                    
                    <li class="with-list">
                        <a href="javascript:void(0);" @click="showSubmenu($event, 'status')">
                            Сменить статус
                            <div class="batch_popup_warning" data-count="10000000" style="display: none;">
                                Для&nbsp;первых&nbsp;10000000&nbsp;заказов
                            </div>
                        </a>
                        <div class="drop save_batch no-pjax batch-status-dropdown" 
                             v-if="activeSubmenu === 'status'"
                             :style="{ 
                                 left: submenuPosition.left + 'px',
                                 top: submenuPosition.top + 'px',
                                 bottom: submenuPosition.bottom
                             }">
                            <div style="max-height: calc(100vh - 150px); overflow-y: auto;">
                                <template v-if="sortedGroupedStatusesForBatchChange && Object.keys(sortedGroupedStatusesForBatchChange).length > 0">
                                    <div v-for="(group, groupName) in sortedGroupedStatusesForBatchChange" :key="'group-' + groupName">
                                        <div class="batch-status-group-header" :style="{ backgroundColor: getStatusGroupColor(group.color || groupName) }">
                                            {{ getStatusGrop(groupName) }}
                                        </div>
                                        <ul class="scroll-x border" 
                                            style="display: block;"
                                            :style="{ '--group-bg-color': getStatusGroupColor(group.color || groupName) }">
                                            <li v-for="status in (group.statuses || [])" 
                                                :key="status.code || status.id"
                                                :class="[status.color || groupName || 'default']"
                                                class="batch-status-item"
                                                :style="{ backgroundColor: getStatusGroupColor(group.color || groupName) }">
                                                <a href="javascript:void(0);" @click="openBatchStatusModal(status.code || status.id, status.name)">
                                                    {{ status.name }}
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </template>
                                <ul v-else class="scroll-x border" style="display: block;">
                                    <li v-for="status in allStatusesList" :key="status.code">
                                        <a href="javascript:void(0);" @click="openBatchStatusModal(status.code, status.name)">{{ status.name }}</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </li>
                    
                    <li v-if="isManagementRole" class="button">
                        <a href="javascript:void(0);" @click="batchBonusReload">
                            Прогрузка бонуса
                        </a>
                    </li>

                    <li class="button">
                        <a href="javascript:void(0);" @click="batchCancelDelivery">
                            Отменить доставку
                            <div class="batch_popup_warning" data-count="20" style="display: none;"></div>
                        </a>
                    </li>
                </ul>
            </div>
        </span>
    </div>
</div>








<!-- Экспорт: Модальное окно -->
<div v-if="showExportModal && canExportOrders" class="export-modal-overlay">
  <div class="export-modal-window" style="min-width: 520px;">

    <div class="manExport">
      <h3 class="export-modal-title">Экспорт: выберите и отсортируйте столбцы</h3>
      <div class="closeManExport" @click="closeExportModal"><svg data-v-193e795c="" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="omnica-popper-target" style="width: 100%;"><path data-v-193e795c="" d="M7.113 6.176a.6.6 0 01.848 0L12 10.214l4.038-4.038a.6.6 0 01.849 0l.937.937a.6.6 0 010 .848L13.785 12l4.04 4.04a.6.6 0 010 .848l-.937.937a.6.6 0 01-.849 0L12 13.784l-4.038 4.04a.6.6 0 01-.849 0l-.937-.937a.6.6 0 010-.848l4.04-4.04-4.039-4.038a.6.6 0 010-.849l.937-.936z" fill="currentColor"></path></svg></div>
    </div>

    <div class="export-block-titl">

    <div class="export-modal-section">
      <!-- <label>Шаблон:</label> -->
      <select v-model="selectedTemplate" @change="applyTemplate" class="export-modal-select">
        <option :value="null">-- Применить шаблон --</option>
        <option v-for="tpl in exportTemplates" :key="tpl.id" :value="tpl.name">{{ tpl.name }}</option>
      </select>
      <button
        v-if="selectedTemplate && !editingTemplateId"
        @click="editTemplate(exportTemplates.find(t=>t.name===selectedTemplate))"
        style="margin-left:10px; color:#007bff"
        title="Редактировать шаблон"
      >Редактировать</button>
      <button
        v-if="selectedTemplate && !editingTemplateId"
        @click="deleteExportTemplate(exportTemplates.find(t=>t.name===selectedTemplate))"
        style="margin-left:10px; color:#dc3545"
        title="Удалить шаблон"
      >Удалить</button>
    </div>

    <div class="newTemplat" style="margin-left:auto">
      <input 
        v-model="newTemplateName" 
        :placeholder="editingTemplateId ? 'Название шаблона (можно изменить)' : 'Название нового шаблона'" 
        style="padding:4px;"
      />
      <button 
        v-if="editingTemplateId"
        @click="updateExportTemplate" 
        :disabled="!newTemplateName || !selectedColumnKeys.length"
        style="background-color:#28a745; color:white;"
      >Сохранить изменения</button>
      <button 
        v-else
        @click="saveExportTemplate" 
        :disabled="!newTemplateName || !selectedColumnKeys.length"
      >Сохранить шаблон</button>
      <button
        v-if="editingTemplateId"
        @click="cancelEditTemplate"
        style="margin-left:10px;"
      >Отмена</button>
    </div>

    </div>

      <div class="modal_grid">


            <!-- Правая колонка: выбранные (можно сортировать dnd) -->
      <div class="export-modal-selected">
        <div style="font-weight: 600; margin-bottom: 6px;">Выгружаемые поля:</div>
        


        <!-- <draggable
          v-model="selectedColumns"
          :options="{handle:'.drag-handle', animation:180}"
          @end="onColumnsSorted"
          class="draggable-list"
        >
          <div v-if="!selectedColumns.length" style="color:#aaa; font-size:13px; padding:12px 0;">
            Нет выбранных столбцов
          </div>
          <div v-for="col in selectedColumns" :key="col.key" class="draggable-row">
            <span class="drag-handle" title="Перетащить" style="font-size:18px;">≡</span>
            <span style="flex:1;">{{ col.label }}</span>
            <span style="margin-left:7px; color:#dc3545; cursor:pointer;" @click="removeSelectedColumn(col.key)">✖</span>
          </div>
        </draggable> -->

        <draggable
              v-model="selectedColumns"
              @end="onDragEnd"
              :options="{animation:180}"
            >
              <div v-for="item in selectedColumns" :key="item.id" class="itemSel">
                <div class="itemsSelect">
                  <span>{{ item.label }}</span>
                  <span class="delitem" @click="removeSelectedColumn(item.key)">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="#AFB9C3" fill-rule="evenodd" d="M20 5.5v-1a.5.5 0 0 0-.5-.5H15V3a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v1H4.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h15a.5.5 0 0 0 .5-.5Zm-4.662 14.64a1 1 0 0 0 .998-.94L17 8h2l-.85 12.14a2 2 0 0 1-2 1.86H7.87a2 2 0 0 1-2-1.86L5 8h2l.664 11.2a1 1 0 0 0 .998.94h6.676Z" clip-rule="evenodd"/></svg>
                  </span>
                </div>
              </div>
            </draggable>

        <div style="margin-top:8px; color:#666; font-size:12px;">
          <span>Перетащите для сортировки. Крестик убирает колонку.</span>
        </div>
      </div>


      <div class="export-modal-columns">
        <div style="font-weight: 600; margin-bottom: 6px;">Доступные столбцы:</div>
        <div class="export-modal-checkboxes">
<div v-for="[groupName, columns] in sortedGroups" :key="groupName" class="groupBlcok">

  <div v-if="groupName !== 'Другие'">

    <p>{{ groupName }}</p>
    <div class="groupCheck">
      <div v-for="col in columns" :key="col.key" class="groupCheckBlock">
        <label>
          <input
            type="checkbox"
            :value="col.key"
            v-model="selectedColumnKeys"
            @change="onCheckboxChange(col)"
          />
          <p>{{ col.label }}</p>
        </label>
      </div>
    </div>

  </div>

  </div>
        </div>
      </div>





      
    </div>
  

    <div class="export-modal-actions">
      <div style="margin-bottom: 10px;">
        <label style="display: flex; align-items: center; cursor: pointer;">
          <input
            type="checkbox"
            v-model="exportAllOrders"
            style="margin-right: 8px;"
          />
          <span>Выгрузить все заказы с учетом фильтров (без пагинации)</span>
        </label>
      </div>
      <div style="margin-bottom: 10px;">
        <label style="display: flex; align-items: center; cursor: pointer;">
          <input
            type="checkbox"
            v-model="exportOneRowPerOrder"
            style="margin-right: 8px;"
          />
          <span>Один заказ — одна строка (все товары в одной ячейке)</span>
        </label>
      </div>
      <button
        class="modal-btn modal-btn-green"
        @click="doExportExcel"
        :disabled="!selectedColumns.length"
      >Выгрузить Excel</button>
      <button class="modal-btn" @click="closeExportModal">Отмена</button>
    </div>

    </div>
  </div>

<!-- Модальное окно настройки фильтров -->
<div v-if="showFilterSettingsModal" class="export-modal-overlay">
  <div class="export-modal-window" style="min-width: 400px;">
    <div class="manExport">
      <h3 class="export-modal-title">Настройка фильтров</h3>
      <div class="closeManExport" @click="showFilterSettingsModal = false">
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style="width: 100%;">
          <path d="M7.113 6.176a.6.6 0 01.848 0L12 10.214l4.038-4.038a.6.6 0 01.849 0l.937.937a.6.6 0 010 .848L13.785 12l4.04 4.04a.6.6 0 010 .848l-.937.937a.6.6 0 01-.849 0L12 13.784l-4.038 4.04a.6.6 0 01-.849 0l-.937-.937a.6.6 0 010-.848l4.04-4.04-4.039-4.038a.6.6 0 010-.849l.937-.936z" fill="currentColor"></path>
        </svg>
      </div>
    </div>

    <div style="padding: 15px; max-height: 60vh; overflow-y: auto;">
        <draggable v-model="selectedFilters" :options="{animation:180}">
            <div v-for="filter in selectedFilters" :key="filter.key" style="display:flex; align-items:center; padding:8px; border-bottom:1px solid #eee; background:#fff;">
                <span style="cursor:move; margin-right:10px; color:#999; font-size: 16px;">☰</span>
                <label style="flex:1; display:flex; align-items:center; cursor:pointer; margin:0;">
                    <input type="checkbox" v-model="filter.visible" style="margin-right:10px;">
                    {{ filter.label }}
                </label>
            </div>
        </draggable>
    </div>

    <div class="export-modal-actions">
      <button class="modal-btn modal-btn-green" @click="saveFilterSettingsFromModal">Сохранить</button>
      <button class="modal-btn" @click="showFilterSettingsModal = false">Отмена</button>
    </div>
  </div>
</div>

<!-- Модальное окно настройки таблицы -->
<div v-if="showTableSettingsModal" class="export-modal-overlay">
  <div class="export-modal-window" style="min-width: 400px;">
    <div class="manExport">
      <h3 class="export-modal-title">Настройка столбцов таблицы</h3>
      <div class="closeManExport" @click="showTableSettingsModal = false">
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style="width: 100%;">
          <path d="M7.113 6.176a.6.6 0 01.848 0L12 10.214l4.038-4.038a.6.6 0 01.849 0l.937.937a.6.6 0 010 .848L13.785 12l4.04 4.04a.6.6 0 010 .848l-.937.937a.6.6 0 01-.849 0L12 13.784l-4.038 4.04a.6.6 0 01-.849 0l-.937-.937a.6.6 0 010-.848l4.04-4.04-4.039-4.038a.6.6 0 010-.849l.937-.936z" fill="currentColor"></path>
        </svg>
      </div>
    </div>

    <div style="padding: 15px; max-height: 60vh; overflow-y: auto;">
        <draggable v-model="selectedTableColumns" :options="{animation:180}">
            <div v-for="col in selectedTableColumns" :key="col.key" style="display:flex; align-items:center; padding:8px; border-bottom:1px solid #eee; background:#fff;">
                <span style="cursor:move; margin-right:10px; color:#999; font-size: 16px;">☰</span>
                <label style="flex:1; display:flex; align-items:center; cursor:pointer; margin:0;">
                    <input type="checkbox" v-model="col.visible" style="margin-right:10px;">
                    {{ col.label || (col.isIcon ? 'Иконка ('+col.key+')' : col.key) }}
                </label>
            </div>
        </draggable>
    </div>

    <div class="export-modal-actions">
      <button class="modal-btn modal-btn-green" @click="saveSettingsFromModal">Сохранить</button>
      <button class="modal-btn" @click="showTableSettingsModal = false">Отмена</button>
    </div>
  </div>
</div>

<!-- Модальное окно для выбора машины курьера -->
<div v-if="showCourierCarModal" class="export-modal-overlay" @click.self="closeCourierCarModal">
  <div class="export-modal-window" style="min-width: 400px;">
    <div class="manExport">
      <h3 class="export-modal-title">Выбор машины курьера</h3>
      <div class="closeManExport" @click="closeCourierCarModal">
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style="width: 100%;">
          <path d="M7.113 6.176a.6.6 0 01.848 0L12 10.214l4.038-4.038a.6.6 0 01.849 0l.937.937a.6.6 0 010 .848L13.785 12l4.04 4.04a.6.6 0 010 .848l-.937.937a.6.6 0 01-.849 0L12 13.784l-4.038 4.04a.6.6 0 01-.849 0l-.937-.937a.6.6 0 010-.848l4.04-4.04-4.039-4.038a.6.6 0 010-.849l.937-.936z" fill="currentColor"></path>
        </svg>
      </div>
    </div>
    <div style="padding: 15px;">
      <div class="input-group" style="margin-bottom: 20px;">
        <label for="courierCarSelect" style="display: block; margin-bottom: 8px; font-weight: 500;">Выберите машину:</label>
        <select 
          id="courierCarSelect" 
          v-model="selectedCarId" 
          class="export-modal-select"
          style="width: 100%; padding: 8px; margin-top: 8px;">
          <option value="">-- Выберите машину --</option>
          <option v-for="car in courierCarsList" :key="car.value" :value="car.value">
            {{ car.label }}
          </option>
        </select>
      </div>
      <div style="display: flex; justify-content: flex-end; gap: 10px; margin-top: 20px;">
        <button type="button" class="btn white" @click="closeCourierCarModal">Отмена</button>
        <button type="button" class="btn" @click="confirmCourierChange(selectedCarId)" :disabled="!selectedCarId">Сохранить</button>
      </div>
    </div>
  </div>
</div>

<!-- Быстрый заказ Lite -->
<div v-if="liteOrderModalVisible" class="export-modal-overlay" @click.self="closeLiteOrderModal">
  <div class="export-modal-window lite-order-modal" style="min-width: 420px; max-width: 520px;">
    <div class="manExport">
      <h3 class="export-modal-title">Быстрый заказ Lite</h3>
      <div class="closeManExport" @click="closeLiteOrderModal">
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style="width: 100%;">
          <path d="M7.113 6.176a.6.6 0 01.848 0L12 10.214l4.038-4.038a.6.6 0 01.849 0l.937.937a.6.6 0 010 .848L13.785 12l4.04 4.04a.6.6 0 010 .848l-.937.937a.6.6 0 01-.849 0L12 13.784l-4.038 4.04a.6.6 0 01-.849 0l-.937-.937a.6.6 0 010-.848l4.04-4.04-4.039-4.038a.6.6 0 010-.849l.937-.936z" fill="currentColor"></path>
        </svg>
      </div>
    </div>

    <div class="lite-order-form">
    <div class="lite-order-field">
      <label class="lite-order-lbl" for="liteOrderComment">Комментарий</label>
      <textarea id="liteOrderComment" v-model="liteOrderForm.comment" class="export-modal-select lite-order-textarea" placeholder="Текст; при необходимости укажите телефон в формате 375…" :disabled="liteOrderSaving"></textarea>
    </div>
    <div class="lite-order-field">
      <label class="lite-order-lbl" for="liteOrderDeliveryAddress">Адрес доставки *</label>
      <textarea id="liteOrderDeliveryAddress" v-model="liteOrderForm.deliveryAddress" class="export-modal-select lite-order-textarea lite-order-address-textarea" placeholder="Полный адрес" rows="3" :disabled="liteOrderSaving"></textarea>
      <span v-if="liteOrderErrors.deliveryAddress" class="lite-order-err">{{ liteOrderErrors.deliveryAddress }}</span>
    </div>
    <div class="lite-order-field">
      <label class="lite-order-lbl" for="liteOrderDeliveryDate">Дата доставки *</label>
      <div class="lite-order-dp-wrap">
        <date-picker
          id="liteOrderDeliveryDate"
          v-model="liteOrderForm.deliveryDate"
          :format="formatDate"
          :language="language"
          placeholder="Дата доставки"
          :shortcuts="datepickerShortcuts"
          :disabled="liteOrderSaving"
        >
          <template v-slot:footer="{ emit }">
            <div class="datepicker-footer">
              <button type="button" class="btn-datepicker-reset" @click="emit(null)">
                <svg viewBox="0 0 24 24" width="16" height="16"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" fill="currentColor"/></svg>
                Сбросить
              </button>
            </div>
          </template>
        </date-picker>
      </div>
      <span v-if="liteOrderErrors.deliveryDate" class="lite-order-err">{{ liteOrderErrors.deliveryDate }}</span>
    </div>
    <div class="lite-order-field lite-order-courier-field">
      <label class="lite-order-lbl" for="liteOrderCourier">Курьер</label>
      <div class="lite-order-vselect-wrap">
        <v-select
          id="liteOrderCourier"
          v-model="liteOrderForm.courier"
          :options="couriersList"
          label="label"
          placeholder="- Не указан -"
          :clearable="true"
          :disabled="liteOrderSaving"
          :appendToBody="true"
        />
      </div>
    </div>
    <div class="lite-order-field lite-order-time-row">
      <div class="lite-order-time-cell">
        <label class="lite-order-lbl" for="liteOrderTimeFrom">Время с *</label>
        <date-picker
          id="liteOrderTimeFrom"
          v-model="liteOrderForm.timeFrom"
          type="time"
          :format="'HH:mm'"
          :value-type="'format'"
          :minute-step="5"
          :show-second="false"
          placeholder="HH:MM"
          class="lite-order-timepicker"
          :disabled="liteOrderSaving"
        />
      </div>
      <div class="lite-order-time-cell">
        <label class="lite-order-lbl" for="liteOrderTimeTo">Время по *</label>
        <date-picker
          id="liteOrderTimeTo"
          v-model="liteOrderForm.timeTo"
          type="time"
          :format="'HH:mm'"
          :value-type="'format'"
          :minute-step="5"
          :show-second="false"
          placeholder="HH:MM"
          class="lite-order-timepicker"
          :disabled="liteOrderSaving"
        />
      </div>
    </div>
    <span v-if="liteOrderErrors.time" class="lite-order-err lite-order-err-block">{{ liteOrderErrors.time }}</span>
    <div class="export-modal-actions lite-order-actions">
      <button type="button" class="modal-btn" @click="closeLiteOrderModal" :disabled="liteOrderSaving">Отмена</button>
      <button type="button" class="modal-btn modal-btn-green" @click="submitLiteOrder" :disabled="liteOrderSaving">
        <span v-if="liteOrderSaving">Создание…</span>
        <span v-else>Сохранить</span>
      </button>
    </div>
    </div>
  </div>
</div>

<!-- Модальное окно для изменения пользовательского поля -->
<div v-if="showCustomFieldModal" class="custom-field-modal-wrapper">
  <div class="export-modal-window custom-field-modal-window" style="min-width: 500px;">
    <div class="manExport">
      <h3 class="export-modal-title">Изменить поле: {{ selectedCustomField ? selectedCustomField.name : '' }}</h3>
      <div class="closeManExport" @click="closeCustomFieldModal" :style="{ cursor: batchCustomFieldLoading ? 'not-allowed' : 'pointer', opacity: batchCustomFieldLoading ? 0.5 : 1 }">
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style="width: 100%;">
          <path d="M7.113 6.176a.6.6 0 01.848 0L12 10.214l4.038-4.038a.6.6 0 01.849 0l.937.937a.6.6 0 010 .848L13.785 12l4.04 4.04a.6.6 0 010 .848l-.937.937a.6.6 0 01-.849 0L12 13.784l-4.038 4.04a.6.6 0 01-.849 0l-.937-.937a.6.6 0 010-.848l4.04-4.04-4.039-4.038a.6.6 0 010-.849l.937-.936z" fill="currentColor"></path>
        </svg>
      </div>
    </div>

    <div style="padding: 15px; position: relative;">
      <!-- Лоадер поверх содержимого -->
      <div v-if="batchCustomFieldLoading" class="custom-field-modal-loader">
        <div class="custom-field-loader-spinner"></div>
        <div class="custom-field-loader-text">Обработка заказов...</div>
      </div>
      
      <div v-if="selectedCustomField" :style="{ opacity: batchCustomFieldLoading ? 0.5 : 1, pointerEvents: batchCustomFieldLoading ? 'none' : 'auto' }">
        <!-- Текстовое поле -->
        <div v-if="selectedCustomField.type === 'text'">
          <label style="display: block; margin-bottom: 8px; font-weight: 500;">Значение:</label>
          <input 
            type="text" 
            v-model="customFieldValue" 
            class="export-modal-select"
            style="width: 100%; padding: 8px;"
            placeholder="Введите значение"
            :disabled="batchCustomFieldLoading"
          />
        </div>
        
        <!-- Поле даты -->
        <div v-if="selectedCustomField.type === 'date'">
          <label style="display: block; margin-bottom: 8px; font-weight: 500;">Дата:</label>
          <input 
            type="date" 
            v-model="customFieldValue" 
            class="export-modal-select"
            style="width: 100%; padding: 8px;"
            :disabled="batchCustomFieldLoading"
          />
        </div>
        
        <!-- Селект для полей со справочниками -->
        <div v-if="selectedCustomField && selectedCustomField.type === 'select'">
          <label style="display: block; margin-bottom: 8px; font-weight: 500;">Выберите значение:</label>
          <select 
            v-model="customFieldValue" 
            class="export-modal-select"
            style="width: 100%; padding: 8px;"
            :disabled="batchCustomFieldLoading"
          >
            <option value="">-- Выберите --</option>
            <option v-for="option in (selectedCustomField ? getCustomFieldOptions(selectedCustomField.code) : [])" 
                    :key="option.value" 
                    :value="option.value">
              {{ option.label }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <div class="export-modal-actions">
      <button 
        class="modal-btn modal-btn-green" 
        @click="batchChangeCustomField"
        :disabled="!customFieldValue || batchCustomFieldLoading"
      >
        <span v-if="batchCustomFieldLoading">Обработка...</span>
        <span v-else>Сохранить</span>
      </button>
      <button 
        class="modal-btn" 
        @click="closeCustomFieldModal"
        :disabled="batchCustomFieldLoading"
      >Отмена</button>
    </div>
  </div>
</div>

<!-- Модальное окно для массовой смены статуса (с комментарием, как в OrderEdit) -->
<div v-if="isModalBatchStatusVisible" class="modal-overlay">
  <div class="omnica-modal-window omnica-modal-window_popup omnica-popper-container">
    <div class="omnica-modal-window__header">
      <div class="omnica-modal-window__title">Смена статуса</div>
      <div aria-label="Esc" role="button" class="omnica-modal-window__close" @click="closeBatchStatusModal">
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style="width: 100%;"><path d="M7.113 6.176a.6.6 0 01.848 0L12 10.214l4.038-4.038a.6.6 0 01.849 0l.937.937a.6.6 0 010 .848L13.785 12l4.04 4.04a.6.6 0 010 .848l-.937.937a.6.6 0 01-.849 0L12 13.784l-4.038 4.04a.6.6 0 01-.849 0l-.937-.937a.6.6 0 010-.848l4.04-4.04-4.039-4.038a.6.6 0 010-.849l.937-.936z" fill="currentColor"></path></svg>
      </div>
    </div>
    <div class="omnica-modal-window__content">
      <div class="mb-6">
        <div class="UiText-text-2_z8 UiText-text_gray-3-JE UiText-text_small-QTWp UiText-text_accent-nhXJ text_X0OGL">Новый статус</div>
        <div class="status_gL3ii status_complete_sa6B2 md_ZnSCb">
          <div class="UiText-text-2_z8 UiText-text_black-1BwQ UiText-text_small-QTWp title_I6f5a">{{ pendingBatchStatusLabel || '' }}</div>
        </div>
      </div>
      <div>
        <div class="text_X0OGL text_comment_x9UJJ"><div class="UiText-text-2_z8 UiText-text_gray-3-JE UiText-text_small-QTWp UiText-text_accent-nhXJ">Комментарий</div>
        <div class="UiText-text-2_z8 UiText-text_gray-3-JE UiText-text_tiny-1_wc">Опционально</div></div>
        <div class="UiTextarea-textarea-wrap-2K2Y" style="height: 192px;">
          <div class="UiTextarea-textarea-2DUR UiTextarea-textarea_default-26FY">
            <textarea rows="1" class="UiTextarea-textarea__area-1IwX" v-model="batchStatusComment" placeholder="Введите комментарий"></textarea>
          </div>
        </div>
      </div>
    </div>
    <div class="omnica-modal-window__footer">
      <div>
        <button type="button" class="omnica-button omnica-button_primary omnica-button_sm omnica-button_default omnica-button_success omnica-button_has-leading-icon omnica-button_ellipsis" @click="confirmBatchStatus">
          <span class="omnica-button__inner">
            <span class="omnica-button__icon"><svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" class="UiIcon-icon-2pR-"><path fill-rule="evenodd" clip-rule="evenodd" d="M19.792 6.965a.77.77 0 01-.021 1.075l-9.815 9.607a1.224 1.224 0 01-1.714.006l-4.01-3.878a.77.77 0 01-.028-1.074l.684-.736a.735.735 0 011.053-.028l3.15 3.046 8.96-8.771a.735.735 0 011.053.022l.688.731z"></path></svg></span>
            <span class="omnica-button__text">Сохранить</span>
          </span>
        </button>
        <button type="button" class="omnica-button omnica-button_secondary omnica-button_sm omnica-button_default omnica-button_ellipsis" @click="closeBatchStatusModal">
          <span class="omnica-button__inner"><span class="omnica-button__text">Отменить</span></span>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Оверлей прогрузки бонуса (массовое действие для руководителей) -->
<div v-if="batchBonusReloadLoading" class="batch-bonus-reload-overlay">
  <div class="batch-bonus-reload-panel">
    <div class="batch-bonus-reload-spinner"></div>
    <div class="batch-bonus-reload-title">Прогрузка бонуса</div>
    <div v-if="batchBonusReloadProgress.total" class="batch-bonus-reload-progress">
      {{ batchBonusReloadProgress.current }} из {{ batchBonusReloadProgress.total }}
    </div>
    <div class="batch-bonus-reload-hint">Не закрывайте страницу</div>
  </div>
</div>




    </div>

 

  </div>

        <!-- Пагинация и информация о количестве -->
        <div :class="{'fixedPagination': !atPageEnd, 'staticPagination': atPageEnd}" class="pagination-wrapper">
          <div v-if="pagination" class="pagination-container">
            <div class="m-pagination">
            <div class="pagination">
              <ul class="pagination">
                <!-- Стрелка в начало -->
                <li 
                  :class="['navigation-arrow', 'bord', { 'ardisbl': pagination.currentPage === 1 } ]"
                >
                  <a @click.prevent="fetchOrders(1)">«</a>
                </li>

                <!-- Первая btLink (предыдущая страница) -->
                <li 
                :class="['bt-link', { 'ardisbl': pagination.currentPage === 1 } ]"
                  >
                  <a @click.prevent="fetchOrders(pagination.currentPage - 1)">‹</a>
                </li>

                <!-- Основная пагинация -->
                <li 
                  v-for="page in visiblePages" 
                  :key="page === '...' ? `ellipsis_${Math.random()}` : page"
                  :class="{ active: page === pagination.currentPage }"
                >
                  <a v-if="page !== '...'" @click.prevent="fetchOrders(page)">{{ page }}</a>
                  <span v-else>...</span>
                </li>

                <!-- Вторая btLink (следующая страница) -->
                <li 
                  :class="['bt-link', {'ardisblEnd': pagination.currentPage === pagination.totalPageCount } ]"
                >
                  <a @click.prevent="fetchOrders(pagination.currentPage + 1)">›</a>
                </li>

                <!-- Стрелка в конец -->
                <li 
                  :class="['navigation-arrow', 'bordEnd', {'ardisblEnd': pagination.currentPage === pagination.totalPageCount } ]"
                >
                  <a @click.prevent="fetchOrders(pagination.totalPageCount)">»</a>
                </li>
              </ul>
            </div>
          </div> <!-- end .m-pagination -->
          
          <!-- Информация о количестве заказов -->
          <div v-if="pagination && pagination.totalCount" class="order-count-summary">
            <span>
              Показано
              {{ (pagination.currentPage - 1) * pagination.limit + 1 }}
              –
              {{
                Math.min(pagination.currentPage * pagination.limit, pagination.totalCount)
              }}
              из {{ pagination.totalCount }}
            </span>
            <span class="grand-total-sum">
              Общая сумма: 
              <span v-if="loadingStatusStatistics" class="status-count-loader"></span>
              <span v-else>{{ formatCurrency(grandTotalSum) }}</span>
            </span>
          </div>
          
          <!-- Кнопка для открытия модального окна -->
          <button
            v-if="canExportOrders"
            class="excels"
            @click="openExportModal"
            :disabled="!selectedOrders.length"
          >
            <svg width="30px" xmlns:x="http://ns.adobe.com/Extensibility/1.0/" xmlns:i="http://ns.adobe.com/AdobeIllustrator/10.0/" xmlns:graph="http://ns.adobe.com/Graphs/1.0/" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Livello_1" x="0px" y="0px" viewBox="0 0 2289.75 2130" enable-background="new 0 0 2289.75 2130" xml:space="preserve"> <metadata> <sfw xmlns="http://ns.adobe.com/SaveForWeb/1.0/"> <slices/> <sliceSourceBounds bottomLeftOrigin="true" height="2130" width="2289.75" x="-1147.5" y="-1041"/> </sfw> </metadata> <path fill="#185C37" d="M1437.75,1011.75L532.5,852v1180.393c0,53.907,43.7,97.607,97.607,97.607l0,0h1562.036 c53.907,0,97.607-43.7,97.607-97.607l0,0V1597.5L1437.75,1011.75z"/> <path fill="#21A366" d="M1437.75,0H630.107C576.2,0,532.5,43.7,532.5,97.607c0,0,0,0,0,0V532.5l905.25,532.5L1917,1224.75 L2289.75,1065V532.5L1437.75,0z"/> <path fill="#107C41" d="M532.5,532.5h905.25V1065H532.5V532.5z"/> <path opacity="0.1" enable-background="new " d="M1180.393,426H532.5v1331.25h647.893c53.834-0.175,97.432-43.773,97.607-97.607 V523.607C1277.825,469.773,1234.227,426.175,1180.393,426z"/> <path opacity="0.2" enable-background="new " d="M1127.143,479.25H532.5V1810.5h594.643 c53.834-0.175,97.432-43.773,97.607-97.607V576.857C1224.575,523.023,1180.977,479.425,1127.143,479.25z"/> <path opacity="0.2" enable-background="new " d="M1127.143,479.25H532.5V1704h594.643c53.834-0.175,97.432-43.773,97.607-97.607 V576.857C1224.575,523.023,1180.977,479.425,1127.143,479.25z"/> <path opacity="0.2" enable-background="new " d="M1073.893,479.25H532.5V1704h541.393c53.834-0.175,97.432-43.773,97.607-97.607 V576.857C1171.325,523.023,1127.727,479.425,1073.893,479.25z"/> <linearGradient id="SVGID_1_" gradientUnits="userSpaceOnUse" x1="203.5132" y1="1729.0183" x2="967.9868" y2="404.9817" gradientTransform="matrix(1 0 0 -1 0 2132)"> <stop offset="0" style="stop-color:#18884F"/> <stop offset="0.5" style="stop-color:#117E43"/> <stop offset="1" style="stop-color:#0B6631"/> </linearGradient> <path fill="url(#SVGID_1_)" d="M97.607,479.25h976.285c53.907,0,97.607,43.7,97.607,97.607v976.285 c0,53.907-43.7,97.607-97.607,97.607H97.607C43.7,1650.75,0,1607.05,0,1553.143V576.857C0,522.95,43.7,479.25,97.607,479.25z"/> <path fill="#FFFFFF" d="M302.3,1382.264l205.332-318.169L319.5,747.683h151.336l102.666,202.35 c9.479,19.223,15.975,33.494,19.49,42.919h1.331c6.745-15.336,13.845-30.228,21.3-44.677L725.371,747.79h138.929l-192.925,314.548 L869.2,1382.263H721.378L602.79,1160.158c-5.586-9.45-10.326-19.376-14.164-29.66h-1.757c-3.474,10.075-8.083,19.722-13.739,28.755 l-122.102,223.011H302.3z"/> <path fill="#33C481" d="M2192.143,0H1437.75v532.5h852V97.607C2289.75,43.7,2246.05,0,2192.143,0L2192.143,0z"/> <path fill="#107C41" d="M1437.75,1065h852v532.5h-852V1065z"/> </svg>
          </button>
          </div> <!-- end .pagination-container -->

        </div>

        <!-- Суммы по типу оплаты и справочнику предоплаты (кликабельно — дофильтровать) -->
        <div class="payment-sums-block" v-if="paymentSumsDisplay.length > 0">
          <template v-if="loadingPaymentSums">
            <span class="payment-sums-loader">Загрузка сумм...</span>
          </template>
          <template v-else>
            <span
              v-for="item in paymentSumsDisplay"
              :key="item.filterKind + '-' + item.filterValue"
              class="payment-sum-item"
              :class="{ 'payment-sum-item--active': isPaymentSumFilterActive(item) }"
              :title="'Нажмите, чтобы отфильтровать по: ' + item.label"
              @click="applyPaymentSumFilter(item.filterKind, item.filterValue)"
            >{{ item.label }}: {{ formatCurrency(item.sum) }}</span>
          </template>
        </div>

</div>
</div>


</div>
</template>

<script>
import { ORDERS_API_BASE } from '@/config/api';
import axios from 'axios';  
import Vue from 'vue';
import LoaderTable from '@/components/LoaderTable.vue';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import ru from 'vue2-datepicker/locale/ru'; // Импортируем русскую локализацию
import Treeselect from '@riophae/vue-treeselect';
import { mapState, mapActions, mapGetters } from 'vuex';
import { filterFieldsByRole, ROLES_ORDER_DISCOUNT_COLUMN } from '@/assets/filterFieldsByRole';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import draggable from 'vuedraggable';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import { sortManagersByLabel } from '@/constants/sortManagers';

/** Быстрый заказ Lite: магазин, склад, товар по умолчанию */
const LITE_ORDER_SITE = { label: 'Центральный офис 1akb.by', value: '1akb-by' };
const BONUS_RELOAD_CONSULTATION_STATUS = 'availability-confirmed';
const LITE_ORDER_SHIPMENT_STORE = { label: 'Склад "Карвата"', value: 'rfhdfnfcrkfl' };
/** externalId оффера в RetailCRM */
const LITE_ORDER_OFFER_EXTERNAL_ID = '16309m-gj0O3hi4W6k7E0cb8f01';
const LITE_ORDER_DELIVERY = { label: '1. Доставка курьером', value: 'courier' };
/** Как в OrderEdit: группа delivery, «Доставка курьером» */
const LITE_ORDER_STATUS = { label: 'Доставка курьером', value: 'redirect' };
const LITE_ORDER_DEFAULT_PHONE = '375290000000';

const fieldLabels = {
  // Корень заказа
  paymentType: 'Тип оплаты',
  paymentStatus: 'Статус оплаты',
  // slug: 'ID заказа',
  discount: 'Скидка (BYN)',
  discountPercent: 'Скидка (%)',
  summ: 'Сумма заказа',
  paymentDetail: 'Детали оплаты',
  id: 'ID заказа',
  number: 'Номер заказа',
  orderType: 'Тип заказа',
  orderMethod: 'Способ оформления',
  countryIso: 'Страна',
  createdAt: 'Дата создания',
  statusUpdatedAt: 'Дата изменения статуса',
  totalSumm: 'Итоговая сумма',
  prepaySum: 'Предоплата безналичными',
  purchaseSumm: 'Себестоимость заказа',
  markDatetime: 'Дата отметки',
  firstName: 'Имя покупателя',
  lastName: 'Фамилия',
  phone: 'Телефон',
  additionalPhone: 'Дополнительный телефон',
  call: 'Требуется звонок',
  expired: 'Просрочен',
  managerComment: 'Комментарий менеджера',
  statusComment: 'Комментарий к статусу',
  managerId: 'ID менеджера',

  // customer
  'customer.id': 'ID покупателя',
  'customer.isContact': 'Является контактом',
  'customer.createdAt': 'Дата создания покупателя',
  'customer.managerId': 'ID менеджера покупателя',
  'customer.vip': 'VIP покупатель',
  'customer.bad': 'Плохой покупатель',
  'customer.site': 'Магазин покупателя',

  // contragent
  'contragent.contragentType': 'Тип контрагента',

  // customFields
  'customFields.shiny': 'Шинный клиент',
  'customFields.lsuakdhf': 'LSU AK DHF',
  'customFields.parolopt': 'Пароль опт',
  'customFields.skidkaopt': 'Оптовая скидка',
  'customFields.proslushka': 'Прослушка',
  'customFields.celevoi_necelevoi': 'Целевой клиент',
  'customFields.moyskladexternalid': 'Внешний ID МойСклад',
  'customFields.proverkaklientamenedgero': 'Проверка клиента менеджером',
  'customFields.personalDiscount': 'Персональная скидка',
  'customFields.cumulativeDiscount': 'Накопительная скидка',
  'customFields.marginSumm': 'Маржа',
  'customFields.totalSumm': 'Итого по всем заказам',
  'customFields.averageSumm': 'Средний чек',
  'customFields.ordersCount': 'Кол-во заказов',
  'customFields.sssylkaaaaasssyyylka': 'Ссылка на подбор',
  'customFields.forma_na_saite': 'Форма на сайте',
  'customFields.visitor_code': 'Код посетителя',
  'customFields.visitor_city': 'Город посетителя',
  'customFields.personal_offer_discount': 'Скидка Товар дня %',
  'customFields.vgvgvgv': 'Номер ВГ',
  'customFields.lkjdhgdhg768': 'Номер реестра',
  'customFields.marssh': 'Маршрутный лист курьер',
  'customFields.tegi_dialoga': 'Теги диалога',
  'customFields.zvonok_text_bot': 'Выжимка бота',
  'customFields.data_soglasovaniia1': 'Дата согласования',
  'customFields.proslushka': 'Прослушка',
  'customFields.proverkaklientamenedgero': 'Проверка клиента у менеджера',
  'customFields.podbor_trigger': 'Триггер подбора',
  'customFields.podbor_plox_sovsem': 'Плохой подбор',
  'customFields.sklad_api': 'Склад (API)',
  'customFields.magazin_api': 'Магазин (API)',
  'customFields.toplivo_vid': 'Вид топлива',
  'customFields.zp_za_zakaz': 'ЗП за заказ',
  'customFields.godts_podbor': 'Год ТС для подбора',
  'customFields.marka_podbor': 'Марка для подбора',
  'customFields.model_podborts': 'Модель для подбора',
  'customFields.nazvats_podbor': 'Название ТС для подбора',
  'customFields.otgruzkabezoplata': 'Отгрузка без оплаты',
  'customFields.sozdan_cherez_managera': 'Создан через менеджера',
  'customFields.proverkazakazamenedgero': 'Проверка заказа менеджером',
  'customFields.usluga_s_vyezdom_diagnostika_i_podzariadka_akkumuliatora': 'Услуга: выезд, диагностика и подзарядка АКБ',
  'customFields.currency': 'Валюта',
  'customFields.dfghodsf8g7': 'Бонусы',
  'customFields.ocenkaprodavcu': 'Оценка продавцу',
  'customFields.bonus_client': 'Бонус клиенту',
  'customFields.bonus_prodavec': 'Бонус продавцу',
  'customFields.manager_kosjak': 'Косяк менеджера',
  'customFields.redaktor': 'Редактор',
  'customFields.dfghodsf8g7': 'Бонусы (число)',
  'customFields.dfgfdddfnew': 'Сумма за аккумулятор в зачет',
  'customFields.slksdkk2j3iu3nnew': 'Ёмкость аккумулятора в зачет',
  'customFields.ssylkaaaaasssyyylka': 'Ссылка на подбор',
  'customFields.dfhgodsf8g7': 'Бонус',
  'customFields.dsksajklsal': 'Служебное поле',
  'customFields.marssh': 'Маршрутный лист курьер',
  'customFields.dfghodsf8g7': 'Бонус',
  'customFields.moyskladexternalid': 'Внешний ID заказа МойСклад',
  'customFields.nekorrektnyi_bonus': 'Некорректный бонус',
  'customFields.oplacheno_bonusami': 'Оплачено бонусами',
  'customFields.podbor_plox_sovsem': 'Плохой подбор совсем',
  'customFields.tiprorpusa_ts_podbor': 'Тип корпуса ТС для подбора',
  'customFields.otpravit_ssylku_na_oplatu': 'Отправить ссылку на оплату',
  'customFields.rezultatsxdg': 'Результат подбора',
  'customFields.dgh66hhhhhhh': 'Приглашение на СТО',
  'customFields.magazin_api': 'API магазина',
  // ...добавь любые новые поля customFields сюда

  // address
  'address.id': 'ID адреса',
  'address.countryIso': 'Страна (ISO)',
  'address.text': 'Адрес полностью',

  // customerSubscriptions
  'customerSubscriptions[].subscribed': 'Подписка активна',
  'customerSubscriptions[].subscription.id': 'ID подписки',
  'customerSubscriptions[].subscription.channel': 'Канал подписки',
  'customerSubscriptions[].subscription.name': 'Название подписки',
  'customerSubscriptions[].subscription.code': 'Код подписки',
  'customerSubscriptions[].subscription.active': 'Статус подписки',
  'customerSubscriptions[].subscription.autoSubscribe': 'Автоподписка',
  'customerSubscriptions[].subscription.ordering': 'Порядок подписки',

  // phones
  'phones[].number': 'Телефон',

  // source
  'source.source': 'Источник (например, google)',
  'source.medium': 'Канал рекламы',
  'source.campaign': 'Название кампании',
  'source.keyword': 'Ключевое слово',

  // contragent
  'contragent.contragentType': 'Тип контрагента',

  // delivery
  'delivery.code': 'Тип доставки (код)',
  'delivery.integrationCode': 'Код интеграции доставки',
  'delivery.data.locked': 'Доставка: заблокирована',
  'delivery.data.id': 'ID курьера',
  'delivery.data.firstName': 'Имя курьера',
  'delivery.data.phone.number': 'Телефон курьера',
  'delivery.courierId': 'ID курьера',
  /** Виртуальное поле экспорта: имя курьера из справочника (как колонка «Курьер» в таблице) */
  courier: 'Курьер',
  'delivery.cost': 'Стоимость доставки',
  'delivery.netCost': 'Себестоимость доставки',
  'delivery.date': 'Дата доставки',
  'delivery.time.from': 'Время доставки от',
  'delivery.time.to': 'Время доставки до',
  'delivery.address.countryIso': 'Страна доставки',
  'delivery.address.region': 'Регион доставки',
  'delivery.address.city': 'Город доставки',
  'delivery.address.street': 'Улица доставки',
  'delivery.address.building': 'Дом',
  'delivery.address.flat': 'Квартира',
  'delivery.address.floor': 'Этаж',
  'delivery.address.block': 'Блок',
  'delivery.address.house': 'Дом (alt)',
  'delivery.address.housing': 'Корпус',
  'delivery.address.text': 'Адрес (строка)',
  'delivery.site': 'Магазин доставки',
  'delivery.status': 'Статус доставки',

  // items (массив)
  'items[].discount': 'Скидка на товар',
  'items[].discountPercent': 'Скидка на товар (%)',
  'items[].id': 'ID позиции',
  'items[].initialPrice': 'Исходная цена',
  'items[].prices[].price': 'Цена',
  'items[].prices[].quantity': 'Количество',
  'items[].vatRate': 'Ставка НДС',
  'items[].createdAt': 'Дата добавления позиции',
  'items[].quantity': 'Количество (общ.)',
  'items[].status': 'Статус позиции',
  'items[].offer.displayName': 'Товар (полное название)',
  'items[].offer.id': 'ID товара',
  'items[].offer.externalId': 'Внешний ID товара',
  'items[].offer.xmlId': 'XML ID товара',
  'items[].offer.name': 'Наименование товара',
  'items[].offer.vatRate': 'Ставка НДС товара',
  'items[].offer.properties.code': 'Код товара',
  'items[].purchasePrice': 'Себестоимость товара',
  'items[].totalPrice': 'Стоимость товара',
  'items[].ordering': 'Порядок в списке',
  'items[].fromApi': 'Добавлено через API',
  'items[].shipmentStore': 'Склад отгрузки',
  'items[].shipped': 'Отгружено',
  // customFields у позиции
  'items[].customFields.sto': 'СТО (позиция)',
  'items[].customFields.marssh': 'Маршрутный лист (позиция)',
  'items[].customFields.dfgfdddf': 'Служебное поле (позиция)',
  'items[].customFields.redaktor': 'Редактор (позиция)',
  'items[].customFields.sklad_api': 'Склад API (позиция)',
  'items[].customFields.magazin_api': 'Магазин API (позиция)',
  'items[].customFields.toplivo_vid': 'Вид топлива (позиция)',
  'items[].customFields.zp_za_zakaz': 'ЗП за заказ (позиция)',
  'items[].customFields.bonus_client': 'Бонус клиенту (позиция)',
  'items[].customFields.bonus_prodavec': 'Бонус продавцу (позиция)',
  'items[].customFields.godts_podbor': 'Год ТС подбора (позиция)',
  'items[].customFields.marka_podbor': 'Марка ТС подбора (позиция)',
  'items[].customFields.model_podborts': 'Модель ТС подбора (позиция)',
  'items[].customFields.nazvats_podbor': 'Название ТС подбора (позиция)',
  'items[].customFields.rezultatsxdg': 'Результат подбора (позиция)',
  'items[].customFields.manager_kosjak': 'Косяк менеджера (позиция)',
  'items[].customFields.podbor_plox_sovsem': 'Плохой подбор (позиция)',
  'items[].customFields.tiprorpusa_ts_podbor': 'Тип корпуса ТС подбора (позиция)',
  'items[].customFields.sozdan_cherez_managera': 'Создан через менеджера (позиция)',
  'items[].customFields.proverkazakazamenedgero': 'Проверка заказа менеджером (позиция)',
  'items[].customFields.otpravit_ssylku_na_oplatu': 'Отправить ссылку на оплату (позиция)',
  'items[].customFields.usluga_s_vyezdom_diagnostika_i_podzariadka_akkumuliatora': 'Услуга диагностика и подзарядка АКБ (позиция)',
  'items[].customFields.currency': 'Валюта (позиция)',
  'items[].customFields.dgh66hhhhhhh': 'Приглашение на СТО',
  // ...и др. по образцу

  // Общие служебные поля, если нужны
  status: 'Статус заказа',
  expired: 'Просрочен',
  call: 'Требуется звонок',
  managerComment: 'Комментарий менеджера',
  customerComment: 'Комментарий клиента',
  seller: 'Продавец',
  items: 'Состав заказа',

  // Для фильтрации/выбора (если хочешь выводить)
  sites: 'Магазины',
  shipmentStores: 'Склады отгрузки',
  deliveryTypes: 'Типы доставки',
  couriers: 'Курьеры',
  managers: 'Менеджеры',
  paymentTypes: 'Типы оплаты',
  paymentStatus: 'Статусы оплат',
  proverkazakazamenedgeroTypes: 'Проверка заказа менеджером',
  ocenka_manageruTypes: 'Оценка менеджеру',
  obzvon_klienta: 'Обзвон клиента',
  orderMethodd: 'Способы оформления',
  statusTsAt: 'Отгружено ТС',
  statusUpdatedAt: 'Последнее изменение статуса',
  sssylkaaaaasssyyylka: 'Ссылка на подбор',
  vgvgvgv: 'Номер ВГ',
  lkjdhgdhg768: 'Номер реестра',
  marssh: 'Маршрутный лист курьер',
  tegi_dialoga: 'Теги диалога',
  personal_offer_discount: 'Скидка Товар дня %',
  visitor_code: 'Код посетителя',
  visitor_city: 'Город посетителя',
  zvonok_text_bot: 'Выжимка бота',
  dataSoglasovaniia: 'Дата согласования',
  dgh66hhhhhhh: 'Приглашение на СТО',

  patronymic: 'Отчество',
  'order-manager-comment': 'Комментарий оператора',
  
  // Недостающие поля из списка
  'customer.email': 'E-mail',
  'customer.fullName': 'Покупатель',
  'payments.totalAmount': 'Сумма оплаты',
  'payments.lastPaidAt': 'Дата полной оплаты'
};

/** Подписи колонок экспорта в Excel (жёстко, чтобы не подставлялось старое имя поля из CRM вроде «Новое служебное поле»). */
const exportColumnLabelOverrides = {
  'customFields.dfgfdddfnew': 'Сумма за аккумулятор в зачет',
  'customFields.slksdkk2j3iu3nnew': 'Ёмкость аккумулятора в зачет',
  'customFields.dgh66hhhhhhh': 'Приглашение на СТО',
  'delivery.courierId': 'Имя курьера',
  'delivery.data.id': 'Имя курьера'
};

const groupMapping = {
  // Аналитика
  'source.source': 'Аналитика',
  'source.medium': 'Аналитика',
  'source.campaign': 'Аналитика',
  'source.keyword': 'Аналитика',
  'createdAt': 'Аналитика', // Первое посещение
  'statusUpdatedAt': 'Аналитика', // Последнее изменение статуса

  // Покупатель
  'phone': 'Покупатель',
  'additionalPhone': 'Покупатель',
  'firstName': 'Покупатель',
  'lastName': 'Покупатель',
  'patronymic': 'Покупатель',
  'customer.id': 'Покупатель',
  'customer.vip': 'Покупатель',
  'customer.bad': 'Покупатель',
  'customer.email': 'Покупатель',
  'customer.fullName': 'Покупатель',
  'phones[].number': 'Покупатель',
  'customFields.magazin_api': 'Покупатель',

  // Контрагент
  'contragent.contragentType': 'Контрагент',

  // Стоимость
  'summ': 'Стоимость',
  'discount': 'Стоимость',
  'discountPercent': 'Стоимость',
  'totalSumm': 'Стоимость',
  'prepaySum': 'Стоимость',
  'purchaseSumm': 'Стоимость',
  'marginSumm': 'Стоимость',

  // Доставка
  'delivery.code': 'Доставка',
  'delivery.date': 'Доставка',
  'delivery.time.from': 'Доставка',
  'delivery.time.to': 'Доставка',
  'delivery.address.text': 'Доставка',
  'delivery.cost': 'Доставка',
  'delivery.netCost': 'Доставка',
  'delivery.status': 'Доставка',
  'delivery.courierId': 'Доставка',
  'delivery.site': 'Доставка',
  
  'customFields.marssh': 'Доставка', // Маршрутный лист курьер
  'deliveryTypes': 'Доставка',      // Типы доставки
  'delivery.address.city': 'Доставка', // Город доставки
  'delivery.data.phone.number': 'Доставка', // Телефон курьера
  'delivery.data.locked': 'Доставка', // Доставка: заблокирована
  courier: 'Доставка',

  // Заказ
  'number': 'Заказ',
  'slug': 'Заказ',
  'id': 'Заказ',
  'orderType': 'Заказ',
  'orderMethod': 'Заказ',
  'createdAt': 'Заказ',
  'status': 'Заказ',
  'managerId': 'Заказ',
  'managers': 'Заказ',
  'customerComment': 'Заказ',
  'countryIso': 'Заказ',
  'expired': 'Заказ',
  'call': 'Заказ',
  'managerComment': 'Заказ',
  'operatorComment': 'Заказ',
  'order-manager-comment': 'Заказ',
  seller: 'Заказ',
  items: 'Заказ',
  'customFields.dfgfdddfnew': 'Заказ',
  'customFields.slksdkk2j3iu3nnew': 'Заказ',
  'statusComment': 'Заказ',

  // Оплата
  'paymentType': 'Оплата',
  'paymentStatus': 'Оплата',
  'paymentDetail': 'Оплата',
  'payments.totalAmount': 'Оплата',
  'payments.lastPaidAt': 'Оплата',

  // Товар
  'items[].offer.name': 'Товар',
  'items[].offer.id': 'Товар',
  'items[].offer.externalId': 'Товар',
  'items[].offer.xmlId': 'Товар',
  'items[].quantity': 'Товар',
  'items[].initialPrice': 'Товар',
  'items[].purchasePrice': 'Товар',
  'items[].totalPrice': 'Товар',
  'items[].discount': 'Товар',
  'items[].discountPercent': 'Товар',
  'items[].status': 'Товар',

  // Коммуникации
  'customFields.chat': 'Коммуникации',

  // Отгрузка
  'items[].shipmentStore': 'Отгрузка',
  'items[].shipped': 'Отгрузка',
  'customFields.statusTsAt': 'Отгрузка', // Отгружено ТС

  // Пользовательские поля
  'managers': 'Пользовательские поля',
  'customFields.dfhgodsf8g7': 'Пользовательские поля', // Бонус
  'customFields.bonus_client': 'Пользовательские поля',
  'customFields.sssylkaaaaasssyyylka': 'Пользовательские поля',
  'customFields.tegi_dialoga': 'Пользовательские поля',
  'customFields.zvonok_text_bot': 'Коммуникации',
  tegi_dialoga: 'Пользовательские поля',
  zvonok_text_bot: 'Коммуникации',
  dataSoglasovaniia: 'Пользовательские поля',
  'customFields.data_soglasovaniia1': 'Пользовательские поля',
  'customFields.bonus_prodavec': 'Пользовательские поля',
  'customFields.manager_kosjak': 'Пользовательские поля',
  'customFields.godts_podbor': 'Пользовательские поля',
  'customFields.marka_podbor': 'Пользовательские поля',
  'customFields.model_podborts': 'Пользовательские поля',
  'customFields.nazvats_podbor': 'Пользовательские поля',
  'customFields.toplivo_vid': 'Пользовательские поля',
  'customFields.tiprorpusa_ts_podbor': 'Пользовательские поля',
  'customFields.podbor_plox_sovsem': 'Пользовательские поля',
  'customFields.nekorrektnyi_bonus': 'Пользовательские поля',
  'customFields.oplacheno_bonusami': 'Пользовательские поля',
  'customFields.otpravit_ssylku_na_oplatu': 'Пользовательские поля',
  'customFields.usluga_s_vyezdom_diagnostika_i_podzariadka_akkumuliatora': 'Пользовательские поля',
  'customFields.currency': 'Пользовательские поля',
  'customFields.ocenkaprodavcu': 'Пользовательские поля',
  'customFields.obzvon_klienta': 'Пользовательские поля',
  'customFields.proverkazakazamenedgero': 'Пользовательские поля',
  'customFields.proslushka': 'Пользовательские поля',
  'customFields.rezultatsxdg': 'Пользовательские поля',
  'customFields.dgh66hhhhhhh': 'Пользовательские поля',
  'customFields.vgvgvgv': 'Пользовательские поля',
  'customFields.lkjdhgdhg768': 'Пользовательские поля',
  'customFields.moyskladexternalid': 'Пользовательские поля',
  'customFields.marssh': 'Пользовательские поля',
  'customFields.sklad_api': 'Пользовательские поля',
  'customFields.zp_za_zakaz': 'Пользовательские поля',
  'customFields.sozdan_cherez_managera': 'Пользовательские поля',
};


const valueDictionary = {
   nepozvonila: 'Не перезвонила',
        hkhjyghj: 'неизвестно',
        "5otlichno": 'Отлично, 5',
        "dozvonilas-i-sms-otpravila": 'Дозвонилась, отправлена смс',
        true: 'Да',
        false: 'Нет',
        tn: 'ТН',
        paid: 'Оплачено',
        "ready-for-assembly": 'Отгружен',
        "assembly-not-delivery": 'Доставляется ТК',
        completed: 'Укомплектован',
        "product-is-damaged": 'Укомплектован',
        base: 'Базовая',
        vozimby: '2. vozim.by',
        cash: 'Наличными',
        "3-predoplata-kartoi": 'Предоплата безналичными',
        new: 'Зарезервирован МС',
        prodan: 'Доставляется курьером',
        courier: '1. Доставка курьером',
        kjivjv9u39oijskj: '4. Магазин',
        "not-paid": "Не оплачен",
        "1akb-by": '---1akb.by---',
        "rassrochka-cherez-bank": 'рассрочка через банк',
        "live-chat": 'Онлайн-консультант',
        "self-delivery": '3. Самовывоз',
        individual: 'Физическое лицо',
        "legal-entity": 'Юридическое лицо',
        saled: 'Продан в магазине',
        grodnomagaz: 'Гродно',
        grodnoooskalad: 'Гродно склад',
        rfhdfnfcrkfl: 'Склад Карвата',
        "exideby": 'exide.by',
        "eshop-individual": 'Физическое лицо',
        "eshop-legal": 'Юридическое лицо',
        "neizvestno": 'неизвестно',
        ukomplektovan: 'Укомплектован',
        "sklad-vitebsk": "Витебск, пр-т. Строителей 12",
        "vitebsk-magazin": "Витебск",
        euro987fh: '7. Европочта',
        fghgfh345lf342g: "Рябов Владислав Русланович ( г. Бобруйск ул. Орджоникидзе, 1 )",
        "456odkjf93jug": "Лакизо Игорь Викторович ( г. Гомель ул.Подпольщиков 18 )",
        savko: "Савко Александр ( г. Минск ул. Ваупшасова, 10 )",
        vorobei: "Михаил Воробей ( г. Минск ул. Ваупшасова, 10 )",
        ksdkdkdpdpoooo: "Иванов Александр Владимирович ( г. Новополоцк ул. Молодёжная 166А )",
        kjdhfldkf88: "Гончаров Андрей ( г. Витебск пр-т Строителей д. 12 к. 1 )",
        volodko: "Верниковский Станислав ( г. Минск ул. Володько, 9 )",
        "grodno-skut": "Шкут Денис ( г. Гродно ул. Горького, 63 )",
        iyuoiglhojpkl99: "Тофоров Павел Васильевич( г. Новополоцк ул. Молодёжная 166А )",
        sdgllkbhjs: "Шумский Юрий Михайлович (г. Могилев ул. Сурганова 13,а )",
        hdovnbsoifgv89: "Муха Андрей ( г. Брест ул. б-р Космонавтов 66 )",
        lkjijoju77: "Корсак Александр ( г. Полоцк ул. Строительная, 19 )",
        fghj77jgggjjjfg: "Черноусов Владислав Юрьевич ( г. Гродно ул. Горького, 63 )",
        kljhjjjjjj7u7uj: "Семенцов Дмитрий Михайлович ( г. Бобруйск ул. Орджоникидзе, 1 )",
        kshfhfhfhhhhooy7: "Патиюк Дмитрий Геннадьевич ( г. Минск ул. Машино-лей, 9А к.1 )",
        kjklhjkl3333: "Жук Артём Александрович ( г. Минск ул. Бельского, 14 )",
        golovkp9isd: "Головко Иван Андреевич ( г. Минск ул. Машино-лей, 9А к.1 )",
        ukjhklledff: "Валуй Сергей ( г. Минск ул. Машино-лей, 9А к.1 )",
        ksjdd9990090876: "Рябцев Вячеслав ( г. Минск ул. Бельского, 14 )",
        vasilev: "Васильев Евгений Валерьевич ( г. Витебск пр-т Строителей д. 12 к. 1 )",
        mjfjgdmjhgt779: "Трояновский Никита ( г. Гомель ул. Б. Хмельницкого, 59 )",
        goml23: "Пилявский Вадим Николаевич ( г. Гомель ул.Подпольщиков 18 )",
        jgfidl8: "Козлов Владислав Викторович ( г. Гомель ул. Б. Хмельницкого, 59 )",
        hanev: "Ханевич Дмитрий( г. Новополоцк ул. Молодёжная 166А )",
        "9yhkjh": "Заболотнёв Дмитрий Анатольевич ( г. Брест ул. б-р Космонавтов 66 )",
        korchunov: "Коршунов Антон Николаевич ( г. Могилев ул. Сурганова 13,а )",
        kjdhlgjuk2: "Середа Дмитрий ( г. Барановичи ул. Комсомольская, 17 )",
        baranki876: "Лешик Виталий Сергеевич ( г. Барановичи ул. Комсомольская, 17 )",
        jdnfbk88: "Дедюля Павел Леонидович ( г. Бобруйск ул. Орджоникидзе, 1 )",
        dflkhjsdfoasdfjhu: "Гурский Александр Игоревич ( г. Бобруйск ул. Орджоникидзе, 1 )",
        bobru23123: "Федотов Павел Александрович ( г. Бобруйск ул. Орджоникидзе, 1 )",
        "5eghdfhdfh5": "Банкевич Вадим Вячеславович ( г. Барановичи ул. Комсомольская, 17 )",
        "andrushchenko-taras-sergeevich": "Андрущенко Тарас Сергеевич ( г. Барановичи ул. Комсомольская, 17 )",
        "pomazenko-aleksandr-sergeevich": "Помазенко Александр Сергеевич ( г. Минск ул. Машино-лей, 9А к.1 )",
        "9p8oyihjg": "Замыслова Инга",
        ishdjsdkj34: "ул. Ваупшасова 10 ",
        "salyt-magazin": "Ваупшасова",
        "in-reserve": "Отмена",
        bonusami: "Бонусами",
        "onliner-autoenergy-by": "1. onliner *Energy Centre",
        Gomelsklad: "Гомель, Ефремовский склад",
        Gomel: "Гомель, Ефремовский рынок",
        "ukomplektovan-1": "Укомплектован",
        "beznal-oplata": "2. Терминал (любые карты)",
        sto32: "СТО",
        nedozvonilas: "Не дозвонилась",
        jy7t879y: "Шунейко Алесь Юрьевич ( г. Минск ул. Володько, 9 )",
        "volodko-magazin": "Володько 9",
        "ne-otgruzhen-eshche": "не отгружен еще",
        "servisnyi-tsentr": "Сервисный центр",
        "1-brak-servisnyi-tsentr": "1. БРАК - Сервисный центр",
        "masshinostroiteley-magazin": "Машиностроителей 9а",
        "sklad-mashinostroiteley": "Машиностроителей 9А",
        "loyalty_level": "По уровню",
        none: "Без скидки",
        returned: "Возврат",
        "prodan-1": "Продан (контроль)",
        "by-post": "8. ЕРИП или рассрочка банк - не используем",
        "mogilev-magaz": "Могилев",
        mogilevsklad: "Могилёв склад",
        "sklad-volodko": "Володько 9",
        krasavchikprodavec: "5. Продавец красавчик (вилкой проверил+дисконт+гарантия)",
        "volodko-magazin": "Володько 9",
        "salyt-magazin": "Ваупшасова",
        "belskodihfjpsd": "Бельского",
        "masshinostroiteley-magazin": "Машиностроителей 9а",
        "vitebsk-magazin": "Витебск",
        "pol1": "Полоцк №1 Северный рынок",
        "baramkimagaz": "Барановичи",
        "bobruiskmagaz": "Бобруйск, ул. Минская, 123-3",
        "gomel-bakunin": "Гомель, Бакунинский рынок",
        "Gomel": "Гомель, Ефремовский рынок",
        "grodnomagaz": "Гродно",
        "mogilev-magaz": "Могилев",
        "strelec-magaz": "Новополоцк ТЦ \"Стрелецкий капитал\"",
        "brestmagaz": "Брест",
        "sto-prodaza": "СТО",
        "servisnyi-tsentr": "Сервисный центр",
};




export default {
components: {
    LoaderTable,
    'TreeSelect': Treeselect,  // Локальная регистрация компонента для использования в шаблоне
    'date-picker': DatePicker, // Зарегистрируйте DatePicker
    draggable,
    'v-select': vSelect
  },
  data() {
    return {
      itemss: [
        { id: 1, name: 'Элемент 1' },
        { id: 2, name: 'Элемент 2' },
        { id: 3, name: 'Элемент 3' }
      ],
      predefinedFilter: null, // Хранит текущий выбранный предустановленный фильтр
      checkboxKey: 0, // Уникальный ключ для перерисовки чекбоксов
      predefinedFilters: {
        orderday: {name: 'Сегодня', filter: {statuses: [], managers:[]}},
        karvata: { name: 'Срез + менеджер', filter: { statuses: ['offer-analog'], managers: [] } },
        minsk: { name: 'Конс + менеджер', filter: { statuses: ['availability-confirmed'], managers: [] } },
        ourStores: { name: 'Самовывоз + менеджер', filter: { statuses: ['dskjdslksd'], managers: [] } },
        ourPrepend: { name: 'Отложенные + менеджер', filter: { statuses: ['dffddsdfsdd'], managers: [] } },
        vgg: { name: 'ВГ', filter: { statuses: ['fdjkdfkljd'], managers: []} },
        lomVozim:  { name: 'Лом возим', filter: { statuses: ['send-to-delivery', 'redirect',
         'fdjkdfkljd',
          'dskjdslksd',
           'zakaz-dostavlen-kur', 
           'zakaz-magaz',
            'korrektirovka-zakaza', 'fdkjsdkjdsklkl1', 'kushddflsidudhy', 'kontrol-vozvrat-na-sklad'], managers: []} },
        oplataVozim: { name: 'Оплата возим', filter: { statuses: ['send-to-delivery',
         'redirect',
        'fdjkdfkljd',
        'dskjdslksd',
         'zakaz-dostavlen-kur',
          'zakaz-magaz',
          'korrektirovka-zakaza',
          '1-zakaz-kurerom-dostavlen-dengi-i-bu-sdany', 
         'ofis-prinyal-dengi',
          'zaradka-akb-uspeshno',
          'zaradka-akb-uspeshno4', 'zamena0po0braku', 'povtornaya098', 'fdkjsdkjdsklkl1', 'kushddflsidudhy', 'nelvvhs47ujgt', 'dsfssffsds'], managers: []} },
        konverse: {name: 'Конверсия чатов', filter: { statuses: [
          'approval',
          'korrektirovka-zakaza',
          '1-zakaz-kurerom-dostavlen-dengi-i-bu-sdany',
          'ofis-prinyal-dengi',
          'zaradka-akb-uspeshno',
          'zaradka-akb-uspeshno4',
          'zamena0po0braku',
          'povtornaya098',
          'fdkjsdkjdsklkl1',
          'kushddflsidudhy',
          'nelvvhs47ujgt',
          'dsfssffsds',
          '5asjkdhgfilu333',
          'kontrol-vozvrat-na-sklad',
          'samovyvos-zabra-vypol',
          'send-to-delivery',
          'redirect',
          'fdjkdfkljd',
          'dskjdslksd',
          'zakaz-dostavlen-kur',
          'zakaz-magaz',
          'new',
          'kontrolhgcfxhg',
          'availability-confirmed',
          'sdilsddkls',
          'lskdjslkklsk',
          'dffddsdfsdd',
          'offer-analog',
          'maslosto',
          'vzial-v-rabotu',
          'sdlkfsdjfsdfsdf-sdfgsdf-sdf',
          'pod-zakaz',
          'novyi-beznalnyi-klient',
          'assembling',
          'assembling-complete',
          '4-komplektuetsya-sklad-sharangovicha-kurer-2',
          '3-komplektuetsya-sklad-sharangovicha-kurer-1',
          'ktuetsya-sklad-sharangovicha-kur234234ggg',
          'jdhfjfhjdhfjdhfdfhhhhhhhhhhhhh',
          '8-komplektuetsia-sklad-karvata-kurer-8',
          '7-komplektuetsia-sklad-karvata-kurer-7',
          '10-komplektuetsia-sklad-karvata-kurer-10',
          '9-komplektuetsia-sklad-karvata-kurer-9'
        ], managers: [] } },
      },
      statusBarOpened: false,
      isFirstLoad: true,
      displayFilter: true,
      atPageEnd: false,
      showExportModal: false,
      isVisibleMegamenu: false,
      exportTemplates: [], // Загружаются с сервера
      // --- Table Settings Data ---
      showTableSettingsModal: false,
      baseTableColumns: [
        { key: 'createdAt', label: 'Дата и время', style: 'min-width: 70px;' },
        { key: 'number', label: 'Номер', style: 'max-width: 100px;' },
        { key: 'copyNumber', label: '', isIcon: true, width: '40px' },
        { key: 'amountToPay', label: 'Сумма к оплате' },
        { key: 'items', label: 'Состав', style: 'min-width: 220px;' },
        { key: 'deliveryDate', label: 'Дата доставки' },
        { key: 'deliveryTime', label: 'Время доставки' },
        { key: 'deliveryAddress', label: 'Адрес доставки' },
        { key: 'paymentType', label: 'Тип оплаты' },
        { key: 'paymentStatus', label: 'Оплата', style: 'text-align: center; width: 80px;' },
        { key: 'tradeInAmountNew', label: 'Сумма за аккумулятор в зачет' },
        { key: 'batteryCapacity', label: 'Ёмкость аккумулятора в зачет' },
        { key: 'operatorComment', label: 'Комментарий оператора' },
        { key: 'visitor_code', label: 'Код посетителя' },
        { key: 'visitor_city', label: 'Город посетителя' },
        { key: 'personal_offer_discount', label: 'Скидка Товар дня %' },
        { key: 'courier', label: 'Курьер' },
        { key: 'courierRouteSheet', label: 'Маршрутный лист курьер' },
        { key: 'status', label: 'Статус заказа', style: 'max-width: 230px;' },
        { key: 'vgNumber', label: '№ ВГ' },
        { key: 'deliveryStatus', label: 'Статус доставки' },
        { key: 'deliveryType', label: 'Тип доставки' },
        { key: 'phone', label: 'Контактный телефон' },
        { key: 'copyPhone', label: '', isIcon: true, width: '40px' },
        { key: 'manager', label: 'Менеджер', style: 'min-width: 120px;' },
        { key: 'statusUpdatedAt', label: 'Последнее изменение статуса' },
        { key: 'dataSoglasovaniia', label: 'Дата согласования', style: 'min-width: 120px;' },
        { key: 'paymentSum', label: 'Сумма оплаты' },
        { key: 'customer', label: 'Покупатель', style: 'min-width: 120px;' },
        { key: 'cashbox', label: 'касса' },
        { key: 'orderMethod', label: 'Способ оформления' },
        { key: 'orderCorrection', label: 'Корректировка заказа' },
        { key: 'carBrand', label: 'марка ТС' },
        { key: 'carModel', label: 'модель ТС' },
        { key: 'seller', label: 'Продавец', style: 'min-width: 120px;' },
        { key: 'city', label: 'Город' },
        { key: 'amount', label: 'Сумма' },
        { key: 'orderDiscount', label: 'Размер скидки' },
        { key: 'bonus', label: 'Бонус' },
        { key: 'shipped', label: 'Отгружен', style: 'text-align: center; width: 60px;' },
        { key: 'lkjdhgdhg768', label: 'Номер реестра' },
        { key: 'tegi_dialoga', label: 'Теги диалога', style: 'min-width: 120px; max-width: 220px;' },
        { key: 'zvonok_text_bot', label: 'Выжимка бота', style: 'min-width: 150px; max-width: 320px;' }
      ],
      tableColumnSettings: [], // [{key, visible}]
      selectedTableColumns: [], // Для модального окна (реактивный массив для dnd)
      // --- Filter Settings Data ---
      showFilterSettingsModal: false,
      availableFilters: [
        { key: 'number', label: 'Номер заказа' },
        { key: 'customer', label: 'Покупатель' },
        { key: 'city', label: 'Город' },
        { key: 'inn', label: 'ИНН' },
        { key: 'createdAt', label: 'Дата оформления заказа' },
        { key: 'managers', label: 'Менеджеры(тест)' },
        { key: 'managersOld', label: 'Менеджеры (old)' },
        { key: 'prodavec', label: 'Продавцы' },
        { key: 'couriers', label: 'Курьеры' },
        { key: 'deliveryDate', label: 'Дата доставки' },
        { key: 'chipmentDate', label: 'Дата отгрузки' },
        { key: 'totalSumm', label: 'Сумма заказа, руб.' },
        { key: 'shipmentStores', label: 'Склады отгрузки' },
        { key: 'shipped', label: 'Отгрузка' },
        { key: 'product', label: 'Товар/услуга в заказе' },
        { key: 'deliveryTypes', label: 'Типы доставки' },
        { key: 'sites', label: 'Магазины' },
        { key: 'paymentTypes', label: 'Типы оплаты' },
        { key: 'predoplata_beznalichnymi_spravochnik', label: 'Предоплата безналичными (справочник)' },
        { key: 'ocenka_manageru', label: 'Оценка менеджеру' },
        { key: 'obzvon_klienta', label: 'Обзвон клиентов' },
        { key: 'orderMethod', label: 'Способы оформления' },
        { key: 'proverkazakazamenedgero', label: 'Проверка заказа менеджер' },
        { key: 'contragentTypes', label: 'Тип контрагента' },
        { key: 'paymentStatus', label: 'Статусы оплат' },
        { key: 'paymentDate', label: 'Дата оплаты' },
        { key: 'statusTsAt', label: 'Отгружено ТС' },
        { key: 'managerComment', label: 'Комментарий оператора' },
        { key: 'visitor_code', label: 'Код посетителя' },
        { key: 'visitor_city', label: 'Город посетителя' },
        { key: 'personal_offer_discount', label: 'Скидка Товар дня %' },
        { key: 'customerComment', label: 'Комментарий клиента' },
        { key: 'statusUpdatedAt', label: 'Последнее изменение статуса' },
        { key: 'datazakazaobrabotki', label: 'Дата обработки заказа' },
        { key: 'kasssas', label: 'Касса' },
        { key: 'sssylkaaaaasssyyylka', label: 'Cсылка на подбор' },
        { key: 'vgvgvgv', label: 'Номер ВГ' },
        { key: 'lkjdhgdhg768', label: 'Номер реестра' },
        { key: 'marssh', label: 'Маршрутный лист курьер' },
        { key: 'tegi_dialoga', label: 'Теги диалога' }
      ],
      filterSettings: [], // [{key, visible, order}]
      selectedFilters: [], // Для модального окна (реактивный массив для dnd)
      // ---------------------------
      // Batch actions
      showBatchMenu: false,
      activeSubmenu: null, // 'print', etc
      submenuPosition: { left: 0, top: 0, bottom: 'auto' },
      paymentStatuses: [], // Загружается из API через paymentStatusList
      printTemplates: [
        { id: 116, name: 'Лист курьера 2025', disabled: false },
        { id: 115, name: 'Гарантийный талон 2025', disabled: false },
        { id: 110, name: 'Список заказов для курьера (с подписью)', disabled: false },
        { id: 109, name: 'Договор c печатью Галицкий (новый)', disabled: true },
        { id: 70, name: 'Счет-фактура с печатью Галицкий', disabled: false },
        { id: 112, name: 'Нормальный Товарный чек НДС(печатать)', disabled: false },
        { id: 66, name: 'Договор без печати Гамзюк', disabled: true },
        { id: 107, name: 'Счет-фактура Гамзюк (3 дня)', disabled: false },
        { id: 67, name: 'Счет-фактура Гамзюк (5 дней)', disabled: false },
        { id: 118, name: 'Копия Лист курьера 2025', disabled: false },
        { id: 117, name: 'Лист Акт на зарядку', disabled: false },
        { id: 119, name: 'Печать vozim.by', disabled: false },
        { id: 120, name: 'Ведомость учета', disabled: false },
        { id: 121, name: 'Касса', disabled: false },
        { id: 122, name: 'Акт выполненных работ', disabled: false },
        { id: 123, name: 'Расчёт зарплаты курьера', disabled: false },
      ],
      // ---------------------------
      selectedTemplate: null,
      newTemplateName: '', // Для input нового шаблона
      editingTemplateId: null, // ID редактируемого шаблона
      exportAllOrders: false, // Чекбокс для выгрузки всех заказов с учетом фильтров
      exportOneRowPerOrder: false, // Один заказ — одна строка, товары в одной ячейке
      selectedColumns: [],
      selectedColumnKeys: [],
      copiedId: null,
      // Сортировка
      sortField: null, // Поле для сортировки
      sortDirection: 'asc', // Направление сортировки: 'asc' или 'desc'
      showTooltip: false,
      // Шаблоны быстрых фильтров (сохраняются пользователем)
      filterTemplates: [], // [{ id, name, queryString }]
      activeFilterTemplateId: null, // id выбранного сохранённого шаблона (как predefinedFilter для дефолтных)
      tempBkCollapsed: true,
      showFilterTemplateEdit: false,
      filterTemplatesToDelete: [],
      inactivityTimer: null,
      user:'',
      filtersApplied: false,
      showApplyButton: true, // Флаг для управления видимостью кнопки "Применить"
      loading: false, // Управляет видимостью лоадера
      isClosed: true, // состояние закрытия
      statuses: [], // Все статусы с сервера
      selectedStatuses: [], // Выбранные статусы
      lastSelectedStatus: null, // Последний выбранный статус
      groupedStatuses: {}, // Сгруппированные по категориям статусы
      statusStatistics: {}, // Статистика по статусам для всех групп {groupName: [{code, count}]}
      loadingStatusStatistics: false, // Флаг загрузки статистики
      enableStatusStatistics: false, // Включен ли подсчет количества заказов в статусах (по умолчанию выключен)
      grandTotalSum: 0, // Общая сумма всех заказов в статусах
      orders: [], // Список заказов
      pagination: null, // Пагинация
      perPage: 50,
      currentPage: 1, // Текущая страница
      showPopupStatus: false,
      selectedOrders: [], // id выбранных заказов
      lastOrderCheckboxIndex: null, // якорь для Shift+клик по чекбоксам
      selectAll: false,   // состояние "выделить все"
      selectAllForBatch: false, // при "выбрать все" — применять действие ко всем заказам по фильтру (до 6000)
      filters: { // Данные фильтров
        number: '',
        customer: '',
        city: '',
        inn: '',
        createdAt_gte: '',
        sssylkaaaaasssyyylka:'',
        createdAt_lte: '',
        couriers: [],
        managers: [],
        prodavec: [],
        managersOld: [],
        deliveryDate_gte: '',
        deliveryDate_lte: '',
        totalSumm_gte: '',
        totalSumm_lte: '',
        shipmentStores: [],
        product: '',
        deliveryTypes: [],
        sites: [],
        managerComment: '',
        vgvgvgv:'',
        customerComment: '',
        statusUpdatedAt_gte: '',
        statusUpdatedAt_lte: '',
        datazakazaobrabotki_gte: '',
        datazakazaobrabotki_lte: '',
        kasssas_gte: '',
        kasssas_lte: '',
        chipmentDate_gte: '',
        chipmentDate_lte: '',
        tegi_dialoga:'',
        marssh:'',
        lkjdhgdhg768:'',
        personal_offer_discount: '',
        statusTsAt_gte: '',
        statusTsAt_lte:'',
        paymentStatus:[],
        proverkazakazamenedgeroTypes:[],
        ocenka_manageruTypes:[],
        obzvon_klienta: [],
        predoplata_beznalichnymi_spravochnik: [],
        orderMethodd: [],
        paymentTypes:[],
        contragentTypes: [],
        paymentDate_gte: '',
        paymentDate_lte: '',
        shipped: ''

      },
      activeIndex: null, // Хранит индекс элемента, у которого открыт блок
      formatDate: 'YYYY-MM-DD', // Формат даты для retailCRM
      language: ru, // Локализация для DatePicker
      datepickerShortcuts: [
        {
          text: 'Сегодня',
          onClick: () => {
            return new Date();
          },
        },
        {
          text: 'Вчера',
          onClick: () => {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            return date;
          },
        },
        {
          text: '7 дней',
          onClick: () => {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            return date;
          },
        },
        {
          text: '30 дней',
          onClick: () => {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 30);
            return date;
          },
        }
      ],
      couriersListData: [], // Данные для списка курьеров (загружаются из curier.php)
      paymentList: [],
      ocenka_manageruList:[],
      ocenkaprodavcuList: [], // Список для оценки продавцу
      obzvon_klientaList: [],
      predoplata_beznalichnymi_spravochnikList: [],
      paymentSums: { paymentTypes: {}, predoplata: {} },
      loadingPaymentSums: false,
      paymentStatusList: [],
      orderMethods: [],
      contragentTypesList: [
        { label: 'Физическое лицо', value: 'eshop-individual' },
        { label: 'Юридическое лицо', value: 'eshop-legal' }
      ],
      managersList: [], // Данные для списка менеджеров
      prodavecList: [],
      managersListOld: [],
      storesList: [], // Данные для списка складов
      deliveryTypesList: [], // Данные для типов доставки
      proverkazakazamenedgeroTypesList:[],
      statusNameMap: {},
      siteNameMap: {},
      deliveryTypesMap: {},
      statusGroupMap: {},
      sitesList: [], // Данные для списка магазинов
      // Модальное окно для изменения пользовательских полей
      showCustomFieldModal: false,
      selectedCustomField: null,
      customFieldValue: '',
      batchCustomFieldLoading: false, // Флаг загрузки при массовом изменении полей
      batchBonusReloadLoading: false,
      batchBonusReloadProgress: { current: 0, total: 0 },
      // Модальное окно массовой смены статуса (с комментарием, как в OrderEdit)
      isModalBatchStatusVisible: false,
      batchStatusComment: '',
      pendingBatchStatusCode: null,
      pendingBatchStatusLabel: '',
      // Модальное окно для выбора машины курьера
      showCourierCarModal: false,
      selectedCourierId: null,
      selectedCarId: null,
      courierCarsList: [
        { value: 'E894BM-7', label: 'FAW BESTUNE NAT E894BM-7' },
        { value: 'AX1155-7', label: 'Peugeot Partner AX1155-7' },
        { value: 'AT8729-7', label: 'Peugeot Partner AT8729-7' },
        { value: 'AX1171-7', label: 'Peugeot Partner AX1171-7' },
        { value: 'AT4192-7', label: 'Peugeot Partner AT4192-7' },
        { value: 'AT4069-7', label: 'Peugeot Partner AT4069-7' },
        { value: 'AT6109-7', label: 'Peugeot Partner AT6109-7' },
        { value: 'AT0722-7', label: 'Ford Transit AT0722-7' },
        { value: 'AT9805-7', label: 'Ford Transit AT9805-7' },
        { value: 'AC8850-7', label: 'Lada Largus AC8850-7' },
        { value: 'AC1982-7', label: 'Lada Largus AC1982-7' },
        { value: 'AC1983-7', label: 'Lada Largus AC1983-7' },
        { value: 'AC1984-7', label: 'Lada Largus AC1984-7' },
        { value: 'BC7620-6', label: 'Volkswagen Golf BC7620-6' }
      ], // Список машин курьера
      liteOrderModalVisible: false,
      liteOrderSaving: false,
      liteOrderForm: {
        comment: '',
        deliveryAddress: '',
        deliveryDate: null,
        timeFrom: '',
        timeTo: '',
        courier: null
      },
      liteOrderErrors: {},
      customFieldsList: [
        // Блок «Доставка» — на самый верх (массовое изменение полей)
        { code: 'otgrugeno_na_region', name: 'Отгружено ТС', group: 'Доставка', type: 'date' },
        { code: 'marssh', name: 'Маршрутный лист курьер', group: 'Доставка', type: 'text' },
        { code: 'kasssas', name: 'касса', group: 'Доставка', type: 'date' },
        { code: 'sssylkaaaaasssyyylka', name: 'ссылка на подбор', group: 'Клиент', type: 'text' },
        { code: 'forma_na_saite', name: 'Форма на сайте', group: 'Клиент', type: 'text' },
        { code: 'visitor_code', name: 'Код посетителя', group: 'Клиент', type: 'text' },
        { code: 'visitor_city', name: 'Город посетителя', group: 'Клиент', type: 'text' },
        { code: 'personal_offer_discount', name: 'Скидка Товар дня %', group: 'Клиент', type: 'text' },
        { code: 'manager', name: 'Менеджеры', group: 'Клиент', type: 'select' },
        { code: 'nekorrektnyi_bonus', name: 'некорректный бонус?', group: 'Клиент', type: 'text' },
        { code: 'prodavec', name: 'Продавец', group: 'Клиент', type: 'select' },
        { code: 'lkjdhgdhg768', name: 'Номер реестра', group: 'Оплата', type: 'text' },
        { code: 'komisi', name: 'комиссия', group: 'Оплата', type: 'text' },
        { code: 'otgruzkabezoplata', name: 'отгрузка без оплаты', group: 'Оплата', type: 'text' },
        { code: 'predoplata_beznalichnymi_spravochnik', name: 'Предоплата безналичными (справочник)', group: 'Оплата', type: 'select' },
        { code: 'pometka_zakaza', name: 'пометка заказа', group: 'Оплата', type: 'text' },
        { code: 'datazakazaobrabotki', name: 'Дата обработки заказа', group: 'Склад', type: 'date' },
        { code: 'sf_num', name: 'Корректировка заказа', group: 'Склад', type: 'text' },
        { code: 'ocenka_manageru1', name: 'Оценка менеджеру', group: 'Склад', type: 'select' },
        { code: 'ocenkaprodavcu', name: 'Оценка продавцу', group: 'Склад', type: 'select' },
        { code: 'obzvon_klienta', name: 'Обзвон клиента', group: 'Склад', type: 'select' },
        { code: 'proverkazakazamenedgero', name: 'Проверка заказа менеджер', group: 'Склад', type: 'select' },
        { code: 'vgvgvgv', name: '№ ВГ', group: 'Склад', type: 'text' },
        { code: 'mjhfyusdsd7776', name: 'рекламация', group: 'Склад', type: 'text' },
        { code: 'raschet_kurera1', name: 'акб сдан', group: 'Склад', type: 'text' },
        { code: 'sto', name: 'диагностика', group: 'Склад', type: 'text' },
        { code: 'postavshchik_zamenil_brakovannyi_akb', name: 'Поставщик заменил бракованный акб', group: 'Склад', type: 'text' },
        { code: 'jsdhjlkshdlk99', name: 'история страниц', group: 'Склад', type: 'text' },
        { code: 'vision_site', name: 'посещённые страницы (vision_site)', group: 'Склад', type: 'text' },
        { code: 'data_soglasovaniia1', name: 'Дата согласования', group: 'Основное', type: 'datetime' },
        { code: 'tip_ts_podbor', name: 'тип ТС', group: 'Склад', type: 'text' }
      ]
    };
  },
  watch: {
    // Отслеживаем изменения пользователя в store
    '$store.state.user': {
      handler(newUser) {
        this.user = newUser;
        console.log('DEBUG: Store user changed, updated this.user:', newUser);
        
        // Для ограниченного пользователя задаём фильтр магазинов по умолчанию только если ещё не выбран (пусто или невалидно)
        if (newUser && this.isRestrictedUser) {
          const allowed = this.getRestrictedSites();
          const current = this.filters.sites || [];
          const needDefault = current.length === 0 || !current.every(s => allowed.includes(s));
          if (needDefault) {
            this.filters.sites = [...allowed];
            this.filtersApplied = true;
            this.$forceUpdate();
          }
        }
      },
      immediate: true
    },
    // Для роли Магазины: не допускаем пустой выбор магазинов — хотя бы один должен оставаться
    'filters.sites': {
      handler(newVal) {
        if (!this.isRestrictedUser || !this.user) return;
        const allowed = this.getRestrictedSites();
        if (!allowed.length) return;
        const current = Array.isArray(newVal) ? newVal : [];
        if (current.length === 0) {
          this.$nextTick(() => {
            this.filters.sites = [...allowed];
          });
        }
      },
      deep: true
    },
    
  selectedStatuses(newVal) {
    // Не трогаем lastSelectedStatus, если уже установлен в 'all'
    if (this.lastSelectedStatus === 'all') return;
    this.lastSelectedStatus = newVal.length > 0 ? newVal[newVal.length - 1] : null;
  },
  selectedOrders(newVal) {
    // Если сняли часть галочек — это уже не "выбрать все по фильтру"
    if (this.orders.length && newVal.length < this.orders.length) {
      this.selectAllForBatch = false;
    }
  },
  selectedColumns: {
    handler(val) {
      // Формируем новые ключи из выбранных колонок (dnd)
      const newKeys = val.map(c => c.key);
      console.log(newKeys);
    },
    deep: true
  },
  selectedColumnKeys(val) {
    console.log(this.exportColumns);
    // Сохраняем текущий порядок сортировки и только добавляем/удаляем элементы
    const currentKeys = this.selectedColumns.map(c => c.key);
    const newKeys = val;
    
    // Если порядок ключей не изменился, ничего не делаем (чтобы не сбрасывать сортировку при drag&drop)
    if (currentKeys.length === newKeys.length && 
        currentKeys.every((key, i) => key === newKeys[i])) {
      return;
    }
    
    // Если изменился только порядок (те же элементы, но в другом порядке),
    // это значит, что пользователь перетащил элементы - не трогаем selectedColumns
    const currentSet = new Set(currentKeys);
    const newSet = new Set(newKeys);
    const sameElements = currentKeys.length === newKeys.length && 
                         currentKeys.every(key => newSet.has(key)) &&
                         newKeys.every(key => currentSet.has(key));
    
    if (sameElements) {
      // Это перестановка через drag&drop - selectedColumns уже обновлен draggable,
      // просто синхронизируем selectedColumnKeys (но это уже сделано в onDragEnd)
      return;
    }
    
    // Удаляем элементы, которых больше нет в выбранных
    const filteredColumns = this.selectedColumns.filter(c => newKeys.includes(c.key));
    
    // Сохраняем порядок существующих элементов из selectedColumns
    const existingKeysSet = new Set(filteredColumns.map(c => c.key));
    
    // Добавляем новые элементы в конец, сохраняя порядок существующих
    const keysToAdd = newKeys.filter(key => !existingKeysSet.has(key));
    const newCols = keysToAdd.map(key => this.exportColumns.find(c => c.key === key)).filter(Boolean);
    
    // Объединяем: сначала существующие в их текущем порядке, потом новые
    this.selectedColumns = [...filteredColumns, ...newCols];
  }
},
  computed: {
    ...mapState('savedFormsModule', ['savedForms']),
     hasSavedOrders() {
      return this.savedForms.length > 0;
      //console.log(this.savedForms.id);
    },
    validFilterTemplates() {
      const list = this.filterTemplates || [];
      return Array.isArray(list) ? list.filter(t => t && t.id != null && t.name != null && t.queryString != null) : [];
    },
    hasActiveFilters() {
      const f = this.filters || {};
      const strFields = ['number', 'customer', 'city', 'inn', 'product', 'managerComment', 'customerComment', 'tegi_dialoga', 'marssh', 'lkjdhgdhg768', 'sssylkaaaaasssyyylka', 'vgvgvgv', 'personal_offer_discount', 'shipped'];
      if (strFields.some(k => f[k] && String(f[k]).trim() !== '')) return true;
      const dateFields = ['createdAt_gte', 'createdAt_lte', 'deliveryDate_gte', 'deliveryDate_lte', 'chipmentDate_gte', 'chipmentDate_lte', 'statusUpdatedAt_gte', 'statusUpdatedAt_lte', 'datazakazaobrabotki_gte', 'datazakazaobrabotki_lte', 'kasssas_gte', 'kasssas_lte', 'statusTsAt_gte', 'statusTsAt_lte', 'paymentDate_gte', 'paymentDate_lte'];
      if (dateFields.some(k => f[k])) return true;
      if ((f.totalSumm_gte && String(f.totalSumm_gte).trim() !== '') || (f.totalSumm_lte && String(f.totalSumm_lte).trim() !== '')) return true;
      const arrFields = ['couriers', 'managers', 'managersOld', 'prodavec', 'shipmentStores', 'deliveryTypes', 'sites', 'paymentTypes', 'ocenka_manageruTypes', 'obzvon_klienta', 'orderMethodd', 'paymentStatus', 'proverkazakazamenedgeroTypes', 'contragentTypes', 'predoplata_beznalichnymi_spravochnik', 'ocenka'];
      if (arrFields.some(k => Array.isArray(f[k]) && f[k].length > 0)) return true;
      if (this.selectedStatuses && this.selectedStatuses.length > 0) return true;
      return false;
    },
    availableStatuses() {
      // Возвращаем статусы из this.statuses, если они загружены
      return this.statuses.map(status => ({
        id: status.code,
        name: status.name,
        group: status.group || ''
      }));
    },
    exportColumns() {
    return Object.entries(fieldLabels).map(([key, label]) => ({
      key,
      label: Object.prototype.hasOwnProperty.call(exportColumnLabelOverrides, key)
        ? exportColumnLabelOverrides[key]
        : label,
      group: groupMapping[key] || 'Другие'
    }));
  },
  
  groupedExportColumns() {
    const groups = {};
    this.exportColumns.forEach(col => {
      if (!groups[col.group]) groups[col.group] = [];
      groups[col.group].push(col);
    });
    return groups;
  },
  
  sortedGroups() {
    const order = [
      'Аналитика',
      'Покупатель',
      'Контрагент',
      'Стоимость',
      'Расходы',
      'Доставка',
      'Заказ',
      'Оплата',
      'Товар',
      'Коммуникации',
      'Отгрузка',
      'Пользовательские поля',
      'Другие'
    ];
    
    return Object.entries(this.groupedExportColumns)
      .sort((a, b) => order.indexOf(a[0]) - order.indexOf(b[0]));
  },

    isAllSelected() {
      return this.orders.length && this.selectedOrders.length === this.orders.length;
    },
    userRole() {
      return this.$store.state.user ? this.$store.state.user.role : null;
    },
    isLogist() {
      const role = String(this.userRole || '').toLowerCase();
      return role && role.includes('логист');
    },
    // Доступ к столбцу «Размер скидки»: роли Менеджеры и Руководство (из filterFieldsByRole.js)
    isManagersOrManagement() {
      const role = String(this.userRole || '').trim();
      if (!role) return false;
      return ROLES_ORDER_DISCOUNT_COLUMN.some(
        r => role === r || role.toLowerCase() === r.toLowerCase()
      );
    },
    // Подсчёт в статусах принудительно только для логистов, которые не ограничены (не Магазины)
    isLogistForcedStatistics() {
      return this.isLogist && !this.isRestrictedUser;
    },
    enableStatusStatisticsComputed: {
      get() {
        // Для логистов (кроме роли Магазины) всегда включено
        if (this.isLogistForcedStatistics) {
          return true;
        }
        return this.enableStatusStatistics;
      },
      set(value) {
        if (!this.isLogistForcedStatistics) {
          this.enableStatusStatistics = value;
        }
      }
    },
    sortedGroupedStatuses() {
      const groups = { ...this.groupedStatuses };
      const groupNames = Object.keys(groups);
      
      // Если пользователь логист, меняем порядок: assembling выше approval, approval выше delivery
      if (this.isLogist) {
        const sortedNames = [...groupNames];
        
        // Находим индексы групп assembling и approval
        // Проверяем и по названию группы, и по цвету
        const assemblingIndex = sortedNames.findIndex(name => {
          const group = groups[name];
          return group.color === 'assembling' || 
                 name.toLowerCase() === 'assembling' ||
                 name.toLowerCase().includes('assembling');
        });
        const approvalIndex = sortedNames.findIndex(name => {
          const group = groups[name];
          return group.color === 'approval' || 
                 name.toLowerCase() === 'approval' ||
                 name.toLowerCase().includes('approval');
        });
        const deliveryIndex = sortedNames.findIndex(name => {
          const group = groups[name];
          return group.color === 'delivery' || 
                 name.toLowerCase() === 'delivery' ||
                 name.toLowerCase().includes('delivery');
        });
        
        // Если обе группы найдены и assembling ниже approval, меняем их местами
        if (assemblingIndex !== -1 && approvalIndex !== -1 && assemblingIndex > approvalIndex) {
          // Меняем местами: assembling должен быть выше approval
          [sortedNames[approvalIndex], sortedNames[assemblingIndex]] = 
            [sortedNames[assemblingIndex], sortedNames[approvalIndex]];
        }
        
        // Для логистов: approval должен быть выше delivery (перемещаем approval перед delivery)
        if (approvalIndex !== -1 && deliveryIndex !== -1) {
          // Находим новые индексы после возможной перестановки assembling/approval
          const newApprovalIndex = sortedNames.findIndex(name => {
            const group = groups[name];
            return group.color === 'approval' || 
                   name.toLowerCase() === 'approval' ||
                   name.toLowerCase().includes('approval');
          });
          const newDeliveryIndex = sortedNames.findIndex(name => {
            const group = groups[name];
            return group.color === 'delivery' || 
                   name.toLowerCase() === 'delivery' ||
                   name.toLowerCase().includes('delivery');
          });
          
          // Если approval ниже delivery, перемещаем approval перед delivery
          if (newApprovalIndex !== -1 && newDeliveryIndex !== -1 && newApprovalIndex > newDeliveryIndex) {
            // Удаляем approval из текущей позиции
            const approvalName = sortedNames[newApprovalIndex];
            sortedNames.splice(newApprovalIndex, 1);
            // Вставляем approval перед delivery
            const newDeliveryPos = sortedNames.findIndex(name => {
              const group = groups[name];
              return group.color === 'delivery' || 
                     name.toLowerCase() === 'delivery' ||
                     name.toLowerCase().includes('delivery');
            });
            sortedNames.splice(newDeliveryPos, 0, approvalName);
          }
        }
        
        const sortedGroups = {};
        sortedNames.forEach(name => {
          sortedGroups[name] = groups[name];
        });
        return sortedGroups;
      }
      
      return groups;
    },
    sortedGroupedStatusesForBatchChange() {
      // Для массового изменения статуса используем sortedGroupedStatuses, но убираем группы "Брак", "СТО" и "Новый"
      const groups = JSON.parse(JSON.stringify(this.sortedGroupedStatuses)); // deep copy
      
      // Убираем группы "Брак", "СТО" и "Новый"
      delete groups['brak12'];
      delete groups['sto12f'];
      delete groups['new'];
      
      // В группе "Согласование" (approval) оставляем только статус "Консультация"
      // В группе "Доставка" (delivery) оставляем только указанные статусы
      Object.keys(groups).forEach(groupName => {
        const group = groups[groupName];
        
        if (group.color === 'approval') {
          // Фильтруем статусы, оставляя только те, которые содержат "консультация" в названии
          if (group.statuses && Array.isArray(group.statuses)) {
            group.statuses = group.statuses.filter(status => 
              status.name && status.name.toLowerCase().includes('консультаци')
            );
          }
        }
        
        if (group.color === 'delivery') {
          // Оставляем только указанные статусы для доставки
          const allowedDeliveryStatuses = [
            'доставка курьером',
            'доставка транспортной компанией',
            'передан в доставку',
            'самовывоз',
            'заказ доставлен курьером'
          ];
          
          if (group.statuses && Array.isArray(group.statuses)) {
            group.statuses = group.statuses.filter(status => {
              if (!status.name) return false;
              const statusName = status.name.toLowerCase().trim();
              return allowedDeliveryStatuses.some(allowed => 
                statusName.includes(allowed.toLowerCase())
              );
            });
          }
        }
        
        if (group.color === 'dflkdslskl' || groupName === 'dflkdslskl') {
          // Оставляем только указанные статусы для завершающего этапа
          const allowedFinalStatuses = [
            '2. заказ курьером доставлен (деньги и мд сданы)',
            '3. доставлен тс',
            '4. корректировка заказа',
            '5. заказ забран',
            '6. замена по браку',
            'доставлен тс + бу не забрали !',
            'доставлен тс + мд забрали'
          ];
          
          if (group.statuses && Array.isArray(group.statuses)) {
            group.statuses = group.statuses.filter(status => {
              if (!status.name) return false;
              const statusName = status.name.toLowerCase().trim();
              return allowedFinalStatuses.some(allowed => 
                statusName.includes(allowed.toLowerCase()) || allowed.toLowerCase().includes(statusName)
              );
            });
          }
        }
        
        if (group.color === 'cancel') {
          // Оставляем только указанные статусы для отмененных
          const allowedCancelStatuses = [
            '1. отменен',
            '6. отмена дубль',
            '7. отмена нашёл намного дешевле у конкурентов',
            '12. отмена с возвратом в этот же магазин (собственная продажа магазина)',
            '2b. отмена с доставкой тк товар на складе',
            '2. отмена с доставкой минск',
            '3. отмена с отгрузкой курьеру',
            'контроль нецелевой'
          ];
          
          if (group.statuses && Array.isArray(group.statuses)) {
            group.statuses = group.statuses.filter(status => {
              if (!status.name) return false;
              const statusName = status.name.toLowerCase().trim();
              return allowedCancelStatuses.some(allowed => 
                statusName.includes(allowed.toLowerCase()) || allowed.toLowerCase().includes(statusName)
              );
            });
          }
        }
        
        if (group.color === 'complete') {
          // Оставляем только указанные статусы для выполненных
          const allowedCompleteStatuses = [
            '6a.контроль отмена дубль',
            '6b. контроль отмена диагностика, сдача акб',
            '7а контроль отмена контроль купил у другого менеджера',
            'контроль масло, сто, запчасти, шины'
          ];
          
          if (group.statuses && Array.isArray(group.statuses)) {
            group.statuses = group.statuses.filter(status => {
              if (!status.name) return false;
              const statusName = status.name.toLowerCase().trim();
              return allowedCompleteStatuses.some(allowed => 
                statusName.includes(allowed.toLowerCase()) || allowed.toLowerCase().includes(statusName)
              );
            });
          }
        }
      });
      
      return groups;
    },
    canExportOrders() {
      const role = String(this.userRole || '').toLowerCase();
      const allowedMarkers = ['руковод', 'контрол', 'логист'];
      return role && allowedMarkers.some(marker => role.includes(marker));
    },
    isManagementRole() {
      const role = String(this.userRole || '').toLowerCase();
      return role.includes('руковод');
    },
    
    // TODO: УДАЛИТЬ - Проверка ограниченных пользователей для жесткого фильтра магазинов
    isRestrictedUser() {
      const restrictedUserValues = [47, 205, 202, 204, 284];
      const retailCrmId = this.user && this.user.retailCrmId;
      const parsedRetailCrmId = parseInt(retailCrmId);
      const result = retailCrmId && restrictedUserValues.includes(parsedRetailCrmId);
      
      console.log('DEBUG: isRestrictedUser check:', {
        user: this.user,
        retailCrmId: retailCrmId,
        parsedRetailCrmId: parsedRetailCrmId,
        retailCrmIdType: typeof retailCrmId,
        restrictedUserValues,
        result,
        userInList: retailCrmId ? restrictedUserValues.includes(parsedRetailCrmId) : false,
        is202: parsedRetailCrmId === 202
      });
      
      return result;
    },
    
    // TODO: УДАЛИТЬ - Проверка готовности данных для отображения колонки продавца
    showSellerColumn() {
      return this.isRestrictedUser && this.prodavecList && Array.isArray(this.prodavecList) && this.prodavecList.length > 0;
    },
    // Список колонок таблицы (в настройках столбец «Размер скидки» виден всем)
    availableTableColumns() {
      return this.baseTableColumns || [];
    },
    visibleTableColumns() {
      const settings = this.tableColumnSettings || [];
      const available = this.availableTableColumns;
      let ordered = [];

      if (settings.length > 0) {
        // Сортируем настройки по порядку, если он есть
        const sortedSettings = [...settings].sort((a, b) => {
          const orderA = a.order !== undefined ? a.order : 9999;
          const orderB = b.order !== undefined ? b.order : 9999;
          return orderA - orderB;
        });
        
        const handledKeys = new Set();
        // Сначала добавляем столбцы в сохраненном порядке
        sortedSettings.forEach(s => {
          const col = available.find(c => c.key === s.key);
          if (col) {
            ordered.push(col);
            handledKeys.add(col.key);
          }
        });
        // Затем добавляем новые столбцы, которых нет в настройках
        available.forEach(c => {
          if (!handledKeys.has(c.key)) {
            ordered.push(c);
          }
        });
      } else {
        ordered = [...available];
      }

      // Фильтруем по видимости; столбец «Размер скидки» показываем только для роли Менеджеры и руководство
      return ordered.filter(col => {
        if (col.key === 'orderDiscount' && !this.isManagersOrManagement) return false;
        const s = settings.find(x => x.key === col.key);
        if (s && s.visible === false) return false;
        return true;
      });
    },
    // Отсортированные заказы
    sortedOrders() {
      if (!this.sortField) {
        return this.orders;
      }
      if (this.sortField === 'deliveryTime') {
        const orders = [...this.orders];
        const direction = this.sortDirection === 'asc' ? 1 : -1;
        return orders.sort((a, b) => {
          const getDeliveryTime = (order) => {
            if (!order.delivery || !order.delivery.time) return null;
            const timeFrom = order.delivery.time.from;
            if (timeFrom) {
              const [hours, minutes] = timeFrom.split(':').map(Number);
              return hours * 60 + (minutes || 0);
            }
            return null;
          };
          const timeA = getDeliveryTime(a);
          const timeB = getDeliveryTime(b);
          if (timeA === null && timeB === null) return 0;
          if (timeA === null) return 1;
          if (timeB === null) return -1;
          return (timeA - timeB) * direction;
        });
      }
      if (this.sortField === 'deliveryDate') {
        const orders = [...this.orders];
        const direction = this.sortDirection === 'asc' ? 1 : -1;
        return orders.sort((a, b) => {
          const getDeliveryDate = (order) => {
            if (!order.delivery || !order.delivery.date) return null;
            const d = order.delivery.date;
            if (typeof d === 'string') return d; // YYYY-MM-DD сравниваются лексикографически
            return d;
          };
          const dateA = getDeliveryDate(a);
          const dateB = getDeliveryDate(b);
          if (dateA == null && dateB == null) return 0;
          if (dateA == null) return 1;
          if (dateB == null) return -1;
          const cmp = String(dateA).localeCompare(String(dateB));
          return (cmp < 0 ? -1 : cmp > 0 ? 1 : 0) * direction;
        });
      }
      if (this.sortField === 'orderDiscount') {
        const orders = [...this.orders];
        const direction = this.sortDirection === 'asc' ? 1 : -1;
        return orders.sort((a, b) => {
          const valA = this.getOrderTotalDiscount(a);
          const valB = this.getOrderTotalDiscount(b);
          return (valA - valB) * direction;
        });
      }
      return this.orders;
    },
    visiblePages() {
      const totalPages = this.pagination.totalPageCount;
      const currentPage = this.pagination.currentPage;
      const delta = 2;
      let pages = [];

      if (totalPages <= 1) return pages;

      pages.push(1);
      if (currentPage - delta > 2) pages.push("...");
      
      const start = Math.max(2, currentPage - delta);
      const end = Math.min(totalPages - 1, currentPage + delta);
      for (let i = start; i <= end; i++) pages.push(i);
      
      if (currentPage + delta < totalPages - 1) pages.push("...");
      // if (totalPages > 1) pages.push(totalPages);

      return pages;
    }
,
  formattedSitesList() {
      return this.sitesList.map(site => ({
        id: site.value, // Преобразуем в id, который требуется
        label: site.label,   // Отображаемое название
      }));
    },
    // Для роли Магазины: в фильтре показываем только разрешённые магазины (или один, если задан restrictedUserSingleSite)
    sitesFilterOptions() {
      if (!this.isRestrictedUser || !this.user) {
        return this.formattedSitesList;
      }
      const allowedIds = this.getRestrictedSites();
      if (!allowedIds.length) return this.formattedSitesList;
      return this.formattedSitesList.filter(site => allowedIds.includes(site.id));
    },
    formattedManagersList() {
      return sortManagersByLabel(this.managersList).map(manager => ({
        id: manager.value, // Преобразуем в id, который требуется
        label: manager.surname + ' ' + manager.name,   // Отображаемое название
      }));
    },
    formattedProdavecList() {
      const list = this.prodavecList.map(prodavec => ({
        id: prodavec.value, // Преобразуем в id, который требуется
        label: prodavec.label,   // Отображаемое название
      }));
      list.unshift({ id: 'empty', label: 'Пусто' });
      return list;
    },
    formattedCouriersList() {
      return this.couriersListData.map(courier => ({
        id: courier.value, // Преобразуем в id, который требуется
        label: courier.label,   // Отображаемое название
      }));
    },
    formattedManagersListOld() {
      return sortManagersByLabel(this.managersListOld).map(manager => ({
        id: manager.value, // Преобразуем в id, который требуется
        label: manager.surname + ' ' + manager.name,   // Отображаемое название
      }));
    },
     formattedShipmentList() {
      return this.storesList.map(sklad => ({
        id: sklad.value, // Преобразуем в id, который требуется
        label: sklad.label,   // Отображаемое название
      }));
    },
    formattedDeliveryList() {
      return this.deliveryTypesList.map(delivery => ({
        id: delivery.value, // Преобразуем в id, который требуется
        label: delivery.label,   // Отображаемое название
      }));
    },
    formattedContragentTypesList() {
      return (this.contragentTypesList || []).map(contragentType => ({
        id: contragentType.value,
        label: contragentType.label,
      }));
    },
    formattedproverkazakazamenedgeroList() {
      return (this.proverkazakazamenedgeroTypesList || []).map(proverkazakazamenedger => ({
        id: proverkazakazamenedger.value || proverkazakazamenedger.code || proverkazakazamenedger.id, // Преобразуем в id, который требуется
        label: proverkazakazamenedger.label || proverkazakazamenedger.name,   // Отображаемое название
      }));
    },  
    formattedoplataList() {
      return this.deliveryTypesList.map(oplata => ({
        id: oplata.value, // Преобразуем в id, который требуется
        label: oplata.label,   // Отображаемое название
      }));
    },  
    formattedocenka_manageruList() {
      return this.ocenka_manageruList.map(ocenka => ({
        id: ocenka.value, // Преобразуем в id, который требуется
        label: ocenka.label,   // Отображаемое название
      }));
    },
    formartpaymentStatusList(){
      return this.paymentStatusList.map(paymentStatus => ({
        id: paymentStatus.value,
        label: paymentStatus.label
      }));
    }, 
    formattedobzvon_klienta(){
      return this.obzvon_klientaList.map(obzvon => ({
        id: obzvon.value,
        label: obzvon.label
      }));
    },
    formattedPredoplataBeznalichnymiList() {
      return (this.predoplata_beznalichnymi_spravochnikList || []).map(p => ({
        id: p.value,
        label: p.label
      }));
    },
    formatteOrderMethods(){
      return this.orderMethods.map(meth => ({
        id: meth.value,
        label: meth.label
      }));
    },
    formattedPaymentList() {
      return Array.isArray(this.paymentList)
        ? this.paymentList.map(payment => ({
            id: payment.value,
            label: payment.label,
          }))
        : []; // Возвращаем пустой массив, если paymentList не массив
    },
    // Сводка сумм по типу оплаты и справочнику предоплаты для блока под пагинацией
    // «Предоплата безналичными» из типов оплаты не выводим — вместо неё показываем пункты справочника (ЕРИП, ТН, online оплата картой и т.д.)
    // Порядок сортировки: 1 наличные, 2 карта, 3 тн, 4 ерип, 5 рассрочка, 6 онлайн оплаты, 7 qr код, 8 без денег, 9 бонус, 10 оплати здесь
    paymentSumsDisplay() {
      const out = [];
      const pt = this.paymentSums && this.paymentSums.paymentTypes ? this.paymentSums.paymentTypes : {};
      const pred = this.paymentSums && this.paymentSums.predoplata ? this.paymentSums.predoplata : {};
      const getPaymentSortOrder = (label) => {
        const l = String(label || '').toLowerCase();
        if (l.includes('наличн')) return 1;
        if (l.includes('терминал') || (l.includes('карт') && !l.includes('online'))) return 2;
        if (l.includes('тн') && !l.includes('оплат')) return 3;
        if (l.includes('ерип')) return 4;
        if (l.includes('рассрочк')) return 5;
        if (l.includes('online') || l.includes('онлайн')) return 6;
        if (l.includes('qr') || l.includes('qr-код')) return 7;
        if (l.includes('без денег')) return 8;
        if (l.includes('бонус')) return 9;
        if (l.includes('оплати')) return 10;
        return 99;
      };
      (this.paymentList || []).forEach(p => {
        const value = p.value || p.id;
        const label = p.label || p.name || value;
        if (label && String(label).includes('Предоплата безналичными')) return;
        out.push({
          label,
          sum: pt[value] != null ? pt[value] : 0,
          filterKind: 'paymentType',
          filterValue: value,
          _sortOrder: getPaymentSortOrder(label)
        });
      });
      (this.predoplata_beznalichnymi_spravochnikList || []).forEach(p => {
        const value = p.value;
        const label = p.label || value;
        out.push({
          label,
          sum: pred[value] != null ? pred[value] : 0,
          filterKind: 'predoplata',
          filterValue: value,
          _sortOrder: getPaymentSortOrder(label)
        });
      });
      return out.sort((a, b) => (a._sortOrder || 99) - (b._sortOrder || 99)).map(({ _sortOrder, ...item }) => item);
    },
    isAllStatusesActive() {
      return this.selectedStatuses.length === 0; // Если не выбрано ни одного статуса, считаем, что активен "Все"
    },
    allStatusesList() {
      // Используем массив statuses напрямую
      if (!this.statuses || !Array.isArray(this.statuses)) {
        return [];
      }
      return this.statuses.map(status => ({
        code: status.code,
        name: status.name || status.code
      }));
    },
    couriersList() {
      // Возвращаем загруженный список курьеров из curier.php
      return Array.isArray(this.couriersListData) ? this.couriersListData : [];
    }
  },

  
  mounted() {
    // Инициализация пользователя из store
    this.user = this.$store.state.user;
    console.log('DEBUG: mounted - user from store:', this.$store.state.user);
    console.log('DEBUG: mounted - user from localStorage:', JSON.parse(localStorage.getItem('user')));
    console.log('DEBUG: mounted - final user:', this.user);
    
    // Для ограниченного пользователя: задаём фильтр магазинов по умолчанию только если ещё не выбран
    if (this.user && this.isRestrictedUser) {
      const allowed = this.getRestrictedSites();
      const current = this.filters.sites || [];
      const needDefault = current.length === 0 || !current.every(s => allowed.includes(s));
      if (needDefault) {
        this.filters.sites = [...allowed];
        this.filtersApplied = true;
        this.$forceUpdate();
      }
    }

    this.$store.dispatch('savedFormsModule/loadSavedForms');
    this.loadTableSettings();
    this.loadFilterSettings();
    this.$nextTick(() => { this.loadFilterTemplates(); });
    
    // Закрытие подменю при клике вне его
    document.addEventListener('click', this.closeSubmenuOnClickOutside);
    
    // TODO: УДАЛИТЬ - Загрузка данных продавцов для ограниченных пользователей
    fetch(ORDERS_API_BASE + '/seller.php')
      .then(response => response.json())
      .then(data => {
         this.prodavecList = data;
         console.log('DEBUG: prodavecList loaded:', this.prodavecList);
      })
      .catch(error => {
        console.error('Ошибка при получении prodavecList:', error);
      });

    // Получение данных о статусах с сервера
    fetch(ORDERS_API_BASE + '/statuses.php') // Замените на ваш реальный API
      .then(response => response.json())
      .then(data => {
        this.statuses = data.statuses;
        this.createStatusNameMap(); 
        this.createStatusGroupMap();
        this.groupStatuses(); // Группируем статусы после получения
      })
      .catch(error => {
        console.error('Ошибка при получении статусов:', error);
      });

      
 


      fetch(ORDERS_API_BASE + '/store.php') // Замените на ваш реальный API
      .then(response => response.json())
      .then(data => {
         this.sitesList = data;
         this.createSiteNameMap();           
      })
      .catch(error => {
        console.error('Ошибка при получении статусов:', error);
      });


      fetch(ORDERS_API_BASE + '/payment.php')
        .then(response => response.json())
        .then(data => {
           this.paymentList = Array.isArray(data.paymentTypes) ? data.paymentTypes : [];
        })
        .catch(error => {
          console.error('Ошибка при получении статусов:', error);
        });


        fetch(ORDERS_API_BASE + '/ocenka.php')
        .then(response => response.json())
        .then(data => {
           this.ocenka_manageruList = data;
        })
        .catch(error => {
          console.error('Ошибка при получении статусов:', error);
        });
        
        fetch(ORDERS_API_BASE + '/ocenkapr.php')
        .then(response => response.json())
        .then(data => {
           this.ocenkaprodavcuList = data;
        })
        .catch(error => {
          console.error('Ошибка при получении ocenkaprodavcuList:', error);
        });
        
        fetch(ORDERS_API_BASE + '/paymentStatus.php')
        .then(response => response.json())
        .then(data => {
           this.paymentStatusList = data;
           // Заполняем paymentStatuses для массового изменения
           this.paymentStatuses = data.map(status => ({
             id: status.value, // Код статуса (например, "not-paid", "paid")
             name: status.label // Название статуса
           }));
        })
        .catch(error => {
          console.error('Ошибка при получении статусов:', error);
        });

        fetch(ORDERS_API_BASE + '/obzvon_klienta.php')
        .then(response => response.json())
        .then(data => {
           this.obzvon_klientaList = data;
        })
        .catch(error => {
          console.error('Ошибка при получении статусов:', error);
        });

        fetch(ORDERS_API_BASE + '/proverka.php')
        .then(response => response.json())
        .then(data => {
           this.proverkazakazamenedgeroTypesList = Array.isArray(data) ? data : [];
           console.log('proverkazakazamenedgeroTypesList loaded:', this.proverkazakazamenedgeroTypesList);
        })
        .catch(error => {
          console.error('Ошибка при получении proverkazakazamenedgeroTypesList:', error);
        });

        fetch(ORDERS_API_BASE + '/vozim.php')
        .then(response => response.json())
        .then(data => {
          this.predoplata_beznalichnymi_spravochnikList = Array.isArray(data) ? data : [];
        })
        .catch(error => {
          console.error('Ошибка при получении predoplata_beznalichnymi_spravochnikList:', error);
        });

      fetch(ORDERS_API_BASE + '/manager.php') 
      .then(response => response.json())
      .then(data => {
         this.managersListOld = sortManagersByLabel(data);
            
      })
      .catch(error => {
        console.error('Ошибка при получении managersList:', error);
      });

       // TODO: УДАЛИТЬ - Дублирование загрузки продавцов (уже загружается выше)
       // fetch(ORDERS_API_BASE + '/seller.php') 
       //   .then(response => response.json())
       //   .then(data => {
       //      this.prodavecList = data;
       //         
       //   })
       //   .catch(error => {
       //     console.error('Ошибка при получении managersList:', error);
       //   });


      fetch(ORDERS_API_BASE + '/managers.php') 
      .then(response => response.json())
      .then(data => {
        this.managersList = sortManagersByLabel(data.map(manager => {
          // Разбиваем label по пробелу
          const [name, surname] = manager.label.split(' ');

          return {
            ...manager,
            name: name || '',       // Имя (первое слово)
            surname: surname || ''  // Фамилия (второе слово, если есть)
          };
        }));
            
      })
      .catch(error => {
        console.error('Ошибка при получении managersList:', error);
      });

      fetch(ORDERS_API_BASE + '/curier.php') 
      .then(response => response.json())
      .then(data => {
         this.couriersListData = Array.isArray(data) ? data : [];
      })
      .catch(error => {
        console.error('Ошибка при получении couriersList:', error);
      });

      fetch(ORDERS_API_BASE + '/sposob.php') 
      .then(response => response.json())
      .then(data => {
        this.orderMethods = data;
            
      })
      .catch(error => {
        console.error('Ошибка при получении sposobov:', error);
      });
      

      fetch(ORDERS_API_BASE + '/sklad.php') 
      .then(response => response.json())
      .then(data => {
         this.storesList = data;
            
      })
      .catch(error => {
        console.error('Ошибка при получении статусов:', error);
      });

      fetch(ORDERS_API_BASE + '/delivery.php') 
      .then(response => response.json())
      .then(data => {
         this.deliveryTypesList = data;
         this.createdeliveryTypes();     
      })
      .catch(error => {
        console.error('Ошибка при получении статусов:', error);
      });
      this.user = this.$store.state.user;

      this.$store.dispatch('savedFormsModule/loadSavedForms');

      window.addEventListener("scroll", this.checkScroll);
  },
  beforeDestroy() {
    // Удаляем обработчик клика вне меню при размонтировании компонента
    document.removeEventListener('click', this.handleClickOutsideBatchMenu);
    // Удаляем обработчик при удалении компонента
    document.removeEventListener('click', this.closeSubmenuOnClickOutside);

    window.removeEventListener("scroll", this.checkScroll);
  },
  created() {
  this.$store.dispatch('savedFormsModule/loadSavedForms');
   //this.fetchOrders(this.currentPage); // Загружаем заказы при загрузке компонента
    this.fetchFilterData(); // Загружаем данные для фильтров (курьеры, менеджеры и т.д.)
    
    // Загружаем сохраненное состояние status-bar
    const savedStatusBarState = localStorage.getItem('orderForm_statusBarOpened');
    if (savedStatusBarState !== null) {
      this.statusBarOpened = JSON.parse(savedStatusBarState);
      this.isClosed = !this.statusBarOpened; // Синхронизируем isClosed с statusBarOpened
    }
    
    // TODO: УДАЛИТЬ - Инициализация пользователя для ограниченных пользователей
    this.user = this.$store.state.user || JSON.parse(localStorage.getItem('user')) || null;
    console.log('DEBUG: created - user:', this.user);
    
    // Для логистов (кроме роли Магазины) всегда включаем подсчет статистики по статусам
    if (this.isLogistForcedStatistics) {
      this.enableStatusStatistics = true;
    }
    
    // Загружаем фильтры из URL (приоритет) или sessionStorage — для всех ролей, включая Магазины
    const loadedFromURL = this.deserializeFiltersFromURL();

    if (loadedFromURL) {
      this.filtersApplied = true;
      this.$nextTick(() => {
        this.$forceUpdate();
      });
    }

    // Для ограниченного пользователя: по умолчанию все его магазины в фильтре, если из URL/sessionStorage ничего не подставилось
    if (this.isRestrictedUser && this.user && this.user.id) {
      const allowed = this.getRestrictedSites();
      const current = this.filters.sites || [];
      const needDefault = current.length === 0 || !current.every(s => allowed.includes(s));
      if (needDefault) {
        this.filters.sites = [...allowed];
        this.filtersApplied = true;
      }
    }

    // Восстанавливаем выбранные статусы из sessionStorage (если не загрузились из URL)
    if (this.selectedStatuses.length === 0) {
      const savedSelectedStatuses = sessionStorage.getItem('selectedStatuses');
      if (savedSelectedStatuses) {
        try {
          this.selectedStatuses = JSON.parse(savedSelectedStatuses);
        } catch (e) {
          console.error('Ошибка при загрузке статусов из sessionStorage:', e);
        }
      }
    }
    
    // Восстанавливаем текущую страницу из URL или sessionStorage
    const urlParams = new URLSearchParams(window.location.search);
    const pageFromURL = urlParams.get('page');
    if (pageFromURL) {
      this.currentPage = parseInt(pageFromURL, 10) || 1;
    } else {
      const savedPage = sessionStorage.getItem('currentPage');
      if (savedPage) {
        this.currentPage = parseInt(savedPage, 10) || 1;
      }
    }

    // Всегда загружаем заказы при старте компонента, с фильтрами или без
    this.fetchOrders(this.currentPage);

    const savedState = localStorage.getItem('displayFilter');
    if (savedState !== null) {
      this.displayFilter = JSON.parse(savedState);
    }
  },
  methods: {
    // TODO: УДАЛИТЬ - Получение жестко заданных магазинов для ограниченных пользователей
    getRestrictedSites() {
      if (!this.user || !this.user.retailCrmId) {
        console.log('DEBUG: getRestrictedSites - no user or user.retailCrmId');
        return [];
      }
      const retailCrmId = parseInt(this.user.retailCrmId);
      console.log('DEBUG: getRestrictedSites - retailCrmId:', retailCrmId, 'type:', typeof retailCrmId);
      switch (retailCrmId) {
        case 47: // Ваупшасова-Машиностроителей
          console.log('DEBUG: getRestrictedSites - case 47');
          return ["salyt-magazin", "masshinostroiteley-magazin"];
        case 205: // Володько-Бельского
          console.log('DEBUG: getRestrictedSites - case 205');
          return ["volodko-magazin", "belskodihfjpsd"];
        case 202: // Витебск-Могилев-Полоцк-Новополоцк
          console.log('DEBUG: getRestrictedSites - case 202, returning sites');
          return ["strelec-magaz", "vitebsk-magazin", "pol1"];
        case 204: // Брест-Гродно-Могилёв
          console.log('DEBUG: getRestrictedSites - case 204');
          return ["brestmagaz", "grodnomagaz", "mogilev-magaz"];
        case 284: // gomel-bobru-baran
          console.log('DEBUG: getRestrictedSites - case 284');
          return ["baramkimagaz", "bobruiskmagaz", "gomel-bakunin", "Gomel"];
        default:
          console.log('DEBUG: getRestrictedSites - default case');
          return [];
      }
    },
    // Получить порядок фильтра из настроек
    getFilterOrder(filterKey) {
      // Возвращает порядок фильтра из настроек для применения через CSS order
      if (!this.filterSettings || this.filterSettings.length === 0) {
        return 0;
      }
      const setting = this.filterSettings.find(s => s.key === filterKey);
      if (setting && setting.order !== undefined) {
        return setting.order;
      }
      // Для фильтров, которых нет в сохранённых настройках (например, новых), используем порядок из availableFilters — тогда они идут вместе с остальными
      const keys = this.availableFilters;
      if (Array.isArray(keys)) {
        const idx = keys.findIndex(k => (k.key || k) === filterKey);
        if (idx >= 0) return idx;
      }
      return 9999;
    },
    // Сортировка
    toggleSort(field) {
      if (this.sortField === field) {
        // Меняем направление сортировки
        this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
      } else {
        // Устанавливаем новое поле сортировки
        this.sortField = field;
        this.sortDirection = 'asc';
      }
    },
    clearSort() {
      this.sortField = null;
      this.sortDirection = 'asc';
    },
    isSortableColumn(key) {
      return key === 'deliveryTime' || key === 'deliveryDate' || key === 'orderDiscount';
    },
    // Batch actions methods
    toggleBatchMenu() {
      this.showBatchMenu = !this.showBatchMenu;
      if (this.showBatchMenu) {
        // Добавляем обработчик клика вне меню при открытии
        this.$nextTick(() => {
          document.addEventListener('click', this.handleClickOutsideBatchMenu);
        });
      } else {
        // Удаляем обработчик при закрытии
        document.removeEventListener('click', this.handleClickOutsideBatchMenu);
        this.activeSubmenu = null;
      }
    },
    handleClickOutsideBatchMenu(event) {
      // Проверяем, был ли клик вне меню (исключаем кнопку "Действия")
      if (this.$refs.batchMenuContainer && !this.$refs.batchMenuContainer.contains(event.target)) {
        this.closeBatchMenu();
      }
    },
    closeBatchMenu() {
      this.showBatchMenu = false;
      this.activeSubmenu = null;
      document.removeEventListener('click', this.handleClickOutsideBatchMenu);
    },
    showSubmenu(event, submenuName) {
      event.stopPropagation();
      
      if (this.activeSubmenu === submenuName) {
        this.activeSubmenu = null;
        return;
      }
      
      const rect = event.currentTarget.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      const submenuHeight = 400; // примерная высота подменю
      
      // Вычисляем, достаточно ли места снизу
      const spaceBelow = windowHeight - rect.top;
      
      // Для окна статуса всегда устанавливаем bottom: 50px, чтобы не улетало за пределы верха экрана
      if (submenuName === 'status') {
        this.submenuPosition = {
          left: rect.right + 5,
          top: 'auto',
          bottom: '50px'
        };
      } else {
        this.submenuPosition = {
          left: rect.right + 5,
          top: spaceBelow >= submenuHeight ? rect.top : 'auto',
          bottom: spaceBelow < submenuHeight ? (windowHeight - rect.bottom) + 'px' : 'auto'
        };
      }
      
      this.activeSubmenu = submenuName;
    },
    closeSubmenuOnClickOutside(event) {
      // Проверяем, что клик был вне подменю
      const dropElement = event.target.closest('.drop');
      const withListElement = event.target.closest('.with-list');
      
      if (!dropElement && !withListElement) {
        this.activeSubmenu = null;
      }
    },
    getElementWord(count) {
      const lastDigit = count % 10;
      const lastTwoDigits = count % 100;
      
      if (lastTwoDigits >= 11 && lastTwoDigits <= 14) {
        return 'элементов';
      }
      if (lastDigit === 1) {
        return 'элемент';
      }
      if (lastDigit >= 2 && lastDigit <= 4) {
        return 'элемента';
      }
      return 'элементов';
    },
    async batchPrint(templateId) {
      const isKassa = templateId === 121;
      const isCourierSalary = templateId === 123;
      if (!isKassa && !isCourierSalary && this.selectedOrders.length === 0) {
        return;
      }

      // Показываем загрузку
      this.loading = true;

      try {
        // Проверяем, это шаблон "Лист курьера" (ID 116 или 110) или "Гарантийный талон" (ID 115) или "Печать vozim.by" (ID 119) или "Договор Галицкий" (ID 109) или "Счет-фактура Галицкий" (ID 70) или "Ведомость" (ID 120) или "Счет-фактура Гамзюк" (ID 107, 67)
        const isRouteSheet = templateId === 116 || templateId === 110 || templateId === 118;
        const isVozimSheet = templateId === 119;
        const isWarrantyTicket = templateId === 115;
        const isGalitskyContract = templateId === 109;
        const isGalitskyInvoice = templateId === 70;
        const isGamz3Invoice = templateId === 107;
        const isGamz5Invoice = templateId === 67;
        const isVedomost = templateId === 120;
        const isActDelivery = templateId === 122;
        const isCourierSalary = templateId === 123;
        const shouldAppendVedomostToRouteSheet = templateId === 116; // Только "Лист курьера 2025"

        if (isRouteSheet) {
          // Для маршрутного листа используем новый способ - генерируем из данных заказов
          // Используем sortedOrders чтобы учитывать сортировку
          const selectedOrdersData = this.sortedOrders.filter(order => 
            this.selectedOrders.includes(order.id)
          );
          
          if (selectedOrdersData.length === 0) {
            this.loading = false;
            return;
          }
          
          console.log('Генерация маршрутного листа для заказов:', selectedOrdersData.length);
          console.log('Данные первого заказа:', selectedOrdersData[0]);
          
          // Подготавливаем данные для отправки (убираем циклические ссылки и лишние данные)
          const ordersToSend = selectedOrdersData.map(order => {
            // Обрабатываем payments - убираем циклические ссылки
            // В v5 API payments может быть объектом {id: {amount, type, ...}} или массивом
            let payments = [];
            if (order.payments) {
              if (Array.isArray(order.payments)) {
                payments = order.payments.map(payment => {
                  const amount = parseFloat(payment.amount) || 0;
                  let typeCode = '';
                  let typeName = '';
                  
                  // Обрабатываем type - может быть строкой или объектом
                  if (typeof payment.type === 'string') {
                    typeCode = payment.type;
                    // Получаем название из словаря или метода
                    if (typeof valueDictionary !== 'undefined' && valueDictionary[payment.type]) {
                      typeName = valueDictionary[payment.type];
                    } else if (this && this.getPaymentTypeName) {
                      typeName = this.getPaymentTypeName(payment.type) || payment.type;
                    } else {
                      typeName = payment.type;
                    }
                  } else if (payment.type && typeof payment.type === 'object') {
                    typeCode = payment.type.code || '';
                    typeName = payment.type.name || '';
                  }
                  
                  return {
                    amount: amount,
                    type: {
                      code: typeCode,
                      name: typeName
                    }
                  };
                }).filter(p => p.type.code);
              } else if (typeof order.payments === 'object') {
                // Обрабатываем объект payments {id: {amount, type, ...}}
                payments = Object.values(order.payments).map(payment => {
                  const amount = parseFloat(payment.amount) || 0;
                  let typeCode = '';
                  let typeName = '';
                  
                  // Обрабатываем type - может быть строкой или объектом
                  if (typeof payment.type === 'string') {
                    typeCode = payment.type;
                    // Получаем название из словаря или метода
                    if (typeof valueDictionary !== 'undefined' && valueDictionary[payment.type]) {
                      typeName = valueDictionary[payment.type];
                    } else if (this && this.getPaymentTypeName) {
                      typeName = this.getPaymentTypeName(payment.type) || payment.type;
                    } else {
                      typeName = payment.type;
                    }
                  } else if (payment.type && typeof payment.type === 'object') {
                    typeCode = payment.type.code || '';
                    typeName = payment.type.name || '';
                  }
                  
                  return {
                    amount: amount,
                    type: {
                      code: typeCode,
                      name: typeName
                    }
                  };
                }).filter(p => p.type.code);
              }
            }
            
            // ФИО в RetailCRM часто на корне заказа, а не в customer —
            // без нормализации в МЛ уходит только имя (как «Александр»).
            const lastName = order.lastName || (order.customer && order.customer.lastName) || '';
            const firstName = order.firstName || (order.customer && order.customer.firstName) || '';
            const patronymic = order.patronymic || order.middleName
              || (order.customer && (order.customer.patronymic || order.customer.middleName)) || '';
            const fullName = [lastName, firstName, patronymic].filter(Boolean).join(' ').trim()
              || (order.customer && (order.customer.fullName || order.customer.nickName)) || '';

            return {
              id: order.id,
              number: order.number,
              site: order.site,
              phone: order.phone,
              additionalPhone: order.additionalPhone,
              lastName,
              firstName,
              patronymic,
              customer: {
                ...(order.customer || {}),
                lastName,
                firstName,
                patronymic,
                middleName: patronymic,
                fullName: fullName || undefined,
              },
              delivery: order.delivery || {},
              items: order.items || [],
              payments: payments,
              paymentType: order.paymentType || null,
              customFields: order.customFields || {},
              totalSumm: order.totalSumm,
              prepaySum: order.prepaySum || 0,
              managerComment: order.managerComment
            };
          });
          
          console.log('Подготовлено заказов для отправки:', ordersToSend.length);
          console.log('Размер данных (примерно):', JSON.stringify(ordersToSend).length, 'байт');
          // Отладочная информация о payments
          if (ordersToSend.length > 0) {
            console.log('Первый заказ payments:', ordersToSend[0].payments);
            console.log('Первый заказ paymentType:', ordersToSend[0].paymentType);
            console.log('Первый заказ totalSumm:', ordersToSend[0].totalSumm);
          }
          
          // Отправляем данные заказов на сервер для генерации PDF
          try {
            const response = await axios.post(ORDERS_API_BASE + '/generate_route_sheet.php', {
              orders: ordersToSend
            }, {
              timeout: 60000, // 60 секунд таймаут
              headers: {
                'Content-Type': 'application/json'
              }
            });
            
            console.log('Ответ получен:', response.data);
            
            // Проверяем успешность ответа
            if (response.data && response.data.success && response.data.url) {
              // Для "Лист курьера 2025" собираем маршрутный лист + ведомость в один PDF
              if (shouldAppendVedomostToRouteSheet) {
                try {
                  const routeFilename = response.data.filename;
                  if (!routeFilename) {
                    throw new Error('Не получено имя файла маршрутного листа');
                  }

                  const vedomostOrdersToSend = selectedOrdersData.map(order => ({
                    ...order,
                    lastName: order.lastName || (order.customer && order.customer.lastName) || '',
                    firstName: order.firstName || (order.customer && order.customer.firstName) || '',
                    patronymic: order.patronymic || order.middleName || (order.customer && (order.customer.patronymic || order.customer.middleName)) || '',
                    customer: {
                      ...(order.customer || {}),
                      lastName: order.lastName || (order.customer && order.customer.lastName) || '',
                      firstName: order.firstName || (order.customer && order.customer.firstName) || '',
                      patronymic: order.patronymic || order.middleName || (order.customer && (order.customer.patronymic || order.customer.middleName)) || ''
                    },
                    createdAt: order.createdAt || order.created_at || null
                  }));

                  const vedomostResponse = await axios.post(ORDERS_API_BASE + '/generate_vedomost.php', {
                    orders: vedomostOrdersToSend
                  }, {
                    timeout: 60000,
                    headers: { 'Content-Type': 'application/json' }
                  });

                  if (!vedomostResponse.data || !vedomostResponse.data.success || !vedomostResponse.data.filename) {
                    throw new Error((vedomostResponse.data && vedomostResponse.data.error) || 'Не удалось сгенерировать ведомость');
                  }

                  const combineResponse = await axios.post(ORDERS_API_BASE + '/combine_print_files.php', {
                    files: [routeFilename, vedomostResponse.data.filename],
                    prefix: 'route_sheet_vedomost'
                  }, {
                    timeout: 60000,
                    headers: { 'Content-Type': 'application/json' }
                  });

                  if (combineResponse.data && combineResponse.data.success && combineResponse.data.url) {
                    const combinedWindow = window.open(combineResponse.data.url, '_blank');
                    if (!combinedWindow) {
                      console.warn('Не удалось открыть окно. Разрешите всплывающие окна для открытия документа');
                    }
                  } else {
                    throw new Error((combineResponse.data && combineResponse.data.error) || 'Не удалось объединить PDF');
                  }
                } catch (combineError) {
                  console.warn('Ошибка при объединении маршрутного листа и ведомости:', combineError);
                  // fallback: хотя бы открыть маршрутный лист
                  const fallbackWindow = window.open(response.data.url, '_blank');
                  if (!fallbackWindow) {
                    console.warn('Не удалось открыть окно. Разрешите всплывающие окна для открытия документа');
                  }
                }
              } else {
                // Обычный маршрутный лист — открываем как есть
                const newWindow = window.open(response.data.url, '_blank');
                if (!newWindow) {
                  console.warn('Не удалось открыть окно. Разрешите всплывающие окна для открытия документа');
                }
              }

              this.loading = false;
            } else {
              throw new Error((response.data && response.data.error) || 'Ошибка генерации документа');
            }
          } catch (axiosError) {
            console.error('Ошибка axios:', axiosError);
            this.loading = false;
            if (axiosError.response && axiosError.response.data) {
              const errorMsg = axiosError.response.data.error || axiosError.response.data.message || 'Ошибка сервера';
              console.error('Ошибка: ' + errorMsg);
            } else if (axiosError.request) {
              console.error('Нет ответа от сервера. Проверьте доступность API.');
            } else {
              console.error('Ошибка: ' + axiosError.message);
            }
          }
        } else if (isWarrantyTicket) {
          // Для гарантийного талона используем отдельный endpoint
          // Используем sortedOrders чтобы учитывать сортировку
          const selectedOrdersData = this.sortedOrders.filter(order => 
            this.selectedOrders.includes(order.id)
          );
          
          if (selectedOrdersData.length === 0) {
            this.loading = false;
            return;
          }
          
          console.log('Генерация гарантийного талона для заказов:', selectedOrdersData.length);
          
          // Подготавливаем данные для отправки
          const ordersToSend = selectedOrdersData.map(order => {
            return {
              ...(() => {
                const normalizedLastName = order.lastName || (order.customer && order.customer.lastName) || '';
                const normalizedFirstName = order.firstName || (order.customer && order.customer.firstName) || '';
                const normalizedPatronymic = order.patronymic || order.middleName || (order.customer && (order.customer.patronymic || order.customer.middleName)) || '';
                return {
                  lastName: normalizedLastName,
                  firstName: normalizedFirstName,
                  patronymic: normalizedPatronymic
                };
              })(),
              id: order.id,
              number: order.number,
              site: order.site,
              phone: order.phone,
              additionalPhone: order.additionalPhone,
              customer: {
                ...(order.customer || {}),
                lastName: order.lastName || (order.customer && order.customer.lastName) || '',
                firstName: order.firstName || (order.customer && order.customer.firstName) || '',
                patronymic: order.patronymic || order.middleName || (order.customer && (order.customer.patronymic || order.customer.middleName)) || ''
              },
              delivery: order.delivery || {},
              items: order.items || [],
              payments: order.payments || [],
              customFields: order.customFields || {},
              totalSumm: order.totalSumm,
              managerComment: order.managerComment
            };
          });
          
          console.log('Подготовлено заказов для отправки:', ordersToSend.length);
          
          try {
            const response = await axios.post(ORDERS_API_BASE + '/generate_warranty_ticket.php', {
              orders: ordersToSend
            }, {
              timeout: 60000,
              headers: {
                'Content-Type': 'application/json'
              }
            });
            
            console.log('Ответ получен:', response.data);
            
            if (response.data && response.data.success && response.data.url) {
              const newWindow = window.open(response.data.url, '_blank');
              if (!newWindow) {
                console.warn('Не удалось открыть окно. Разрешите всплывающие окна для открытия документа');
              }
              this.loading = false;
            } else {
              throw new Error((response.data && response.data.error) || 'Ошибка генерации документа');
            }
          } catch (axiosError) {
            console.error('Ошибка axios:', axiosError);
            this.loading = false;
            if (axiosError.response && axiosError.response.data) {
              const errorMsg = axiosError.response.data.error || axiosError.response.data.message || 'Ошибка сервера';
              console.error('Ошибка: ' + errorMsg);
            } else if (axiosError.request) {
              console.error('Нет ответа от сервера. Проверьте доступность API.');
            } else {
              console.error('Ошибка: ' + axiosError.message);
            }
          }
        } else if (isVozimSheet) {
          // Для vozim.by используем отдельный endpoint
          // Используем sortedOrders чтобы учитывать сортировку
          const selectedOrdersData = this.sortedOrders.filter(order => 
            this.selectedOrders.includes(order.id)
          );
          
          if (selectedOrdersData.length === 0) {
            this.loading = false;
            return;
          }
          
          console.log('Генерация vozim.by документа для заказов:', selectedOrdersData.length);
          console.log('Данные первого заказа:', selectedOrdersData[0]);
          
          // Подготавливаем данные для отправки (убираем циклические ссылки и лишние данные)
          const ordersToSend = selectedOrdersData.map(order => {
            // Обрабатываем payments - убираем циклические ссылки
            // В v5 API payments может быть объектом {id: {amount, type, ...}} или массивом
            let payments = [];
            if (order.payments) {
              if (Array.isArray(order.payments)) {
                payments = order.payments.map(payment => {
                  const amount = parseFloat(payment.amount) || 0;
                  let typeCode = '';
                  let typeName = '';
                  
                  // Обрабатываем type - может быть строкой или объектом
                  if (typeof payment.type === 'string') {
                    typeCode = payment.type;
                    // Получаем название из словаря или метода
                    if (typeof valueDictionary !== 'undefined' && valueDictionary[payment.type]) {
                      typeName = valueDictionary[payment.type];
                    } else if (this && this.getPaymentTypeName) {
                      typeName = this.getPaymentTypeName(payment.type) || payment.type;
                    } else {
                      typeName = payment.type;
                    }
                  } else if (payment.type && typeof payment.type === 'object') {
                    typeCode = payment.type.code || '';
                    typeName = payment.type.name || '';
                  }
                  
                  return {
                    amount: amount,
                    type: {
                      code: typeCode,
                      name: typeName
                    }
                  };
                }).filter(p => p.type.code);
              } else if (typeof order.payments === 'object') {
                // Обрабатываем объект payments {id: {amount, type, ...}}
                payments = Object.values(order.payments).map(payment => {
                  const amount = parseFloat(payment.amount) || 0;
                  let typeCode = '';
                  let typeName = '';
                  
                  // Обрабатываем type - может быть строкой или объектом
                  if (typeof payment.type === 'string') {
                    typeCode = payment.type;
                    // Получаем название из словаря или метода
                    if (typeof valueDictionary !== 'undefined' && valueDictionary[payment.type]) {
                      typeName = valueDictionary[payment.type];
                    } else if (this && this.getPaymentTypeName) {
                      typeName = this.getPaymentTypeName(payment.type) || payment.type;
                    } else {
                      typeName = payment.type;
                    }
                  } else if (payment.type && typeof payment.type === 'object') {
                    typeCode = payment.type.code || '';
                    typeName = payment.type.name || '';
                  }
                  
                  return {
                    amount: amount,
                    type: {
                      code: typeCode,
                      name: typeName
                    }
                  };
                }).filter(p => p.type.code);
              }
            }
            
            return {
              id: order.id,
              number: order.number,
              site: order.site,
              phone: order.phone,
              additionalPhone: order.additionalPhone,
              customer: order.customer || {},
              delivery: order.delivery || {},
              items: order.items || [],
              payments: payments,
              paymentType: order.paymentType || null,
              customFields: order.customFields || {},
              totalSumm: order.totalSumm,
              prepaySum: order.prepaySum || 0,
              managerComment: order.managerComment
            };
          });
          
          console.log('Подготовлено заказов для отправки:', ordersToSend.length);
          console.log('Размер данных (примерно):', JSON.stringify(ordersToSend).length, 'байт');
          // Отладочная информация о payments
          if (ordersToSend.length > 0) {
            console.log('Первый заказ payments:', ordersToSend[0].payments);
            console.log('Первый заказ paymentType:', ordersToSend[0].paymentType);
            console.log('Первый заказ totalSumm:', ordersToSend[0].totalSumm);
          }
          
          // Отправляем данные заказов на сервер для генерации PDF
          try {
            const response = await axios.post(ORDERS_API_BASE + '/generate_vozim_sheet.php', {
              orders: ordersToSend
            }, {
              timeout: 60000, // 60 секунд таймаут
              headers: {
                'Content-Type': 'application/json'
              }
            });
            
            console.log('Ответ получен:', response.data);
            
            if (response.data && response.data.success && response.data.url) {
              const newWindow = window.open(response.data.url, '_blank');
              if (!newWindow) {
                console.warn('Не удалось открыть окно. Разрешите всплывающие окна для открытия документа');
              }
              this.loading = false;
            } else {
              throw new Error((response.data && response.data.error) || 'Ошибка генерации документа');
            }
          } catch (axiosError) {
            console.error('Ошибка axios:', axiosError);
            this.loading = false;
            if (axiosError.response && axiosError.response.data) {
              const errorMsg = axiosError.response.data.error || axiosError.response.data.message || 'Ошибка сервера';
              console.error('Ошибка: ' + errorMsg);
            } else if (axiosError.request) {
              console.error('Нет ответа от сервера. Проверьте доступность API.');
            } else {
              console.error('Ошибка: ' + axiosError.message);
            }
          }
        } else if (isVedomost) {
          // Для ведомости учета металлолома используем отдельный endpoint
          // Используем sortedOrders чтобы учитывать сортировку
          const selectedOrdersData = this.sortedOrders.filter(order => 
            this.selectedOrders.includes(order.id)
          );
          
          if (selectedOrdersData.length === 0) {
            this.loading = false;
            return;
          }
          
          console.log('Генерация ведомости учета металлолома для заказов:', selectedOrdersData.length);
          
          // Подготавливаем данные для отправки
          const ordersToSend = selectedOrdersData.map(order => {
            return {
              ...order,
              lastName: order.lastName || (order.customer && order.customer.lastName) || '',
              firstName: order.firstName || (order.customer && order.customer.firstName) || '',
              patronymic: order.patronymic || order.middleName || (order.customer && (order.customer.patronymic || order.customer.middleName)) || '',
              customer: {
                ...(order.customer || {}),
                lastName: order.lastName || (order.customer && order.customer.lastName) || '',
                firstName: order.firstName || (order.customer && order.customer.firstName) || '',
                patronymic: order.patronymic || order.middleName || (order.customer && (order.customer.patronymic || order.customer.middleName)) || ''
              },
              createdAt: order.createdAt || order.created_at || null
            };
          });
          
          console.log('Подготовлено заказов для отправки:', ordersToSend.length);
          
          try {
            const response = await axios.post(ORDERS_API_BASE + '/generate_vedomost.php', {
              orders: ordersToSend
            }, {
              timeout: 60000,
              headers: {
                'Content-Type': 'application/json'
              }
            });
            
            console.log('Ответ получен:', response.data);
            
            if (response.data && response.data.success && response.data.url) {
              const newWindow = window.open(response.data.url, '_blank');
              if (!newWindow) {
                console.warn('Не удалось открыть окно. Разрешите всплывающие окна для открытия документа');
              }
              this.loading = false;
            } else {
              throw new Error((response.data && response.data.error) || 'Ошибка генерации документа');
            }
          } catch (axiosError) {
            console.error('Ошибка axios:', axiosError);
            this.loading = false;
            if (axiosError.response && axiosError.response.data) {
              const errorMsg = axiosError.response.data.error || axiosError.response.data.message || 'Ошибка сервера';
              console.error('Ошибка: ' + errorMsg);
            } else if (axiosError.request) {
              console.error('Нет ответа от сервера. Проверьте доступность API.');
            } else {
              console.error('Ошибка: ' + axiosError.message);
            }
          }
        } else if (isActDelivery) {
          // Акт выполненных работ (доставка)
          const selectedOrdersData = this.sortedOrders.filter(order =>
            this.selectedOrders.includes(order.id)
          );

          if (selectedOrdersData.length === 0) {
            this.loading = false;
            return;
          }

          const ordersToSend = selectedOrdersData.map(order => ({
            id: order.id,
            number: order.number,
            site: order.site,
            customer: order.customer || {},
            delivery: order.delivery || {},
            items: order.items || [],
            customFields: order.customFields || {},
            contragent: order.contragent || {}
          }));

          try {
            const response = await axios.post(ORDERS_API_BASE + '/generate_act_delivery.php', {
              orders: ordersToSend
            }, {
              timeout: 60000,
              headers: { 'Content-Type': 'application/json' }
            });

            if (response.data && response.data.success && response.data.url) {
              const newWindow = window.open(response.data.url, '_blank');
              if (!newWindow) {
                console.warn('Не удалось открыть окно. Разрешите всплывающие окна для открытия документа');
              }
              this.loading = false;
            } else {
              throw new Error((response.data && response.data.error) || 'Ошибка генерации документа');
            }
          } catch (axiosError) {
            console.error('Ошибка axios:', axiosError);
            this.loading = false;
            if (axiosError.response && axiosError.response.data) {
              this.$toast.error(axiosError.response.data.error || axiosError.response.data.message || 'Ошибка сервера');
            } else {
              this.$toast.error('Ошибка при генерации акта выполненных работ');
            }
          }
        } else if (isCourierSalary) {
          // Для расчёта зарплаты берём ВСЕ заказы по текущим фильтрам, а не только видимые на странице
          const allOrdersData = await this.fetchAllFilteredOrdersForPrint();
          if (!allOrdersData || allOrdersData.length === 0) {
            this.loading = false;
            return;
          }

          const ordersToSend = allOrdersData.map(order => ({
            id: order.id,
            number: order.number,
            status: order.status || '',
            delivery: order.delivery || {},
            items: order.items || [],
            customFields: order.customFields || {},
          }));

          const formatCourierSalaryDate = (d) => new Date(d).toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit', year: 'numeric' });
          const deliveryDateGte = this.filters.deliveryDate_gte;
          const deliveryDateLte = this.filters.deliveryDate_lte;
          let dateForTitle;
          if (deliveryDateGte && deliveryDateLte) {
            dateForTitle = `${formatCourierSalaryDate(deliveryDateGte)} – ${formatCourierSalaryDate(deliveryDateLte)}`;
          } else if (deliveryDateGte || deliveryDateLte) {
            dateForTitle = formatCourierSalaryDate(deliveryDateGte || deliveryDateLte);
          } else {
            dateForTitle = formatCourierSalaryDate(new Date());
          }

          try {
            const response = await axios.post(ORDERS_API_BASE + '/generate_courier_salary.php', {
              orders: ordersToSend,
              date: dateForTitle,
            }, {
              timeout: 60000,
              headers: { 'Content-Type': 'application/json' },
            });

            if (response.data && response.data.success && response.data.url) {
              const newWindow = window.open(response.data.url, '_blank');
              if (!newWindow) {
                console.warn('Не удалось открыть окно. Разрешите всплывающие окна для открытия документа');
              }
              this.loading = false;
            } else {
              throw new Error((response.data && response.data.error) || 'Ошибка генерации документа');
            }
          } catch (axiosError) {
            console.error('Ошибка axios:', axiosError);
            this.loading = false;
            if (axiosError.response && axiosError.response.data) {
              this.$toast.error(axiosError.response.data.error || axiosError.response.data.message || 'Ошибка сервера');
            } else {
              this.$toast.error('Ошибка при генерации расчёта зарплаты курьеров');
            }
          }
        } else if (isKassa) {
          // Для Кассы всегда берём ВСЕ заказы по текущим фильтрам, а не только видимые на странице
          const allOrdersData = await this.fetchAllFilteredOrdersForPrint();
          if (!allOrdersData || allOrdersData.length === 0) {
            this.loading = false;
            return;
          }
          const ordersToSend = allOrdersData.map(order => {
            let payments = [];
            if (order.payments) {
              if (Array.isArray(order.payments)) {
                payments = order.payments.map(payment => {
                  const amount = parseFloat(payment.amount) || 0;
                  let typeCode = '';
                  let typeName = '';
                  if (typeof payment.type === 'string') {
                    typeCode = payment.type;
                    typeName = payment.type;
                  } else if (payment.type && typeof payment.type === 'object') {
                    typeCode = payment.type.code || '';
                    typeName = payment.type.name || '';
                  }
                  return { amount, type: { code: typeCode, name: typeName } };
                }).filter(p => p.type.code);
              } else if (typeof order.payments === 'object') {
                payments = Object.values(order.payments).map(payment => {
                  const amount = parseFloat(payment.amount) || 0;
                  let typeCode = '';
                  let typeName = '';
                  if (typeof payment.type === 'string') {
                    typeCode = payment.type;
                    typeName = payment.type;
                  } else if (payment.type && typeof payment.type === 'object') {
                    typeCode = payment.type.code || '';
                    typeName = payment.type.name || '';
                  }
                  return { amount, type: { code: typeCode, name: typeName } };
                }).filter(p => p.type.code);
              }
            }
            return {
              id: order.id,
              number: order.number,
              site: order.site,
              customer: order.customer || {},
              delivery: order.delivery || {},
              items: order.items || [],
              payments,
              paymentType: order.paymentType || null,
              customFields: order.customFields || {},
              totalSumm: order.totalSumm,
              prepaySum: order.prepaySum || 0,
              managerComment: order.managerComment
            };
          });
          try {
            // Дата в заголовке «Касса для сдачи в CRM» — из поля/фильтра «Касса», а не дата печати
            const kassaFilterDate = this.filters.kasssas_gte || this.filters.kasssas_lte || null;
            const dateForTitle = kassaFilterDate || new Date().toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit', year: 'numeric' });
            const response = await axios.post(ORDERS_API_BASE + '/generate_kassa.php', {
              orders: ordersToSend,
              date: dateForTitle
            }, {
              timeout: 60000,
              headers: { 'Content-Type': 'application/json' }
            });
            if (response.data && response.data.success && response.data.url) {
              const newWindow = window.open(response.data.url, '_blank');
              if (!newWindow) {
                console.warn('Не удалось открыть окно. Разрешите всплывающие окна для открытия документа');
              }
              this.loading = false;
            } else {
              throw new Error((response.data && response.data.error) || 'Ошибка генерации документа');
            }
          } catch (axiosError) {
            console.error('Ошибка axios:', axiosError);
            this.loading = false;
            if (axiosError.response && axiosError.response.data) {
              const errorMsg = axiosError.response.data.error || axiosError.response.data.message || 'Ошибка сервера';
              console.error('Ошибка: ' + errorMsg);
            }
          }
        } else if (isGalitskyContract || isGalitskyInvoice) {
          // Для договора и счета-фактуры Галицкого используем отдельные endpoints
          // Используем sortedOrders чтобы учитывать сортировку
          const selectedOrdersData = this.sortedOrders.filter(order => 
            this.selectedOrders.includes(order.id)
          );
          
          if (selectedOrdersData.length === 0) {
            this.loading = false;
            return;
          }
          
          const templateName = isGalitskyContract ? 'договора' : 'счета-фактуры';
          console.log(`Генерация ${templateName} Галицкий для заказов:`, selectedOrdersData.length);
          
          // Подготавливаем данные для отправки
          const ordersToSend = selectedOrdersData.map(order => {
            let payments = [];
            if (order.payments && Array.isArray(order.payments)) {
              payments = order.payments.map(payment => ({
                amount: payment.amount || 0,
                type: payment.type ? {
                  code: payment.type.code || '',
                  name: payment.type.name || ''
                } : null
              })).filter(p => p.type !== null);
            }
            
            return {
              id: order.id,
              number: order.number,
              site: order.site,
              phone: order.phone,
              additionalPhone: order.additionalPhone,
              customer: order.customer || {},
              delivery: order.delivery || {},
              items: order.items || [],
              payments: payments,
              paymentType: order.paymentType || null,
              customFields: order.customFields || {},
              totalSumm: order.totalSumm,
              prepaySum: order.prepaySum || 0,
              managerComment: order.managerComment,
              createdAt: order.createdAt || order.created_at || null,
              contragent: order.contragent || {}
            };
          });
          
          // Определяем endpoint
          let endpoint = '';
          if (isGalitskyContract) {
            endpoint = ORDERS_API_BASE + '/generate_galitsky_contract.php';
          } else if (isGalitskyInvoice) {
            endpoint = ORDERS_API_BASE + '/generate_galitsky_invoice.php';
          }
          
          try {
            const response = await axios.post(endpoint, {
              orders: ordersToSend
            }, {
              timeout: 60000,
              headers: {
                'Content-Type': 'application/json'
              }
            });
            
            console.log('Ответ получен:', response.data);
            
            if (response.data && response.data.success && response.data.url) {
              const newWindow = window.open(response.data.url, '_blank');
              if (!newWindow) {
                console.warn('Не удалось открыть окно. Разрешите всплывающие окна для открытия документа');
              }
              this.loading = false;
            } else {
              throw new Error((response.data && response.data.error) || 'Ошибка генерации документа');
            }
          } catch (axiosError) {
            console.error('Ошибка axios:', axiosError);
            this.loading = false;
            if (axiosError.response && axiosError.response.data) {
              const errorMsg = axiosError.response.data.error || axiosError.response.data.message || 'Ошибка сервера';
              console.error('Ошибка: ' + errorMsg);
            } else if (axiosError.request) {
              console.error('Нет ответа от сервера. Проверьте доступность API.');
            } else {
              console.error('Ошибка: ' + axiosError.message);
            }
          }
        } else if (isGamz3Invoice || isGamz5Invoice) {
          // Для счетов-фактур Гамзюк используем отдельные endpoints
          // Используем sortedOrders чтобы учитывать сортировку
          const selectedOrdersData = this.sortedOrders.filter(order => 
            this.selectedOrders.includes(order.id)
          );
          
          if (selectedOrdersData.length === 0) {
            this.loading = false;
            return;
          }
          
          const templateName = isGamz3Invoice ? 'счета-фактуры Гамзюк (3 дня)' : 'счета-фактуры Гамзюк (5 дней)';
          console.log(`Генерация ${templateName} для заказов:`, selectedOrdersData.length);
          
          // Подготавливаем данные для отправки
          const ordersToSend = selectedOrdersData.map(order => {
            let payments = [];
            if (order.payments && Array.isArray(order.payments)) {
              payments = order.payments.map(payment => ({
                amount: payment.amount || 0,
                type: payment.type ? {
                  code: payment.type.code || '',
                  name: payment.type.name || ''
                } : null
              })).filter(p => p.type !== null);
            }
            
            return {
              id: order.id,
              number: order.number,
              site: order.site,
              phone: order.phone,
              additionalPhone: order.additionalPhone,
              customer: order.customer || {},
              delivery: order.delivery || {},
              items: order.items || [],
              payments: payments,
              paymentType: order.paymentType || null,
              customFields: order.customFields || {},
              totalSumm: order.totalSumm,
              prepaySum: order.prepaySum || 0,
              managerComment: order.managerComment,
              contragent: order.contragent || {}
            };
          });
          
          console.log('Подготовлено заказов для отправки:', ordersToSend.length);
          
          try {
            const endpoint = isGamz3Invoice 
              ? ORDERS_API_BASE + '/generate_gamz3_invoice.php'
              : ORDERS_API_BASE + '/generate_gamz5_invoice.php';
            
            const response = await axios.post(endpoint, {
              orders: ordersToSend
            }, {
              timeout: 60000,
              headers: {
                'Content-Type': 'application/json'
              }
            });
            
            console.log('Ответ получен:', response.data);
            
            if (response.data && response.data.success && response.data.url) {
              const newWindow = window.open(response.data.url, '_blank');
              if (!newWindow) {
                console.warn('Не удалось открыть окно. Разрешите всплывающие окна для открытия документа');
              }
              this.loading = false;
            } else {
              throw new Error((response.data && response.data.error) || 'Ошибка генерации документа');
            }
          } catch (axiosError) {
            console.error('Ошибка axios:', axiosError);
            this.loading = false;
            if (axiosError.response && axiosError.response.data) {
              const errorMsg = axiosError.response.data.error || axiosError.response.data.message || 'Ошибка сервера';
              console.error('Ошибка: ' + errorMsg);
            } else if (axiosError.request) {
              console.error('Нет ответа от сервера. Проверьте доступность API.');
            } else {
              console.error('Ошибка: ' + axiosError.message);
            }
          }
        } else {
          // Для других шаблонов используем старый способ через RetailCRM API
          if (this.selectedOrders.length === 1) {
            const orderId = this.selectedOrders[0];
            const downloadUrl = `${ORDERS_API_BASE}/print_orders.php?template_id=${templateId}&order_id=${orderId}&download=true`;
            window.open(downloadUrl, '_blank');
            this.loading = false;
          } else {
            // Если выбрано несколько заказов - объединяем в один PDF через старый способ
            const orderIds = this.selectedOrders.join(',');
            const params = new URLSearchParams({
              template_id: templateId.toString(),
              order_ids: orderIds,
              download: 'true'
            });
            const downloadUrl = `${ORDERS_API_BASE}/print_orders_combined.php?${params.toString()}`;
            window.open(downloadUrl, '_blank');
            this.loading = false;
          }
        }
        
      } catch (error) {
        this.loading = false;
        console.error('Ошибка при печати:', error);
        const errorMessage = (error.response && error.response.data && error.response.data.error) 
          ? error.response.data.error 
          : (error.message || 'Неизвестная ошибка');
        console.error('Ошибка при генерации печатной формы: ' + errorMessage);
      }
      
      // Закрываем меню
      this.closeBatchMenu();
    },
    
    async batchChangePaymentStatus(paymentStatusId) {
      if (this.selectedOrders.length === 0) {
        return;
      }

      const canEdit = await this.checkCanEditSelectedOrdersBatch();
      if (!canEdit) return;
      
      this.loading = true;
      let successCount = 0;
      let errorCount = 0;
      
      try {
        for (const orderId of this.selectedOrders) {
          try {
            const order = this.orders.find(o => o.id === orderId);
            if (!order) continue;
            
            // Для массового изменения статуса оплаты нужно обновить все платежи
            // Используем paymentOrder.php для изменения статуса оплаты
            let paymentsArray = [];
            
            if (order.payments) {
              // В API v5 payments может быть массивом или объектом {id: {amount, type, ...}}
              if (Array.isArray(order.payments) && order.payments.length > 0) {
                paymentsArray = order.payments;
              } else if (typeof order.payments === 'object' && !Array.isArray(order.payments)) {
                // Преобразуем объект в массив
                paymentsArray = Object.values(order.payments);
              }
            }
            
            // Формируем массив платежей для обновления
            // Если у заказа есть платежи, обновляем их статус, иначе создаем новый платеж
            const payments = paymentsArray.length > 0
              ? paymentsArray.map(p => {
                  // Извлекаем код типа платежа (может быть объектом или строкой)
                  let paymentType = 'cash';
                  if (p.type) {
                    if (typeof p.type === 'string') {
                      paymentType = p.type;
                    } else if (p.type.code) {
                      paymentType = p.type.code;
                    } else if (p.type.value) {
                      paymentType = p.type.value;
                    }
                  }
                  
                  // Формируем объект платежа для paymentOrder.php
                  const paymentData = {
                    id: p.id || p.externalId,
                    amount: p.amount || order.totalSumm || 0,
                    type: paymentType,
                    status: paymentStatusId // Код статуса (например, "not-paid", "paid")
                  };
                  
                  // Добавляем опциональные поля только если они есть
                  if (p.comment) {
                    paymentData.comment = p.comment;
                  }
                  if (p.paidAt) {
                    paymentData.paidAt = p.paidAt;
                  }
                  
                  return paymentData;
                })
              : [{
                  amount: order.totalSumm || 0,
                  type: 'cash',
                  status: paymentStatusId // Код статуса (например, "not-paid", "paid")
                }];
            
            // Отправляем запрос на paymentOrder.php для изменения статуса оплаты
            const response = await axios.post(ORDERS_API_BASE + '/paymentOrder.php', {
              action: 'edit',
              order_id: orderId,
              order: {
                site: order.site || order.magazin || '1akb-by'
              },
              payments: payments,
              userRole: this.userRole
            });
            
            if (response.data.success) {
              // paymentOrder.php возвращает массив responses для каждого платежа
              if (response.data.responses && Array.isArray(response.data.responses)) {
                const hasErrors = response.data.responses.some(r => !r.success);
                if (hasErrors) {
                  errorCount++;
                  console.error(`Ошибка при обновлении платежей для заказа ${orderId}:`, response.data.responses);
                } else {
                  successCount++;
                }
              } else {
                successCount++;
              }
            } else {
              errorCount++;
              console.error(`Ошибка для заказа ${orderId}:`, response.data.message);
            }
          } catch (error) {
            console.error(`Ошибка при обновлении заказа ${orderId}:`, error);
            errorCount++;
          }
        }
        
        console.log(`Обновлено: ${successCount}, Ошибок: ${errorCount}`);
        this.fetchOrders(this.currentPage);
      } catch (error) {
        console.error('Ошибка при массовом изменении статуса оплаты:', error);
      } finally {
        this.loading = false;
        this.closeBatchMenu();
        this.activeSubmenu = null;
        this.selectedOrders = [];
      }
    },
    
    async batchShip() {
      if (this.selectedOrders.length === 0) {
        return;
      }

      const canEdit = await this.checkCanEditSelectedOrdersBatch();
      if (!canEdit) return;
      
      this.loading = true;
      let successCount = 0;
      let errorCount = 0;
      
      try {
        for (const orderId of this.selectedOrders) {
          try {
            const order = this.orders.find(o => o.id === orderId);
            if (!order) continue;
            
            const shipmentDate = new Date().toISOString().split('T')[0];
            
            const response = await axios.post(ORDERS_API_BASE + '/updateOrder.php', {
              order: {
                id: orderId,
                site: order.site,
                magazin: {
                  value: order.site || order.magazin || '1akb-by'
                },
                customFields: {
                  datazakazaobrabotki: shipmentDate
                }
              },
              userRole: this.userRole
            }, { timeout: 5000 });
            
            if (response.data.success) {
              successCount++;
            } else {
              errorCount++;
              console.error(`Ошибка для заказа ${orderId}:`, response.data.message);
            }
          } catch (error) {
            console.error(`Ошибка при отгрузке заказа ${orderId}:`, error);
            errorCount++;
          }
        }
        
        console.log(`Отгружено: ${successCount}, Ошибок: ${errorCount}`);
        this.fetchOrders(this.currentPage);
      } catch (error) {
        console.error('Ошибка при массовой отгрузке:', error);
      } finally {
        this.loading = false;
        this.closeBatchMenu();
        this.selectedOrders = [];
      }
    },
    
    batchChangeCourier(courierId) {
      if (this.selectedOrders.length === 0) {
        return;
      }
      
      // Сохраняем выбранный ID курьера и показываем модальное окно выбора машины
      this.selectedCourierId = courierId;
      this.selectedCarId = null;
      this.showCourierCarModal = true;
      this.activeSubmenu = null;
      
      // Загружаем список машин для курьера (если есть API)
      this.loadCourierCars(courierId);
    },
    
    
    async confirmCourierChange(carId) {
      if (!this.selectedCourierId) {
        return;
      }

      const canEdit = await this.checkCanEditSelectedOrdersBatch();
      if (!canEdit) return;
      
      this.loading = true;
      let successCount = 0;
      let errorCount = 0;
      
      try {
        for (const orderId of this.selectedOrders) {
          try {
            const order = this.orders.find(o => o.id === orderId);
            if (!order) continue;
            
            const orderData = {
              order: {
                id: orderId,
                site: order.site,
                magazin: {
                  value: order.site || order.magazin || '1akb-by'
                },
                delivery: {
                  code: order.delivery && order.delivery.code ? {
                    value: order.delivery.code,
                    label: order.delivery.code
                  } : {
                    value: 'courier',
                    label: 'courier'
                  },
                  data: {
                    id: parseInt(this.selectedCourierId),
                    courierId: parseInt(this.selectedCourierId)
                  }
                }
              },
              userRole: this.userRole
            };
            
            // Если выбрана машина, добавляем её в кастомные поля
            if (carId) {
              if (!orderData.order.customFields) {
                orderData.order.customFields = {};
              }
              // Сохраняем машину в кастомное поле
              orderData.order.customFields.mashina_kurera = carId;
            }
            
            const response = await axios.post(ORDERS_API_BASE + '/updateOrder.php', orderData, { timeout: 5000 });
            
            if (response.data.success) {
              successCount++;
            } else {
              errorCount++;
              console.error(`Ошибка для заказа ${orderId}:`, response.data.message);
            }
          } catch (error) {
            if (error.code === 'ECONNABORTED') {
              console.error(`Таймаут для заказа ${orderId}: сервер не ответил за 5 сек`);
            }
            console.error(`Ошибка при смене курьера для заказа ${orderId}:`, error);
            errorCount++;
          }
        }
        
        console.log(`Обновлено: ${successCount}, Ошибок: ${errorCount}`);
        this.fetchOrders(this.currentPage);
      } catch (error) {
        console.error('Ошибка при массовой смене курьера:', error);
      } finally {
        this.loading = false;
        this.closeBatchMenu();
        this.activeSubmenu = null;
        this.selectedOrders = [];
        this.showCourierCarModal = false;
        this.selectedCourierId = null;
        this.selectedCarId = null;
      }
    },
    
    closeCourierCarModal() {
      this.showCourierCarModal = false;
      this.selectedCourierId = null;
      this.selectedCarId = null;
    },

    openBatchStatusModal(statusCode, statusLabel) {
      this.pendingBatchStatusCode = statusCode;
      this.pendingBatchStatusLabel = statusLabel || '';
      this.batchStatusComment = '';
      this.isModalBatchStatusVisible = true;
    },
    closeBatchStatusModal() {
      this.isModalBatchStatusVisible = false;
      this.batchStatusComment = '';
      this.pendingBatchStatusCode = null;
      this.pendingBatchStatusLabel = '';
    },
    confirmBatchStatus() {
      if (this.pendingBatchStatusCode != null) {
        this.batchChangeStatus(this.pendingBatchStatusCode, this.batchStatusComment || '');
        this.closeBatchStatusModal();
      }
    },
    delay(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    async postOrderStatusUpdate(order, statusCode) {
      const orderId = order.id;
      const editorLabel = (this.$store.state.user && this.$store.state.user.label) || (this.user && this.user.label) || '';
      const orderPayload = {
        id: orderId,
        site: order.site || order.magazin || '1akb-by',
        magazin: {
          value: order.site || order.magazin || '1akb-by'
        },
        status: {
          value: statusCode
        }
      };
      if (editorLabel) {
        orderPayload.customFields = { redaktor: editorLabel };
      }
      const response = await axios.post(ORDERS_API_BASE + '/updateOrder.php', {
        order: orderPayload,
        userRole: this.userRole
      }, { timeout: 15000 });
      return response.data && response.data.success;
    },
    async batchBonusReload() {
      if (!this.isManagementRole) {
        this.$toast && this.$toast.error('Прогрузка бонуса доступна только руководителям');
        return;
      }
      if (!this.selectAllForBatch && this.selectedOrders.length === 0) {
        return;
      }

      this.closeBatchMenu();
      this.activeSubmenu = null;

      let ordersToProcess = [];
      try {
        if (this.selectAllForBatch) {
          ordersToProcess = await this.fetchFilteredOrdersForBatch(6000);
          if (ordersToProcess.length === 0) {
            this.$toast && this.$toast.info('По текущему фильтру заказов не найдено');
            return;
          }
        } else {
          ordersToProcess = this.selectedOrders
            .map(id => this.orders.find(o => o.id === id))
            .filter(Boolean);
        }
      } catch (e) {
        console.error('Ошибка загрузки заказов для прогрузки бонуса:', e);
        this.$toast && this.$toast.error('Не удалось загрузить список заказов');
        return;
      }

      const consultationStatus = BONUS_RELOAD_CONSULTATION_STATUS;
      const eligibleOrders = ordersToProcess.filter(o => (o.status || '') !== consultationStatus);
      const skippedCount = ordersToProcess.length - eligibleOrders.length;

      if (eligibleOrders.length === 0) {
        this.$toast && this.$toast.warning(
          skippedCount > 0
            ? 'Все выбранные заказы уже в статусе «Консультация»'
            : 'Нет заказов для прогрузки бонуса'
        );
        return;
      }

      this.batchBonusReloadLoading = true;
      this.batchBonusReloadProgress = { current: 0, total: eligibleOrders.length };

      let successCount = 0;
      let errorCount = 0;

      try {
        for (const order of eligibleOrders) {
          const originalStatus = order.status || '';
          try {
            const toConsultation = await this.postOrderStatusUpdate(order, consultationStatus);
            if (!toConsultation) {
              errorCount++;
              continue;
            }
            await this.delay(900);
            const restored = await this.postOrderStatusUpdate(order, originalStatus);
            if (restored) {
              successCount++;
            } else {
              errorCount++;
            }
          } catch (error) {
            console.error(`Ошибка прогрузки бонуса для заказа ${order.id}:`, error);
            errorCount++;
          } finally {
            this.batchBonusReloadProgress = {
              current: this.batchBonusReloadProgress.current + 1,
              total: eligibleOrders.length
            };
          }
        }

        if (successCount > 0) {
          let msg = `Прогрузка бонуса: обработано ${successCount} заказ(ов)`;
          if (errorCount > 0) msg += `, ошибок: ${errorCount}`;
          if (skippedCount > 0) msg += `, пропущено (уже «Консультация»): ${skippedCount}`;
          this.$toast && this.$toast.success(msg, { timeout: 5000, position: 'bottom-right' });
        } else if (errorCount > 0) {
          this.$toast && this.$toast.error(`Не удалось выполнить прогрузку бонуса (${errorCount} ошибок)`);
        }

        await this.fetchOrders(this.currentPage);
      } catch (error) {
        console.error('Ошибка при массовой прогрузке бонуса:', error);
        this.$toast && this.$toast.error('Ошибка при прогрузке бонуса');
      } finally {
        this.batchBonusReloadLoading = false;
        this.batchBonusReloadProgress = { current: 0, total: 0 };
        this.selectedOrders = [];
        this.selectAllForBatch = false;
      }
    },
    getBatchOrderSiteValue(order) {
      if (!order) return '';
      const pick = (v) => {
        if (v == null || v === '') return '';
        if (typeof v === 'object' && v.value != null && String(v.value).trim() !== '') {
          return String(v.value).trim();
        }
        const s = String(v).trim();
        return s === '[object Object]' ? '' : s;
      };
      const fromSite = pick(order.site);
      if (fromSite) return fromSite;
      return pick(order.magazin);
    },
    async checkCanEditSelectedOrdersBatch() {
      const userGroup = this.userRole || (this.$store.state.user && this.$store.state.user.group_name) || '';
      if (!userGroup) return true;
      try {
        const matrixRes = await fetch(`https://manager.1akb.by/status-transitions-matrix?group=${encodeURIComponent(userGroup)}`);
        const matrixData = await matrixRes.json();
        const matrix = matrixData.matrix || {};
        if (Object.keys(matrix).length === 0) return true;
        for (const orderId of this.selectedOrders) {
          const order = this.orders.find(o => o.id === orderId);
          if (!order) continue;
          const fromCode = order.status || '';
          if (!(fromCode in matrix)) {
            const fromName = this.getStatusName(fromCode);
            this.$toast.error(`Вы не можете редактировать заказ в текущем статусе «${fromName}»`);
            return false;
          }
        }
      } catch (e) {
        console.warn('Ошибка проверки матрицы переходов:', e);
      }
      return true;
    },
    async batchChangeStatus(statusCode, statusComment = '') {
      if (!this.selectAllForBatch && this.selectedOrders.length === 0) {
        return;
      }

      this.loading = true;
      let ordersToProcess = [];
      try {
        if (this.selectAllForBatch) {
          ordersToProcess = await this.fetchFilteredOrdersForBatch(6000);
          if (ordersToProcess.length === 0) {
            this.$toast && this.$toast.info('По текущему фильтру заказов не найдено');
            return;
          }
        } else {
          ordersToProcess = this.selectedOrders
            .map(id => this.orders.find(o => o.id === id))
            .filter(Boolean);
        }
      } catch (e) {
        console.error('Ошибка загрузки заказов для массовой смены статуса:', e);
        this.$toast && this.$toast.error('Не удалось загрузить список заказов');
        return;
      } finally {
        if (ordersToProcess.length === 0) this.loading = false;
      }

      const CENTRAL_OFFICE_SITE = '1akb-by';
      const deliveryStatusesCentralOfficeOnly = ['send-to-delivery', 'redirect', 'fdjkdfkljd'];
      if (deliveryStatusesCentralOfficeOnly.includes(String(statusCode))) {
        const allowedForDeliveryStatus = [];
        const skippedNonCentral = [];
        for (const order of ordersToProcess) {
          const siteVal = this.getBatchOrderSiteValue(order);
          if (siteVal && siteVal !== CENTRAL_OFFICE_SITE) {
            skippedNonCentral.push(order);
          } else {
            allowedForDeliveryStatus.push(order);
          }
        }
        if (skippedNonCentral.length === ordersToProcess.length) {
          this.$toast.error(
            'Статусы «Передан в доставку», «Доставка курьером» и «Доставка транспортной компанией» доступны только для магазина «Центральный офис 1akb.by». В выборке нет таких заказов.',
            { timeout: 6000, position: 'bottom-right', style: { padding: '10px', minWidth: '350px', minHeight: '40px', display: 'flex', alignItems: 'center' } }
          );
          this.loading = false;
          this.closeBatchMenu();
          this.activeSubmenu = null;
          this.selectedOrders = [];
          this.selectAllForBatch = false;
          return;
        }
        if (skippedNonCentral.length > 0) {
          this.$toast.warning(
            `Пропущено ${skippedNonCentral.length} заказ(ов): для магазинов, кроме центрального офиса, этот статус недоступен. Будет изменено заказов: ${allowedForDeliveryStatus.length}.`,
            { timeout: 6500, position: 'bottom-right', style: { padding: '10px', minWidth: '350px', minHeight: '40px', display: 'flex', alignItems: 'center' } }
          );
          ordersToProcess = allowedForDeliveryStatus;
        }
      }

      const userGroup = this.userRole || (this.$store.state.user && this.$store.state.user.group_name) || '';
      if (userGroup) {
        try {
          const matrixRes = await fetch(`https://manager.1akb.by/status-transitions-matrix?group=${encodeURIComponent(userGroup)}`);
          const matrixData = await matrixRes.json();
          const matrix = matrixData.matrix || {};
          if (Object.keys(matrix).length > 0) {
            for (const order of ordersToProcess) {
              const fromCode = order.status || '';
              if (!(fromCode in matrix)) {
                const fromName = this.getStatusName(fromCode);
                this.$toast.error(`Вы не можете редактировать заказ в текущем статусе «${fromName}»`);
                this.loading = false;
                this.selectedOrders = [];
                this.selectAllForBatch = false;
                return;
              }
              if (fromCode === statusCode) continue;
              const row = matrix[fromCode];
              const allowed = row && typeof row === 'object' && row[statusCode];
              if (!allowed) {
                const fromName = this.getStatusName(fromCode);
                const toName = this.getStatusName(statusCode);
                this.$toast.error(`Ваши права не позволяют перевести из «${fromName}» в «${toName}»`);
                this.loading = false;
                this.selectedOrders = [];
                this.selectAllForBatch = false;
                return;
              }
            }
          }
        } catch (e) {
          console.warn('Ошибка проверки матрицы переходов:', e);
        }
      }

      let successCount = 0;
      let errorCount = 0;

      try {
        for (const order of ordersToProcess) {
          const orderId = order.id;
          try {
            const editorLabel = (this.$store.state.user && this.$store.state.user.label) || (this.user && this.user.label) || '';
            const orderPayload = {
              id: orderId,
              site: order.site || order.magazin || '1akb-by',
              magazin: {
                value: order.site || order.magazin || '1akb-by'
              },
              status: {
                value: statusCode
              }
            };
            if (statusComment) {
              orderPayload.statusComment = statusComment;
            }
            if (editorLabel) {
              orderPayload.customFields = { redaktor: editorLabel };
            }
            
            const response = await axios.post(ORDERS_API_BASE + '/updateOrder.php', {
              order: orderPayload,
              userRole: this.userRole
            }, { timeout: 5000 });
            
            if (response.data.success) {
              successCount++;
            } else {
              errorCount++;
              console.error(`Ошибка для заказа ${orderId}:`, response.data.message);
            }
          } catch (error) {
            if (error.code === 'ECONNABORTED') {
              console.error(`Таймаут для заказа ${orderId}: сервер не ответил за 5 сек`);
            }
            console.error(`Ошибка при смене статуса заказа ${orderId}:`, error);
            errorCount++;
          }
        }
        
        console.log(`Обновлено: ${successCount}, Ошибок: ${errorCount}`);
        this.fetchOrders(this.currentPage);
      } catch (error) {
        console.error('Ошибка при массовой смене статуса:', error);
      } finally {
        this.loading = false;
        this.closeBatchMenu();
        this.activeSubmenu = null;
        this.selectedOrders = [];
        this.selectAllForBatch = false;
      }
    },
    
    async batchCancelDelivery() {
      if (this.selectedOrders.length === 0) {
        return;
      }
      
      if (!confirm(`Вы уверены, что хотите отменить доставку для ${this.selectedOrders.length} заказов?`)) {
        return;
      }

      const canEdit = await this.checkCanEditSelectedOrdersBatch();
      if (!canEdit) return;
      
      this.loading = true;
      let successCount = 0;
      let errorCount = 0;
      
      try {
        for (const orderId of this.selectedOrders) {
          try {
            const order = this.orders.find(o => o.id === orderId);
            if (!order) continue;
            
            const response = await axios.post(ORDERS_API_BASE + '/updateOrder.php', {
              order: {
                id: orderId,
                site: order.site,
                magazin: {
                  value: order.site || order.magazin || '1akb-by'
                },
                delivery: {
                  code: 'self-delivery',
                  cost: 0
                }
              },
              userRole: this.userRole
            }, { timeout: 5000 });
            
            if (response.data.success) {
              successCount++;
            } else {
              errorCount++;
              console.error(`Ошибка для заказа ${orderId}:`, response.data.message);
            }
          } catch (error) {
            if (error.code === 'ECONNABORTED') {
              console.error(`Таймаут для заказа ${orderId}: сервер не ответил за 5 сек`);
            }
            console.error(`Ошибка при отмене доставки для заказа ${orderId}:`, error);
            errorCount++;
          }
        }
        
        console.log(`Отменено доставок: ${successCount}, Ошибок: ${errorCount}`);
        this.fetchOrders(this.currentPage);
      } catch (error) {
        console.error('Ошибка при массовой отмене доставки:', error);
      } finally {
        this.loading = false;
        this.closeBatchMenu();
        this.selectedOrders = [];
      }
    },
    
    openCustomFieldModal(field) {
      this.selectedCustomField = field;
      this.customFieldValue = '';
      this.showCustomFieldModal = true;
      this.activeSubmenu = null;
    },
    
    closeCustomFieldModal() {
      // Не закрываем модальное окно во время загрузки
      if (this.batchCustomFieldLoading) {
        return;
      }
      this.showCustomFieldModal = false;
      this.selectedCustomField = null;
      this.customFieldValue = '';
    },
    
    getCustomFieldOptions(fieldCode) {
      // Возвращаем варианты для полей со справочниками
      if (fieldCode === 'manager') {
        // managersList уже имеет структуру { id, name } или { value, label }
        return sortManagersByLabel(this.managersList || []).map(m => ({ 
          value: m.id || m.value, 
          label: m.name || m.label || m.label 
        }));
      } else if (fieldCode === 'prodavec') {
        // prodavecList имеет структуру { value, label }
        return (this.prodavecList || []).map(p => ({ 
          value: p.value || p.id, 
          label: p.label || p.name 
        }));
      } else if (fieldCode === 'ocenka_manageru1') {
        // ocenka_manageruList имеет структуру { code, name }
        return (this.ocenka_manageruList || []).map(o => ({ 
          value: o.code, 
          label: o.name 
        }));
      } else if (fieldCode === 'ocenkaprodavcu') {
        // ocenkaprodavcuList имеет структуру { code, name }
        return (this.ocenkaprodavcuList || []).map(o => ({ 
          value: o.code, 
          label: o.name 
        }));
      } else if (fieldCode === 'obzvon_klienta') {
        // obzvon_klientaList имеет структуру { code, name }
        return (this.obzvon_klientaList || []).map(o => ({ 
          value: o.code, 
          label: o.name 
        }));
      } else if (fieldCode === 'proverkazakazamenedgero') {
        // proverkazakazamenedgeroTypesList может иметь структуру { code, name } или { value, label }
        console.log('getCustomFieldOptions for proverkazakazamenedgero:', this.proverkazakazamenedgeroTypesList);
        return (this.proverkazakazamenedgeroTypesList || []).map(p => {
          const value = p.code || p.value || p.id;
          const label = p.name || p.label;
          console.log('Mapping proverkazakazamenedgero option:', { original: p, value, label });
          return { value, label };
        });
      } else if (fieldCode === 'predoplata_beznalichnymi_spravochnik') {
        return (this.predoplata_beznalichnymi_spravochnikList || []).map(p => ({
          value: p.value,
          label: p.label
        }));
      }
      return [];
    },
    
    async batchChangeCustomField() {
      if (this.selectedOrders.length === 0) {
        return;
      }
      
      if (!this.selectedCustomField || !this.customFieldValue) {
        return;
      }

      const canEdit = await this.checkCanEditSelectedOrdersBatch();
      if (!canEdit) return;
      
      // Устанавливаем флаг загрузки только для модального окна (не для таблицы)
      this.batchCustomFieldLoading = true;
      let successCount = 0;
      let errorCount = 0;
      
      try {
        for (const orderId of this.selectedOrders) {
          try {
            const order = this.orders.find(o => o.id === orderId);
            if (!order) continue;
            
            // Формируем объект customFields с нужным полем
            // Смотрим в OrderEdit.vue как там передаются поля
            const customFields = {};
            const fieldCode = this.selectedCustomField.code;
            
            // Поля, которые требуют структуру { label: ..., value: ... } как в OrderEdit.vue
            const fieldsWithLabelValue = ['manager', 'prodavec', 'proverkazakazamenedgero', 
                                         'ocenka_manageru1', 'ocenkaprodavcu', 'obzvon_klienta',
                                         'predoplata_beznalichnymi_spravochnik'];
            
            if (this.selectedCustomField.type === 'select' || fieldsWithLabelValue.includes(fieldCode)) {
              // Для полей со справочниками передаем в формате { label: ..., value: ... }
              // Находим выбранный вариант для получения label
              const options = this.getCustomFieldOptions(fieldCode);
              const selectedOption = options.find(opt => String(opt.value) === String(this.customFieldValue));
              const selectedLabel = selectedOption ? selectedOption.label : '';
              
              if (fieldCode === 'manager') {
                customFields['manager_new'] = { 
                  label: selectedLabel,
                  value: this.customFieldValue 
                };
              } else if (fieldCode === 'ocenka_manageru1') {
                customFields['ocenka_manageru'] = { 
                  label: selectedLabel,
                  value: this.customFieldValue 
                };
              } else {
                customFields[fieldCode] = { 
                  label: selectedLabel,
                  value: this.customFieldValue 
                };
              }
            } else if (this.selectedCustomField.type === 'date') {
              // Для всех полей типа date форматируем в YYYY-MM-DD
              const dateValue = this.customFieldValue;
              if (dateValue) {
                let formattedDate = '';
                
                // Если это Date объект, форматируем
                if (dateValue instanceof Date) {
                  const year = dateValue.getFullYear();
                  const month = String(dateValue.getMonth() + 1).padStart(2, '0');
                  const day = String(dateValue.getDate()).padStart(2, '0');
                  formattedDate = `${year}-${month}-${day}`;
                } 
                // Если это строка, пытаемся распарсить и отформатировать
                else if (typeof dateValue === 'string') {
                  const dateObj = new Date(dateValue);
                  if (!isNaN(dateObj.getTime())) {
                    const year = dateObj.getFullYear();
                    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
                    const day = String(dateObj.getDate()).padStart(2, '0');
                    formattedDate = `${year}-${month}-${day}`;
                  } else {
                    // Если не удалось распарсить, используем как есть
                    formattedDate = dateValue;
                  }
                } 
                // Для других типов используем как есть
                else {
                  formattedDate = dateValue;
                }
                
                customFields[fieldCode] = formattedDate;
              }
            } else {
              // Для всех остальных текстовых полей передаем значение напрямую
              // Это: sssylkaaaaasssyyylka, nekorrektnyi_bonus, marssh, 
              // lkjdhgdhg768, komisi, otgruzkabezoplata, pometka_zakaza, sf_num,
              // vgvgvgv, mjhfyusdsd7776, raschet_kurera1, sto, postavshchik_zamenil_brakovannyi_akb,
              // jsdhjlkshdlk99, tip_ts_podbor
              customFields[fieldCode] = this.customFieldValue;
            }
            
            const response = await axios.post(ORDERS_API_BASE + '/updateOrder.php', {
              order: {
                id: orderId,
                site: order.site,
                magazin: {
                  value: order.site || order.magazin || '1akb-by'
                },
                customFields: customFields
              },
              userRole: this.userRole
            }, { timeout: 5000 });
            
            if (response.data.success) {
              successCount++;
            } else {
              errorCount++;
              console.error(`Ошибка для заказа ${orderId}:`, response.data.message);
            }
          } catch (error) {
            if (error.code === 'ECONNABORTED') {
              console.error(`Таймаут для заказа ${orderId}: сервер не ответил за 5 сек`);
            }
            console.error(`Ошибка при изменении поля для заказа ${orderId}:`, error);
            errorCount++;
          }
        }
        
        console.log(`Обновлено: ${successCount}, Ошибок: ${errorCount}`);
        
        // Показываем уведомление об успешном завершении
        if (successCount > 0) {
          // Можно добавить toast-уведомление здесь, если есть такая система
          console.log(`Успешно обновлено заказов: ${successCount}`);
        }
        
        // Закрываем модальное окно и сбрасываем флаг загрузки ПЕРЕД обновлением таблицы
        this.batchCustomFieldLoading = false;
        this.closeCustomFieldModal();
        this.closeBatchMenu();
        this.selectedOrders = [];
        
        // Обновляем список заказов после закрытия модального окна
        // Теперь лоадер таблицы будет показываться отдельно, без конфликта с модальным окном
        await this.fetchOrders(this.currentPage);
        
      } catch (error) {
        console.error('Ошибка при массовом изменении пользовательского поля:', error);
        // В случае ошибки тоже закрываем модальное окно
        this.batchCustomFieldLoading = false;
        this.closeCustomFieldModal();
        this.closeBatchMenu();
        this.selectedOrders = [];
      }
    },
    
    // TODO: УДАЛИТЬ - Получение имени продавца по символьному коду
    getSeller(sellerCode) {
      console.log('DEBUG: getSeller called with:', sellerCode);
      console.log('DEBUG: prodavecList:', this.prodavecList);
      
      if (!sellerCode || !this.prodavecList || !Array.isArray(this.prodavecList)) {
        console.log('DEBUG: Early return - no sellerCode or prodavecList');
        return sellerCode || '';
      }
      
      // Ищем продавца в списке prodavecList по полю value (как в managersList)
      const seller = this.prodavecList.find(prodavec => {
        console.log('DEBUG: Comparing', prodavec.value, 'with', sellerCode);
        return prodavec.value === sellerCode;
      });
      
      console.log('DEBUG: Found seller:', seller);
      return seller ? seller.label : sellerCode; // Возвращаем label или сам код, если не найден
    },
    
    onDragEnd (event) {
      // Обновляем selectedColumnKeys после перетаскивания, чтобы сохранить порядок
      this.selectedColumnKeys = this.selectedColumns.map(c => c.key);
    },
    openMegamenu(){
      this.isVisibleMegamenu = !this.isVisibleMegamenu;
    },
    toggleFilter(){
      this.displayFilter = !this.displayFilter;
      localStorage.setItem('displayFilter', JSON.stringify(this.displayFilter));
    },
    onCheckboxChange(col) {
    // Watcher selectedColumnKeys автоматически обновит selectedColumns,
    // сохраняя порядок сортировки и добавляя новые элементы в конец
    // Поэтому здесь ничего не делаем - v-model уже обновил selectedColumnKeys
  },
  removeSelectedColumn(key) {
    this.selectedColumns = this.selectedColumns.filter(c => c.key !== key);
    this.selectedColumnKeys = this.selectedColumnKeys.filter(k => k !== key);
  },
  onColumnsSorted() {
    // после drag&drop сохраняем новый порядок ключей
    console.log('Порядок отсортирован:', this.selectedColumns);
    this.selectedColumnKeys = this.selectedColumns.map(c => c.key);
  },

  getNestedForItem(item, path) {
    // Метод для получения значения поля товара из пути типа items[].offer.name
    // Убираем префикс items[] из пути
    if (!path.startsWith('items[')) return '';
    
    const itemPath = path.replace(/^items\[\]\.?/, '');
    if (!itemPath) return '';
    
    // Специальная обработка для стоимости товара
    if (itemPath === 'totalPrice') {
      // Если есть готовое поле totalPrice, используем его
      if (item.totalPrice !== undefined && item.totalPrice !== null) {
        return item.totalPrice;
      }
      // Иначе вычисляем: initialPrice * quantity
      const price = item.initialPrice || 0;
      const quantity = item.quantity || 1;
      return price * quantity;
    }
    
    return this.getNested(item, itemPath);
  },

  // Цена позиции без скидки (как в OrderEdit — originalPrice)
  getOrderItemOriginalPrice(item) {
    return parseFloat(item.initialPrice) || 0;
  },
  // Цена позиции с учётом скидки (как displayPrice в OrderEdit)
  getOrderItemDisplayPrice(item) {
    const original = this.getOrderItemOriginalPrice(item);
    let discounted = original;
    const discountPercent = parseFloat(item.discountPercent || item.discountManualPercent) || 0;
    const qty = Math.max(1, parseInt(item.quantity, 10) || 1);
    let discountAmount = parseFloat(item.discountManualAmount) || 0;
    if (!discountAmount && item.discounts && Array.isArray(item.discounts)) {
      const manual = item.discounts.find(d => d.type === 'manual_product');
      discountAmount = manual ? (manual.amount || 0) / qty : 0;
    }
    if (discountPercent) discounted -= (original * discountPercent) / 100;
    if (discountAmount) discounted -= discountAmount;
    return parseFloat(Math.max(discounted, 0).toFixed(2));
  },
  hasOrderItemDiscount(item) {
    const percent = parseFloat(item.discountPercent || item.discountManualPercent) || 0;
    const qty = Math.max(1, parseInt(item.quantity, 10) || 1);
    let amount = parseFloat(item.discountManualAmount) || 0;
    if (!amount && item.discounts && Array.isArray(item.discounts)) {
      const manual = item.discounts.find(d => d.type === 'manual_product');
      amount = manual ? (manual.amount || 0) / qty : 0;
    }
    return percent > 0 || amount > 0;
  },

  // Суммарная скидка по заказу в рублях (для столбца «Размер скидки»)
  getOrderTotalDiscount(order) {
    let total = Number(order.discountManualAmount) || 0;
    const items = order.items || [];
    items.forEach(item => {
      const qty = Math.max(1, parseInt(item.quantity, 10) || 1);
      const original = this.getOrderItemOriginalPrice(item) * qty;
      const withDiscount = this.getOrderItemDisplayPrice(item) * qty;
      total += Math.max(0, original - withDiscount);
    });
    const orderPercent = parseFloat(order.discountManualPercent) || 0;
    if (orderPercent > 0 && orderPercent < 100 && order.totalSumm != null) {
      total += (Number(order.totalSumm) * orderPercent) / (100 - orderPercent);
    }
    return Math.max(0, total);
  },

  getNested(obj, path) {
    if (!obj) return '';
    
    // Специальная обработка для менеджеров
    if (path === 'managers') {
      return this.getManager(null, obj);
    }
    if (path === 'seller') {
      return this.getSeller(obj.customFields && obj.customFields.prodavec);
    }
    if (path === 'items') {
      return this.getOrderItems(obj.items || []);
    }

    if (path === 'tradeInAmountNew') {
      const v = obj.customFields && obj.customFields.dfgfdddfnew;
      if (v == null || String(v).trim() === '') return '';
      return String(v);
    }
    if (path === 'batteryCapacityNew') {
      return (obj.customFields && obj.customFields.slksdkk2j3iu3nnew) || '';
    }
    if (path === 'dgh66hhhhhhh' || path === 'customFields.dgh66hhhhhhh') {
      return (obj.customFields && obj.customFields.dgh66hhhhhhh) || '';
    }
    if (path === 'tegi_dialoga' || path === 'customFields.tegi_dialoga') {
      return (obj.customFields && obj.customFields.tegi_dialoga) || '';
    }
    if (path === 'zvonok_text_bot' || path === 'customFields.zvonok_text_bot') {
      return (obj.customFields && obj.customFields.zvonok_text_bot) || '';
    }
    if (path === 'dataSoglasovaniia' || path === 'customFields.data_soglasovaniia1' || path === 'data_soglasovaniia1') {
      return this.getCurDat(obj.customFields && obj.customFields.data_soglasovaniia1);
    }
    
    // Специальная обработка для полного ФИО покупателя
    if (path === 'customer.fullName') {
      const customer = obj.customer || {};
      const parts = [];
      if (customer.lastName) parts.push(customer.lastName);
      if (customer.firstName) parts.push(customer.firstName);
      if (customer.patronymic) parts.push(customer.patronymic);
      return parts.length > 0 ? parts.join(' ') : (obj.lastName && obj.firstName ? `${obj.lastName} ${obj.firstName} ${obj.patronymic || ''}`.trim() : '');
    }
    
    // Специальная обработка для суммы всех оплат (формат: "тип оплаты - сумма")
    if (path === 'payments.totalAmount') {
      if (!obj.payments) return '';
      const payments = Array.isArray(obj.payments) ? obj.payments : Object.values(obj.payments);
      if (!payments.length) return '';
      
      // Формируем строку для каждой оплаты: "тип оплаты - сумма"
      const paymentStrings = payments.map(payment => {
        if (!payment || !payment.type) return '';
        
        // Получаем название типа оплаты
        let paymentTypeName = payment.type;
        
        // Сначала пробуем получить из valueDictionary (если доступен)
        if (typeof valueDictionary !== 'undefined' && valueDictionary[payment.type]) {
          paymentTypeName = valueDictionary[payment.type];
        } else if (this && this.getPaymentTypeName) {
          // Пробуем получить из paymentList через getPaymentTypeName
          try {
            const name = this.getPaymentTypeName(payment.type);
            if (name && name !== payment.type) {
              paymentTypeName = name;
            }
          } catch (e) {
            // Оставляем исходное значение
          }
        }
        
        const amount = payment.amount || 0;
        return `${paymentTypeName} - ${amount}`;
      }).filter(Boolean);
      
      return paymentStrings.join(', ');
    }
    
    // Специальная обработка для последней даты оплаты
    if (path === 'payments.lastPaidAt') {
      if (!obj.payments) return '';
      const payments = Array.isArray(obj.payments) ? obj.payments : Object.values(obj.payments);
      if (!payments.length) return '';
      // Находим последнюю дату оплаты (самую позднюю)
      const dates = payments
        .map(p => p.paidAt || p.date)
        .filter(Boolean)
        .map(d => new Date(d))
        .filter(d => !isNaN(d.getTime()))
        .sort((a, b) => b - a);
      return dates.length > 0 ? dates[0].toISOString().split('T')[0] : '';
    }
    
    // Специальная обработка для типа оплаты
    if (path === 'paymentType') {
      let paymentType = obj.paymentType;
      
      // Если paymentType нет на верхнем уровне, берем из payments (первый платеж)
      if (!paymentType && obj.payments) {
        const payments = Array.isArray(obj.payments) ? obj.payments : Object.values(obj.payments);
        if (payments.length > 0 && payments[0].type) {
          paymentType = payments[0].type;
        }
      }
      
      if (!paymentType) return '';
      
      // Пробуем получить из valueDictionary
      if (typeof valueDictionary !== 'undefined' && valueDictionary[paymentType]) {
        return valueDictionary[paymentType];
      }
      
      // Пробуем получить через getPaymentTypeName
      if (this && this.getPaymentTypeName) {
        try {
          const name = this.getPaymentTypeName(paymentType);
          if (name && name !== paymentType) {
            return name;
          }
        } catch (e) {
          // Оставляем исходное значение
        }
      }
      
      return paymentType;
    }
    
    // Специальная обработка для типа доставки (проверяем ДО стандартной обработки)
    if (path === 'delivery.code') {
      const delivery = obj.delivery;
      if (!delivery || !delivery.code) return '';
      const deliveryCode = delivery.code;
      
      // Пробуем получить из valueDictionary
      if (typeof valueDictionary !== 'undefined' && valueDictionary[deliveryCode]) {
        return valueDictionary[deliveryCode];
      }
      
      // Пробуем получить через getDeliveryName
      if (this && this.getDeliveryName) {
        try {
          const name = this.getDeliveryName(deliveryCode);
          if (name && name !== deliveryCode) {
            return name;
          }
        } catch (e) {
          // Оставляем исходное значение
        }
      }
      
      return deliveryCode;
    }

    // Курьер в Excel: имя из справочника (curier.php), а не сырой ID — как в таблице заказов
    if (path === 'courier') {
      const d = obj.delivery;
      if (!d) return '';
      const cid =
        d.data && d.data.courierId != null && d.data.courierId !== ''
          ? d.data.courierId
          : d.courierId;
      return this.getCourierName(cid);
    }
    if (path === 'delivery.courierId') {
      const id = obj.delivery && obj.delivery.courierId;
      if (id == null || id === '') return '';
      return this.getCourierName(id);
    }
    if (path === 'delivery.data.id') {
      const id = obj.delivery && obj.delivery.data && obj.delivery.data.id;
      if (id == null || id === '') return '';
      return this.getCourierName(id);
    }

    const parts = path.split('.');
    let cur = obj;
    for (let i = 0; i < parts.length; i++) {
      let p = parts[i];
      // Для массивов, например items[].discount
      if (p.endsWith('[]')) {
        const arrKey = p.slice(0, -2);
        if (!Array.isArray(cur[arrKey])) return '';
        const rest = parts.slice(i + 1).join('.');
        return cur[arrKey].map(item => {
          // Специальная обработка для стоимости товара
          if (rest === 'totalPrice') {
            if (item.totalPrice !== undefined && item.totalPrice !== null) {
              return item.totalPrice;
            }
            const price = item.initialPrice || 0;
            const quantity = item.quantity || 1;
            return price * quantity;
          }
          return this.getNested(item, rest);
        }).join(', ');
      }
      if (!cur) return '';
      cur = cur[p];
      if (cur === undefined || cur === null) {
        return '';
      }
    }
    
    // Форматирование дат для экспорта
    if (typeof cur === 'string' && /^\d{4}-\d{2}-\d{2}/.test(cur)) {
      // Если это дата создания или изменения статуса - форматируем с временем
      if (path === 'createdAt' || path === 'statusUpdatedAt' || path.includes('statusTsAt')) {
        return this.getCurDat(cur);
      }
      // Для остальных дат (доставка, отгрузка и т.д.) - только дата
      return this.getCurDatDostavka(cur);
    }
    
    return cur;
  },

    /** Миграция экспорта: старые поля зачёта → актуальные (RetailCRM customFields). */
    migrateExportColumnKeys(columns) {
      if (!Array.isArray(columns)) return [];
      const MAP = {
        'customFields.dfgfdddf': 'customFields.dfgfdddfnew',
        'customFields.slksdkk2j3iu3n': 'customFields.slksdkk2j3iu3nnew',
        'batteryCapacityNew': 'customFields.slksdkk2j3iu3nnew'
      };
      const out = [];
      const seen = new Set();
      columns.forEach(k => {
        const next = MAP[k] || k;
        if (seen.has(next)) return;
        seen.add(next);
        out.push(next);
      });
      return out;
    },

    /*export*/
   async loadExportTemplates() {
    try {
      const resp = await axios.get('/export-templates');
      const list = resp.data || [];
      this.exportTemplates = list.map(t => ({
        ...t,
        columns: this.migrateExportColumnKeys(t.columns || [])
      }));
    } catch (e) {
      // обработка ошибки
      this.exportTemplates = [];
    }
  },

  async saveExportTemplate() {
    if (!this.newTemplateName.trim() || !this.selectedColumns.length) return;
    try {
      const cols = this.migrateExportColumnKeys(this.selectedColumnKeys);
      const payload = {
        name: this.newTemplateName.trim(),
        columns: cols
      };
      const resp = await axios.post('/export-templates', payload);
      const saved = { ...resp.data, columns: this.migrateExportColumnKeys(resp.data.columns || []) };
      this.exportTemplates.push(saved);
      this.selectedColumnKeys = cols;
      this.newTemplateName = '';
    } catch (e) {
      // ошибка
    }
  },

  async updateExportTemplate() {
    if (!this.editingTemplateId || !this.newTemplateName.trim() || !this.selectedColumns.length) return;
    try {
      const cols = this.migrateExportColumnKeys(this.selectedColumnKeys);
      const payload = {
        name: this.newTemplateName.trim(),
        columns: cols
      };
      const resp = await axios.put(`/export-templates/${this.editingTemplateId}`, payload);
      // Обновляем шаблон в списке
      const index = this.exportTemplates.findIndex(t => t.id === this.editingTemplateId);
      if (index !== -1) {
        this.exportTemplates[index] = { ...resp.data, columns: this.migrateExportColumnKeys(resp.data.columns || []) };
      }
      this.selectedColumnKeys = cols;
      // Обновляем selectedTemplate если имя изменилось
      if (this.selectedTemplate && this.selectedTemplate !== resp.data.name) {
        this.selectedTemplate = resp.data.name;
      }
      this.cancelEditTemplate();
    } catch (e) {
      console.error('Ошибка обновления шаблона:', e);
      alert('Ошибка при сохранении изменений шаблона');
    }
  },

  editTemplate(tpl) {
    if (!tpl) return;
    this.editingTemplateId = tpl.id;
    this.newTemplateName = tpl.name;
    // Применяем шаблон для редактирования
    this.applyTemplate();
  },

  cancelEditTemplate() {
    this.editingTemplateId = null;
    this.newTemplateName = '';
  },

  async deleteExportTemplate(tpl) {
    if (!tpl.id) return;
    try {
      await axios.delete(`/export-templates/${tpl.id}`);
      this.exportTemplates = this.exportTemplates.filter(t => t.id !== tpl.id);
      if (this.selectedTemplate === tpl.name) {
        this.selectedTemplate = null;
        this.selectedColumns = [];
        this.selectedColumnKeys = [];
      }
    } catch (e) {
      // ошибка
    }
  },

  openExportModal() {
    if (!this.canExportOrders) {
      return;
    }
    this.showExportModal = true;
    this.selectedColumns = [];
    this.selectedColumnKeys = [];
    this.selectedTemplate = null;
    this.editingTemplateId = null;
    this.newTemplateName = '';
    this.loadExportTemplates(); // Загружаем с сервера при открытии
  },

  closeExportModal() {
    this.exportAllOrders = false;
    this.exportOneRowPerOrder = false;
    this.showExportModal = false;
  },
  applyTemplate() {
    const tpl = this.exportTemplates.find(t => t.name === this.selectedTemplate);
    if (tpl) {
      const cols = this.migrateExportColumnKeys(tpl.columns || []);
      this.selectedColumns = cols
        .map(colKey => this.exportColumns.find(c => c.key === colKey))
        .filter(Boolean);
      this.selectedColumnKeys = cols.slice();
    }
  },
  replaceValuesInRows(rows, valueDictionary) {

    //словарь статусы заказа
    const statuses = this.statusGroupMap;
    const dictonaryStatus = {};
    Object.entries(statuses).forEach(([key, value]) => {
      if(value.name){
        dictonaryStatus[key] = value.name;
      }
    });


      rows.forEach(row => {
        row.forEach((cell, index) => {
          //русифицируем основной словарь
          if (valueDictionary.hasOwnProperty(cell)) {
            row[index] = valueDictionary[cell];
          }
          // русифицируем статусы
          else if(dictonaryStatus.hasOwnProperty(cell)){
            row[index] = dictonaryStatus[cell];
          }
        });
      });
      
    },

async doExportExcel() {
  if (!this.canExportOrders) {
    return;
  }
  
  this.loading = true;
  
  try {
    let ordersToExport = [];
    
    if (this.exportAllOrders) {
      ordersToExport = await this.fetchAllOrdersForExport();
    } else {
      ordersToExport = this.sortedOrders.filter(order => this.selectedOrders.includes(order.id));
    }
    
    if (ordersToExport.length === 0) {
      console.warn('Нет заказов для экспорта');
      this.loading = false;
      return;
    }
    
    const keys = this.migrateExportColumnKeys(this.selectedColumns.map(c => c.key));
    const columnsMeta = keys.map(k => this.exportColumns.find(c => c.key === k)).filter(Boolean);
    if (columnsMeta.length === 0) {
      console.warn('Нет столбцов для экспорта');
      this.loading = false;
      return;
    }
    const headers = columnsMeta.map(col => col.label);
    
    const hasItemFields = columnsMeta.some(col => col.key.startsWith('items['));
    
    const rows = [];
    
    if (hasItemFields) {
      if (this.exportOneRowPerOrder) {
        // Один заказ — одна строка: колонки товаров объединяем в одну ячейку (через перевод строки)
        ordersToExport.forEach(order => {
          const items = order.items || [];
          const row = columnsMeta.map(col => {
            if (col.key.startsWith('items[')) {
              if (items.length === 0) return '';
              return items.map(item => this.getNestedForItem(item, col.key)).filter(v => v != null && v !== '').join('\n');
            }
            return this.getNested(order, col.key);
          });
          rows.push(row);
        });
      } else {
        ordersToExport.forEach(order => {
          const items = order.items || [];
          
          if (items.length === 0) {
            const row = columnsMeta.map(col => {
              if (col.key.startsWith('items[')) {
                return '';
              }
              return this.getNested(order, col.key);
            });
            rows.push(row);
          } else {
            items.forEach((item, itemIndex) => {
              const row = columnsMeta.map(col => {
                if (col.key.startsWith('items[')) {
                  return this.getNestedForItem(item, col.key);
                } else {
                  return this.getNested(order, col.key);
                }
              });
              rows.push(row);
            });
          }
        });
      }
    } else {
      ordersToExport.forEach(order => {
        const row = columnsMeta.map(col => this.getNested(order, col.key));
        rows.push(row);
      });
    }

    this.replaceValuesInRows(rows, valueDictionary);

    const worksheet = XLSX.utils.aoa_to_sheet([headers, ...rows]);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Заказы');
    const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    saveAs(new Blob([wbout], { type: 'application/octet-stream' }), 'orders.xlsx');
    
    this.closeExportModal();
  } catch (error) {
    console.error('Ошибка при экспорте в Excel:', error);
  } finally {
    this.loading = false;
  }
},
  /*end export*/




    toggleSelectAll() {
    if (this.isAllSelected) {
      this.selectedOrders = [];
      this.selectAllForBatch = false;
    } else {
      this.selectedOrders = this.orders.map((o) => o.id);
      this.selectAllForBatch = true; // массовые действия будут по всем заказам по фильтру (до 6000)
    }
    this.lastOrderCheckboxIndex = null;
  },
  onOrderCheckboxClick(event, index) {
    const orders = this.sortedOrders;
    if (!orders[index]) {
      return;
    }

    if (
      event.shiftKey &&
      this.lastOrderCheckboxIndex !== null &&
      this.lastOrderCheckboxIndex !== index
    ) {
      const start = Math.min(this.lastOrderCheckboxIndex, index);
      const end = Math.max(this.lastOrderCheckboxIndex, index);

      // Сначала даём v-model обработать клик по последней строке (галочка в UI),
      // затем добираем весь диапазон в selectedOrders.
      this.$nextTick(() => {
        const byKey = new Map();
        this.selectedOrders.forEach((id) => {
          byKey.set(String(id), id);
        });
        for (let i = start; i <= end; i += 1) {
          const id = orders[i].id;
          byKey.set(String(id), id);
        }
        this.selectedOrders = Array.from(byKey.values());
      });

      this.lastOrderCheckboxIndex = index;
      return;
    }

    this.lastOrderCheckboxIndex = index;
  },
  handleBatchCheckboxChange(event) {
    if (!event.target.checked) {
      // Если чекбокс снят - снимаем выделение со всех заказов
      this.selectedOrders = [];
      this.lastOrderCheckboxIndex = null;
    }
  },
  exportSelectedToExcel() {
    if (!this.canExportOrders) {
      return;
    }
    // Используем sortedOrders чтобы учитывать сортировку
  const selected = this.sortedOrders.filter(order => this.selectedOrders.includes(order.id));
    if (!selected.length) return;
    
    const headers = ['Дата и время', 'Номер', 'Менеджер'];
    if (this.showSellerColumn) {
      headers.push('Продавец');
    }
    headers.push('Дата доставки', 'Тип доставки', 'Статус', 'Покупатель', 'Телефон', 'Состав', 'Сумма', 'Бонус');

    // Преобразуем в массив для SheetJS: заголовки + строки
    const worksheetData = [
      headers,
      ...selected.map(order => {
        const row = [
          this.getCurDat(order.createdAt),
          order.number,
          this.getManager(null, order)
        ];
        
        // TODO: УДАЛИТЬ - Добавляем продавца для ограниченных пользователей
        if (this.showSellerColumn) {
          row.push(this.getSeller(order.customFields.prodavec));
        }
        
        row.push(
          this.getCurDatDostavka(order.delivery.date),
          this.getDeliveryName(order.delivery.code),
          this.getStatusName(order.status),
          order.customer.firstName,
          order.phone,
          this.getOrderItems(order.items),
          order.totalSumm,
          order.customFields.dfhgodsf8g7
        );
        
        return row;
      })
    ];
    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Выбранные заказы');
    const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    saveAs(new Blob([wbout], { type: 'application/octet-stream' }), 'orders.xlsx');
  },
    // --- Table Settings Methods ---
    loadTableSettings() {
      if (!this.user || !this.user.id) {
        // Если user еще не загружен, попробуем загрузить из store или localStorage
        this.user = this.$store.state.user || JSON.parse(localStorage.getItem('user')) || null;
        if (!this.user || !this.user.id) {
          // Если все еще нет user, отложим загрузку
          setTimeout(() => this.loadTableSettings(), 500);
          return;
        }
      }
      fetch(`https://manager.1akb.by/order-table-columns?userKey=${this.user.id}`)
        .then(res => res.json())
        .then(data => {
          if (data && data.columns && Array.isArray(data.columns) && data.columns.length > 0) {
            // Сохраняем настройки с порядком столбцов
            this.tableColumnSettings = data.columns;
            console.log('Table column settings loaded:', this.tableColumnSettings);
          } else {
            // Если нет сохраненных настроек, используем значения по умолчанию
            console.log('No saved table column settings found, using defaults');
          }
        })
        .catch(err => {
          console.error('Error loading table columns:', err);
          // При ошибке используем значения по умолчанию
        });
    },
    openTableSettings() {
      const currentSettings = this.tableColumnSettings.length 
        ? this.tableColumnSettings 
        : this.availableTableColumns.map(c => ({ key: c.key, visible: true }));
      
      const combined = [];
      const handled = new Set();
      
      currentSettings.forEach(s => {
         const def = this.availableTableColumns.find(c => c.key === s.key);
         if (def) {
           combined.push({ ...def, visible: s.visible !== false });
           handled.add(s.key);
         }
      });
      
      this.availableTableColumns.forEach(c => {
        if (!handled.has(c.key)) {
           combined.push({ ...c, visible: true });
        }
      });
      
      this.selectedTableColumns = combined;
      this.showTableSettingsModal = true;
    },
    saveSettingsFromModal() {
      // Сохраняем порядок столбцов из selectedTableColumns
      const columnsToSave = this.selectedTableColumns.map((c, index) => ({
        key: c.key,
        visible: c.visible !== false,
        order: index // Сохраняем порядок
      }));
      
      this.tableColumnSettings = columnsToSave;

      const userKey = (this.$store.state.user && this.$store.state.user.id) || (this.user && this.user.id);

      fetch(`https://manager.1akb.by/order-table-columns`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          userKey: String(userKey),
          columns: columnsToSave
        })
      })
      .then(res => {
        if (!res.ok) {
          throw new Error(`HTTP error! status: ${res.status}`);
        }
        return res.json();
      })
      .then(data => {
         if (data && data.columns) {
           // Обновляем настройки с сервера (сохраняем порядок)
           this.tableColumnSettings = data.columns;
           console.log('Table column settings saved:', this.tableColumnSettings);
           this.showTableSettingsModal = false;
         } else {
           console.error('Invalid response from server:', data);
         }
      })
      .catch(err => {
        console.error('Error saving table columns:', err);
        alert('Ошибка при сохранении настроек столбцов. Попробуйте еще раз.');
      });
    },
    // --- Filter Settings Methods ---
    loadFilterSettings() {
      if (!this.$store.state.user || !this.$store.state.user.id) {
        // Если user еще не загружен в store, отложим загрузку
        setTimeout(() => this.loadFilterSettings(), 500);
        return;
      }
      fetch(`https://manager.1akb.by/order-filter-settings?userKey=${this.$store.state.user.id}`)
        .then(res => res.json())
        .then(data => {
          if (data && data.filters && Array.isArray(data.filters) && data.filters.length > 0) {
            // Сохраняем настройки с порядком фильтров
            this.filterSettings = data.filters;
            console.log('Filter settings loaded:', this.filterSettings);
          } else {
            // Если нет сохраненных настроек, используем значения по умолчанию
            console.log('No saved filter settings found, using defaults');
          }
        })
        .catch(err => {
          console.error('Error loading filter settings:', err);
          // При ошибке используем значения по умолчанию
        });
    },
    openFilterSettings() {
      const currentSettings = this.filterSettings.length 
        ? this.filterSettings 
        : this.availableFilters.map(f => ({ key: f.key, visible: true }));
      
      const combined = [];
      const handled = new Set();
      
      currentSettings.forEach(s => {
         const def = this.availableFilters.find(f => f.key === s.key);
         if (def) {
           combined.push({ ...def, visible: s.visible !== false });
           handled.add(s.key);
         }
      });
      
      this.availableFilters.forEach(f => {
        if (!handled.has(f.key)) {
           combined.push({ ...f, visible: true });
        }
      });
      
      this.selectedFilters = combined;
      this.showFilterSettingsModal = true;
    },
    saveFilterSettingsFromModal() {
      // Сохраняем порядок фильтров из selectedFilters
      const filtersToSave = this.selectedFilters.map((f, index) => ({
        key: f.key,
        visible: f.visible !== false,
        order: index // Сохраняем порядок
      }));
      
      this.filterSettings = filtersToSave;

      if (!this.$store.state.user || !this.$store.state.user.id) {
        console.error('Cannot save: user not found in store');
        alert('Ошибка: пользователь не найден. Пожалуйста, обновите страницу.');
        return;
      }

      const userKey = this.$store.state.user.id;

      fetch(`https://manager.1akb.by/order-filter-settings`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          userKey: String(userKey),
          filters: filtersToSave
        })
      })
      .then(res => {
        if (!res.ok) {
          throw new Error(`HTTP error! status: ${res.status}`);
        }
        return res.json();
      })
      .then(data => {
         if (data && data.filters) {
           // Обновляем настройки с сервера (сохраняем порядок)
           this.filterSettings = data.filters;
           console.log('Filter settings saved:', this.filterSettings);
           this.showFilterSettingsModal = false;
         } else {
           console.error('Invalid response from server:', data);
         }
      })
      .catch(err => {
        console.error('Error saving filter settings:', err);
        alert('Ошибка при сохранении настроек фильтров. Попробуйте еще раз.');
      });
    },
    isFilterVisible(filterKey) {
      // Если нет настроек, показываем все фильтры
      if (!this.filterSettings || this.filterSettings.length === 0) {
        return true;
      }
      
      // Ищем настройку для этого фильтра
      const setting = this.filterSettings.find(s => s.key === filterKey);
      
      // Если настройка найдена, используем её значение visible
      if (setting) {
        return setting.visible !== false;
      }
      
      // Если настройки нет, показываем фильтр по умолчанию
      return true;
    },
    // -----------------------------

getManager(managerid, order = null) {
  // Если передан объект заказа, используем приоритетную логику
  if (order) {
    console.log('getManager для заказа:', order.id, {
      managerId: order.managerId,
      customFieldsManager: order.customFields && order.customFields.manager,
      managerListOldLength: this.managersListOld.length,
      managersListLength: this.managersList.length
    });
    
    // Сначала проверяем customFields.manager (новое поле) в managersList
    if (order.customFields && order.customFields.manager && this.managersList.length > 0) {
      console.log('Ищем по customFields.manager:', order.customFields.manager, 'в managersList');
      const manag = this.managersList.find(manager => manager.value === order.customFields.manager);
      console.log('Результат поиска в managersList:', manag);
      if (manag) {
        return manag.surname + ' ' + manag.name;
      }
    }
    
    // Если не найден по customFields.manager, ищем по order.managerId в managerListOld
    if (order.managerId && this.managersListOld.length > 0) {
      console.log('Ищем по managerId:', order.managerId, 'в managerListOld');
      const manag = this.managersListOld.find(manager => String(manager.value) === String(order.managerId));
      console.log('Результат поиска в managerListOld:', manag);
      if (manag) {
        return manag.label;
      }
    }
    
    console.log('Менеджер не найден, возвращаем пустую строку');
    return '';
  }
  
  // Старая логика для обратной совместимости
  if (managerid) {
    const manag = this.managersList.find(manager => manager.value === managerid);
    return manag ? manag.label : '';
  }
  return '';
},
isFieldVisible(field) {
  const role = this.userRole ? String(this.userRole).trim().toLowerCase() : '';

  let matchedRoleKey = Object.keys(filterFieldsByRole).find(key => {
    const normalizedKey = String(key).trim().toLowerCase();
    return (
      role === normalizedKey ||
      role.includes(normalizedKey) ||
      normalizedKey.includes(role)
    );
  });

  if (!matchedRoleKey && this.canExportOrders && filterFieldsByRole.control) {
    matchedRoleKey = 'control';
  }

  if (matchedRoleKey) {
    return filterFieldsByRole[matchedRoleKey].includes(field);
  }

  return false;
},
    getCurDat(dateform){
      if (!dateform) return '';
      const date = new Date(dateform.toString().replace(' ', 'T'));
      if (isNaN(date.getTime())) return dateform;

      // Извлекаем компоненты даты
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');

      // Форматируем в нужный вид
      return `${day}.${month}.${year} ${hours}:${minutes}`;

    },
    getCurDatDostavka(dates){

      if(dates){
        const ndate = new Date(dates.toString().replace(' ', 'T'));
        if (isNaN(ndate.getTime())) return dates;

        // извлекаем компоненты даты
        const month = String(ndate.getMonth() + 1).padStart(2, '0');
        const year = String(ndate.getFullYear());
        const day = String(ndate.getDate()).padStart(2,'0');

        return `${day}.${month}.${year}`;
      }

    },

  getStatusGrop(status){
    const statuses = {
      'new': 'Новый',
      'approval': 'Согласование',
      'delivery': 'Доставка',
      'complete': 'Выполнен',
      'cancel': 'Отменен',
      'assembling': 'Комплектуется',
      'dflkdslskl': 'Завершающий этап',
      'brak12': 'Брак',
      'sto12f': 'СТО',
    }
    return statuses[status] || status;
  },
  getStatusGroupColor(colorName) {
    const colors = {
      'new': 'rgba(254,165,48,1)',
      'approval': 'rgba(254,165,48,0.2)',
      'delivery': 'rgba(0,94,235,0.13)',
      'complete': 'rgba(34,201,147,0.15)',
      'cancel': 'rgba(255,83,83,0.15)',
      'assembling': 'rgba(101,40,215,0.1)',
      'dflkdslskl': 'rgba(175,185,195,1)',
      'brak12': 'rgba(101,40,215,0.1)',
      'sto12f': 'rgba(30,34,72,1)',
    };
    return colors[colorName] || colorName || 'rgba(0,0,0,0.1)';
  },
  fetchStatusStatistics() {
    if (!this.filtersApplied) {
      console.log('Filters not applied, skipping status statistics');
      return;
    }
    if (!this.enableStatusStatisticsComputed) {
      return;
    }
    // Запускаем запрос асинхронно (следующий тик), чтобы не конкурировать с fetchOrders и другими запросами
    setTimeout(() => this._fetchStatusStatisticsRequest(), 0);
  },
  async _fetchStatusStatisticsRequest() {
    if (!this.filtersApplied || !this.enableStatusStatisticsComputed) return;

    this.loadingStatusStatistics = true;
    try {
      // Собираем текущие фильтры (БЕЗ фильтра по статусу)
      const filters = { ...this.filters };
      
      // Преобразуем даты
      const dateFields = ['createdAt', 'deliveryDate', 'chipmentDate', 'statusUpdatedAt', 
                        'datazakazaobrabotki', 'kasssas', 'statusTsAt', 'paymentDate'];
      dateFields.forEach(f => {
        if (filters[`${f}_gte`]) filters[`${f}_gte`] = this.getFormattedDate(filters[`${f}_gte`]);
        if (filters[`${f}_lte`]) filters[`${f}_lte`] = this.getFormattedDate(filters[`${f}_lte`]);
      });

      const queryParams = new URLSearchParams();
      
      // Добавляем строковые фильтры
      const stringFields = ['number', 'customer', 'city', 'inn', 'product', 'managerComment', 
                          'customerComment', 'tegi_dialoga', 'marssh', 'lkjdhgdhg768', 'sssylkaaaaasssyyylka', 'vgvgvgv', 'personal_offer_discount', 'shipped'];
      stringFields.forEach(f => {
        if (filters[f]) queryParams.append(`filter[${f}]`, filters[f]);
      });
      
      // Добавляем диапазоны
      const rangeFields = ['createdAt', 'totalSumm'];
      rangeFields.forEach(f => {
        if (filters[`${f}_gte`]) queryParams.append(`filter[${f}][gte]`, filters[`${f}_gte`]);
        if (filters[`${f}_lte`]) queryParams.append(`filter[${f}][lte]`, filters[`${f}_lte`]);
      });
      
      // Добавляем кастомные диапазоны
      const customDateFields = ['statusUpdatedAt', 'deliveryDate', 'chipmentDate', 'datazakazaobrabotki', 'kasssas', 'statusTsAt', 'paymentDate'];
      customDateFields.forEach(f => {
        const key = f === 'paymentDate' ? 'paidAt' : f;
        if (filters[`${f}_gte`]) queryParams.append(`filter[${f}][gte][abs]`, filters[`${f}_gte`]);
        if (filters[`${f}_lte`]) queryParams.append(`filter[${f}][lte][abs]`, filters[`${f}_lte`]);
      });

      // Добавляем мульти-фильтры
      const multiFilters = {
        couriers: 'filter[couriers][in][]',
        managers: 'filter[managers][in][]',
        managersOld: 'filter[managersOld][in][]',
        prodavec: 'filter[prodavec][in][]',
        shipmentStores: 'filter[shipmentStores][in][]',
        deliveryTypes: 'filter[deliveryTypes][in][]',
        sites: 'filter[sites][in][]',
        paymentTypes: 'filter[paymentTypes][in][]',
        paymentStatus: 'filter[paymentStatus][in][]',
        contragentTypes: 'filter[contragentTypes][in][]'
      };

      Object.keys(multiFilters).forEach(key => {
        if (filters[key] && filters[key].length > 0) {
          filters[key].forEach(val => queryParams.append(multiFilters[key], val));
        }
      });

      // Добавляем мульти-фильтры для справочника предоплаты и др. (как в orders)
      const extraMulti = {
        ocenka_manageruTypes: 'filter[ocenka_manageruTypes][in][]',
        obzvon_klienta: 'filter[obzvon_klienta][in][]',
        orderMethodd: 'filter[orderMethodd][in][]',
        proverkazakazamenedgeroTypes: 'filter[proverkazakazamenedgeroTypes][in][]',
        predoplata_beznalichnymi_spravochnik: 'filter[predoplata_beznalichnymi_spravochnik][in][]'
      };
      Object.keys(extraMulti).forEach(key => {
        if (filters[key] && filters[key].length > 0) {
          filters[key].forEach(val => queryParams.append(extraMulti[key], val));
        }
      });

      // Добавляем фильтр по статусам (extendedStatus), если они выбраны
      const statusesToQuery = new Set();
      if (this.selectedStatuses && this.selectedStatuses.length > 0) {
        Object.values(this.groupedStatuses).forEach(group => {
          const hasSelectedStatus = group.statuses && group.statuses.some(status => 
            this.selectedStatuses.includes(status.id)
          );
          if (hasSelectedStatus && group.statuses) {
            group.statuses.forEach(status => {
              statusesToQuery.add(status.id);
            });
          }
        });
        statusesToQuery.forEach(status => {
          queryParams.append('filter[extendedStatus][]', status);
        });
        this.selectedStatuses.forEach(status => {
          queryParams.append('filter[selectedStatuses][]', status);
        });
      }

      const response = await fetch(`${ORDERS_API_BASE}/status_statistics.php?${queryParams}`);
      const data = await response.json();
      
      if (data.success) {
        if (this.enableStatusStatisticsComputed && data.statistics) {
          this.statusStatistics = data.statistics;
          if (data.totalSum !== undefined) {
            this.grandTotalSum = data.totalSum;
          }
          console.log('Status statistics updated from backend:', this.statusStatistics);
        }
        // Суммы по типу оплаты и справочнику предоплаты — из того же ответа
        if (data.paymentTypes || data.predoplata) {
          this.paymentSums = {
            paymentTypes: data.paymentTypes || {},
            predoplata: data.predoplata || {}
          };
        }
      }
      
    } catch (error) {
      console.error('Ошибка при получении статистики по статусам:', error);
    } finally {
      this.loadingStatusStatistics = false;
    }
  },
  getStatusCount(statusCode, groupColor) {
    // Используем статистику из API для всех групп
    if (groupColor && this.statusStatistics[groupColor]) {
      const groupStats = this.statusStatistics[groupColor] || [];
      const statusStat = groupStats.find(s => s.code === statusCode);
      return statusStat ? statusStat.count : 0;
    }
    // Если статистики нет, возвращаем 0
    return 0;
  },
  getGroupCount(groupName) {
    // Суммируем статистику для всех групп
    const group = this.groupedStatuses[groupName];
    if (!group) return 0;
    
    const groupColor = group.color;
    if (groupColor && this.statusStatistics[groupColor]) {
      const groupStats = this.statusStatistics[groupColor] || [];
      return groupStats.reduce((sum, stat) => sum + (stat.count || 0), 0);
    }
    
    // Если статистики нет, возвращаем старое значение или 0
    return group.count || 0;
  },
  /** К оплате: `totalSumm` уже приходит с учетом скидки, дополнительный вычет не нужен. */
  getAmountToPay(order) {
    if (order == null) return 0;
    let base = NaN;
    if (order.totalSumm != null && order.totalSumm !== '') {
      base = parseFloat(order.totalSumm);
    }
    if (Number.isNaN(base) && order.summ != null && order.summ !== '') {
      base = parseFloat(order.summ);
    }
    if (Number.isNaN(base)) base = 0;
    return Math.max(0, parseFloat(base.toFixed(2)));
  },
  formatCurrency(amount) {
    // Форматируем сумму с разделителями тысяч и добавляем "руб."
    if (!amount && amount !== 0) return '0 руб.';
    return new Intl.NumberFormat('ru-RU', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount) + ' руб.';
  },
  // Методы для работы с фильтрами в URL
  serializeFiltersToURL() {
    const params = new URLSearchParams();
    
    // Простые строковые поля
    const stringFields = ['number', 'customer', 'city', 'inn', 'product', 'managerComment', 
      'customerComment', 'tegi_dialoga', 'marssh', 'lkjdhgdhg768', 'sssylkaaaaasssyyylka', 'vgvgvgv', 'personal_offer_discount', 'shipped'];
    stringFields.forEach(field => {
      if (this.filters[field] && this.filters[field] !== '') {
        params.append(`f_${field}`, this.filters[field]);
      }
    });
    
    // Даты (сохраняем как строки в формате YYYY-MM-DD)
    const dateFields = ['createdAt_gte', 'createdAt_lte', 'deliveryDate_gte', 'deliveryDate_lte',
      'chipmentDate_gte', 'chipmentDate_lte', 'statusUpdatedAt_gte', 'statusUpdatedAt_lte',
      'datazakazaobrabotki_gte', 'datazakazaobrabotki_lte', 'statusTsAt_gte', 'statusTsAt_lte'];
    dateFields.forEach(field => {
      if (this.filters[field]) {
        if (this.filters[field] instanceof Date) {
          params.append(`f_${field}`, this.getFormattedDate(this.filters[field]));
        } else if (typeof this.filters[field] === 'string' && this.filters[field] !== '') {
          params.append(`f_${field}`, this.filters[field]);
        }
      }
    });
    
    // Числовые поля
    if (this.filters.totalSumm_gte) params.append('f_totalSumm_gte', this.filters.totalSumm_gte);
    if (this.filters.totalSumm_lte) params.append('f_totalSumm_lte', this.filters.totalSumm_lte);
    
    // Массивы
    if (this.filters.sites && this.filters.sites.length > 0) {
      this.filters.sites.forEach(site => params.append('f_sites[]', site));
    }
    if (this.filters.managers && this.filters.managers.length > 0) {
      this.filters.managers.forEach(manager => params.append('f_managers[]', manager));
    }
    if (this.filters.couriers && this.filters.couriers.length > 0) {
      this.filters.couriers.forEach(courier => params.append('f_couriers[]', courier));
    }
    if (this.filters.shipmentStores && this.filters.shipmentStores.length > 0) {
      this.filters.shipmentStores.forEach(store => params.append('f_shipmentStores[]', store));
    }
    if (this.filters.deliveryTypes && this.filters.deliveryTypes.length > 0) {
      this.filters.deliveryTypes.forEach(type => params.append('f_deliveryTypes[]', type));
    }
    if (this.filters.paymentTypes && this.filters.paymentTypes.length > 0) {
      this.filters.paymentTypes.forEach(type => params.append('f_paymentTypes[]', type));
    }
    if (this.filters.predoplata_beznalichnymi_spravochnik && this.filters.predoplata_beznalichnymi_spravochnik.length > 0) {
      this.filters.predoplata_beznalichnymi_spravochnik.forEach(v => params.append('f_predoplata_beznalichnymi_spravochnik[]', v));
    }
    
    // Выбранные статусы
    if (this.selectedStatuses && this.selectedStatuses.length > 0) {
      this.selectedStatuses.forEach(status => params.append('f_selectedStatuses[]', status));
    }
    
    // Страница
    if (this.currentPage > 1) {
      params.append('page', this.currentPage);
    }
    
    // Обновляем URL без перезагрузки страницы
    const newURL = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
    window.history.replaceState({}, '', newURL);
    
    // Также сохраняем в sessionStorage для быстрого доступа
    sessionStorage.setItem('orderFilters', JSON.stringify(this.filters));
    sessionStorage.setItem('selectedStatuses', JSON.stringify(this.selectedStatuses));
    sessionStorage.setItem('currentPage', String(this.currentPage));
  },
  deserializeFiltersFromURL() {
    const params = new URLSearchParams(window.location.search);
    const hasFilters = Array.from(params.keys()).some(key => key.startsWith('f_'));
    
    if (!hasFilters) {
      // Если нет фильтров в URL, пробуем загрузить из sessionStorage (для всех ролей)
      const savedFilters = sessionStorage.getItem('orderFilters');
      if (savedFilters) {
        try {
          const parsedFilters = JSON.parse(savedFilters);
          this.restoreFiltersFromObject(parsedFilters);
          if (this.isRestrictedUser && this.user && parsedFilters.sites) {
            const allowed = this.getRestrictedSites();
            this.filters.sites = (parsedFilters.sites || []).filter(s => allowed.includes(s));
          }
          return true;
        } catch (e) {
          console.error('Ошибка при загрузке фильтров из sessionStorage:', e);
        }
      }
      return false;
    }
    
    // Загружаем простые строковые поля
    const stringFields = ['number', 'customer', 'city', 'inn', 'product', 'managerComment', 
      'customerComment', 'tegi_dialoga', 'marssh', 'lkjdhgdhg768', 'sssylkaaaaasssyyylka', 'vgvgvgv', 'personal_offer_discount', 'shipped'];
    stringFields.forEach(field => {
      const value = params.get(`f_${field}`);
      if (value) {
        this.filters[field] = value;
      }
    });
    
    // Загружаем даты
    const dateFields = ['createdAt_gte', 'createdAt_lte', 'deliveryDate_gte', 'deliveryDate_lte',
      'chipmentDate_gte', 'chipmentDate_lte', 'statusUpdatedAt_gte', 'statusUpdatedAt_lte',
      'datazakazaobrabotki_gte', 'datazakazaobrabotki_lte', 'statusTsAt_gte', 'statusTsAt_lte'];
    dateFields.forEach(field => {
      const value = params.get(`f_${field}`);
      if (value) {
        const dateValue = new Date(value);
        if (!isNaN(dateValue.getTime())) {
          this.filters[field] = dateValue;
        }
      }
    });
    
    // Загружаем числовые поля
    const totalSummGte = params.get('f_totalSumm_gte');
    if (totalSummGte) this.filters.totalSumm_gte = totalSummGte;
    const totalSummLte = params.get('f_totalSumm_lte');
    if (totalSummLte) this.filters.totalSumm_lte = totalSummLte;
    
    // Загружаем массивы
    const sitesFromUrl = params.getAll('f_sites[]') || [];
    this.filters.sites = (this.isRestrictedUser && this.user)
      ? sitesFromUrl.filter(s => this.getRestrictedSites().includes(s))
      : sitesFromUrl;
    this.filters.managers = params.getAll('f_managers[]') || [];
    this.filters.couriers = params.getAll('f_couriers[]') || [];
    this.filters.shipmentStores = params.getAll('f_shipmentStores[]') || [];
    this.filters.deliveryTypes = params.getAll('f_deliveryTypes[]') || [];
    this.filters.paymentTypes = params.getAll('f_paymentTypes[]') || [];
    this.filters.predoplata_beznalichnymi_spravochnik = params.getAll('f_predoplata_beznalichnymi_spravochnik[]') || [];
    
    // Загружаем выбранные статусы
    this.selectedStatuses = params.getAll('f_selectedStatuses[]') || [];
    
    // Загружаем страницу
    const page = params.get('page');
    if (page) {
      this.currentPage = parseInt(page, 10) || 1;
    }
    
    // Сохраняем в sessionStorage для быстрого доступа
    sessionStorage.setItem('orderFilters', JSON.stringify(this.filters));
    sessionStorage.setItem('selectedStatuses', JSON.stringify(this.selectedStatuses));
    sessionStorage.setItem('currentPage', String(this.currentPage));
    
    return true;
  },
  restoreFiltersFromObject(parsedFilters) {
    // Преобразуем строки дат обратно в объекты Date для date-picker
    const dateFields = [
      'createdAt_gte', 'createdAt_lte',
      'deliveryDate_gte', 'deliveryDate_lte',
      'chipmentDate_gte', 'chipmentDate_lte',
      'statusUpdatedAt_gte', 'statusUpdatedAt_lte',
      'datazakazaobrabotki_gte', 'datazakazaobrabotki_lte',
      'statusTsAt_gte', 'statusTsAt_lte'
    ];
    
    dateFields.forEach(field => {
      if (parsedFilters[field]) {
        if (typeof parsedFilters[field] === 'string' && parsedFilters[field] !== '') {
          const dateValue = new Date(parsedFilters[field]);
          if (!isNaN(dateValue.getTime())) {
            parsedFilters[field] = dateValue;
          } else {
            parsedFilters[field] = '';
          }
        }
        if (parsedFilters[field] === null || parsedFilters[field] === undefined) {
          parsedFilters[field] = '';
        }
      }
    });
    
    this.filters = { ...this.filters, ...parsedFilters };
  },
  loadFilterTemplates() {
    const userKey = (this.$store.state.user && this.$store.state.user.id) || (this.user && (this.user.id || this.user.retailCrmId));
    if (!userKey) {
      setTimeout(() => this.loadFilterTemplates(), 500);
      return;
    }
    fetch(`https://manager.1akb.by/order-filter-templates?userKey=${encodeURIComponent(String(userKey))}`)
      .then(res => res.json())
      .then(data => {
        const list = data && data.templates && Array.isArray(data.templates) ? data.templates : [];
        this.filterTemplates = list.filter(t => t && typeof t === 'object' && t.id != null && t.name != null && t.queryString != null);
      })
      .catch(err => {
        console.error('Ошибка загрузки шаблонов фильтров:', err);
        this.filterTemplates = [];
      });
  },
  saveFilterTemplatesToStorage() {
    const userKey = (this.$store.state.user && this.$store.state.user.id) || (this.user && (this.user.id || this.user.retailCrmId));
    if (!userKey) {
      console.error('Не удалось сохранить шаблоны: пользователь не найден');
      return;
    }
    fetch('https://manager.1akb.by/order-filter-templates', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        userKey: String(userKey),
        templates: this.filterTemplates
      })
    })
      .then(res => {
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return res.json();
      })
      .then(() => {})
      .catch(err => {
        console.error('Ошибка сохранения шаблонов фильтров:', err);
        alert('Не удалось сохранить шаблоны фильтров. Попробуйте ещё раз.');
      });
  },
  parseApiQueryToFilters(queryString) {
    if (!queryString || typeof queryString !== 'string') return;
    this.predefinedFilter = null;
    this.filters = {
      number: '',
      customer: '',
      city: '',
      createdAt_gte: '',
      createdAt_lte: '',
      couriers: [],
      managers: [],
      managersOld: [],
      prodavec: [],
      deliveryDate_gte: '',
      deliveryDate_lte: '',
      totalSumm_gte: '',
      totalSumm_lte: '',
      shipmentStores: [],
      product: '',
      deliveryTypes: [],
      sites: this.isRestrictedUser && this.user ? this.getRestrictedSites() : [],
      managerComment: '',
      customerComment: '',
      vgvgvgv: '',
      statusUpdatedAt_gte: '',
      statusUpdatedAt_lte: '',
      sssylkaaaaasssyyylka: '',
      tegi_dialoga: '',
      marssh: '',
      lkjdhgdhg768: '',
      personal_offer_discount: '',
      statusTsAt_gte: '',
      statusTsAt_lte: '',
      paymentStatus: [],
      proverkazakazamenedgeroTypes: [],
      ocenka_manageruTypes: [],
      ocenka: [],
      obzvon_klienta: [],
      predoplata_beznalichnymi_spravochnik: [],
      orderMethodd: [],
      paymentTypes: [],
      contragentTypes: [],
      paymentDate_gte: '',
      paymentDate_lte: '',
      datazakazaobrabotki_gte: '',
      datazakazaobrabotki_lte: '',
      kasssas_gte: '',
      kasssas_lte: '',
      shipped: ''
    };
    const params = new URLSearchParams(queryString);
    this.selectedStatuses = params.getAll('filter[extendedStatus][]') || [];
    const stringFields = {
      'filter[number]': 'number',
      'filter[sssylkaaaaasssyyylka]': 'sssylkaaaaasssyyylka',
      'filter[vgvgvgv]': 'vgvgvgv',
      'filter[customer]': 'customer',
      'filter[city]': 'city',
      'filter[inn]': 'inn',
      'filter[product]': 'product',
      'filter[managerComment]': 'managerComment',
      'filter[customerComment]': 'customerComment',
      'filter[tegi_dialoga]': 'tegi_dialoga',
      'filter[marssh]': 'marssh',
      'filter[lkjdhgdhg768]': 'lkjdhgdhg768',
      'filter[personal_offer_discount]': 'personal_offer_discount',
      'filter[shipped]': 'shipped'
    };
    Object.keys(stringFields).forEach(paramKey => {
      const v = params.get(paramKey);
      if (v !== null && v !== undefined) this.filters[stringFields[paramKey]] = v;
    });
    const dateParams = {
      'filter[createdAt][gte]': 'createdAt_gte',
      'filter[createdAt][lte]': 'createdAt_lte',
      'filter[deliveryDate][gte][abs]': 'deliveryDate_gte',
      'filter[deliveryDate][lte][abs]': 'deliveryDate_lte',
      'filter[shipmentDate][gte][abs]': 'chipmentDate_gte',
      'filter[shipmentDate][lte][abs]': 'chipmentDate_lte',
      'filter[statusUpdatedAt][gte][abs]': 'statusUpdatedAt_gte',
      'filter[statusUpdatedAt][lte][abs]': 'statusUpdatedAt_lte',
      'filter[datazakazaobrabotki][gte][abs]': 'datazakazaobrabotki_gte',
      'filter[datazakazaobrabotki][lte][abs]': 'datazakazaobrabotki_lte',
      'filter[kasssas][gte][abs]': 'kasssas_gte',
      'filter[kasssas][lte][abs]': 'kasssas_lte',
      'filter[statusTsAt][gte][abs]': 'statusTsAt_gte',
      'filter[statusTsAt][lte][abs]': 'statusTsAt_lte',
      'filter[paymentDate][gte][abs]': 'paymentDate_gte',
      'filter[paymentDate][lte][abs]': 'paymentDate_lte'
    };
    Object.keys(dateParams).forEach(paramKey => {
      const v = params.get(paramKey);
      if (v) {
        const d = new Date(v);
        this.filters[dateParams[paramKey]] = !isNaN(d.getTime()) ? d : v;
      }
    });
    const numFields = { 'filter[totalSumm][gte]': 'totalSumm_gte', 'filter[totalSumm][lte]': 'totalSumm_lte' };
    Object.keys(numFields).forEach(paramKey => {
      const v = params.get(paramKey);
      if (v !== null && v !== undefined) this.filters[numFields[paramKey]] = v;
    });
    const multiKeys = {
      'filter[couriers][in][]': 'couriers',
      'filter[managers][in][]': 'managers',
      'filter[managersOld][in][]': 'managersOld',
      'filter[prodavec][in][]': 'prodavec',
      'filter[shipmentStores][in][]': 'shipmentStores',
      'filter[deliveryTypes][in][]': 'deliveryTypes',
      'filter[sites][in][]': 'sites',
      'filter[ocenka][in][]': 'ocenka',
      'filter[paymentTypes][in][]': 'paymentTypes',
      'filter[ocenka_manageruTypes][in][]': 'ocenka_manageruTypes',
      'filter[obzvon_klienta][in][]': 'obzvon_klienta',
      'filter[orderMethodd][in][]': 'orderMethodd',
      'filter[paymentStatus][in][]': 'paymentStatus',
      'filter[proverkazakazamenedgeroTypes][in][]': 'proverkazakazamenedgeroTypes',
      'filter[contragentTypes][in][]': 'contragentTypes',
      'filter[predoplata_beznalichnymi_spravochnik][in][]': 'predoplata_beznalichnymi_spravochnik'
    };
    Object.keys(multiKeys).forEach(paramKey => {
      const arr = params.getAll(paramKey);
      if (arr && arr.length) this.filters[multiKeys[paramKey]] = arr;
    });
    this.lastSelectedStatus = null;
    this.showApplyButton = false;
    this.filtersApplied = true;
    this.serializeFiltersToURL();
  },
  toggleFilterTemplate(tpl) {
    if (this.activeFilterTemplateId === tpl.id) {
      this.activeFilterTemplateId = null;
      this.resetFilters();
      return;
    }
    this.activeFilterTemplateId = tpl.id;
    this.predefinedFilter = null;
    this.parseApiQueryToFilters(tpl.queryString);
    this.fetchOrders(1);
    this.fetchStatusStatistics();
  },
  applyFilterTemplate(queryString) {
    this.parseApiQueryToFilters(queryString);
    this.fetchOrders(1);
    this.fetchStatusStatistics();
  },
  saveCurrentFilterAsTemplate() {
    const name = window.prompt('Название шаблона быстрого фильтра:', '');
    if (name === null || !String(name).trim()) return;
    const qs = this.getOrdersQueryParams(1, this.perPage);
    const queryString = qs.toString();
    const id = Date.now().toString(36) + Math.random().toString(36).slice(2);
    this.filterTemplates.push({ id, name: name.trim(), queryString });
    this.activeFilterTemplateId = id;
    this.predefinedFilter = null;
    this.saveFilterTemplatesToStorage();
    this.showFilterTemplateEdit = false;
  },
  deleteSelectedFilterTemplates() {
    if (this.filterTemplatesToDelete.length === 0) return;
    const set = new Set(this.filterTemplatesToDelete);
    if (set.has(this.activeFilterTemplateId)) this.activeFilterTemplateId = null;
    this.filterTemplates = this.filterTemplates.filter(t => !set.has(t.id));
    this.filterTemplatesToDelete = [];
    this.saveFilterTemplatesToStorage();
    this.showFilterTemplateEdit = false;
  },
  applyPredefinedFilter(filterKey) {
  if (this.predefinedFilter === filterKey) {
    this.predefinedFilter = null;
    this.resetFilters();
    return;
  }

  this.predefinedFilter = filterKey;
  this.activeFilterTemplateId = null;

  // Сбрасываем все поля фильтра, чтобы избежать "накладок"
  this.filters = {
    number: '',
    customer: '',
    city: '',
    createdAt_gte: '',
    createdAt_lte: '',
    couriers: [],
    managers: [],
    managersOld: [],
    prodavec:[],
    deliveryDate_gte: '',
    deliveryDate_lte: '',
    totalSumm_gte: '',
    totalSumm_lte: '',
    shipmentStores: [],
    product: '',
    deliveryTypes: [],
    sites: this.isRestrictedUser && this.user ? this.getRestrictedSites() : [], // TODO: УДАЛИТЬ - Сохранение фильтра магазинов в applyPredefinedFilter
    managerComment: '',
    customerComment: '',
    vgvgvgv: '',
    statusUpdatedAt_gte: '',
    statusUpdatedAt_lte: '',
    sssylkaaaaasssyyylka: '',
    tegi_dialoga:'',
    marssh:'',
    lkjdhgdhg768:'',
    personal_offer_discount: '',
    statusTsAt_gte: '',
    statusTsAt_lte:'',
    paymentStatus:[],
    proverkazakazamenedgeroTypes:[],
    ocenka_manageruTypes:[],
    obzvon_klienta: [],
    predoplata_beznalichnymi_spravochnik: [],
    orderMethodd: [],
    paymentTypes:[]
  };

  // Сбрасываем выбранные статусы
  this.selectedStatuses = [];

  // Обнуляем поля отображения
  this.lastSelectedStatus = null;
  this.showApplyButton = false;

  let filterData = {};
  if (this.predefinedFilters[filterKey]) {
    filterData = { ...this.predefinedFilters[filterKey].filter };
  }

  if(filterKey !== 'konverse'){
    // Добавляем текущего пользователя как менеджера
    if (this.user && this.user.symbolicCode) {
      filterData.managers = [this.user.symbolicCode];
    }
  }
  if(filterKey === 'oplataVozim' || filterKey === 'vgg' || filterKey === 'lomVozim'){
    if (this.user && this.user.id) {
      filterData.managers = [];
    }
  }

    if(filterKey === 'vgg' || filterKey === 'oplataVozim'){
      // добавляем vozim 
      filterData.deliveryTypes = ['vozimby', 'rb'];
    }

    if(filterKey === 'konverse'){
        const nowday = new Date();

        // Получаем год и месяц предыдущего месяца
        const year = nowday.getMonth() === 0 ? nowday.getFullYear() - 1 : nowday.getFullYear();
        const month = nowday.getMonth() === 0 ? 11 : nowday.getMonth() - 1;

        // Первый день предыдущего месяца
        const endDay = new Date(year, month, 1);

        // Последний день предыдущего месяца
        const startDay = new Date(year, month + 1, 0);

        // Пример присвоения в объект фильтрации
        filterData.createdAt_gte = endDay;
        filterData.createdAt_lte = startDay;

        // добавляем ozon и онлайн консультант
        filterData.orderMethodd = ['live-chat', 'messenger'];
    }


  // Если "Сегодня" — ставим текущий день
  if (filterKey === 'orderday') {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const endOfToday = new Date();
    endOfToday.setHours(23, 59, 59, 999);

    filterData.createdAt_gte = today;
    filterData.createdAt_lte = endOfToday;
  }

  // Применяем новые значения
  this.filters = {
    ...this.filters,
    ...filterData
  };

  // Обновляем выбранные статусы
  if (filterData.statuses) {
    this.selectedStatuses = [...filterData.statuses];
  }

  this.filtersApplied = true;
  this.fetchOrders(1);
}

,



   ...mapActions({
      // Подключение экшенов из модуля savedFormsModule
      loadSavedForms: "savedFormsModule/loadSavedForms",
      saveForm: "savedFormsModule/saveForm",
      deleteForm: "savedFormsModule/deleteForm",

      // Подключение экшенов из модуля sourceModule
      addPhoneTrunk: "sourceModule/addPhoneTrunk", // Добавление phone -> trunk
    }),

generateUniqueId() {
      return Math.floor(Date.now() / 1000);
    },

 async newOrder() {
  const formId = this.generateUniqueId();

  // Формируем объект данных формы
  const formOrder = {
    order: {
      id: formId,
      orderType: {label: "Физическое лицо", value: "eshop-individual"},
      site: {label: "Центральный офис 1akb.by", value: "1akb-by"},
      /*managerId: {
        label: this.user.label, // Передаём label
        value: this.user.id, // Передаём value
      },*/
      orderMethod: {},
      contragent:{
        contragentType:{ label: 'Физическое лицо', value: 'individual' },
      },
      
      
      products: [], // Пустой массив продуктов
      comments: {
        customerComment: '',
        managerComment: '',
      },
      shipment: {
        shipmentDate: null,
        deliveryCost: null,
        deliveryAddress: '',
        deliveryDate: null,
        weight: null,
        dimensions: {
          length: null,
          width: null,
          height: null,
        },
      },
      deliveryTime: {
        from: null,
        to: null,
      },
      customTime: null,
      oneTimeDiscountAmount: null,
      oneTimeDiscountPercent: null,
      customFields: {
        manager: {
          label: this.user.label,
          value: this.user.symbolicCode
        }
      }
    }
  };

  // Сохраняем форму через Vuex
  //this.saveForm(formData);
  try {
                    const response = await axios.post(ORDERS_API_BASE + '/saveCallOrder.php', formOrder);
                        if (response.data.success) {
                            const { orderId, numberOrder, orderSite, orderCreated } = response.data;
                            
                            const formData = { id:orderId, idorder:orderId, number:numberOrder, site: orderSite ? orderSite : {label: "Центральный офис 1akb.by", value: "1akb-by"}, created:orderCreated, orderMethod:{label:null,value: null}};
                            this.loading = false;
                            alert('Заказ успешно созданнн!');
                            this.$store.dispatch('savedFormsModule/clearSavedForms');
                            this.$store.commit('clearProducts'); // Очистка продуктов через Vuex мутацию
                            this.saveForm(formData);
                            this.$router.push({ name: 'OrderEdit', params: { orderId, site: orderSite } });
                        } else {
                            this.loading = false;
                            alert('Ошибка при создании заказа: ' + response.data.message);
                        }
                    } catch (error) {
                        console.error('Ошибка при создании заказа:', error);
                        alert('Произошла ошибка при создании заказаffff.');
                        this.loading = false;
                    }
  /*console.log(
    `Форма с номером телефона ${phone} успешно сохранена. Источник: ${source.label} (${source.value})`
  );*/
},

extractPhoneFromComment(text) {
  if (!text || typeof text !== 'string') return null;
  const compact = text.replace(/\s/g, '');
  let m = compact.match(/(?:\+?375|375)(\d{9})/);
  if (m) return '375' + m[1];
  m = compact.match(/80(\d{9})/);
  if (m) return '375' + m[1];
  m = text.match(/\+?\d[\d\s\-()]{10,}/);
  if (m) {
    const digits = m[0].replace(/\D/g, '');
    if (digits.length >= 9) {
      if (digits.startsWith('375') && digits.length >= 12) return digits.slice(0, 12);
      if (digits.startsWith('80') && digits.length >= 11) return '375' + digits.slice(2, 11);
    }
  }
  return null;
},

async openLiteOrderModal() {
  this.liteOrderForm = {
    comment: '',
    deliveryAddress: '',
    deliveryDate: null,
    timeFrom: '',
    timeTo: '',
    courier: null
  };
  this.liteOrderErrors = {};
  this.liteOrderModalVisible = true;
  try {
    const { data } = await axios.get(ORDERS_API_BASE + '/curier.php');
    this.couriersListData = Array.isArray(data) ? data : [];
  } catch (e) {
    console.error('Курьеры (Lite): не удалось загрузить список', e);
    this.couriersListData = [];
  }
},

closeLiteOrderModal() {
  if (this.liteOrderSaving) return;
  this.liteOrderModalVisible = false;
},

async submitLiteOrder() {
  this.liteOrderErrors = {};
  const addr = (this.liteOrderForm.deliveryAddress || '').trim();
  if (!addr) this.liteOrderErrors.deliveryAddress = 'Укажите адрес';
  if (!this.liteOrderForm.deliveryDate) this.liteOrderErrors.deliveryDate = 'Укажите дату доставки';
  if (!this.liteOrderForm.timeFrom || !this.liteOrderForm.timeTo) {
    this.liteOrderErrors.time = 'Укажите интервал времени доставки (с и по)';
  }
  if (Object.keys(this.liteOrderErrors).length) return;

  const u = this.user || this.$store.state.user || {};
  const phone = this.extractPhoneFromComment(this.liteOrderForm.comment) || LITE_ORDER_DEFAULT_PHONE;
  const firstName = (u.label && String(u.label).trim()) || 'Сотрудник';
  const managerId = u.retailCrmId != null && u.retailCrmId !== ''
    ? { label: u.label || '', value: u.retailCrmId }
    : null;

  let dateStr = null;
  const dd = this.liteOrderForm.deliveryDate;
  if (dd instanceof Date) {
    const yyyy = dd.getFullYear();
    const mm = String(dd.getMonth() + 1).padStart(2, '0');
    const ddStr = String(dd.getDate()).padStart(2, '0');
    dateStr = `${yyyy}-${mm}-${ddStr}`;
  } else if (dd) {
    dateStr = String(dd).split('T')[0];
  }

  const orderData = {
    order: {
      orderType: { label: 'Физическое лицо', value: 'eshop-individual' },
      orderMethod: null,
      status: LITE_ORDER_STATUS,
      site: LITE_ORDER_SITE,
      managerId,
      shipmentStore: LITE_ORDER_SHIPMENT_STORE,
      customer: {
        firstName,
        lastName: '',
        patronymic: '',
        phone,
        additionalPhone: '',
        email: ''
      },
      items: [{
        offer: { externalId: LITE_ORDER_OFFER_EXTERNAL_ID },
        discountAmount: 0,
        percentAmount: 0,
        productName: 'Конверт (забрать бу)',
        initialPrice: 0,
        quantity: 1
      }],
      payments: [],
      shipmentDate: null,
      delivery: {
        code: LITE_ORDER_DELIVERY,
        cost: null,
        date: dateStr,
        address: {
          text: addr
        },
        time: {
          from: this.liteOrderForm.timeFrom,
          to: this.liteOrderForm.timeTo,
          custom: null
        },
        weight: null,
        dimensions: { length: null, width: null, height: null }
      },
      contragent: {
        contragentType: { label: 'Физическое лицо', value: 'individual' }
      },
      managerComment: (this.liteOrderForm.comment || '').trim(),
      customerComment: '',
      customFields: {
        invoiceDate: null,
        email2: '',
        selectionLink: '',
        wrongSelection: 'no',
        dfgfdddf: 0,
        sssylkaaaaasssyyylka: '',
        komentariimenedgera: '',
        slksdkk2j3iu3n: '',
        prodavec: null
      }
    }
  };

  this.liteOrderSaving = true;
  try {
    const response = await axios.post(ORDERS_API_BASE + '/createOrder.php', orderData);
    if (!response.data || !response.data.success) {
      const msg = (response.data && response.data.message) || 'Не удалось создать заказ';
      if (this.$toast) this.$toast.error(msg);
      else alert(msg);
      return;
    }
    const { orderId, orderSite, orderCreated } = response.data;
    const courier = this.liteOrderForm.courier;
    const courierVal = courier && (courier.value != null ? courier.value : courier);
    if (courierVal != null && courierVal !== '') {
      const cid = parseInt(courierVal, 10);
      if (!Number.isNaN(cid)) {
        try {
          const upd = await axios.post(
            ORDERS_API_BASE + '/updateOrder.php',
            {
              order: {
                id: orderId,
                site: LITE_ORDER_SITE,
                magazin: LITE_ORDER_SITE,
                store: LITE_ORDER_SITE,
                /* Иначе updateOrder перезапишет delivery только code+data и сотрёт адрес/дату/время из createOrder */
                delivery: {
                  code: LITE_ORDER_DELIVERY,
                  date: dateStr,
                  address: { text: addr },
                  time: {
                    from: this.liteOrderForm.timeFrom,
                    to: this.liteOrderForm.timeTo,
                    custom: null
                  },
                  data: { id: cid, courierId: cid }
                }
              },
              userRole: this.userRole || (this.$store.state.user && this.$store.state.user.group_name) || ''
            },
            { timeout: 8000 }
          );
          if (upd.data && upd.data.success === false && this.$toast) {
            this.$toast.warning('Заказ создан; курьера не удалось назначить: ' + (upd.data.message || ''));
          }
        } catch (e) {
          console.error('Lite order: courier update failed', e);
          if (this.$toast) this.$toast.warning('Заказ создан, но назначение курьера не сохранилось. Укажите курьера в карточке заказа.');
        }
      }
    }
    const formData = {
      id: orderId,
      idorder: orderId,
      site: LITE_ORDER_SITE,
      created: orderCreated,
      phone,
      orderMethod: null
    };
    this.$store.dispatch('savedFormsModule/clearSavedForms');
    this.$store.commit('clearProducts');
    this.saveForm(formData);
    this.liteOrderModalVisible = false;
    if (this.$toast) this.$toast.success('Заказ Lite создан');
    else alert('Заказ успешно создан!');
    this.$router.push({ name: 'OrderEdit', params: { orderId, site: orderSite || LITE_ORDER_SITE } });
  } catch (error) {
    console.error('Ошибка быстрого заказа Lite:', error);
    const msg = (error.response && error.response.data && error.response.data.message) || error.message || 'Ошибка сервера';
    if (this.$toast) this.$toast.error(msg);
    else alert('Ошибка: ' + msg);
  } finally {
    this.liteOrderSaving = false;
  }
},


async makeCall(phone) {
  console.log(phone);

  if (!phone|| !this.$store.state.user.phone_extension) {
    console.error("Не указан номер телефона или внутренний номер пользователя.");
    return;
  }

  const internalNumber = this.$store.state.user.phone_extension;
  console.log(internalNumber);

  // Удаляем все символы, кроме цифр (phone может прийти числом из own DB)
  let phoneNumber = String(phone).replace(/\D/g, '');

  // Преобразование номера, если он начинается с 8029 или других кодов
  if (phoneNumber.startsWith('80')) {
    phoneNumber = '375' + phoneNumber.slice(2);
  }

  if (!phoneNumber) {
    console.error("Некорректный номер телефона:", phone);
    return;
  }

  // clientId (secret) — только для инициации звонков через makecallexternal
  const clientId = "e16bc4fc51d243ae80ab476c51b1e7c2";
  const url = `https://bot.vochi.by/api/makecallexternal?code=${encodeURIComponent(internalNumber)}&phone=${encodeURIComponent('+' + phoneNumber)}&clientId=${clientId}`;

  try {
    const response = await axios.get(url);

    if (response.data && response.data.success === false) {
      console.error("Ошибка при инициации звонка:", response.data.message || response.data);
    } else {
      console.log("Звонок успешно инициирован:", (response.data && response.data.message) || response.data);
    }
  } catch (error) {
    console.error("Ошибка при обращении к API Vochi:", error);
  }
  
},

    checkScroll() {
      const scrollBottom =
      window.innerHeight + window.scrollY >= document.body.offsetHeight - 10;
      this.atPageEnd = scrollBottom;
    },



  updateItemsPerPage() {
    this.currentPage = 1; // Сбрасываем на первую страницу
    
    this.fetchOrders(1); // Загружаем данные с обновленным количеством элементов
    
  },  
  loadSavedForms() {
    const savedForms = JSON.parse(localStorage.getItem('savedForms')) || [];
    this.$store.commit('savedFormsModule/SET_SAVED_FORMS', savedForms);
  }
  ,
  openSavedForm(formId) {
    const savedForms = JSON.parse(localStorage.getItem('savedForms'));
    const selectedForm = savedForms.find(form => form.id === formId);
    
    if (selectedForm) {
      localStorage.setItem('currentFormId', formId);
      this.$router.push({ name: 'OrderCreate', params: { formId } });
    }
    },
 resetFilters() {
      // Очищаем sessionStorage
      sessionStorage.removeItem('selectedStatuses'); 
      sessionStorage.removeItem('orderFilters');
      sessionStorage.removeItem('currentPage');
      
      // Очищаем URL параметры
      window.history.replaceState({}, '', window.location.pathname);
      
      // Очищаем фильтры
      this.filters = {
            number: '',
            customer: '',
            city: '',
            createdAt_gte: '',
            createdAt_lte: '',
            couriers: [],
            managers: [],
            managersOld: [],
            prodavec:[],
            deliveryDate_gte: '',
            deliveryDate_lte: '',
            totalSumm_gte: '',
            totalSumm_lte: '',
            shipmentStores: [],
            product: '',
            vgvgvgv:'',
            deliveryTypes: [],
            paymentTypes: [],
            sites: this.isRestrictedUser && this.user ? this.getRestrictedSites() : [], // TODO: УДАЛИТЬ - Сохранение фильтра магазинов для ограниченных пользователей
            managerComment: '',
            customerComment: '',
            statusUpdatedAt_gte: '',
            statusUpdatedAt_lte: '',
            tegi_dialoga:'',
            marssh:'',
            lkjdhgdhg768:'',
            personal_offer_discount: '',
            statusTsAt_gte: '',
            statusTsAt_lte:'',
            paymentStatus:[],
            proverkazakazamenedgeroTypes:[],
            ocenka_manageruTypes:[],
            obzvon_klienta: [],
            predoplata_beznalichnymi_spravochnik: [],
            orderMethodd: [],
            shipped: ''
        };
        this.filtersApplied = false; // Сбрасываем флаг примененных фильтров
        this.selectedStatuses = []; // Сбрасываем выбранные статусы
        this.statusStatistics = {}; // Сбрасываем статистику по статусам
        this.grandTotalSum = 0; // Сбрасываем общую сумму
        this.showApplyButton = false; // Скрываем кнопку
        this.checkboxKey += 1;
        this.predefinedFilter = null; // Сбрасываем предустановленный фильтр
        this.activeFilterTemplateId = null; // Сбрасываем выбранный шаблон
        this.currentPage = 1; // Сбрасываем страницу
        
        // Очищаем URL
        window.history.replaceState({}, '', window.location.pathname);
        
        this.fetchOrders(1); // Перезагружаем данные без фильтров
    },
  normalizeSiteData(node) {
      return {
        id: node.id,
        label: node.label,
      };
    },
    /** Собрать все id из дерева опций (для кнопки «Выбрать все»). */
    getAllIdsFromOptions(options) {
      if (!options || !Array.isArray(options)) return [];
      return options.reduce((acc, node) => {
        if (node.id != null && node.id !== '') acc.push(node.id);
        if (node.children && node.children.length) acc.push(...this.getAllIdsFromOptions(node.children));
        return acc;
      }, []);
    },

  getFormattedDate(date) {
  if (!date) return '';

  // Если date уже объект Date, оставляем, иначе преобразуем
  const parsedDate = typeof date === 'string' ? new Date(date) : date;

  const year = parsedDate.getFullYear();
  const month = String(parsedDate.getMonth() + 1).padStart(2, '0');
  const day = String(parsedDate.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
}
,
  createStatusGroupMap() {
      this.statusGroupMap = this.statuses.reduce((map, status) => {
        map[status.code] = {
          name: status.name,
          group: status.group,
          color: status.color
        };
        return map;
      }, {});
    },

    copyOrderNumber(order) {
      // Копируем order.number и устанавливаем id для показа тултипа
      navigator.clipboard.writeText(order.number.toString())
        .then(() => {
          this.copiedId = order.id;
          // Скрываем тултип через 2 секунды
          setTimeout(() => {
            this.copiedId = null;
          }, 2000);
        })
        .catch(err => {
          console.error("Ошибка копирования номера:", err);
        });
    },
    copyNumberClient(order) {
      if (!order || order.phone == null || order.phone === '') return;
      const phoneText = String(order.phone);
      navigator.clipboard.writeText(phoneText)
        .then(() => {
          this.copiedId = order.phone;
          // Скрываем тултип через 2 секунды
          setTimeout(() => {
            this.copiedId = null;
          }, 2000);
        })
        .catch(err => {
          console.error("Ошибка копирования номера:", err);
        });
    },
  
    getStatusColor(statusCode) {
      if (this.statusGroupMap[statusCode]) {
        return this.statusGroupMap[statusCode].color;
      }
      return 'rgba(0,0,0,0.1)'; // Дефолтный цвет
    },
    getStatusGroupClass(statusCode) {
      if (this.statusGroupMap[statusCode]) {
        return this.statusGroupMap[statusCode].group;
      }
      return 'default-group'; // Дефолтный класс
    },
  createStatusNameMap() {
      this.statusNameMap = this.statuses.reduce((map, status) => {
        map[status.code] = status.name; // Предполагаем, что `status` имеет свойства `code` и `name`
        return map;
      }, {});
    },
    getStatusName(statusCode) {
      return this.statusNameMap[statusCode] || statusCode;
    },
    getDeliveryName(deliveryCode) {
      return this.deliveryTypesMap[deliveryCode] || deliveryCode;
    },
    getPaymentTypeName(paymentType) {
      if (!paymentType) return '';
      const paymentTypeObj = this.paymentList && Array.isArray(this.paymentList) 
        ? this.paymentList.find(p => p.value === paymentType || p.id === paymentType)
        : null;
      return paymentTypeObj ? paymentTypeObj.label || paymentTypeObj.name : paymentType;
    },
    isOrderPaid(order) {
      if (!order || !order.payments) return false;
      
      let payments = [];
      if (Array.isArray(order.payments)) {
        payments = order.payments;
      } else if (typeof order.payments === 'object' && Object.keys(order.payments).length > 0) {
        payments = Object.values(order.payments);
      }
      
      if (payments.length === 0) return false;
      
      // Все платежи должны иметь статус "paid"
      const allPaid = payments.every(payment => {
        const status = payment.status || payment.paymentStatus;
        return status === 'paid';
      });
      if (!allPaid) return false;
      
      // Сумма оплаченных должна быть не меньше суммы к оплате
      const amountToPay = this.getAmountToPay(order);
      if (amountToPay > 0) {
        const paidSum = payments.reduce((sum, p) => sum + (parseFloat(p.amount) || 0), 0);
        if (paidSum < amountToPay) return false;
      }
      return true;
    },
    isOrderPartiallyPaid(order) {
      if (!order || !order.payments) return false;
      
      let payments = [];
      if (Array.isArray(order.payments)) {
        payments = order.payments;
      } else if (typeof order.payments === 'object' && Object.keys(order.payments).length > 0) {
        payments = Object.values(order.payments);
      }
      
      if (payments.length === 0) return false;
      
      const paidPayments = payments.filter(payment => {
        const status = payment.status || payment.paymentStatus;
        return status === 'paid';
      });
      const paidCount = paidPayments.length;
      const unpaidCount = payments.filter(payment => {
        const status = payment.status || payment.paymentStatus;
        return status !== 'paid';
      }).length;
      
      // Случай 1: есть хотя бы один оплаченный и хотя бы один неоплаченный платёж
      if (paidCount > 0 && unpaidCount > 0) return true;
      
      // Случай 2: есть оплаченные платежи, но сумма по ним меньше суммы к оплате (в т.ч. один платёж на меньшую сумму)
      const amountToPay = this.getAmountToPay(order);
      if (amountToPay > 0 && paidCount > 0) {
        const paidSum = paidPayments.reduce((sum, p) => sum + (parseFloat(p.amount) || 0), 0);
        if (paidSum < amountToPay) return true;
      }
      
      return false;
    },
    getCourierName(courierId) {
      if (!courierId && courierId !== 0) return '';
      const courier = this.couriersList && Array.isArray(this.couriersList)
        ? this.couriersList.find(
            c =>
              c.value === courierId ||
              c.id === courierId ||
              String(c.value) === String(courierId) ||
              String(c.id) === String(courierId)
          )
        : null;
      return courier ? (courier.label || courier.name) : courierId;
    },
    getDeliveryStatusName(status) {
      // Простое отображение статуса доставки
      if (!status) return '';
      const statusMap = {
        'new': 'Новый',
        'processing': 'В обработке',
        'assembling': 'Собирается',
        'assembled': 'Собран',
        'shipping': 'Отправлен',
        'delivering': 'Доставляется',
        'delivered': 'Доставлен',
        'complete': 'Завершен',
        'cancel': 'Отменен'
      };
      return statusMap[status] || status;
    },
    getOrderMethodName(orderMethod) {
      if (!orderMethod) return '';
      const methodMap = {
        'phone': 'Телефон',
        'online': 'Онлайн',
        'pos': 'Точка продаж',
        'mobile-app': 'Мобильное приложение'
      };
      return methodMap[orderMethod] || orderMethod;
    },
    createdeliveryTypes() {
      this.deliveryTypesMap = this.deliveryTypesList.reduce((map, site) => {
        map[site.value] = site.label; // Используем `value` как ключ, `label` как значение
        return map;
      }, {});
    },
    createSiteNameMap() {
      this.siteNameMap = this.sitesList.reduce((map, site) => {
        map[site.value] = site.label; // Используем `value` как ключ, `label` как значение
        return map;
      }, {});
    },
    getSiteName(siteCode) {
      return this.siteNameMap[siteCode] || siteCode;
    },
  openOrder(orderNumber, orderSite) {
  const hasSavedForms = this.$store.getters['savedFormsModule/hasSavedForms'];
      if (hasSavedForms) {
        console.warn("Есть несохраненные формы. Переход запрещен.");
        this.$toast.warning("Сначала обработайте заказ, прежде чем продолжить.");
        return; // Останавливаем выполнение функции
      }
    this.$router.push({ name: 'OrderEdit', params: { orderId: orderNumber, site:orderSite } });
  },
  handleOrderLinkClick(event, order) {
    const isModifiedClick =
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey ||
      event.button !== 0;

    if (isModifiedClick) {
      if (!this.isLogist) {
        return; // для не логистов сохраняем нативное поведение ссылки
      }
      const hasSavedForms = this.$store.getters['savedFormsModule/hasSavedForms'];
      if (hasSavedForms) {
        if (this.$toast) this.$toast.warning('Сначала обработайте заказ, прежде чем продолжить.');
        return;
      }
      const href = this.$router.resolve({
        name: 'OrderEdit',
        params: { orderId: order.id, site: order.site }
      }).href;
      window.open(href, '_blank');
      return;
    }

    if (event.preventDefault) event.preventDefault();
    this.openOrder(order.id, order.site);
  },
  /**
   * Клик по строке заказа → переход в карточку. Не срабатывает при выделении текста,
   * по чекбоксу, копированию, звонку и прочим интерактивным элементам.
   */
  onOrderRowClick(event, order) {
    if (typeof window !== 'undefined' && window.getSelection) {
      const text = window.getSelection().toString();
      if (text && text.trim()) {
        return;
      }
    }
    const root = event.target && event.target.closest
      ? event.target.closest(
          'a, button, input, label, select, textarea, .copy-btn, .call-button, .message-indic'
        )
      : null;
    if (root) {
      return;
    }
    const isModifiedClick =
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey ||
      (typeof event.button === 'number' && event.button !== 0);
    if (isModifiedClick) {
      const hasSavedForms = this.$store.getters['savedFormsModule/hasSavedForms'];
      if (hasSavedForms) {
        if (this.$toast) this.$toast.warning('Сначала обработайте заказ, прежде чем продолжить.');
        return;
      }
      const href = this.$router.resolve({
        name: 'OrderEdit',
        params: { orderId: order.id, site: order.site }
      }).href;
      window.open(href, '_blank');
      return;
    }
    this.openOrder(order.id, order.site);
  },
    toggleStatusBar() {
      this.statusBarOpened = !this.statusBarOpened;
      this.isClosed = !this.isClosed; // переключение состояния
      // Сохраняем состояние в localStorage
      localStorage.setItem('orderForm_statusBarOpened', JSON.stringify(this.statusBarOpened));
    },
    selectAllStatuses() {
      
  this.selectedStatuses = [];
  this.lastSelectedStatus = 'all'; // фиктивный ID для отслеживания
  this.showApplyButton = true;
  console.log(this.lastSelectedStatus); 
},
    // Метод для переключения статуса
    toggleStatus(statusId) {
        // Если фильтр по статусам уже применен (кнопка "Применить" скрыта),
        // то клик по статусу должен выбрать ТОЛЬКО этот статус (сбросить все остальные)
        if (
          this.filtersApplied &&
          this.showApplyButton === false
        ) {
          // Сбрасываем все выделения и выбираем только этот статус
          this.selectedStatuses = [statusId];
          this.lastSelectedStatus = statusId;
          this.showApplyButton = true; // Показываем кнопку для применения нового выбора
          return;
        }

        // Если фильтр не применен, работаем как обычный toggle (мультивыбор)
        const index = this.selectedStatuses.indexOf(statusId);
        if (index === -1) {
            this.selectedStatuses.push(statusId);
            this.lastSelectedStatus = statusId;
            this.showApplyButton = true; // Показываем кнопку, когда выбран новый статус
        } else {
            this.selectedStatuses.splice(index, 1);
            this.lastSelectedStatus = this.selectedStatuses.length > 0 ? this.selectedStatuses[this.selectedStatuses.length - 1] : null;
            this.showApplyButton = this.selectedStatuses.length > 0; // Показываем кнопку, если остались выбранные статусы
        }
    },

    // Метод для переключения всей группы
    toggleGroup(groupName) {
      const group = this.groupedStatuses[groupName];
      const allSelected = group.statuses.every(status => this.selectedStatuses.includes(status.id));

      // Если фильтр по статусам уже применен (кнопка "Применить" скрыта),
      // то клик по группе должен выбрать ТОЛЬКО статусы этой группы (сбросить все остальные)
      if (
        this.filtersApplied &&
        this.showApplyButton === false
      ) {
        // Сбрасываем все выделения и выбираем только статусы этой группы
        this.selectedStatuses = group.statuses.map(status => status.id);
        this.lastSelectedStatus = group.statuses.length > 0 ? group.statuses[group.statuses.length - 1].id : null;
        this.showApplyButton = true; // Показываем кнопку для применения нового выбора
        return;
      }

      // Если фильтр не применен, работаем как обычный toggle (мультивыбор)
      if (allSelected) {
        // Если все статусы группы выбраны, снимаем выделение
        this.selectedStatuses = this.selectedStatuses.filter(id => !group.statuses.some(status => status.id === id));
      } else {
        // Иначе добавляем недостающие статусы
        group.statuses.forEach(status => {
          if (!this.selectedStatuses.includes(status.id)) {
            this.selectedStatuses.push(status.id);
          }
        });
      }

      this.showApplyButton = this.selectedStatuses.length > 0;
      // Также обновляем lastSelectedStatus для отображения кнопки под последним статусом
      if (group.statuses.length > 0) {
        this.lastSelectedStatus = group.statuses[group.statuses.length - 1].id;
      }
    },
   togglePopupStatus(index) {
      // Переключаем видимость для конкретного элемента
      this.activeIndex = this.activeIndex === index ? null : index;
    },
    applyStatuses() {
        this.filters.statuses = this.selectedStatuses;
      this.serializeFiltersToURL(); // Сохраняем в URL и sessionStorage
      this.filtersApplied = true;
      this.showApplyButton = false;

      this.fetchOrders(1); // Перезагружаем список заказов с выбранными статусами
      // Загружаем статистику по статусам после применения фильтра
      this.fetchStatusStatistics();
    },
    groupStatuses() {
      // Группируем статусы по группам
      this.groupedStatuses = this.statuses.reduce((groups, status) => {
        const groupName = status.group || 'Без группы';
        if (!groups[groupName]) {
          groups[groupName] = {
            color: status.color || 'default',
            count: 0,
            statuses: []
          };
        }
        groups[groupName].count += status.count || 0;
        groups[groupName].statuses.push(status);

        return groups;
      }, {});
      
      // Сортируем статусы внутри каждой группы по номеру в названии
      Object.keys(this.groupedStatuses).forEach(groupName => {
        const group = this.groupedStatuses[groupName];
        if (group.statuses && Array.isArray(group.statuses)) {
          group.statuses.sort((a, b) => {
            // Извлекаем номер из начала названия (например, "1. Комплектуется..." -> 1)
            const getNumber = (name) => {
              if (!name) return 999999;
              const match = name.match(/^(\d+)\./);
              return match ? parseInt(match[1], 10) : 999999;
            };
            
            const numA = getNumber(a.name);
            const numB = getNumber(b.name);
            
            // Если оба имеют номер, сортируем по номеру
            if (numA !== 999999 && numB !== 999999) {
              return numA - numB;
            }
            // Если только один имеет номер, он идет первым
            if (numA !== 999999) return -1;
            if (numB !== 999999) return 1;
            // Если оба без номера, сортируем по названию
            return (a.name || '').localeCompare(b.name || '');
          });
        }
      });
    },

    getOrdersQueryParams(page, perPage) {
      const filters = { ...this.filters };
      filters.createdAt_gte = this.getFormattedDate(filters.createdAt_gte);
      filters.createdAt_lte = this.getFormattedDate(filters.createdAt_lte);
      filters.deliveryDate_gte = this.getFormattedDate(filters.deliveryDate_gte);
      filters.deliveryDate_lte = this.getFormattedDate(filters.deliveryDate_lte);
      filters.chipmentDate_gte = this.getFormattedDate(filters.chipmentDate_gte);
      filters.chipmentDate_lte = this.getFormattedDate(filters.chipmentDate_lte);
      filters.statusUpdatedAt_gte = this.getFormattedDate(filters.statusUpdatedAt_gte);
      filters.statusUpdatedAt_lte = this.getFormattedDate(filters.statusUpdatedAt_lte);
      filters.datazakazaobrabotki_gte = this.getFormattedDate(filters.datazakazaobrabotki_gte);
      filters.datazakazaobrabotki_lte = this.getFormattedDate(filters.datazakazaobrabotki_lte);
      filters.kasssas_gte = this.getFormattedDate(filters.kasssas_gte);
      filters.kasssas_lte = this.getFormattedDate(filters.kasssas_lte);
      filters.statusTsAt_gte = this.getFormattedDate(filters.statusTsAt_gte);
      filters.statusTsAt_lte = this.getFormattedDate(filters.statusTsAt_lte);
      filters.paymentDate_gte = this.getFormattedDate(filters.paymentDate_gte);
      filters.paymentDate_lte = this.getFormattedDate(filters.paymentDate_lte);
      const queryParams = new URLSearchParams({ page });
      if (this.selectedStatuses.length > 0) {
        this.selectedStatuses.forEach(status => { queryParams.append('filter[extendedStatus][]', status); });
      }
      const numberVal = (filters.number || '').replace(/;/g, ' ').trim();
      if (numberVal) queryParams.append('filter[number]', numberVal);
      if (filters.sssylkaaaaasssyyylka) queryParams.append('filter[sssylkaaaaasssyyylka]', filters.sssylkaaaaasssyyylka);
      if (filters.vgvgvgv) queryParams.append('filter[vgvgvgv]', filters.vgvgvgv);
      if (filters.customer) queryParams.append('filter[customer]', filters.customer);
      if (filters.city) queryParams.append('filter[city]', filters.city);
      if (filters.inn) queryParams.append('filter[inn]', filters.inn);
      if (filters.createdAt_gte) queryParams.append('filter[createdAt][gte]', filters.createdAt_gte);
      if (filters.createdAt_lte) queryParams.append('filter[createdAt][lte]', filters.createdAt_lte);
      if (filters.deliveryDate_gte) queryParams.append('filter[deliveryDate][gte][abs]', filters.deliveryDate_gte);
      if (filters.deliveryDate_lte) queryParams.append('filter[deliveryDate][lte][abs]', filters.deliveryDate_lte);
      if (filters.chipmentDate_gte) queryParams.append('filter[shipmentDate][gte][abs]', filters.chipmentDate_gte);
      if (filters.chipmentDate_lte) queryParams.append('filter[shipmentDate][lte][abs]', filters.chipmentDate_lte);
      if (filters.totalSumm_gte) queryParams.append('filter[totalSumm][gte]', filters.totalSumm_gte);
      if (filters.totalSumm_lte) queryParams.append('filter[totalSumm][lte]', filters.totalSumm_lte);
      if (filters.product) queryParams.append('filter[product]', filters.product);
      if (filters.managerComment) queryParams.append('filter[managerComment]', filters.managerComment);
      if (filters.customerComment) queryParams.append('filter[customerComment]', filters.customerComment);
      if (filters.tegi_dialoga) queryParams.append('filter[tegi_dialoga]', filters.tegi_dialoga);
      if (filters.marssh) queryParams.append('filter[marssh]', filters.marssh);
      if (filters.lkjdhgdhg768) queryParams.append('filter[lkjdhgdhg768]', filters.lkjdhgdhg768);
      if (filters.personal_offer_discount) queryParams.append('filter[personal_offer_discount]', filters.personal_offer_discount);
      if (filters.statusUpdatedAt_gte) queryParams.append('filter[statusUpdatedAt][gte][abs]', filters.statusUpdatedAt_gte);
      if (filters.statusUpdatedAt_lte) queryParams.append('filter[statusUpdatedAt][lte][abs]', filters.statusUpdatedAt_lte);
      if (filters.datazakazaobrabotki_gte) queryParams.append('filter[datazakazaobrabotki][gte][abs]', filters.datazakazaobrabotki_gte);
      if (filters.datazakazaobrabotki_lte) queryParams.append('filter[datazakazaobrabotki][lte][abs]', filters.datazakazaobrabotki_lte);
      if (filters.kasssas_gte) queryParams.append('filter[kasssas][gte][abs]', filters.kasssas_gte);
      if (filters.kasssas_lte) queryParams.append('filter[kasssas][lte][abs]', filters.kasssas_lte);
      if (filters.statusTsAt_gte) queryParams.append('filter[statusTsAt][gte][abs]', filters.statusTsAt_gte);
      if (filters.statusTsAt_lte) queryParams.append('filter[statusTsAt][lte][abs]', filters.statusTsAt_lte);
      if (filters.paymentDate_gte) queryParams.append('filter[paymentDate][gte][abs]', filters.paymentDate_gte);
      if (filters.paymentDate_lte) queryParams.append('filter[paymentDate][lte][abs]', filters.paymentDate_lte);
      if (filters.shipped === 'true' || filters.shipped === 'false') queryParams.append('filter[shipped]', filters.shipped);
      if (perPage) queryParams.append('per_page', perPage);
      const multiFilters = {
        couriers: 'filter[couriers][in][]',
        managers: 'filter[managers][in][]',
        managersOld: 'filter[managersOld][in][]',
        prodavec: 'filter[prodavec][in][]',
        shipmentStores: 'filter[shipmentStores][in][]',
        deliveryTypes: 'filter[deliveryTypes][in][]',
        sites: 'filter[sites][in][]',
        ocenka: 'filter[ocenka][in][]',
        paymentTypes: 'filter[paymentTypes][in][]',
        ocenka_manageruTypes: 'filter[ocenka_manageruTypes][in][]',
        obzvon_klienta: 'filter[obzvon_klienta][in][]',
        orderMethodd: 'filter[orderMethodd][in][]',
        paymentStatus: 'filter[paymentStatus][in][]',
        proverkazakazamenedgeroTypes: 'filter[proverkazakazamenedgeroTypes][in][]',
        contragentTypes: 'filter[contragentTypes][in][]',
        predoplata_beznalichnymi_spravochnik: 'filter[predoplata_beznalichnymi_spravochnik][in][]'
      };
      Object.keys(multiFilters).forEach(key => {
        if (filters[key] && filters[key].length > 0) {
          filters[key].forEach(value => { queryParams.append(multiFilters[key], value); });
        }
      });
      return queryParams;
    },

    async fetchAllFilteredOrdersForPrint() {
      const perPage = 100; // API orders.php отдаёт максимум 100 за раз
      const queryParams = this.getOrdersQueryParams(1, perPage);
      const response = await fetch(`${ORDERS_API_BASE}/orders.php?${queryParams}`);
      const data = await response.json();
      let allOrders = data.orders || [];
      const totalPageCount = (data.pagination && data.pagination.totalPageCount) || 1;
      for (let p = 2; p <= totalPageCount; p++) {
        const q = this.getOrdersQueryParams(p, perPage);
        const r = await fetch(`${ORDERS_API_BASE}/orders.php?${q}`);
        const d = await r.json();
        allOrders = allOrders.concat(d.orders || []);
      }
      return allOrders;
    },

    /** Загружает заказы по текущим фильтрам для массовых действий, с ограничением до limit (по умолчанию 6000). */
    async fetchFilteredOrdersForBatch(limit = 6000) {
      const perPage = 100;
      const maxPages = Math.ceil(limit / perPage);
      let allOrders = [];
      for (let p = 1; p <= maxPages; p++) {
        const queryParams = this.getOrdersQueryParams(p, perPage);
        const response = await fetch(`${ORDERS_API_BASE}/orders.php?${queryParams}`);
        const data = await response.json();
        const chunk = data.orders || [];
        if (chunk.length === 0) break;
        allOrders = allOrders.concat(chunk);
        if (chunk.length < perPage) break;
      }
      return allOrders;
    },

   async fetchOrders(page = 1) {
  // Проверяем, что страница валидна и не выходит за пределы допустимого диапазона
  if (page < 1 || (this.pagination && this.pagination.totalPageCount > 0 && page > this.pagination.totalPageCount)) {
    return; // Если страница не валидна и есть страницы, не делаем запрос
}

  this.loading = true; // Устанавливаем состояние загрузки при каждом запросе
  this.selectAllForBatch = false; // при смене страницы/обновлении сбрасываем "выбрать все по фильтру"
  this.selectedOrders = []; // сбрасываем выбор при загрузке новых данных
  this.lastOrderCheckboxIndex = null;

  try {
    const queryParams = this.getOrdersQueryParams(page, this.perPage);

    // Выполняем запрос с собранными параметрами
    const response = await fetch(`${ORDERS_API_BASE}/orders.php?${queryParams}`);
    const data = await response.json();

    if (data.orders && data.orders.length === 0) {
    console.log(this.loading);
      // Если ответ содержит пустой список заказов
      this.orders = [];
      this.pagination = {
        limit: 20,
        totalCount: 0,
        currentPage: 1,
        totalPageCount: 0
      }; // Устанавливаем пустую пагинацию
      this.grandTotalSum = 0; // Обнуляем общую сумму
      this.filtersApplied = true; // Фильтры остаются примененными
    } else if (data.orders) {
      // Если заказы есть, обновляем состояние
      this.orders = data.orders;
      this.pagination = data.pagination;
      this.currentPage = page; // Сохраняем текущую страницу
      
      // Загружаем статистику по статусам для групп Комплектация и Доставка
      // Общая сумма: из status_statistics (с учётом скидки на бэкенде) или пересчёт по текущей странице
      this.fetchStatusStatistics();
      this.$nextTick(() => {
        this.calculateGrandTotalSum();
      });
      
      // Обновляем URL с текущей страницей (если фильтры применены)
      if (this.filtersApplied) {
        this.serializeFiltersToURL();
      }
    }
  } catch (error) {
    console.error('Ошибка при получении заказов:', error);
  } finally {
    this.loading = false; // Всегда выключаем лоадер после запроса
    console.log(this.loading);
  }
},

calculateGrandTotalSum() {
  // Вычисляем общую сумму из уже загруженных отфильтрованных заказов
  if (!this.orders || this.orders.length === 0) {
    this.grandTotalSum = 0;
    return;
  }

  let totalSum = 0;
  this.orders.forEach(order => {
    totalSum += this.getAmountToPay(order);
  });

  this.grandTotalSum = totalSum;
},

isPaymentSumFilterActive(item) {
  if (!item || !item.filterKind || item.filterValue == null) return false;
  if (item.filterKind === 'paymentType') {
    return Array.isArray(this.filters.paymentTypes) && this.filters.paymentTypes.includes(item.filterValue);
  }
  if (item.filterKind === 'predoplata') {
    return Array.isArray(this.filters.predoplata_beznalichnymi_spravochnik) && this.filters.predoplata_beznalichnymi_spravochnik.includes(item.filterValue);
  }
  return false;
},
applyPaymentSumFilter(filterKind, filterValue) {
  if (filterKind === 'paymentType') {
    this.filters.paymentTypes = [filterValue];
    this.filters.predoplata_beznalichnymi_spravochnik = [];
  } else {
    this.filters.predoplata_beznalichnymi_spravochnik = [filterValue];
    this.filters.paymentTypes = [];
  }
  this.filtersApplied = true;
  this.fetchOrders(1);
},

async fetchAllOrdersForExport() {
  try {
    const filters = { ...this.filters };

    filters.createdAt_gte = this.getFormattedDate(filters.createdAt_gte);
    filters.createdAt_lte = this.getFormattedDate(filters.createdAt_lte);
    filters.deliveryDate_gte = this.getFormattedDate(filters.deliveryDate_gte);
    filters.deliveryDate_lte = this.getFormattedDate(filters.deliveryDate_lte);
    filters.chipmentDate_gte = this.getFormattedDate(filters.chipmentDate_gte);
    filters.chipmentDate_lte = this.getFormattedDate(filters.chipmentDate_lte);
    filters.statusUpdatedAt_gte = this.getFormattedDate(filters.statusUpdatedAt_gte);
    filters.statusUpdatedAt_lte = this.getFormattedDate(filters.statusUpdatedAt_lte);
    filters.datazakazaobrabotki_gte = this.getFormattedDate(filters.datazakazaobrabotki_gte);
    filters.datazakazaobrabotki_lte = this.getFormattedDate(filters.datazakazaobrabotki_lte);
    filters.kasssas_gte = this.getFormattedDate(filters.kasssas_gte);
    filters.kasssas_lte = this.getFormattedDate(filters.kasssas_lte);
    filters.statusTsAt_gte = this.getFormattedDate(filters.statusTsAt_gte);
    filters.statusTsAt_lte = this.getFormattedDate(filters.statusTsAt_lte);
    filters.paymentDate_gte = this.getFormattedDate(filters.paymentDate_gte);
    filters.paymentDate_lte = this.getFormattedDate(filters.paymentDate_lte);

    // Функция для создания queryParams с фильтрами
    const buildQueryParams = (page) => {
      const queryParams = new URLSearchParams({ page: page, per_page: 100 });

      if (this.selectedStatuses.length > 0) {
        this.selectedStatuses.forEach(status => {
          queryParams.append('filter[extendedStatus][]', status);
        });
      }

      const numberVal = (filters.number || '').replace(/;/g, ' ').trim();
      if (numberVal) queryParams.append('filter[number]', numberVal);
      if (filters.sssylkaaaaasssyyylka) queryParams.append('filter[sssylkaaaaasssyyylka]', filters.sssylkaaaaasssyyylka);
      if (filters.vgvgvgv) queryParams.append('filter[vgvgvgv]', filters.vgvgvgv);
      if (filters.customer) queryParams.append('filter[customer]', filters.customer);
      if (filters.city) queryParams.append('filter[city]', filters.city);
      if (filters.inn) queryParams.append('filter[inn]', filters.inn);
      if (filters.createdAt_gte) queryParams.append('filter[createdAt][gte]', filters.createdAt_gte);
      if (filters.createdAt_lte) queryParams.append('filter[createdAt][lte]', filters.createdAt_lte);
      if (filters.deliveryDate_gte) queryParams.append('filter[deliveryDate][gte][abs]', filters.deliveryDate_gte);
      if (filters.deliveryDate_lte) queryParams.append('filter[deliveryDate][lte][abs]', filters.deliveryDate_lte);
      if (filters.chipmentDate_gte) queryParams.append('filter[shipmentDate][gte][abs]', filters.chipmentDate_gte);
      if (filters.chipmentDate_lte) queryParams.append('filter[shipmentDate][lte][abs]', filters.chipmentDate_lte);
      if (filters.totalSumm_gte) queryParams.append('filter[totalSumm][gte]', filters.totalSumm_gte);
      if (filters.totalSumm_lte) queryParams.append('filter[totalSumm][lte]', filters.totalSumm_lte);
      if (filters.product) queryParams.append('filter[product]', filters.product);
      if (filters.managerComment) queryParams.append('filter[managerComment]', filters.managerComment);
      if (filters.customerComment) queryParams.append('filter[customerComment]', filters.customerComment);
      if (filters.tegi_dialoga) queryParams.append('filter[tegi_dialoga]', filters.tegi_dialoga);
      if (filters.marssh) queryParams.append('filter[marssh]', filters.marssh);
      if (filters.lkjdhgdhg768) queryParams.append('filter[lkjdhgdhg768]', filters.lkjdhgdhg768);
      if (filters.personal_offer_discount) queryParams.append('filter[personal_offer_discount]', filters.personal_offer_discount);
      if (filters.statusUpdatedAt_gte) queryParams.append('filter[statusUpdatedAt][gte][abs]', filters.statusUpdatedAt_gte);
      if (filters.statusUpdatedAt_lte) queryParams.append('filter[statusUpdatedAt][lte][abs]', filters.statusUpdatedAt_lte);
      if (filters.datazakazaobrabotki_gte) queryParams.append('filter[datazakazaobrabotki][gte][abs]', filters.datazakazaobrabotki_gte);
      if (filters.datazakazaobrabotki_lte) queryParams.append('filter[datazakazaobrabotki][lte][abs]', filters.datazakazaobrabotki_lte);
      if (filters.kasssas_gte) queryParams.append('filter[kasssas][gte][abs]', filters.kasssas_gte);
      if (filters.kasssas_lte) queryParams.append('filter[kasssas][lte][abs]', filters.kasssas_lte);
      if (filters.statusTsAt_gte) queryParams.append('filter[statusTsAt][gte][abs]', filters.statusTsAt_gte);
      if (filters.statusTsAt_lte) queryParams.append('filter[statusTsAt][lte][abs]', filters.statusTsAt_lte);
      if (filters.paymentDate_gte) queryParams.append('filter[paymentDate][gte][abs]', filters.paymentDate_gte);
      if (filters.paymentDate_lte) queryParams.append('filter[paymentDate][lte][abs]', filters.paymentDate_lte);
      if (filters.shipped === 'true' || filters.shipped === 'false') queryParams.append('filter[shipped]', filters.shipped);

      const multiFilters = {
        couriers: 'filter[couriers][in][]',
        managers: 'filter[managers][in][]',
        managersOld: 'filter[managersOld][in][]',
        prodavec: 'filter[prodavec][in][]',
        shipmentStores: 'filter[shipmentStores][in][]',
        deliveryTypes: 'filter[deliveryTypes][in][]',
        sites: 'filter[sites][in][]',
        ocenka: 'filter[ocenka][in][]',
        paymentTypes: 'filter[paymentTypes][in][]',
        ocenka_manageruTypes: 'filter[ocenka_manageruTypes][in][]',
        obzvon_klienta: 'filter[obzvon_klienta][in][]',
        orderMethodd: 'filter[orderMethodd][in][]',
        paymentStatus: 'filter[paymentStatus][in][]',
        proverkazakazamenedgeroTypes: 'filter[proverkazakazamenedgeroTypes][in][]',
        contragentTypes: 'filter[contragentTypes][in][]',
        predoplata_beznalichnymi_spravochnik: 'filter[predoplata_beznalichnymi_spravochnik][in][]'
      };

      Object.keys(multiFilters).forEach(key => {
        if (filters[key] && filters[key].length > 0) {
          filters[key].forEach(value => {
            queryParams.append(multiFilters[key], value);
          });
        }
      });

      return queryParams;
    };

    // Загружаем первую страницу для получения информации о пагинации
    const firstPageParams = buildQueryParams(1);
    const firstResponse = await fetch(`${ORDERS_API_BASE}/orders.php?${firstPageParams}`);
    const firstData = await firstResponse.json();

    if (!firstData.orders || firstData.orders.length === 0) {
      return [];
    }

    // Собираем все заказы
    let allOrders = [...firstData.orders];
    const totalPages = firstData.pagination ? firstData.pagination.totalPageCount : 1;

    // Загружаем остальные страницы, если они есть
    if (totalPages > 1) {
      for (let page = 2; page <= totalPages; page++) {
        const pageParams = buildQueryParams(page);
        const pageResponse = await fetch(`${ORDERS_API_BASE}/orders.php?${pageParams}`);
        const pageData = await pageResponse.json();
        
        if (pageData.orders && pageData.orders.length > 0) {
          allOrders = allOrders.concat(pageData.orders);
        }
      }
    }

    // Применяем сортировку, если она установлена
    if (this.sortField) {
      return this.sortOrders(allOrders, this.sortField, this.sortDirection);
    }
    
    return allOrders;
  } catch (error) {
    console.error('Ошибка при загрузке всех заказов для экспорта:', error);
    return [];
  }
},

sortOrders(orders, field, direction) {
  const sorted = [...orders];
  const dir = direction === 'asc' ? 1 : -1;
  sorted.sort((a, b) => {
    let aValue, bValue;
    if (field === 'deliveryTime' || field === 'delivery.time.from') {
      const getTime = (o) => {
        const from = this.getNested(o, 'delivery.time.from');
        if (!from) return null;
        const [h, m] = String(from).split(':').map(Number);
        return (h || 0) * 60 + (m || 0);
      };
      aValue = getTime(a);
      bValue = getTime(b);
      if (aValue == null && bValue == null) return 0;
      if (aValue == null) return 1;
      if (bValue == null) return -1;
      return (aValue - bValue) * dir;
    }
    if (field === 'deliveryDate') {
      aValue = this.getNested(a, 'delivery.date') || '';
      bValue = this.getNested(b, 'delivery.date') || '';
    } else {
      aValue = this.getNested(a, field) || '';
      bValue = this.getNested(b, field) || '';
    }
    if (aValue < bValue) return -1 * dir;
    if (aValue > bValue) return 1 * dir;
    return 0;
  });
  return sorted;
},

    /** При вводе в поле «Номер заказа» заменяет ; на пробел (номера через пробел). */
    onFilterNumberInput(e) {
      const val = e.target.value;
      if (val.includes(';')) {
        this.filters.number = val.replace(/;/g, ' ');
      }
    },
    applyFilters() {
        this.serializeFiltersToURL(); // Сохраняем в URL и sessionStorage
        this.loading = true; // Включаем состояние загрузки
        // Статистика загрузится автоматически после fetchOrders
        this.fetchOrders(1)
          .then(() => {
            this.filtersApplied = true; // Устанавливаем флаг, что фильтры были применены
          })
          .catch((error) => {
            console.error('Ошибка при применении фильтров:', error);
          })
          .finally(() => {
            this.loading = false; // В любом случае отключаем лоадер
          });
    },
    getOrderItems(items) {
      if (!Array.isArray(items) || items.length === 0) return '';
      return items
        .map(item => (item && item.offer ? item.offer.name : ''))
        .filter(Boolean)
        .join(', ');
    },
    isOrderShipped(order) {
      // Сначала проверяем флаг отгрузки на уровне заказа (из API)
      if (order.shipped === true) return true;
      if (order.shipped === false) return false;
      // Иначе: заказ отгружен, если все позиции отгружены
      if (!order.items || order.items.length === 0) return false;
      return order.items.every(item => item.shipped === true);
    },
    async fetchFilterData() {
      // Здесь будет запрос для получения данных для фильтров
      // Например, для курьеров, менеджеров, складов и т.д.
      // Для упрощения примера пропускаю реализацию
      this.couriersListData = await this.fetchCouriers();
      //this.managersList = await this.fetchManagers();
      //this.storesList = await this.fetchShipmentStores();
      //this.deliveryTypesList = await this.fetchDeliveryTypes();
      //this.sitesList = await this.fetchSites();
    },
    async fetchCouriers() {
      // Получение курьеров
      return [{ id: 1, name: 'Курьер 1' }, { id: 2, name: 'Курьер 2' }];
    },
    async fetchManagers() {
      // Получение менеджеров
      return [{ id: 1, name: 'Менеджер 1' }, { id: 2, name: 'Менеджер 2' }];
    },
    async fetchShipmentStores() {
      // Получение складов
      return [{ id: 1, name: 'Склад 1' }, { id: 2, name: 'Склад 2' }];
    },
    async fetchDeliveryTypes() {
      // Получение типов доставки
      return [{ id: 1, name: 'Доставка 1' }, { id: 2, name: 'Доставка 2' }];
    },
    //async fetchSites() {},
  }
};
</script>


<style scoped>
th, td {
    padding: 10px;
    border: 0px solid #ccc!important;
}
table {
  width: 100%;
  border-collapse: collapse;
}

th, td {
  padding: 10px;
  border: 1px solid #ccc;
}

.selected {
    background-color: #f0f0f0;
}

#apply-button {
    background-color: #fff;
    border: 1px solid #d9d9d9;
    border-radius: 2px;
    box-shadow: 0 3px 15px rgba(0, 0, 0, .12);
    height: 60px;
    left: 100%;
    margin-left: 10px;
    padding: 9px;
    position: absolute;
    top: -10px;
}

button {
  margin: 10px;
}

.selected {
    position: relative;
}

.m-filter {
    background-color: #fff;
    clear: both;
    padding-bottom: 65px;
    position: relative;
}

.m-filter .filter-content {
    overflow: visible;
    padding-bottom: 8px;
    padding-top: 19px;
}

.filter-content {
    overflow: visible !important;
}

.filter__row {
    overflow: visible !important;
}

.m-filter .filter__row {
    font-size: 0;
    margin-left: -15px;
    margin-right: -15px;
    min-height: 36px;
    position: relative;
    transition: min-height .3s ease;
    width: calc(100% + 30px);
    box-sizing: border-box;
    overflow: visible !important;
}

.m-filter .filter-group {
    float: left;
    font-size: 0;
    letter-spacing: -1px;
    line-height: 0;
    margin-bottom: 15px;
    opacity: 1;
    padding: 0 15px;
    transition: opacity .8s ease;
    width: 16.666%; /* 6 элементов в ряд на больших экранах */
    box-sizing: border-box;
    overflow: visible !important;
}

.filter-group {
    overflow: visible !important;
    position: relative;
}

body .m-filter .filter-group {
    display: inline-block;
    float: none;
    min-width: 0;
    vertical-align: top;
    width: 16.666%; /* 6 элементов в ряд на больших экранах по умолчанию */
}

/* 5 элементов в ряд на средних экранах */
@media screen and (max-width: 1600px) {
    body .m-filter .filter-group {
        width: 20%;
    }
}

/* 4 элемента в ряд на маленьких экранах */
@media screen and (max-width: 1200px) {
    body .m-filter .filter-group {
        width: 25%;
    }
}

body.open-menu .m-filter .filter-group {
    transition: opacity .8s ease, width .2s linear .1s;
}

@media screen and (max-width: 1600px) {
    body.open-menu .m-filter .filter-group {
        width: 20%; /* 5 элементов в ряд */
    }
}

@media screen and (max-width: 1200px) {
    body.open-menu .m-filter .filter-group {
        width: 25%; /* 4 элемента в ряд */
        min-width: 0;
    }
}

.m-filter label {
    display: inline-block;
    font-style: normal;
}

.m-filter .filter-group label {
    color: #636f7f;
    display: block;
}

.m-filter .filter-group .chosen-container, .m-filter .filter-group .chosen-container-single, .m-filter .filter-group .flags-in-filter, .m-filter .filter-group .input-dash, .m-filter .filter-group .selectbox, .m-filter .filter-group input[type=email], .m-filter .filter-group input[type=number], .m-filter .filter-group input[type=password], .m-filter .filter-group input[type=text], .m-filter .filter-group input[type=time], .m-filter .filter-group label, .m-filter .filter-group>div {
    font-size: 13px;
    letter-spacing: 0;
    line-height: 1.1;
}

.m-filter .filter-group label>span {
    vertical-align: middle;
}

button, input, optgroup, select, textarea {
    color: inherit;
    font-family: inherit;
    margin: 0;
}

.filter-group .chosen-container-single:not(.chosen-container_inline) .chosen-single, .filter-group input[type=email], .filter-group input[type=number], .filter-group input[type=password], .filter-group input[type=text], .filter-group input[type=time], .filter-group select, .filter-group span.selectbox {
    clear: left;
    display: inline-block;
    width: 100%;
    box-sizing: border-box;
    max-width: 100%;
}

.m-filter .filter-group .chosen-container, .m-filter .filter-group .chosen-container-single, .m-filter .filter-group .flags-in-filter, .m-filter .filter-group .input-dash, .m-filter .filter-group .selectbox, .m-filter .filter-group input[type=email], .m-filter .filter-group input[type=number], .m-filter .filter-group input[type=password], .m-filter .filter-group input[type=text], .m-filter .filter-group input[type=time], .m-filter .filter-group label, .m-filter .filter-group>div {
    font-size: 13px;
    letter-spacing: 0;
    line-height: 1.1;
}

.m-filter .filter-group .selectbox .select, .m-filter .filter-group input[type=email], .m-filter .filter-group input[type=number], .m-filter .filter-group input[type=password], .m-filter .filter-group input[type=text], .m-filter .filter-group input[type=time], .m-filter .filter-group select {
    border: 1px solid var(--input-border-color);
    border-radius: var(--input-border-radius);
    box-shadow: var(--input-box-shadow);
    color: var(--input-color);
    font-size: var(--input-font-size);
    height: var(--input-height);
    line-height: var(--input-line-height);
    padding: var(--input-padding);
    transition: var(--input-transition);
    box-sizing: border-box;
    max-width: 100%;
}

.m-filter .filter-group input[type=email]:focus,
.m-filter .filter-group input[type=number]:focus,
.m-filter .filter-group input[type=password]:focus,
.m-filter .filter-group input[type=text]:focus,
.m-filter .filter-group input[type=time]:focus,
.filter-group input[type=email]:focus,
.filter-group input[type=number]:focus,
.filter-group input[type=password]:focus,
.filter-group input[type=text]:focus,
.filter-group input[type=time]:focus {
    border-color: var(--input-focus-border-color);
    box-shadow: var(--input-focus-box-shadow);
    outline: none;
}

.contentFilter {
    overflow: visible;
    width: 100%;
    box-sizing: border-box;
}

.default-form-filter {
    position: relative;
    margin: 0 auto;
    padding-left: 25px;
    padding-right: 25px;
    width: 100%;
    box-sizing: border-box;
    max-width: 100%;
}


table {
    border-collapse: separate;
    border-spacing: 0;
    width: 100%;
}

.modern-table {
    background-color: #fff;
    position: relative;
}

.modern-table.batch-tbl {
    min-height: 110px;
}

.grid table.list, .m-box table.list, .stat-box-popup table.list {
    width: 100%;
}

.modern-table tr th {
    background: #f9fafb;
    border-bottom: 1px solid #dee2e6;
    border-left: none;
    color: #636f7f;
    font-size: 11px;
    font-weight: 400;
    padding: 14px 5px;
    text-align: right;
}

.batch-tbl .batch-container {
    padding-left: 14px;
    position: relative;
    vertical-align: middle;
}

.batch-tbl .batch-container_checkbox-out {
    min-width: 50px;
}

.modern-table tr td:first-child, .modern-table tr th:first-child {
    padding-left: 20px;
}

.grid table.list td, .grid table.list th, .m-box table.list td, .m-box table.list th, .stat-box-popup table.list td, .stat-box-popup table.list th {
    padding-left: 15px;
    padding-right: 15px;
}

.grid table.list th, .m-box table.list th, .stat-box-popup table.list th {
    color: #636f7f;
    cursor: default;
    font-size: 11px;
    font-weight: 400;
    height: 41px;
    line-height: 12px;
    padding-bottom: 5px;
    padding-top: 6px;
}

.grid table.list tr td:first-child, .grid table.list tr th:first-child, .m-box table.list tr td:first-child, .m-box table.list tr th:first-child, .stat-box-popup table.list tr td:first-child, .stat-box-popup table.list tr th:first-child {
    padding-left: 20px;
}

.container {
    margin: 0 auto;
    padding-left: 0px;
    padding-right: 0px;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    overflow-x: hidden;
}

.m-filter+div {
    margin-top: -42px;
}

.m-filter+div, .m-filter>.container {
    position: relative;
    margin: 0px;
    width: 100%;
    max-width: 100%;
    padding: 0px;
    box-sizing: border-box;
    overflow-x: hidden;
}

.m-box {
    background-color: transparent;
    border: none;
    border-radius: 4px;
    clear: left;
    margin-bottom: 30px;
    min-height: 95px;
    position: relative;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    overflow-x: hidden;
    overflow-y: hidden;
}

.modern-table-wrap {
    display: flex;
    flex-flow: row nowrap;
    position: relative;
    width: 100%;
    max-width: 100%;
    min-width: 0;
    box-sizing: border-box;
    overflow: hidden;
}

table td {
    empty-cells: show;
}

.modern-table tr td {
    border-bottom: 1px solid #dee2e6 !important;
    color: #1e2248;
    font-size: 12px;
    padding: 8px 5px !important;
    text-align: right;
    vertical-align: middle;
    line-height: 14px;
}

table tr td.price {
    color: #000;
    font-weight: 600;
    text-align: right;
}

.modern-table.list tr td {
    font-size: 13px;
}

.grid table.list td, .grid table.list th, .m-box table.list td, .m-box table.list th, .stat-box-popup table.list td, .stat-box-popup table.list th {
    padding-left: 15px;
    padding-right: 15px;
}


.grid table.list td, .m-box table.list td, .stat-box-popup table.list td {
    padding-bottom: 15px;
    padding-top: 15px;
}

.grid table.list td:not(.numeric):not(.price), .grid table.list th:not(.numeric):not(.price), .m-box table.list td:not(.numeric):not(.price), .m-box table.list th:not(.numeric):not(.price), .stat-box-popup table.list td:not(.numeric):not(.price), .stat-box-popup table.list th:not(.numeric):not(.price) {
    text-align: left;
}

.important-flag, .important-flag__link {
    margin-bottom: 5px;
    margin-right: 3px;
    vertical-align: middle;
    color: #0052cc;
    text-decoration: none;
    cursor:pointer;
}

.important-flag, .important-flag__link:hover{
  opacity:.5;
}

.modern-table .tr-link {
    line-height: 17px;
    margin-right: 3px;
    vertical-align: middle;
}

.modern-table .tr-link:last-child {
    margin-right: 0;
}


.status-bar {
    background: #f9fafb;
    border-right: 1px solid #dee2e6;
    flex: 0 0 160px;
    overflow: visible;
    position: relative;
    transition: flex-basis .2s linear;
    will-change: flex-basis;
    z-index: 2;
}

.status-bar, .status-bar .opened {
    webkit-backface-visibility: hidden;
}

.copy-btn {
  background: none;
  border: none;
  cursor: pointer;
  margin-left: 5px;
  padding: 0;
}

.tooltips {
  position: absolute;
  top: -40px; /* Расстояние от кнопки, можно настроить */
  left: 50%;
  transform: translateX(-50%);
  background: #333;
  color: #fff;
  padding: 5px 10px;
  font-size: 12px;
  border-radius: 4px;
  white-space: nowrap;
  z-index: 10;
}

.tooltips-arrow {
  position: absolute;
  bottom: -5px; /* Расположение стрелочки под тултипом */
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid #333;
}

.status-bar.close {
    cursor: pointer;
    flex-basis: 22px;
    overflow: hidden;
}

.modern-table-container {
    webkit-backface-visibility: hidden;
    flex: 1;
    overflow-x: auto;
    overflow-y: visible;
    min-width: 0;
    width: 0;
    box-sizing: border-box;
    position: relative;
}


.status-bar .opened {
    cursor: default;
    height: auto;
    min-width: 139px;
    opacity: 1;
    padding-bottom: 24px;
    transition: opacity 50ms ease-out .1s;
    will-change: opacity;
}




.fs11 {
    font-size: 11px !important;
}

.gray, .gray-link {
    color: #636f7f !important;
}

.roll-up {
    border-bottom: 1px solid #dee2e6;
    cursor: pointer;
    height: 41px;
    line-height: 41px;
    padding: 0 16px;
}

.status-bar-list {
    margin-right: -1px;
    padding: 0 4px;
}


.status-bar-list ul {
    margin: 10px 0 0;
    padding-left:0px;
}

.status-bar-list ul li {
    cursor: pointer;
    list-style: none;
    padding: 5px 7px 5px 12px;
    position: relative;
    z-index: 99;
    line-height: 14px;
}



.status-bar-list ul li.active {
    background-color: #005eeb;
    border-radius: 4px;
}


.status-bar-list ul li.all {
    margin: 11px 0;
}

.status-bar-list ul li a {
    color: #0052cc;
    color: #151833;
    display: inline-block;
    font-size: 12px;
    font-weight: 600;
    text-decoration: none;
}

.status-bar-list ul li.active .orders-count, .status-bar-list ul li.active a, .status-bar-list ul li.selected .orders-count, .status-bar-list ul li.selected a, .status-bar-list ul li:hover .orders-count, .status-bar-list ul li:hover a {
    color: #fff;
}

/* Лоадер для счетчиков заказов */
.status-count-loader {
    display: inline-block;
    width: 12px;
    height: 12px;
    border: 2px solid #0052cc;
    border-top-color: transparent;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
    vertical-align: middle;
    margin-left: 2px;
}

.status-bar-list ul li.active .status-count-loader,
.status-bar-list ul li.selected .status-count-loader,
.status-bar-list ul li:hover .status-count-loader {
    border-color: #fff;
    border-top-color: transparent;
}

@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}

.status-bar-list ul li {
    cursor: pointer;
    list-style: none;
    padding: 5px 7px 5px 12px;
    position: relative;
    z-index: 99;
    line-height: 14px;
}

.status-bar-list ul li.status-bar-subheader.approval a:before, .status-bar-list ul li.status-bar-subheader.assembling a:before, .status-bar-list ul li.status-bar-subheader.cancel a:before, .status-bar-list ul li.status-bar-subheader.complete a:before, .status-bar-list ul li.status-bar-subheader.custom a:before, .status-bar-list ul li.status-bar-subheader.delivering a:before, .status-bar-list ul li.status-bar-subheader.delivery a:before, .status-bar-list ul li.status-bar-subheader.new a:before {
    background-repeat: no-repeat;
    background-size: contain;
    content: "";
    display: block;
    height: 16px;
    margin-bottom: 4px;
    width: 16px;
}

.status-bar-list ul li.assembling.status-bar-subheader a:before {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%236528D7'%3E%3Cpath fill-rule='evenodd' d='M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12a10 10 0 0 0 10 10zm0-18a8 8 0 1 1 0 16 8 8 0 0 1 0-16zm-.19 14a.77.77 0 0 1-.53-.22l-3.13-3.13a.5.5 0 0 1 0-.71l.71-.71a.49.49 0 0 1 .7 0L11 14.67V6.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v8.17l1.44-1.45a.5.5 0 0 1 .71 0l.7.71a.5.5 0 0 1 0 .71l-3.13 3.14a.75.75 0 0 1-.53.22h-.38z' clip-rule='evenodd'/%3E%3C/svg%3E");
}

.status-bar .closed {
    background-color: inherit;
    height: 100%;
    left: 0;
    opacity: 0;
    overflow: hidden;
    padding: 0 6px 0 5px;
    position: absolute;
    top: 0;
    width: 22px;
    will-change: opacity;
    z-index: -1;
}

.status-bar.close .closed {
    opacity: 1;
    z-index: 1;
}

.status-bar .open-icon {
    fill: #c8ced5;
    height: 12px;
    margin-top: 4px;
    width: 13px;
}

.status-bar-list ul li:hover {
    background: #005eeb;
    border-radius: 4px;
}



.status-bar-list ul li a {
    color: #0052cc;
    color: #151833;
    display: inline-block;
    font-size: 12px;
    font-weight: 600;
    text-decoration: none;
}

.status-bar-list ul li a.no-italic {
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, Roboto, sans-serif;
    font-weight: 400;
}

.status-bar .open-text {
    color: grey;
    display: block;
    font-size: 10px;
    margin: 44px 0 0 -8px;
    text-transform: uppercase;
    transform: rotate(-90deg);
}

.status-bar_closed .open-text {
    margin-top: 28px;
}

.status-bar.close .opened {
    height: 0;
    min-width: 0;
    opacity: 0;
    transition-delay: 0s;
    transition-duration: .2s;
    z-index: -1;
}

.status-bar .opened {
    cursor: default;
    height: auto;
    min-width: 139px;
    opacity: 1;
    padding-bottom: 24px;
    transition: opacity 50ms ease-out .1s;
    will-change: opacity;
}

.status-bar-list ul li.status-bar-subheader.approval a:before, .status-bar-list ul li.status-bar-subheader.assembling a:before, .status-bar-list ul li.status-bar-subheader.cancel a:before, .status-bar-list ul li.status-bar-subheader.complete a:before, .status-bar-list ul li.status-bar-subheader.custom a:before, .status-bar-list ul li.status-bar-subheader.delivering a:before, .status-bar-list ul li.status-bar-subheader.delivery a:before, .status-bar-list ul li.status-bar-subheader.new a:before {
    background-repeat: no-repeat;
    background-size: contain;
    content: "";
    display: block;
    height: 16px;
    margin-bottom: 4px;
    width: 16px;
}


.status-bar-list ul li.active.new, .status-bar-list ul li.selected.new, .status-bar-list ul li:hover.new {
    background-color: #ef8e06;
}

.status-bar-list ul li.new.status-bar-subheader a {
    color: #ef8e06;
}

.status-bar-list ul li.new.status-bar-subheader a:before {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%23FEA530'%3E%3Cpath fill-rule='evenodd' d='M12.5 4h-1a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5zm-6.255 6.334A6 6 0 0 1 12 6a6 6 0 0 1 3.2 11.07 1.48 1.48 0 0 0-.7 1.27v.16a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-.16a1.5 1.5 0 0 0-.7-1.27 6 6 0 0 1-2.555-6.736zM8 12a4 4 0 1 0 8 0 4 4 0 0 0-8 0zm2 9.59a1 1 0 0 0 .29.7l.42.42a1 1 0 0 0 .7.29h1.18a1 1 0 0 0 .7-.29l.42-.42a1 1 0 0 0 .29-.7V21h-4v.59zM20.13 4.58l-.71-.71a.48.48 0 0 0-.7 0L17.3 5.28a.51.51 0 0 0 0 .71l.7.71a.51.51 0 0 0 .71 0l1.41-1.42a.48.48 0 0 0 .01-.7zM5.28 3.87 6.7 5.28a.51.51 0 0 1 0 .72l-.7.7a.51.51 0 0 1-.72 0L3.87 5.28a.48.48 0 0 1 0-.7l.71-.71a.48.48 0 0 1 .7 0zM22.5 11h-2a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm-21 0h2a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5z' clip-rule='evenodd'/%3E%3C/svg%3E");
}

.status-bar-list ul li.new.active a, .status-bar-list ul li.new.selected a, .status-bar-list ul li.new:hover a {
    color: #fff;
}

.status-bar-list ul li.new.active a:before, .status-bar-list ul li.new.selected a:before, .status-bar-list ul li.new:hover a:before {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%23fff'%3E%3Cpath fill-rule='evenodd' d='M12.5 4h-1a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5zm-6.255 6.334A6 6 0 0 1 12 6a6 6 0 0 1 3.2 11.07 1.48 1.48 0 0 0-.7 1.27v.16a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-.16a1.5 1.5 0 0 0-.7-1.27 6 6 0 0 1-2.555-6.736zM8 12a4 4 0 1 0 8 0 4 4 0 0 0-8 0zm2 9.59a1 1 0 0 0 .29.7l.42.42a1 1 0 0 0 .7.29h1.18a1 1 0 0 0 .7-.29l.42-.42a1 1 0 0 0 .29-.7V21h-4v.59zM20.13 4.58l-.71-.71a.48.48 0 0 0-.7 0L17.3 5.28a.51.51 0 0 0 0 .71l.7.71a.51.51 0 0 0 .71 0l1.41-1.42a.48.48 0 0 0 .01-.7zM5.28 3.87 6.7 5.28a.51.51 0 0 1 0 .72l-.7.7a.51.51 0 0 1-.72 0L3.87 5.28a.48.48 0 0 1 0-.7l.71-.71a.48.48 0 0 1 .7 0zM22.5 11h-2a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm-21 0h2a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5z' clip-rule='evenodd'/%3E%3C/svg%3E");
}

.status-bar-list ul li.delivering.status-bar-subheader a, .status-bar-list ul li.delivery.status-bar-subheader a {
    color: #0052cc;
}

.status-bar-list ul li.delivering.active a, .status-bar-list ul li.delivering.selected a, .status-bar-list ul li.delivering:hover a, .status-bar-list ul li.delivery.active a, .status-bar-list ul li.delivery.selected a, .status-bar-list ul li.delivery:hover a {
    color: #fff;
}


.status-bar-list ul li.delivering.status-bar-subheader a:before, .status-bar-list ul li.delivery.status-bar-subheader a:before {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%23005EEB'%3E%3Cpath fill-rule='evenodd' d='M3.169 2.445a1 1 0 0 1 1.386-.277l3 2A1 1 0 0 1 8.001 5v11.17A3.008 3.008 0 0 1 9.83 18H18a1 1 0 1 1 0 2H9.83A3.001 3.001 0 1 1 6 16.17V5.536L3.447 3.832a1 1 0 0 1-.277-1.387zM7 18h-.01a1 1 0 1 0 .02 0H7zM9 7a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2V7zm4 0h-2v8h8V7h-2v3h-4V7z' clip-rule='evenodd'/%3E%3C/svg%3E");
}

.status-bar-list ul li.delivering.active a:before, .status-bar-list ul li.delivering.selected a:before, .status-bar-list ul li.delivering:hover a:before, .status-bar-list ul li.delivery.active a:before, .status-bar-list ul li.delivery.selected a:before, .status-bar-list ul li.delivery:hover a:before {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%23fff'%3E%3Cpath fill-rule='evenodd' d='M3.169 2.445a1 1 0 0 1 1.386-.277l3 2A1 1 0 0 1 8.001 5v11.17A3.008 3.008 0 0 1 9.83 18H18a1 1 0 1 1 0 2H9.83A3.001 3.001 0 1 1 6 16.17V5.536L3.447 3.832a1 1 0 0 1-.277-1.387zM7 18h-.01a1 1 0 1 0 .02 0H7zM9 7a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2V7zm4 0h-2v8h8V7h-2v3h-4V7z' clip-rule='evenodd'/%3E%3C/svg%3E");
}

.status-bar-list ul li.active.delivering, .status-bar-list ul li.active.delivery, .status-bar-list ul li.selected.delivering, .status-bar-list ul li.selected.delivery, .status-bar-list ul li:hover.delivering, .status-bar-list ul li:hover.delivery {
    background-color: #0052cc;
}


.status-bar-list ul li.active.approval, .status-bar-list ul li.selected.approval, .status-bar-list ul li:hover.approval {
    background-color: #ef8e06;
}

.status-bar-list ul li.approval.status-bar-subheader a {
    color: #ef8e06;
}

.status-bar-list ul li.approval.active a, .status-bar-list ul li.approval.selected a, .status-bar-list ul li.approval:hover a {
    color: #fff;
}

.status-bar-list ul li.approval.status-bar-subheader a:before {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%23FEA530'%3E%3Cpath fill-rule='evenodd' d='M18 2a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4H8a3 3 0 0 0-2.15.85l-3 3a.49.49 0 0 1-.35.15.5.5 0 0 1-.5-.5V6a4 4 0 0 1 4-4h12zM8 16h10a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v11.88l.46-.42A5 5 0 0 1 8 16zm-1.5-3h7a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-7a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5zm11-4h-11a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5z' clip-rule='evenodd'/%3E%3C/svg%3E");
}

.status-bar-list ul li.approval.active a:before, .status-bar-list ul li.approval.selected a:before, .status-bar-list ul li.approval:hover a:before {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%23fff'%3E%3Cpath fill-rule='evenodd' d='M18 2a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4H8a3 3 0 0 0-2.15.85l-3 3a.49.49 0 0 1-.35.15.5.5 0 0 1-.5-.5V6a4 4 0 0 1 4-4h12zM8 16h10a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v11.88l.46-.42A5 5 0 0 1 8 16zm-1.5-3h7a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-7a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5zm11-4h-11a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5z' clip-rule='evenodd'/%3E%3C/svg%3E");
}


.status-bar-list ul li.active.assembling, .status-bar-list ul li.selected.assembling, .status-bar-list ul li:hover.assembling {
    background-color: #6528d7;
}




.status-bar-list ul li.assembling.status-bar-subheader a {
    color: #4a2aa5;
}

.status-bar-list ul li.assembling.active a, .status-bar-list ul li.assembling.selected a, .status-bar-list ul li.assembling:hover a {
    color: #fff;
}



.status-bar-list ul li.assembling.status-bar-subheader a:before {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%236528D7'%3E%3Cpath fill-rule='evenodd' d='M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12a10 10 0 0 0 10 10zm0-18a8 8 0 1 1 0 16 8 8 0 0 1 0-16zm-.19 14a.77.77 0 0 1-.53-.22l-3.13-3.13a.5.5 0 0 1 0-.71l.71-.71a.49.49 0 0 1 .7 0L11 14.67V6.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v8.17l1.44-1.45a.5.5 0 0 1 .71 0l.7.71a.5.5 0 0 1 0 .71l-3.13 3.14a.75.75 0 0 1-.53.22h-.38z' clip-rule='evenodd'/%3E%3C/svg%3E");
}

.status-bar-list ul li.assembling.active a:before, .status-bar-list ul li.assembling.selected a:before, .status-bar-list ul li.assembling:hover a:before {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%23fff'%3E%3Cpath fill-rule='evenodd' d='M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12a10 10 0 0 0 10 10zm0-18a8 8 0 1 1 0 16 8 8 0 0 1 0-16zm-.19 14a.77.77 0 0 1-.53-.22l-3.13-3.13a.5.5 0 0 1 0-.71l.71-.71a.49.49 0 0 1 .7 0L11 14.67V6.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v8.17l1.44-1.45a.5.5 0 0 1 .71 0l.7.71a.5.5 0 0 1 0 .71l-3.13 3.14a.75.75 0 0 1-.53.22h-.38z' clip-rule='evenodd'/%3E%3C/svg%3E");
}


.status-bar-list ul li.custom.active, .status-bar-list ul li.custom.selected, .status-bar-list ul li.custom:hover {
    background-color: #eef1f3;
}



.status-bar-list ul li.custom.status-bar-subheader a {
    color: #636f7f;
}

.status-bar-list ul li.custom.active a, .status-bar-list ul li.custom.selected a, .status-bar-list ul li.custom:hover a {
    color: #636f7f;
}



.status-bar-list ul li.custom.status-bar-subheader a:before {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%23636F7F'%3E%3Cpath fill-rule='evenodd' d='M16.004 8A4 4 0 1 1 8 7.998 4 4 0 0 1 16.004 8Zm-2 0a2 2 0 1 0-4.001 0 2 2 0 0 0 4 0Zm5.892 10.55-1.89-3.89A3.001 3.001 0 0 0 15.263 13H8.742a3.001 3.001 0 0 0-2.691 1.66L4.11 18.55A1 1 0 0 0 5 20h14.006a1 1 0 0 0 .89-1.45Zm-12.055-3L6.621 18h10.764l-1.22-2.45a1 1 0 0 0-.9-.55H8.741a1 1 0 0 0-.9.55Z' clip-rule='evenodd'/%3E%3C/svg%3E");
}

.status-bar-list ul li.custom.active a:before, .status-bar-list ul li.custom.selected a:before, .status-bar-list ul li.custom:hover a:before {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%23636F7F'%3E%3Cpath fill-rule='evenodd' d='M16.004 8A4 4 0 1 1 8 7.998 4 4 0 0 1 16.004 8Zm-2 0a2 2 0 1 0-4.001 0 2 2 0 0 0 4 0Zm5.892 10.55-1.89-3.89A3.001 3.001 0 0 0 15.263 13H8.742a3.001 3.001 0 0 0-2.691 1.66L4.11 18.55A1 1 0 0 0 5 20h14.006a1 1 0 0 0 .89-1.45Zm-12.055-3L6.621 18h10.764l-1.22-2.45a1 1 0 0 0-.9-.55H8.741a1 1 0 0 0-.9.55Z' clip-rule='evenodd'/%3E%3C/svg%3E");
}


.status-bar-list ul li.active.complete, .status-bar-list ul li.selected.complete, .status-bar-list ul li:hover.complete {
    background-color: #20a77f;
}



.status-bar-list ul li.complete.status-bar-subheader a {
    color: #20a77f;
}

.status-bar-list ul li.complete.active a, .status-bar-list ul li.complete.selected a, .status-bar-list ul li.complete:hover a {
    color: #fff;
}


.status-bar-list ul li.complete.status-bar-subheader a:before {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%2322C993'%3E%3Cpath fill-rule='evenodd' d='M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10A10 10 0 0 0 12 2zm0 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm3.12-11.51a.5.5 0 0 1 .7 0l.5.53a.5.5 0 0 1 0 .71l-5.62 5.62a.48.48 0 0 1-.7 0l-2.35-2.37a.5.5 0 0 1 0-.71l.53-.53a.48.48 0 0 1 .7 0l1.5 1.49 4.74-4.74z' clip-rule='evenodd'/%3E%3C/svg%3E");
}

.status-bar-list ul li.complete.active a:before, .status-bar-list ul li.complete.selected a:before, .status-bar-list ul li.complete:hover a:before {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%23fff'%3E%3Cpath fill-rule='evenodd' d='M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10A10 10 0 0 0 12 2zm0 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm3.12-11.51a.5.5 0 0 1 .7 0l.5.53a.5.5 0 0 1 0 .71l-5.62 5.62a.48.48 0 0 1-.7 0l-2.35-2.37a.5.5 0 0 1 0-.71l.53-.53a.48.48 0 0 1 .7 0l1.5 1.49 4.74-4.74z' clip-rule='evenodd'/%3E%3C/svg%3E");
}

.status-bar-list ul li.active.cancel, .status-bar-list ul li.selected.cancel, .status-bar-list ul li:hover.cancel {
    background-color: #dd4040;
}



.status-bar-list ul li.cancel.status-bar-subheader a {
    color: #dd4040;
}

.status-bar-list ul li.cancel.active a, .status-bar-list ul li.cancel.selected a, .status-bar-list ul li.cancel:hover a {
    color: #fff;
}


.status-bar-list ul li.cancel.status-bar-subheader a:before {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%23FF5353'%3E%3Cpath fill-rule='evenodd' d='M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10A10 10 0 0 0 12 2zm0 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm2.56-11.09.53.53a.48.48 0 0 1 0 .7L13.24 12l1.85 1.86a.48.48 0 0 1 0 .7l-.53.53a.48.48 0 0 1-.7 0L12 13.24l-1.86 1.85a.48.48 0 0 1-.7 0l-.53-.53a.48.48 0 0 1 0-.7L10.76 12l-1.85-1.86a.48.48 0 0 1 0-.7l.53-.53a.48.48 0 0 1 .7 0L12 10.76l1.86-1.85a.48.48 0 0 1 .7 0z' clip-rule='evenodd'/%3E%3C/svg%3E");
}

.status-bar-list ul li.cancel.active a:before, .status-bar-list ul li.cancel.selected a:before, .status-bar-list ul li.cancel:hover a:before {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%23fff'%3E%3Cpath fill-rule='evenodd' d='M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10A10 10 0 0 0 12 2zm0 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm2.56-11.09.53.53a.48.48 0 0 1 0 .7L13.24 12l1.85 1.86a.48.48 0 0 1 0 .7l-.53.53a.48.48 0 0 1-.7 0L12 13.24l-1.86 1.85a.48.48 0 0 1-.7 0l-.53-.53a.48.48 0 0 1 0-.7L10.76 12l-1.85-1.86a.48.48 0 0 1 0-.7l.53-.53a.48.48 0 0 1 .7 0L12 10.76l1.86-1.85a.48.48 0 0 1 .7 0z' clip-rule='evenodd'/%3E%3C/svg%3E");
}



.roll-up {
    border-bottom: 1px solid #dee2e6;
    cursor: pointer;
    height: 41px;
    line-height: 41px;
    padding: 0 16px;
}



.header-main {
    display: table;
    empty-cells: hide;
    padding: 32px 0 24px;
}


.filter-page .header-main {
    background-color: #fff;
    margin: 0 auto;
    padding-bottom: 21px;
    padding-left: 40px;
    padding-right: 40px;
    width: 100%;
}





.hm-left {
    color: #1e2248;
    float: left;
    width: 75%;
}

.header-main .hm-left, .header-main .hm-right {
    display: table-cell;
    float: none;
    vertical-align: top;
}

.header-main .hm-left {
    width: auto;
}


.hm-left>div {
    padding-left: 15px;
}

body.modern .hm-left>div {
    padding-left: 0;
}

.header-main__title-wrap {
    align-items: baseline;
    display: flex;
}

.hm-left h1 {
    font-size: 24px;
    font-weight: 500;
    letter-spacing: -.3px;
    line-height: 32px;
    margin-top: 10px;
}

.header-main__title:not(:last-child) {
    margin-right: 16px;
}





.hm-right {
    float: right;
    width: 25%;
}

.header-main .hm-left, .header-main .hm-right {
    display: table-cell;
    float: none;
    vertical-align: top;
}

.header-main .hm-right {
    white-space: nowrap;
    width: 1%;
}

.btn-wrapper {
    display: inline-block;
    margin-left: 5px;
    padding: 7px;
}

.btn-wrapper_group {
    font-size: 0;
}

.hm-right .btn-wrapper.new {
    float: right;
    margin-top: 0;
    padding: 0;
}

.btn {
    background: none;
    background-color: #005eeb;
    background-image: linear-gradient(180deg, #0068ff, #005bd5);
    border: none;
    border-radius: 6px;
    color: #fff;
    cursor: pointer;
    display: inline-block;
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, Roboto, sans-serif;
    font-size: 14px;
    font-weight: 400;
    font-weight: 500;
    height: 40px;
    line-height: 20px;
    padding: 8px 20px;
    text-decoration: none;
    user-select: none;
    vertical-align: middle;
}

.m0 {
    margin: 0 !important;
}

.btn_md {
    font-size: 16px;
    height: 25px;
    line-height: 24px;
    padding: 12px 24px;
}



.btn-content {
    display: flex;
}


.btn-content_icon {
    margin-left: -8px;
}

.btn-content:before {
    content: "";
    height: 20px;
    margin-right: 8px;
    width: 20px;
}

.btn-content_icon:before {
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: 100%;
    float: none !important;
    margin-left: 0 !important;
    top: 0 !important;
}

.btn-content_new:before {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none'%3E%3Cpath fill='%23FFF' fill-rule='evenodd' d='M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10A10 10 0 0 0 12 2Zm0 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16Zm1-9h2.5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H13v2.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5V13H8.5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5H11V8.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5V11Z' clip-rule='evenodd'/%3E%3C/svg%3E");
}

.btn_md .btn-content_icon:before, .btn_min-icon {
    height: 24px;
    width: 24px;
}

.status-comment-wrap {
    position: relative;
}

.grid table.list .status-comment-wrap, .grid table.list input[type=checkbox], .m-box table.list .status-comment-wrap, .m-box table.list input[type=checkbox], .stat-box-popup table.list .status-comment-wrap, .stat-box-popup table.list input[type=checkbox] {
    display: inline-block;
    line-height: 1;
    vertical-align: middle;
}


.grid table.list .status-comment-wrap, .m-box table.list .status-comment-wrap, .stat-box-popup table.list .status-comment-wrap {
    max-width: 100%;
    width: 100%;
}

.grid table.list .status-comment-wrap_orders, .m-box table.list .status-comment-wrap_orders, .stat-box-popup table.list .status-comment-wrap_orders {
    display: flex;
    flex-direction: row-reverse;
}

.bill {
    border-radius: 4px;
    font-size: 14px;
    height: 32px;
    line-height: 32px;
    overflow: hidden;
    padding: 0 12px 0 40px;
    position: relative;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.bill, .bill.short {
    min-width: 130px;
}

.bill.new, .status-tbl tr.new {
    background: #fea530;
    color: #fff;
}

.m-box table.list .bill {
    max-width: 100%;
}

.grid table.list .status-comment-wrap_orders .bill, .m-box table.list .status-comment-wrap_orders .bill, .stat-box-popup table.list .status-comment-wrap_orders .bill {
    flex-grow: 1;
    min-width: 0;
}

.grid table.list .status-comment-wrap_orders .mr10, .m-box table.list .status-comment-wrap_orders .mr10, .stat-box-popup table.list .status-comment-wrap_orders .mr10 {
    margin-right: 0 !important;
}

.bill .img-st {
    background-position: 50%;
    background-repeat: no-repeat;
    height: 24px;
    left: 13px;
    margin-top: -12px;
    position: absolute;
    top: 50%;
    width: 24px;
}

.bill .img-st, .bill .img-st+.st-text, .status-tbl tr .img-st, .status-tbl tr .img-st+.st-text {
    vertical-align: middle;
}

.bill.new .img-st, .status-tbl tr.new .img-st {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%23fff'%3E%3Cpath fill-rule='evenodd' d='M12.5 4h-1a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5zm-6.255 6.334A6 6 0 0 1 12 6a6 6 0 0 1 3.2 11.07 1.48 1.48 0 0 0-.7 1.27v.16a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-.16a1.5 1.5 0 0 0-.7-1.27 6 6 0 0 1-2.555-6.736zM8 12a4 4 0 1 0 8 0 4 4 0 0 0-8 0zm2 9.59a1 1 0 0 0 .29.7l.42.42a1 1 0 0 0 .7.29h1.18a1 1 0 0 0 .7-.29l.42-.42a1 1 0 0 0 .29-.7V21h-4v.59zM20.13 4.58l-.71-.71a.48.48 0 0 0-.7 0L17.3 5.28a.51.51 0 0 0 0 .71l.7.71a.51.51 0 0 0 .71 0l1.41-1.42a.48.48 0 0 0 .01-.7zM5.28 3.87 6.7 5.28a.51.51 0 0 1 0 .72l-.7.7a.51.51 0 0 1-.72 0L3.87 5.28a.48.48 0 0 1 0-.7l.71-.71a.48.48 0 0 1 .7 0zM22.5 11h-2a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm-21 0h2a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5z' clip-rule='evenodd'/%3E%3C/svg%3E");
}


.bill.delivery .img-st, .status-tbl tr.delivery .img-st {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%230052CC'%3E%3Cpath fill-rule='evenodd' d='M3.169 2.445a1 1 0 0 1 1.386-.277l3 2A1 1 0 0 1 8.001 5v11.17A3.008 3.008 0 0 1 9.83 18H18a1 1 0 1 1 0 2H9.83A3.001 3.001 0 1 1 6 16.17V5.536L3.447 3.832a1 1 0 0 1-.277-1.387zM7 18h-.01a1 1 0 1 0 .02 0H7zM9 7a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2V7zm4 0h-2v8h8V7h-2v3h-4V7z' clip-rule='evenodd'/%3E%3C/svg%3E");
}

.bill.complete .img-st, .status-tbl tr.complete .img-st {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%2319976E'%3E%3Cpath fill-rule='evenodd' d='M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10A10 10 0 0 0 12 2zm0 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm3.12-11.51a.5.5 0 0 1 .7 0l.5.53a.5.5 0 0 1 0 .71l-5.62 5.62a.48.48 0 0 1-.7 0l-2.35-2.37a.5.5 0 0 1 0-.71l.53-.53a.48.48 0 0 1 .7 0l1.5 1.49 4.74-4.74z' clip-rule='evenodd'/%3E%3C/svg%3E");
}

.bill.assembling .img-st, .status-tbl tr.assembling .img-st {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%236528D7'%3E%3Cpath fill-rule='evenodd' d='M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12a10 10 0 0 0 10 10zm0-18a8 8 0 1 1 0 16 8 8 0 0 1 0-16zm-.19 14a.77.77 0 0 1-.53-.22l-3.13-3.13a.5.5 0 0 1 0-.71l.71-.71a.49.49 0 0 1 .7 0L11 14.67V6.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v8.17l1.44-1.45a.5.5 0 0 1 .71 0l.7.71a.5.5 0 0 1 0 .71l-3.13 3.14a.75.75 0 0 1-.53.22h-.38z' clip-rule='evenodd'/%3E%3C/svg%3E");
}

.bill.approval .img-st, .status-tbl tr.approval .img-st {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%23E18001'%3E%3Cpath fill-rule='evenodd' d='M18 2a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4H8a3 3 0 0 0-2.15.85l-3 3a.49.49 0 0 1-.35.15.5.5 0 0 1-.5-.5V6a4 4 0 0 1 4-4h12zM8 16h10a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v11.88l.46-.42A5 5 0 0 1 8 16zm-1.5-3h7a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-7a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5zm11-4h-11a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5z' clip-rule='evenodd'/%3E%3C/svg%3E");
}

.bill.cancel .img-st, .status-tbl tr.cancel .img-st {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%23DD4040'%3E%3Cpath fill-rule='evenodd' d='M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10A10 10 0 0 0 12 2zm0 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm2.56-11.09.53.53a.48.48 0 0 1 0 .7L13.24 12l1.85 1.86a.48.48 0 0 1 0 .7l-.53.53a.48.48 0 0 1-.7 0L12 13.24l-1.86 1.85a.48.48 0 0 1-.7 0l-.53-.53a.48.48 0 0 1 0-.7L10.76 12l-1.85-1.86a.48.48 0 0 1 0-.7l.53-.53a.48.48 0 0 1 .7 0L12 10.76l1.86-1.85a.48.48 0 0 1 .7 0z' clip-rule='evenodd'/%3E%3C/svg%3E");
}

.bill.custom-status-color-17 .img-st, .status-tbl tr.custom-status-color-17 .img-st {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%23fff'%3E%3Cpath fill-rule='evenodd' d='M16.004 8A4 4 0 1 1 8 7.998 4 4 0 0 1 16.004 8Zm-2 0a2 2 0 1 0-4.001 0 2 2 0 0 0 4 0Zm5.892 10.55-1.89-3.89A3.001 3.001 0 0 0 15.263 13H8.742a3.001 3.001 0 0 0-2.691 1.66L4.11 18.55A1 1 0 0 0 5 20h14.006a1 1 0 0 0 .89-1.45Zm-12.055-3L6.621 18h10.764l-1.22-2.45a1 1 0 0 0-.9-.55H8.741a1 1 0 0 0-.9.55Z' clip-rule='evenodd'/%3E%3C/svg%3E");
}


.bill.dflkdslskl .img-st, .status-tbl tr.dflkdslskl .img-st {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%23fff'%3E%3Cpath fill-rule='evenodd' d='M16.004 8A4 4 0 1 1 8 7.998 4 4 0 0 1 16.004 8Zm-2 0a2 2 0 1 0-4.001 0 2 2 0 0 0 4 0Zm5.892 10.55-1.89-3.89A3.001 3.001 0 0 0 15.263 13H8.742a3.001 3.001 0 0 0-2.691 1.66L4.11 18.55A1 1 0 0 0 5 20h14.006a1 1 0 0 0 .89-1.45Zm-12.055-3L6.621 18h10.764l-1.22-2.45a1 1 0 0 0-.9-.55H8.741a1 1 0 0 0-.9.55Z' clip-rule='evenodd'/%3E%3C/svg%3E");
}


.bill.sto12f .img-st, .status-tbl tr.sto12f .img-st {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%23fff'%3E%3Cpath fill-rule='evenodd' d='M16.004 8A4 4 0 1 1 8 7.998 4 4 0 0 1 16.004 8Zm-2 0a2 2 0 1 0-4.001 0 2 2 0 0 0 4 0Zm5.892 10.55-1.89-3.89A3.001 3.001 0 0 0 15.263 13H8.742a3.001 3.001 0 0 0-2.691 1.66L4.11 18.55A1 1 0 0 0 5 20h14.006a1 1 0 0 0 .89-1.45Zm-12.055-3L6.621 18h10.764l-1.22-2.45a1 1 0 0 0-.9-.55H8.741a1 1 0 0 0-.9.55Z' clip-rule='evenodd'/%3E%3C/svg%3E");
}

.bill.custom, .status-tbl tr.custom {
    background: #eef1f3;
    color: #636f7f;
}
.bill.brak12 .img-st {
   
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24'  fill='%236528D7'%3E%3Cpath fill-rule='evenodd'  d='M16.004 8A4 4 0 1 1 8 7.998 4 4 0 0 1 16.004 8Zm-2 0a2 2 0 1 0-4.001 0 2 2 0 0 0 4 0Zm5.892 10.55-1.89-3.89A3.001 3.001 0 0 0 15.263 13H8.742a3.001 3.001 0 0 0-2.691 1.66L4.11 18.55A1 1 0 0 0 5 20h14.006a1 1 0 0 0 .89-1.45Zm-12.055-3L6.621 18h10.764l-1.22-2.45a1 1 0 0 0-.9-.55H8.741a1 1 0 0 0-.9.55Z' clip-rule='evenodd'/%3E%3C/svg%3E");

}
.bill.brak12 {
  background: rgba(101,40,215,0.1);
  color: #4a2aa5 !important;
}

.bill.delivery {
    background: rgba(0, 94, 235, .13);
    color: #0044b7;
}

.bill.approval, .status-tbl tr.approval {
    background: rgba(254, 165, 48, .2);
    color: #bc6b01;
}

.bill.complete, .status-tbl tr.complete {
    background: rgba(34, 201, 147, .15);
    color: #168561;
}


.bill.cancel, .status-tbl tr.cancel {
    background: rgba(255, 83, 83, .15);
    color: #b73232;
}

.bill.assembling, .status-tbl tr.assembling {
    background: rgba(101, 40, 215, .1);
    color: #4a2aa5;
}

.bill.sto12f, .status-tbl tr.sto12f {
    background-color: rgb(119 128 219);
    color: #fff;
}


.bill.dflkdslskl, .status-tbl tr.dflkdslskl {
    background-color: #afb9c3;
    color: #fff;
}

.modern-table tr:hover {
    background-color: #f9fafb;
    cursor: pointer;
}

.modern-table tr.order-row-go-edit .copy-btn,
.modern-table tr.order-row-go-edit .call-button,
.modern-table tr.order-row-go-edit input[type="checkbox"] {
    cursor: pointer;
}

.modern-table .table-cell-truncate {
    display: inline-block;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: top;
}

.m-filter .filter-group {
        width: 25%;
    }

tbody {
  min-height:1175px;
}

.input_flex {
  display:flex;
  justify-content: space-between;
  align-items:center;
}

.input_flex span{
  margin:0px 10px;
}

.filter-content label {
      min-width: 100% !important;
}

.m-filter .apply {
    background: none;
    background-color: #fff;
    background-image: linear-gradient(180deg, #fff, #e9ecee);
    border: 1px solid #dee2e6;
    border-radius: 6px;
    cursor: pointer;
    display: inline-block;
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, Roboto, sans-serif;
    font-size: 14px;
    font-weight: 400;
    font-weight: 500;
    height: 40px;
    line-height: 20px;
    padding: 7px 20px 8px;
    text-decoration: none;
    text-shadow: none;
    user-select: none;
    vertical-align: middle;
    box-sizing: border-box;
}

.m-filter .apply, .m-filter .apply:focus {
    outline: none;
}

.m-filter .apply, .m-filter .apply.active, .m-filter .apply:active, .m-filter .apply:hover {
    color: #1e2248;
    text-decoration: none;
}

.m-filter .apply .ur-hr-no, .m-filter .filter-cancel .ur-hr-no {
    display: inline-block;
    line-height: 1;
}

.m-filter .apply, .m-filter .apply.active, .m-filter .apply:active, .m-filter .apply:hover {
    color: #1e2248;
    text-decoration: none;
}

.m-filter .apply.active, .m-filter .apply:active {
    background-color: #dee2e6;
    background-image: none;
    border-color: #afb9c3;
}

.m-filter .apply, .m-filter .apply:focus {
    outline: none;
}

.m-filter .apply:hover {
    background-color: #f4f6f8;
    background-image: none;
}

.m-filter .filter-cancel {
    background: none;
    background-color: #fff;
    background-image: linear-gradient(180deg, #fff, #e9ecee);
    border: 1px solid #dee2e6;
    border-radius: 6px;
    cursor: pointer;
    display: inline-block;
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, Roboto, sans-serif;
    font-size: 14px;
    font-size: 0;
    font-weight: 400;
    height: 40px;
    line-height: 20px;
    line-height: 17px;
    overflow: hidden;
    padding: 8px;
    position: relative;
    text-decoration: none;
    text-overflow: ellipsis;
    text-shadow: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
    vertical-align: middle;
    white-space: nowrap;
    width: 40px;
}

.m-filter .filter-cancel, .m-filter .filter-cancel.active, .m-filter .filter-cancel:active, .m-filter .filter-cancel:hover {
    color: #1e2248;
    text-decoration: none;
}

.m-filter .apply+.filter-cancel {
    margin-left: 8px;
}

.m-filter .filter-cancel:before {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24'%3E%3Cpath fill='%23FF5353' d='M7.113 6.176a.6.6 0 0 1 .848 0L12 10.214l4.038-4.038a.6.6 0 0 1 .849 0l.937.937a.6.6 0 0 1 0 .848L13.785 12l4.04 4.04a.6.6 0 0 1 0 .848l-.937.937a.6.6 0 0 1-.849 0L12 13.784l-4.038 4.04a.6.6 0 0 1-.849 0l-.937-.937a.6.6 0 0 1 0-.848l4.04-4.04-4.039-4.038a.6.6 0 0 1 0-.849l.937-.936Z'/%3E%3C/svg%3E");
    background-position: 50%;
    background-repeat: no-repeat;
    bottom: 0;
    content: "";
    height: 24px;
    left: 0;
    margin: auto;
    position: absolute;
    right: 0;
    top: 0;
    width: 24px;
}

.m-filter .apply .ur-hr-no, .m-filter .filter-cancel .ur-hr-no {
    display: inline-block;
    line-height: 1;
}

.filter__cleared {
display: flex;
    width: 100%;
    margin: 10px 15px;
}
.filter__cleared-row {
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}
.filter__cleared-row .temp-bk__wrap {
  flex-shrink: 0;
  margin: 0;
  width: auto;
}

.m-pagination {
  display: flex;
  justify-content: center;
  align-items: center;
}
.m-pagination .navigation-arrow.bord {
  border-top-left-radius: var(--bs-pagination-border-radius);
  border-bottom-left-radius: var(--bs-pagination-border-radius);
}
.m-pagination .navigation-arrow.bordEnd {    
  border-top-right-radius: var(--bs-pagination-border-radius);
  border-bottom-right-radius: var(--bs-pagination-border-radius);
}
.m-pagination .navigation-arrow.ardisbl,
.m-pagination .navigation-arrow.ardisblEnd {
  background-color: var(--bs-pagination-disabled-bg) !important;
  border-color: var(--bs-pagination-disabled-border-color) !important;
  color: var(--bs-pagination-disabled-color) !important;
  pointer-events: none;
}
.m-pagination .ardisbl.bt-link,
.m-pagination .ardisblEnd.bt-link {
  background-color: var(--bs-pagination-disabled-bg) !important;
  border-color: var(--bs-pagination-disabled-border-color) !important;
  color: var(--bs-pagination-disabled-color) !important;
  pointer-events: none;
}

.m-pagination .btLink {
  margin: 0 !important;
  padding: 0 !important;
}
 .m-pagination li {
  padding-top: 9px !important;
  padding-bottom: 10px !important; 
  margin: 0 !important;  
}
.m-pagination li.btLink button{
  padding-bottom: 9px;
 }

.m-pagination .pagination {
    float: right;
    font-size: 0;
    letter-spacing: -1px;
    line-height: 0;
    white-space: nowrap;
}

.m-pagination .pagination .next, .m-pagination .pagination .previous, .m-pagination .pagination .total, .m-pagination .pagination>ul {
    display: flex;
    font-size: 13px;
    letter-spacing: 0;
    line-height: 1;
    vertical-align: top;
}

.m-pagination .pagination ul {
    list-style: none;
    margin: 0;
    padding: 0;
}

.m-pagination .pagination ul:after, .m-pagination .pagination ul:before {
    content: " ";
    display: table;
}

.m-pagination .pagination ul li {
    cursor: pointer;
    float: left;
    line-height: 1;
    margin: 13px 5px 0;
    min-width: 27px;
    padding: 6px 3px;
    text-align: center;
}


.m-pagination .pagination ul li a {
  padding: 10px;
}

.m-pagination .pagination ul li {
    cursor: pointer;
    float: left;
    line-height: 1;
    margin: 13px 5px 13px;
    min-width: 27px;
    padding: 6px 3px;
    text-align: center;
    background: #fff;
    border: var(--bs-pagination-border-width) solid var(--bs-pagination-border-color);
    font-size: 16px;
    color: #005eeb;
}

.m-pagination .pagination ul li.pagination__dots {
    cursor: auto;
    margin-left: 0;
}

.m-pagination .pagination ul li.active {
    background-color: #005eeb;
    color: #fff;
}

.m-pagination .pagination ul li.active a {
    color: #fff;
}

.m-pagination .pagination ul li:hover {
    background: #e8e8e8;
}

.loader-overlay {
  min-height:100vh;
}

.btn_ms {
    margin-right: 15px;
    background: linear-gradient(180deg, #fea530, #e48e1e) !important;
    color: #ffffff;
    font-size: 16px;
    padding: 8px 20px;
    display: inline-block;
    text-decoration: none;
    border-radius: 4px;
    line-height: 1.7;
    height: 32px;
}

.saved-orders-container {
  padding: 20px;
    background-color: #ffffff;
    border-radius: 0px;
    margin-bottom: 50px;
}

.saved-orders-container h2 {
 
    margin-bottom: 20px;
    color: #333;
    font-size: 24px;
    font-weight: 500;
    letter-spacing: -.3px;
    line-height: 32px;
    margin-top: 10px;
}

.saved-order-card {
    background-color: #ffffff;
    border-radius: 2px;
    /* box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); */
    padding: 15px;
    margin-bottom: 15px;
    transition: box-shadow 0.3s ease;
    width: 28%;
    gap: 20px;
    margin-right: 30px;
    border: solid 1px color(srgb 0.87 0.89 0.9 / 0.71);
}

.saved-order-card:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.order-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #ddd;
    padding-bottom: 10px;
    margin-bottom: 10px;
}

.order-header h3 {
    font-size: 14px;
    color: #000000;
    margin: 0;
    line-height: 14px;
}

.order-date {
    font-size: 10px;
    color: #888;
}

.order-details p {
    font-size: 12px;
    color: #000000;
    margin: 5px 0;
}

.order-details strong {
  font-weight: bold;
}

.open-order-button {
    background: linear-gradient(180deg, #005eeb, #0043a8);
    color: #ffffff;
    border: none;
    padding: 6px 12px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 12px;
    transition: background-color 0.3s ease;
    margin-top: 10px;
    border: solid 1px #dee2e6;
    font-weight: 600;
}

.open-order-button:hover {
  background-color: #0056b3;
}

.block_flex {
  display: flex;
    align-items: self-start;
    flex-wrap: wrap;
    width: 100%;
}

.original-price {
    text-decoration: line-through;
    color: #888;
    margin-left: 5px;
}

/* Цены в составе заказа (таблица) — как в OrderEdit: со скидкой + зачёркнутая исходная */
.list-order-products .order-price__value_column {
  display: inline;
}
.list-order-products .order-price__value_column .discounted-price {
  font-weight: 500;
}
.list-order-products .order-price__value_column .original-price {
  display: inline;
  margin-left: 4px;
}

.input-group .v-select.vs--single.vs--searchable{
    border:solid 0px!important;
}


.checkbox-wrapper {
   display: flex;
    align-items: center;
    margin: 0px;
    margin-top: 20px;
    border-top: solid 1px #dddddd;
    padding-top: 10px;
    width: auto;
    justify-content: flex-end;
    padding: 12px 20px;
    position: relative;
    z-index: 1;
}


.items-per-page-selector {
    display: flex;
    align-items: center;
}



.status-comment-wrap .list-status-comment {
    background: #f4f6f8;
    border-radius: 0 2px 2px 0;
    bottom: 0;
    display: block;
    padding: 0;
    position: absolute;
    right: -20px;
    top: 0;
}

.status-comment-wrap_orders .list-status-comment {
    border-radius: 0 4px 4px 0;
    flex-shrink: 0;
    position: static;
}




.message-indic, .task-tbl-commentary {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' fill='%23AFB9C3'%3E%3Cpath d='M16 16a4 4 0 0 0 4-4V4a4 4 0 0 0-4-4H4a4 4 0 0 0-4 4v15.5a.5.5 0 0 0 .5.5.49.49 0 0 0 .35-.15l3-3A3 3 0 0 1 6 16h10Z'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-size: contain;
    cursor: pointer;
    
    height: 13px;
    margin: 20px 10px 0 0;
    position: relative;
    width: 15px;
}

.message-indic.small, .task-tbl-commentary.small {
    height: 13px;
    margin: 4px 0 0;
    width: 13px;
}

.status-comment-wrap .list-status-comment .message-indic.small {
    background-position: 50%;
    background-size: 15px 13px;
    height: 100%;
    margin-bottom: 0;
    margin-top: 0;
    width: 30px;
}




.popup-comment-box {
    background-color: #fff;
    border: 1px solid #d9d9d9;
    border-radius: 2px;
    box-shadow: 0 3px 15px rgb(0 0 0 / 12%);
    cursor: default;
  
    padding: 15px;
    position: absolute;
    right: 25px;
    top: -15px;
    width: 426px;
    z-index: 99;
}


.popup-comment-box.down {
    left: -16px;
    right: auto;
    top: 23px;
}


.status-comment-wrap .list-status-comment .popup-comment-box {
    left: auto;
    right: -12px;
    top: 30px;
}

.fs12 {
    font-size: 12px!important;
}

.lh18 {
    line-height: 18px!important;
}


.black {
    color: #1e2248;
}


.popup-comment-box .comment-text {
    overflow-x: hidden;
    text-overflow: ellipsis;
}





.popup-comment-box:after {
    background: #fff;
    border-color: #d9d9d9;
    border-style: solid;
    border-width: 1px 1px 0 0;
    content: "";
    height: 8px;
    position: absolute;
    right: -5px;
    top: 16px;
    transform: rotate(45deg);
    width: 8px;
}


.popup-comment-box.down:after {
    left: 16px;
    right: auto;
    top: -5px;
    transform: rotate(-45deg);
}

.status-comment-wrap .list-status-comment .popup-comment-box:after {
    left: auto;
    right: 21px;
}



.checkbox-wrapper .custom_filter.t {  
    display: flex;
    gap: 10px;
    align-items: center;
}
.checkbox-wrapper .custom_filter_templates-item {
  display: inline-flex;
  align-items: center;
}

.checkbox-wrapper .custom_filter.t input[type="checkbox"] {
  width: 20px;
  height: 20px;
  cursor: pointer;
  accent-color: #007bff; /* Стилизация чекбокса */
}

.checkbox-wrapper .custom_filter.t label {
    display: flex;
    align-items: center;
    position: relative;
    padding-left: 40px;
    cursor: pointer;
    font-size: 14px;
    min-width: auto;
    max-width: auto;
    justify-content: end;
    height: 18px;
    width: auto;
    max-width: 80px;
}
.custom_filter.t label::before {
    content: "";
    position: absolute;
    left: 0;
    width: 30px;
    height: 18px;
    background-color: #ccc;
    border-radius: 15px;
    transition: background-color 0.3s ease;
}

.custom_filter.t label::after {
    content: "";
    position: absolute;
    left: 2px;
    width: 13px;
    height: 13px;
    background-color: white;
    border-radius: 50%;
    transition: transform 0.3s ease;
    top: 8px;
}
.custom_filter.t input[type="checkbox"].switch:checked + label::before {
  background-color: #21ba8a;
}
.custom_filter.t input[type="checkbox"].switch:checked + label::after {
  transform: translateX(14px);
}


.custom_filter.t input {
  display: none;
}

/* Блок шаблонов быстрых фильтров (temp-bk) — компактный, не на всю ширину */
.temp-bk__wrap {
  display: inline-flex;
  align-items: flex-start;
  position: relative;
  margin: 0;
  padding: 2px 6px 2px 4px;
  background: #f1f3f5;
  border-radius: 4px;
  border: 1px solid #dee2e6;
  width: auto;
  max-width: none;
  box-sizing: border-box;
}
.temp-bk {
  display: flex;
  flex-direction: column;
  gap: 0;
  align-items: stretch;
}
.temp-bk__row {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  min-height: 22px;
}
.temp-bk__wrap .temp-bk__btn-toggle {
  flex-shrink: 0;
  box-sizing: border-box;
  width: 22px;
  height: 22px;
  margin: 0;
  padding: 0;
  border: 1px solid #ced4da;
  border-radius: 3px;
  background: #fff url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='10' viewBox='0 0 24 24' fill='none' stroke='%23495057' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E") no-repeat center;
  background-size: 10px 10px;
  font: inherit;
  color: inherit;
  cursor: pointer;
  appearance: none;
  -webkit-appearance: none;
  transition: background-color 0.12s, border-color 0.12s;
}
.temp-bk__wrap .temp-bk__btn-toggle:hover {
  background-color: #e9ecef;
  border-color: #adb5bd;
}
.temp-bk__wrap .temp-bk.collapsed .temp-bk__btn-toggle {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='10' viewBox='0 0 24 24' fill='none' stroke='%23495057' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='18 15 12 9 6 15'%3E%3C/polyline%3E%3C/svg%3E");
}
.temp-bk__inner-lt {
  font-size: 11px;
  color: #0d6efd;
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
  transition: color 0.12s;
}
.temp-bk__inner-lt:hover {
  color: #0a58ca;
  text-decoration: underline;
}
.temp-bk__panel {
  position: absolute;
  left: 0;
  top: 100%;
  margin-top: 4px;
  padding: 6px 8px;
  background: #fff;
  border-radius: 4px;
  border: 1px solid #dee2e6;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  min-width: 180px;
  max-width: 280px;
  z-index: 100;
}
.temp-bk__list {
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-bottom: 6px;
  max-height: 200px;
  overflow-y: auto;
}
.temp-bk__list-item {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 0;
  padding: 3px 4px;
  font-size: 12px;
  color: #212529;
  cursor: pointer;
  border-radius: 3px;
}
.temp-bk__list-item:hover {
  background: #f8f9fa;
}
.temp-bk__list-item input {
  width: 14px;
  height: 14px;
  margin: 0;
  flex-shrink: 0;
  cursor: pointer;
  accent-color: #0d6efd;
}
.temp-bk__list-item span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.temp-bk__actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  padding-top: 6px;
  border-top: 1px solid #eee;
}
.temp-bk__wrap .temp-bk__btn-delete {
  box-sizing: border-box;
  margin: 0;
  padding: 4px 10px;
  border: 1px solid #dc3545;
  border-radius: 4px;
  background: #dc3545;
  font-size: 11px;
  font-weight: 500;
  line-height: 1.4;
  color: #fff;
  cursor: pointer;
  appearance: none;
  -webkit-appearance: none;
  transition: background-color 0.15s, border-color 0.15s;
}
.temp-bk__wrap .temp-bk__btn-delete:hover {
  background: #bb2d3b;
  border-color: #bb2d3b;
  color: #fff;
}
.temp-bk__wrap .temp-bk__btn-cancel {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  border: none;
  background: none;
  font-size: 11px;
  line-height: 1.4;
  color: #6c757d;
  cursor: pointer;
  transition: color 0.15s;
}
.temp-bk__wrap .temp-bk__btn-cancel:hover {
  color: #0d6efd;
  text-decoration: underline;
}
.temp-bk__wrap .temp-bk__btn-save {
  box-sizing: border-box;
  margin: 0;
  padding: 4px 10px;
  border: 1px solid #0d6efd;
  border-radius: 4px;
  background: #0d6efd;
  font-size: 11px;
  font-weight: 500;
  line-height: 1.4;
  color: #fff;
  cursor: pointer;
  appearance: none;
  -webkit-appearance: none;
  transition: background-color 0.15s, border-color 0.15s;
}
.temp-bk__wrap .temp-bk__btn-save:hover {
  background: #0b5ed7;
  border-color: #0a58ca;
  color: #fff;
}

.fa-copy svg {
    width: 17px;
    height: 17px;
    opacity: .5;
}
.btntask {
  margin-right: 15px !important;
  background:  #f86d6d !important;
}


.call-button {
    background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' width='512' height='512' style='shape-rendering:geometricPrecision;text-rendering:geometricPrecision;image-rendering:optimizeQuality;fill-rule:evenodd;clip-rule:evenodd'%3e%3cpath fill='%23fefffe' d='M277.5-.5h12c104.845 23.53 175.679 85.864 212.5 187a503.138 503.138 0 0 1 9.5 37v9c-5.458 10.198-13.458 12.698-24 7.5l-3.5-3.5C469.001 156.906 426.834 96.74 357.5 56c-26.136-14.045-53.802-23.712-83-29-9.874-10.441-8.874-19.608 3-27.5Z' style='opacity:.958'/%3e%3cpath fill='%23fefffe' d='M381.5 511.5h-28c-28.815-4.324-56.481-12.824-83-25.5C163.94 433.773 83.44 354.94 29 249.5c-14.802-29.566-24.635-60.566-29.5-93v-26c1.952-13.678 6.785-26.345 14.5-38A545.237 545.237 0 0 1 69.5 37c21.868-12.567 42.534-10.9 62 5a1855.233 1855.233 0 0 1 71.5 73.5c12.766 23.757 9.766 45.423-9 65L160.5 214c12.934 25.7 29.434 48.867 49.5 69.5 24.901 27.093 53.567 49.093 86 66a965.629 965.629 0 0 0 37.5-36.5c23.285-18.265 46.285-17.931 69 1l61.5 61.5c19.631 21.462 21.631 44.462 6 69a1765.816 1765.816 0 0 1-49.5 50.5c-11.803 8.539-24.803 14.039-39 16.5Zm-285-453c4.683.439 9.016 1.939 13 4.5l66.5 66.5c7.154 10.304 6.154 19.971-3 29a1101.106 1101.106 0 0 1-40 39c-4.129 5.699-5.462 12.032-4 19a226.895 226.895 0 0 0 25 47c28.999 39.668 63.833 73.168 104.5 100.5l30 16c9.672 3.236 18.338 1.57 26-5l41-41c8.557-6.189 16.89-5.855 25 1a3173.43 3173.43 0 0 1 66.5 67.5c4.667 7.333 4.667 14.667 0 22a1564.09 1564.09 0 0 1-46.5 47.5c-13.749 8.883-28.749 11.883-45 9a214.824 214.824 0 0 1-55-15C185.258 414.758 101.091 331.925 48 217.5c-10.483-23.434-16.65-47.934-18.5-73.5-.395-13.058 3.105-24.891 10.5-35.5L85.5 63c3.553-2.12 7.22-3.62 11-4.5Z' style='opacity:.959'/%3e%3cpath fill='%23fefffe' d='M277.5 91.5c66.203 12.096 111.203 49.596 135 112.5 4.165 10.819 5.998 21.985 5.5 33.5-4.462 8.479-11.296 11.313-20.5 8.5a25.55 25.55 0 0 1-6.5-5.5c-9.644-50.491-37.478-86.991-83.5-109.5a195.367 195.367 0 0 0-35-10c-11.123-8.204-11.79-17.204-2-27 2.427-.902 4.76-1.736 7-2.5Z' style='opacity:.955'/%3e%3c/svg%3e");
    width: 20px;
    height: 20px;
    position: relative;
    background-repeat: no-repeat;
    background-color: #21b889;
    background-position: center;
    background-size: 70%;
    border-radius: 3px !important;
    display: block;
    cursor: pointer;
    transition: background-color 0.3s ease, transform 0.2s ease;
}

.call-button:hover {
  background-color: #3d3d3d;
}

.numbe {
  display: flex;
}
.numbe p {
  margin-left: 3px;
}


.export-modal-overlay,
.modal-overlay {
  position: fixed; z-index: 2000; inset: 0;
  background: rgba(30,30,30,0.28);
  display: flex; align-items: center; justify-content: center;
}
.export-modal-window {
  background: #fff;
  border-radius: 14px;
  min-width: 340px;
  width: 960px;
  max-width: 98vw;
  padding: 28px 34px 22px 34px;
  box-shadow: 0 8px 32px rgba(20,40,60,0.14);
  font-family: inherit;
  animation: fadeInUp .2s cubic-bezier(.4,1,.5,1);
  height: 80%;
  overflow-y: auto;
}
@keyframes fadeInUp {
  from { opacity: 0; transform: translateY(30px);}
  to { opacity: 1; transform: none;}
}
.export-modal-title {
  font-size: 1.15rem; font-weight: 600; margin-bottom: 18px;
}
/* .export-modal-section {
  margin-bottom: 18px;
} */
.export-modal-select {
  margin-left: 8px; font-size: 1rem; border-radius: 4px;
  padding: 3px 10px; border: 1px solid #d0d0d0;
}
.export-modal-actions {
  display: flex; justify-content: flex-end; gap: 12px; margin-top: 8px;
}
.modal-btn {
  font-size: 1rem;
  padding: 7px 22px;
  border: none;
  border-radius: 6px;
  background: #e6e6e6;
  cursor: pointer;
  transition: background .18s;
}
.modal-btn-green {
  background: #38b000; color: #fff;
}
.modal-btn:disabled {
  opacity: 0.6; pointer-events: none;
}

/* Быстрый заказ Lite — в общем стиле кнопок и export-modal */
.btn-lite-wrap {
  margin-left: 15px !important;
}
.lite-order-modal.export-modal-window {
  height: auto;
  max-height: 90vh;
  overflow-y: auto;
}

/* Расчёт зарплаты курьера — изоляция от глобальных .input-group */
.courier-salary-modal.export-modal-window {
  height: auto;
  max-height: 90vh;
  width: 560px;
  min-width: 520px;
  max-width: 96vw;
  overflow-y: auto;
}
.courier-salary-modal .courier-salary-form {
  clear: both;
  overflow: visible;
  width: 100%;
  box-sizing: border-box;
}
.courier-salary-modal .courier-salary-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-bottom: 12px;
  width: 100%;
}
.courier-salary-modal .courier-salary-field {
  margin-bottom: 0;
}
.courier-salary-modal .courier-salary-field-full {
  grid-column: 1 / -1;
  margin-bottom: 12px;
}
.courier-salary-modal .courier-salary-select {
  height: 36px !important;
}
.courier-salary-modal .input-group,
.courier-salary-modal .courier-salary-field {
  float: none !important;
  width: 100% !important;
  max-width: 100% !important;
  display: block !important;
  clear: both !important;
  padding: 0 !important;
  margin: 0 !important;
  min-height: 0 !important;
  flex-wrap: wrap !important;
  align-items: stretch !important;
  box-sizing: border-box;
}
.courier-salary-modal .input-group label,
.courier-salary-modal .courier-salary-lbl,
.courier-salary-modal label {
  float: none !important;
  display: block !important;
  width: auto !important;
  min-width: 0 !important;
  max-width: none !important;
  margin: 0 0 6px 0 !important;
  padding: 0 !important;
  font-weight: 500;
  font-size: 14px;
  color: #636f7f;
}
.courier-salary-modal .input-field,
.courier-salary-modal .courier-salary-input,
.courier-salary-modal .export-modal-select {
  float: none !important;
  display: block !important;
  width: 100% !important;
  max-width: 100% !important;
  height: 36px !important;
  min-height: 36px !important;
  margin: 0 !important;
  padding: 6px 10px !important;
  box-sizing: border-box;
  border: 1px solid #d0d0d0 !important;
  border-radius: 4px;
  font-size: 14px;
  line-height: 1.4;
  background: #fff;
}
.courier-salary-modal .courier-salary-preview,
.courier-salary-modal > div[style*="padding"] > div[style*="background:#f5f5f5"] {
  background: #f5f5f5;
  padding: 10px;
  border-radius: 4px;
  font-size: 12px;
  margin-bottom: 12px;
  clear: both;
}
.courier-salary-modal .courier-salary-actions,
.courier-salary-modal > div[style*="padding"] > div[style*="display:flex"] {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 8px;
  clear: both;
}

/* Изоляция от глобальных .input-group (float 45% в App.vue) и label (min-width 90px) */
.lite-order-modal .lite-order-form {
  clear: both;
  overflow: visible;
  width: 100%;
  box-sizing: border-box;
}
.lite-order-modal .lite-order-form .lite-order-field {
  float: none !important;
  width: 100% !important;
  max-width: 100% !important;
  display: block !important;
  clear: both;
  box-sizing: border-box;
  margin-bottom: 14px;
}
.lite-order-modal .lite-order-form .lite-order-lbl {
  float: none !important;
  display: block !important;
  width: auto !important;
  min-width: 0 !important;
  max-width: none !important;
  margin: 0 0 6px 0 !important;
  padding: 0 !important;
  font-weight: 500;
  font-size: 14px;
  color: #636f7f;
}
.lite-order-modal .lite-order-input-full {
  width: 100%;
  margin-left: 0;
  box-sizing: border-box;
}
.lite-order-modal .lite-order-textarea {
  width: 100%;
  margin-left: 0;
  box-sizing: border-box;
  min-height: 64px;
  resize: vertical;
  display: block;
}
.lite-order-modal .lite-order-dp-wrap {
  width: 100%;
}
.lite-order-modal .lite-order-dp-wrap .mx-datepicker {
  width: 100% !important;
}
.lite-order-modal .lite-order-dp-wrap .mx-input-wrapper {
  width: 100%;
}
.lite-order-modal .lite-order-dp-wrap .mx-input {
  width: 100% !important;
}
.lite-order-modal .lite-order-vselect-wrap {
  width: 100%;
  min-width: 0;
}
.lite-order-modal .lite-order-vselect-wrap .v-select {
  width: 100% !important;
  max-width: 100% !important;
}
.lite-order-modal .lite-order-time-row {
  display: grid !important;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 12px;
  align-items: start;
}
.lite-order-modal .lite-order-time-cell {
  min-width: 0;
}
.lite-order-modal .lite-order-err {
  color: #c00;
  font-size: 12px;
  display: block;
  margin-top: 4px;
}
.lite-order-modal .lite-order-err-block {
  margin-bottom: 8px;
}
.lite-order-modal .lite-order-actions {
  clear: both;
  margin-top: 16px;
  padding-top: 12px;
  border-top: 1px solid #e8e8e8;
  background: #fff;
}
.lite-order-modal .lite-order-actions .modal-btn {
  margin: 0;
}

/* Стили для модального окна изменения пользовательского поля без оверлэя */
.custom-field-modal-wrapper {
  position: fixed;
  z-index: 2000;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}

.custom-field-modal-window {
  pointer-events: auto;
  position: relative;
  max-height: 90vh;
  overflow-y: auto;
}

/* Стили для лоадера в модальном окне изменения пользовательского поля */
.custom-field-modal-loader {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.95);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 10;
  border-radius: 8px;
}

.custom-field-loader-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #38b000;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 12px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.custom-field-loader-text {
  font-size: 14px;
  color: #666;
  font-weight: 500;
}

.batch-bonus-reload-overlay {
  position: fixed;
  inset: 0;
  z-index: 20000;
  background: rgba(15, 23, 42, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(2px);
}

.batch-bonus-reload-panel {
  background: #fff;
  border-radius: 12px;
  padding: 28px 36px;
  min-width: 280px;
  text-align: center;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.18);
  animation: batch-bonus-reload-pulse 1.6s ease-in-out infinite;
}

.batch-bonus-reload-spinner {
  width: 48px;
  height: 48px;
  border: 4px solid #e8f5e9;
  border-top: 4px solid #38b000;
  border-radius: 50%;
  animation: spin 0.9s linear infinite;
  margin: 0 auto 16px;
}

.batch-bonus-reload-title {
  font-size: 16px;
  font-weight: 600;
  color: #212529;
  margin-bottom: 8px;
}

.batch-bonus-reload-progress {
  font-size: 14px;
  color: #005eeb;
  font-weight: 500;
  margin-bottom: 6px;
}

.batch-bonus-reload-hint {
  font-size: 12px;
  color: #868e96;
}

@keyframes batch-bonus-reload-pulse {
  0%, 100% { transform: scale(1); box-shadow: 0 12px 40px rgba(0, 0, 0, 0.18); }
  50% { transform: scale(1.02); box-shadow: 0 16px 48px rgba(56, 176, 0, 0.15); }
}

.draggable-list {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  min-height: 80px;
  padding: 12px 10px;
  background: #f8f9fa;
  margin-bottom: 6px;
}
.draggable-row {
  display: flex; align-items: center; padding: 4px 0;
  gap: 8px; cursor: grab; border-bottom: 1px solid #eee;
}
.draggable-row:last-child { border-bottom: none; }
.drag-handle {
  font-size: 1.25em; color: #888; cursor: grab; margin-right: 8px; transition: color 0.13s;
}
.drag-handle:hover { color: #38b000; }


.excels {
    border: none;
    background: transparent;
    font-size: 13px;
    border-radius: 5px;
    min-height: 35px;
    display: block;
}

.excels:disabled {
  background: transparent;
  display:none;
}


.export-modal-grid {
  display: flex;
  gap: 32px;
  margin: 20px 0;
}

.export-modal-columns {
  flex: 1;
  max-width: 100%;
  max-height: 440px;
  /* min-width: 52%; */
overflow-y: auto;
overflow-x: hidden;
padding-left: 15px;
}

.groupBlcok {
    width: 100%;
    padding: 10px;
    background: #f8f9fa;
    margin: 0 15px 15px 0px;
}
.groupBlcok .groupCheck {
  display: flex;
    flex-wrap: wrap;
    width: 100%;
}
.groupBlcok .groupCheck .groupCheckBlock {
  margin-bottom:6px;
  margin-right: 20px;
}

.groupBlcok .groupCheck label{
    display: flex;
    align-items: start;
}
.groupBlcok .groupCheck label p{
  margin-left: 5px;
}

.export-modal-checkboxes {
  display: block;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px 12px;
}

.export-modal-selected {
  flex: 1;
  min-width: 250px;
  border-right: 1px solid #eee;
  padding-left: 15px;
  max-width: 100px;
}

.draggable-list {
  margin-top: 6px;
}

.draggable-row {
  display: flex;
  align-items: center;
  background: #f8f8f8;
  padding: 6px 8px;
  margin-bottom: 8px;
  border-radius: 5px;
  cursor: grab;
}

.drag-handle {
  cursor: grab;
  margin-right: 8px;
  font-size: 20px;
  opacity: 0.5;
  user-select: none;
}

.modal_grid {
  display: flex;

}

/* .excels {
  display: none;
} */


.export-block-titl {
  display: flex;
  margin-bottom: 18px;
  align-items: center;
}

.newTemplat input{
  padding: 5px 20px;
    border: 1px solid;
    margin-right: 10px;
}

.newTemplat button{
  padding: 5px 15px;
  border: none;
  background: #005eeb;
  color: #fff;
  cursor: pointer;
}
.export-modal-section button{
    margin-left: 10px;
    background: rgb(220, 53, 69);
    color: #fff !important;
    padding: 5px 20px;
    border: none;
}

.manExport {
  display: flex;
}

.closeManExport {
  margin-left: auto;
}
.closeManExport svg {
  width: 24px !important;
  color: #999;
  cursor: pointer;
}


.endFilter {
  color: #0044b7;
  padding: 10px;
  margin-left: 10px;
  display: flex;
  align-items: center;
  justify-content: end;
}
.endFilter span {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.endFilter svg {
  border: 1px solid #c9d7ee;
  margin-left: 5px;
}

.rotated {
 /*transition: transform .3s ease;*/
 transform: rotate(180deg);
}



.btn-wrapper.btn-wrapper_group.new.megamenu .custmenu {
  background: #005eeb;
    border: none;
    color: #fff;
    border-radius: 6px;
    transition: 0.3s;
    margin-right: 15px;
}
.btn-wrapper.btn-wrapper_group.new.megamenu .custmenu:hover {
  background: #1170ff;
}

.btn-wrapper.btn-wrapper_group.new.megamenu {
  display: flex;
  align-items: center;
  justify-content: center;
}


.btn.grens {
  background: #1abc9c !important;
}

.megamenu {
  position: relative;
}
.megamenu .allitem {
  display: flex;
  width: 300px;
  position: absolute;
  flex-wrap: wrap;
  top: 60px;
  z-index: 10;
  padding: 20px;
  background: #f4f6f8;
  padding-top: 5px;
}

 .megamenu .allitem .btn {
  width: 100%;
  margin-left: 0 !important;
  margin-right: 0 !important;
  margin-top: 10px !important;
 }

 .megamenu .currentorange {
  background: #fea530 !important;
 }


 .fade-menu-enter-active,
.fade-menu-leave-active {
  transition: opacity 0.5s ease, transform 0.5s ease;
}

.fade-menu-enter-from,
.fade-menu-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

.fade-menu-enter-to,
.fade-menu-leave-from {
  opacity: 1;
  transform: translateY(0);
}

/* .itemsSelect {
  display: flex;
}*/

.itemSel {
  position: relative;
  margin: 15px 0; 
  cursor: move;
  font-size: 13px;
}
.delitem {
    cursor: pointer;
    display: block;
    height: 16px;
    margin-left: auto;
    margin-right: 12px;
    transition: .25s ease;
    width: 16px;
    position: absolute;
    top: 0;
    right: 0%;
} 

/* Batch actions bar */
.batch-box {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: #fff;
    border-top: 1px solid #e9ecef;
    padding: 16px 24px;
    z-index: 1000;
    animation: slideUp 0.3s ease-out;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.08);
}

@keyframes slideUp {
    from {
        transform: translateY(100%);
    }
    to {
        transform: translateY(0);
    }
}

.batch-box .wrapper {
    max-width: 1400px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    gap: 16px;
}

.batch-box .wrapper input[type="checkbox"] {
    width: 18px;
    height: 18px;
    cursor: pointer;
    margin: 0;
    margin-right: 10px;
    accent-color: #21b486;
    flex-shrink: 0;
}

.batch-box .elements-count {
    font-size: 14px;
    font-weight: 500;
    color: #495057;
    line-height: 1.5;
    white-space: nowrap;
    flex-shrink: 0;
}

.batch-box .wrapper .dropdown {
    flex-shrink: 0;
}

.batch-box .dropdown {
    position: relative;
}

.batch-box .batch-actions {
    background: #21b486;
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    transition: background 0.2s;
    height: auto;
    line-height: normal;
    min-height: 36px;
}

.batch-box .batch-actions {
    background: #21b486;
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    transition: background 0.2s;
    height: auto;
    line-height: normal;
    min-height: 36px;
}

.batch-box .batch-actions:hover {
    background: #1a9a73;
}

.batch-box .ul-scroll-dropdown-wrapper {
    position: absolute;
    bottom: 100%;
    left: 0;
    margin-bottom: 8px;
    background: #fff;
    border: 1px solid #e9ecef;
    border-radius: 8px;
    min-width: 280px;
    max-height: 500px;
    overflow-y: auto;
    overflow-x: visible;
    z-index: 1001;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.batch-box .ul-scroll-dropdown-wrapper::-webkit-scrollbar {
    width: 6px;
}

.batch-box .ul-scroll-dropdown-wrapper::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
}

.batch-box .ul-scroll-dropdown-wrapper::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;
}

.batch-box .ul-scroll-dropdown-wrapper::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
}

.batch-box .left-list {
    list-style: none;
    margin: 0;
    padding: 0;
}

.batch-box .left-list li {
    border-bottom: 1px solid #f0f0f0;
    margin: 0;
}

.batch-box .left-list li:last-child {
    border-bottom: none;
}

.batch-box .left-list li.button {
    margin: 0;
}

.batch-box .left-list li a {
    display: flex;
    align-items: center;
    padding: 12px 16px;
    color: #212529;
    text-decoration: none;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.5;
    transition: all 0.15s ease;
    min-height: 44px;
    position: relative;
}

.batch-box .left-list li a:hover {
    background: #f0f7ff;
    color: #005eeb;
    padding-left: 20px;
}

.batch-box .left-list li.disabled a,
.batch-box .left-list li.disabled {
    opacity: 0.4;
    cursor: not-allowed;
    pointer-events: none;
    background: #f8f9fa;
}

.batch-box .left-list li.disabled a:hover {
    background: #f8f9fa;
    color: #212529;
    padding-left: 16px;
}

.batch-box .left-list li.with-list {
    position: static;
}

.batch-box .left-list .drop {
    position: fixed;
    background: #fff;
    border: 1px solid #e9ecef;
    border-radius: 8px;
    min-width: 280px;
    max-height: 400px;
    overflow-y: auto;
    z-index: 10000;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

/* Специальные стили для окна массовой смены статуса */
.batch-box .left-list .drop.batch-status-dropdown {
    min-width: 220px;
    max-width: 250px;
    max-height: calc(100vh - 150px);
    height: auto;
}

.batch-box .left-list .drop::-webkit-scrollbar {
    width: 6px;
}

.batch-box .left-list .drop::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
}

.batch-box .left-list .drop::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;
}

.batch-box .left-list .drop::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
}

.batch-box .scroll-x {
    list-style: none;
    margin: 0;
    padding: 0;
}

.batch-box .scroll-x li {
    border-bottom: 1px solid #f0f0f0;
}

.batch-box .scroll-x li:last-child {
    border-bottom: none;
}

.batch-box .scroll-x li a {
    display: flex;
    align-items: center;
    padding: 12px 16px;
    color: #212529;
    text-decoration: none;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.5;
    transition: all 0.15s ease;
    min-height: 44px;
    text-align: left;
}

.batch-box .scroll-x li a:hover {
    background: #f0f7ff;
    color: #005eeb;
    padding-left: 20px;
}

/* Стили для меню пользовательских полей */
.batch-box .options__custom-fields {
    list-style: none;
    margin: 0;
    padding: 8px 0;
    min-width: 280px;
    max-height: 500px;
    overflow-y: auto;
    overflow-x: hidden;
}

.batch-box .options__custom-fields li {
    margin: 0;
    border-bottom: none;
}

/* Стили для групп (заголовков) */
.batch-box .options__custom-fields li.group.custom {
    padding: 0;
    margin: 0;
    background: #f8f9fa;
    border-top: 1px solid #e9ecef;
    border-bottom: 1px solid #e9ecef;
}

.batch-box .options__custom-fields li.group.custom:first-child {
    border-top: none;
}

.batch-box .options__custom-fields li.group.custom .icon {
    display: block;
    padding: 10px 16px;
    font-size: 12px;
    font-weight: 600;
    color: #495057;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    background: #f8f9fa;
    border: none;
}

/* Стили для кнопок полей */
.batch-box .options__custom-fields li.button.change-batch-custom-field {
    padding: 0;
    margin: 0;
    border-bottom: none;
    transition: background 0.15s ease;
}

.batch-box .options__custom-fields li.button.change-batch-custom-field:hover {
    background: #f0f7ff;
}

.batch-box .options__custom-fields li.button.change-batch-custom-field a {
    display: block;
    padding: 12px 16px;
    color: #212529;
    text-decoration: none;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.5;
    transition: all 0.15s ease;
    min-height: 44px;
    display: flex;
    align-items: center;
}

.batch-box .options__custom-fields li.button.change-batch-custom-field a:hover {
    background: #f0f7ff;
    color: #005eeb;
    padding-left: 20px;
}

/* Чередование цветов для четных/нечетных элементов */
.batch-box .options__custom-fields li.button.change-batch-custom-field.even {
    background: #fff;
}

.batch-box .options__custom-fields li.button.change-batch-custom-field.odd {
    background: #fafbfc;
}

.batch-box .options__custom-fields li.button.change-batch-custom-field.even:hover,
.batch-box .options__custom-fields li.button.change-batch-custom-field.odd:hover {
    background: #f0f7ff;
}

/* Улучшенная прокрутка */
.batch-box .options__custom-fields::-webkit-scrollbar {
    width: 6px;
}

.batch-box .options__custom-fields::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
}

.batch-box .options__custom-fields::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;
}

.batch-box .options__custom-fields::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
}

.batch-box .scroll-x li.disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.batch-box .scroll-x li.disabled div,
.batch-box .scroll-x li.disabled a {
    pointer-events: none;
}

/* Стили для групп статусов в меню */
.batch-box .batch-status-group-header {
    padding: 10px 16px;
    font-size: 12px;
    font-weight: 600;
    color: #495057;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    border-bottom: 1px solid rgba(0,0,0,0.1);
}

/* Стили для элементов статусов с цветами */
.batch-box .batch-status-item {
    border-left: 4px solid transparent;
}

.batch-box .batch-status-item.new {
    border-left-color: rgba(254,165,48,1);
}

.batch-box .batch-status-item.approval {
    border-left-color: rgba(254,165,48,0.8);
}

.batch-box .batch-status-item.delivery {
    border-left-color: rgba(0,94,235,0.8);
}

.batch-box .batch-status-item.complete {
    border-left-color: rgba(34,201,147,0.8);
}

.batch-box .batch-status-item.cancel {
    border-left-color: rgba(255,83,83,0.8);
}

.batch-box .batch-status-item.assembling {
    border-left-color: rgba(101,40,215,0.8);
}

.batch-box .batch-status-item.dflkdslskl {
    border-left-color: rgba(175,185,195,1);
}

.batch-box .batch-status-item.brak12 {
    border-left-color: rgba(101,40,215,0.8);
}

.batch-box .batch-status-item.sto12f {
    border-left-color: rgba(30,34,72,1);
}

/* Цвета для кастомных статусов */
.batch-box .batch-status-item[class*="custom-status-color"] {
    border-left-color: rgba(101,40,215,0.8);
}

.batch-box .batch-statuses__item {
    cursor: pointer;
}

.batch-box .batch-statuses__link {
    display: block;
    padding: 10px 14px;
    font-size: 13px;
    color: #333;
}

.batch-box .batch-statuses__item:hover .batch-statuses__link {
    background: #f5f5f5;
}

/* Стили для предупреждений */
.batch-box .batch_popup_warning {
    font-size: 11px;
    color: #6c757d;
    font-weight: 400;
    margin-top: 4px;
    padding-top: 4px;
    border-top: 1px solid #e9ecef;
}

/* Улучшенные стили для всех элементов меню */
.batch-box .left-list li.button a,
.batch-box .scroll-x li.button a {
    min-height: 44px;
    display: flex;
    align-items: center;
}

.batch-box .left-list li.with-list > a::after {
    content: '›';
    margin-left: auto;
    color: #6c757d;
    font-size: 18px;
    font-weight: 300;
}

.batch-box .left-list li.with-list > a:hover::after {
    color: #005eeb;
}

/* Стили для vue-treeselect в состоянии фокуса и открытом состоянии */
.vue-treeselect--focused .vue-treeselect__control,
.vue-treeselect--open .vue-treeselect__control,
.vue-treeselect__control:focus {
    border-color: var(--input-focus-border-color);
    box-shadow: var(--input-focus-box-shadow);
    outline: none;
}

/* Исправление z-index для выпадающих меню TreeSelect */
.vue-treeselect {
    position: relative;
    z-index: auto;
}

.vue-treeselect__menu-container {
    z-index: 10000 !important;
}

.vue-treeselect--open .vue-treeselect__menu-container {
    z-index: 10000 !important;
}

/* Строка с TreeSelect и кнопками «Выбрать все» / «Сбросить» */
.filter-treeselect-row {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    gap: 8px;
}
.filter-treeselect-row .vue-treeselect {
    flex: 1 1 200px;
    min-width: 0;
}
.treeselect-actions {
    display: flex;
    gap: 6px;
    flex-shrink: 0;
}
.btn-select-all,
.btn-clear-treeselect {
    padding: 6px 12px;
    font-size: 12px;
    border: 1px solid var(--input-border-color, #ccc);
    border-radius: 4px;
    background: var(--input-bg, #fff);
    color: var(--text-color, #333);
    cursor: pointer;
    white-space: nowrap;
}
.btn-select-all:hover,
.btn-clear-treeselect:hover {
    background: var(--input-focus-border-color, #e0e0e0);
}
.btn-clear-treeselect {
    color: #666;
}

.vue-treeselect__menu {
    z-index: 10000 !important;
    position: relative;
    max-height: 300px;
    overflow-y: auto;
}

/* Убеждаемся, что родительские контейнеры не обрезают меню */
.default-form-filter {
    overflow: visible !important;
}

.filter-content.cleared.filter__row {
    overflow: visible !important;
}

/* Flexbox layout для фильтров с поддержкой order */
.filter-flex-container {
    display: flex !important;
    flex-wrap: wrap !important;
    margin-left: -15px;
    margin-right: -15px;
    width: calc(100% + 30px);
    font-size: 0;
}

.filter-flex-container .filter-group {
    width: 16.666% !important;
    float: none !important;
    display: inline-block !important;
    padding: 0 15px;
    margin-bottom: 15px;
    font-size: 13px;
    letter-spacing: 0;
    line-height: 1.1;
    vertical-align: top;
    box-sizing: border-box;
}

@media screen and (max-width: 1600px) {
    .filter-flex-container .filter-group {
        width: 20% !important;
    }
}

@media screen and (max-width: 1200px) {
    .filter-flex-container .filter-group {
        width: 25% !important;
    }
}

/* Дополнительные стили для правильного отображения меню TreeSelect */
.vue-treeselect__portal-target {
    z-index: 10000 !important;
}

body > .vue-treeselect__menu-container {
    z-index: 10000 !important;
}

/* Стили для иконки отгрузки */
.icon-ok {
    background-image: url("data:image/svg+xml,%3Csvg width=%2724%27 height=%2724%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath fill-rule=%27evenodd%27 clip-rule=%27evenodd%27 d=%27M19.793 6.965a.77.77 0 0 1-.022 1.075l-9.815 9.607a1.224 1.224 0 0 1-1.714.006l-4.01-3.878a.77.77 0 0 1-.028-1.074l.684-.736a.735.735 0 0 1 1.053-.028l3.15 3.046 8.96-8.771a.735.735 0 0 1 1.054.022l.688.731Z%27 fill=%27%2322C993%27/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-size: contain;
    width: 24px;
    height: 24px;
    display: inline-block;
}

ol, ul {
    padding-left: 1rem;
}

/* Стили для кнопок в модальном окне выбора машины курьера */
.export-modal-window .btn {
    background: none;
    background-color: #005eeb;
    background-image: linear-gradient(180deg, #0068ff, #005bd5);
    border: none;
    border-radius: 6px;
    color: #fff;
    cursor: pointer;
    display: inline-block;
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, Roboto, sans-serif;
    font-size: 14px;
    font-weight: 500;
    height: 40px;
    line-height: 20px;
    padding: 8px 20px;
    text-decoration: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
    vertical-align: middle;
}

.export-modal-window .btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.export-modal-window .btn.white {
    background: #fff;
    background-image: none;
    color: #333;
    border: 1px solid #dee2e6;
}

.export-modal-window .btn.white:hover {
    background: #f5f5f5;
}



.pagination-wrapper {
    z-index: 1099;
}

.pagination-container {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 30px;
    flex-wrap: wrap;
    width: 100%;
}

.pagination-container .excels {
    margin: 0;
}

.fixedPagination {
    position: fixed;
    bottom: 15px;
    left: 50%;
    transform: translateX(-50%);
    width: auto;
    max-width: 95%;
    z-index: 1099;
}

.fixedPagination .pagination-container {
    background: #fff;
    padding: 10px 25px;
    border-radius: 10px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.fixedPagination .btn:hover {
  background: #215282;
  opacity: 1;
}

.staticPagination {
    position: relative;
    margin: 30px auto;
    width: 100%;
    display: flex;
    justify-content: center;
}

.staticPagination .pagination-container {
    justify-content: center;
}

.order-count-summary {
    font-size: 14px;
    color: #636f7f;
    display: flex;
    align-items: center;
    gap: 20px;
    white-space: nowrap;
}

.order-count-summary .grand-total-sum {
    font-weight: 600;
    color: #1e2248;
}

/* Блок сумм по типу оплаты и справочнику предоплаты (под пагинацией) */
.payment-sums-block {
    margin-top: 12px;
    padding: 10px 0;
    font-size: 13px;
    color: #636f7f;
    display: flex;
    flex-wrap: wrap;
    gap: 8px 20px;
    align-items: center;
    max-width: 800px;
    margin: 12px auto 0;
}
.payment-sums-block .payment-sums-loader {
    color: #888;
}
.payment-sum-item {
    cursor: pointer;
    padding: 2px 4px;
    border-radius: 4px;
    white-space: nowrap;
}
.payment-sum-item:hover,
.payment-sum-item.payment-sum-item--active {
    background: rgba(0, 94, 235, 0.08);
    color: #005eeb;
    text-decoration: underline;
}

/* Улучшенные стили для DatePicker (vue2-datepicker) */
.mx-datepicker {
  width: 100% !important;
}

.mx-input {
  height: 35px !important;
  border: 1px solid #dee2e6 !important;
  border-radius: 6px !important;
  box-shadow: none !important;
  font-size: 13px !important;
  padding: 1px 10px !important;
  color: #1e2248 !important;
}

.mx-input:focus {
  border-color: #005eeb !important;
  box-shadow: 0 0 0 4px rgba(0, 94, 235, 0.12) !important;
}

.mx-icon-calendar {
  color: #005eeb !important;
  font-size: 16px !important;
}

.mx-datepicker-main {
  border-radius: 8px !important;
  box-shadow: 0px 8px 16px rgba(30, 34, 72, 0.16) !important;
  font-family: inherit !important;
}

.mx-calendar-header-label {
  font-weight: 600 !important;
  font-size: 14px !important;
  color: #1e2248 !important;
}

.mx-btn {
  color: #1e2248 !important;
}

.mx-btn:hover {
  color: #005eeb !important;
  border-color: #005eeb !important;
}

.mx-calendar-content .cell.active {
  background-color: #005eeb !important;
  color: #fff !important;
}

.mx-calendar-content .cell:hover {
  background-color: rgba(0, 94, 235, 0.12) !important;
}

.mx-table-date .today {
    color: #ffffff;
    background: #2a90e9;
}

/* Футер для DatePicker */
.datepicker-footer {
  padding: 8px 12px;
  border-top: 0px solid #dee2e6;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  background: transparent;
}

.btn-datepicker-reset {
  background: none;
  border: none;
  color: #005eeb;
  font-size: 13px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  border-radius: 4px;
  transition: background 0.2s;
  font-weight: 500;
}

.btn-datepicker-reset:hover {
  background: rgba(0, 94, 235, 0.08);
}

.btn-datepicker-relative {
  background: none;
  border: none;
  color: #005eeb;
  font-size: 13px;
  cursor: pointer;
  font-weight: 500;
  text-decoration: none;
  padding: 4px 8px;
  border-radius: 4px;
  transition: background 0.2s;
}

.btn-datepicker-relative:hover {
  background: rgba(0, 94, 235, 0.08);
}

.datepicker-separator {
  width: 100%;
  height: 1px;
  background-color: #dee2e6;
  margin: 2px 0;
}

/* Стили для шорткатов */
.mx-datepicker-sidebar {
  width: 110px !important;
  background-color: #f9fafb !important;
  border-right: 1px solid #dee2e6 !important;
}

.mx-datepicker-sidebar + .mx-datepicker-content {
  margin-left: 110px !important;
}

.mx-btn-shortcut {
  font-size: 12px !important;
  color: #1e2248 !important;
  padding: 8px 12px !important;
  text-align: left !important;
  border-radius: 0 !important;
}

.mx-btn-shortcut:hover {
  background-color: rgba(0, 94, 235, 0.08) !important;
  color: #005eeb !important;
}

/* Стили для статуса оплаты */
.pay-status {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
}

.pay-status.payed {
  background-color: #22c993;
}

.pay-status.wait {
  background-color: #ffa530;
}

.pay-status.partial {
  background-color: #4a90e2;
}

.ml10 {
  margin-left: 10px;
}
</style>

<!-- Глобально: меню vue-select при appendToBody иначе под overlay модалки (z-index 2000) -->
<style>
body .vs__dropdown-menu {
  z-index: 10050 !important;
}
</style>
